import { meaningIcon } from '../meaning-icon'
import { MESSAGE_HOMES, dueToday, pillOf, homeOf, type MessageHome, type EnquiryPill } from '../message-homes'
import { fetchMessagesToday } from '../messages-today'
import { DailyCompletion, mergeMessagesToday, paintMessagesBanner, paintTileProgress, paintEnquiryStreak, streakNote, unknownMessagesToday } from '../messages-banner'
import { copyText } from '../copied'
import { regularChoiceOn, regularChoiceWords } from '../enquiry-regular-choice'
import { mountEnquiryRegularOffer } from '../enquiry-regular-offers'
import { withOfferEnding, OFFER_ENDING } from '../../functions/lib/customer-offer-data'
import { loadCustomerOfferMessages, customerOfferCount, customerOfferMessages, customerOfferTileItems } from '../customer-offers'
import { offerExtras, offerSentences, replaceOfferWords, type ExtraOffer, type OfferExtrasDraft } from '../offer-extras'
import { setReadyWords } from '../ready-words'
import { pinFoot } from '../pin-foot'
import { howOftenPicker, oftenKind, type Often, type OftenKind } from '../how-often'
import { addressLine as addressWithPostcode } from '../address-words'
import { currencySymbol, roundConfig, screenLocale, shownTime } from '../round-config'
import { messagesLayout } from '../messages-layout'
import { enquiryChat, forgetEnquiryChats, releaseEnquiryChat } from '../enquiry-chat'
import { openWriteQuote } from '../write-quote'
import { customerContext, shelved, listQuiet, recanvass, takenOff, listSummary, listTitle, legacyTier, contextDraftsHeld, contextPending, standingFields } from '../customer-context'
import { getMe, ownerDoesJobs, worksAlone } from '../me'
import { SET_YOUR_DAYS } from '../work-days-view'
import { firstName } from '../late-message'
import { styleSelect } from '../styled-select'
import type { WordingKey } from '../business-settings'
import { kindLabel, mailSubject } from '../trade'
import { leadIsOpen } from '../new-jobs'
import { enquiryLane, letGoOn } from '../enquiry-lane'
import { quoteReplies } from '../quote-replies'
import { businessSettings, visibleTime } from '../business-settings'
import { NOTE_WAY, countedWords, isSendPress, leadPhoneLink, leadWay, linkFor, mailtoHref, noteWord, wayFor, wayWords, type CustomerMessageBy, type NoteChannel } from '../contact'
import { sendControl, wayIcon, wayMenu, type WayCustomer } from '../contact-ui'
import { bindEmailSend } from '../email-send'
import { api, ApiError, dismiss, flushQueue, getQueue, mutate, readCache, withdraw, type Ack } from '../api'
import { missingDetails, openAddDetails, withWaiting, type DetailsSaved } from '../add-details'
import { openBooking } from '../booking'
import { bookEnquiry, bookingWaiting } from '../book-enquiry'
import { calendarIcon } from '../book-icons'
import { foldAway, reducedMotion, slideAway, slideIn, tickStamp } from '../motion'
import { buzz } from '../haptic'
import { cycleRisk, noDateYet, riskNote, summariseRound, type RoundCustomer } from '../attention'
import {
  appendNote, contactLineWords, visitMovedMessage, replyGroup, replyQuiet, replyForJob, replyConversations, replyNeedsFollowup, replyDates, acceptedReplyDates, datesReplyMessage, type ReplyGroup,
  comingUpDays,
  customerArea,
  defaultOfferDate,
  plannedWeekOf,
  offerLabel,
  firstMessageKind,
  LONG_CYCLE_DAYS,
  longAway,
  messageNoteLine,
  WINBACK_DISCOUNT_PERCENT,
  winbackNoteLine,
  messagesThisCycle,
  noReplyNoteLine,
  rebookMessage,
  secondMessage,
  finalMessage,
  secondMessageFrom,
  SECOND_MESSAGE_AFTER_DAYS,
  stageOf,
  type RebookStage,
} from '../rebook-message'
import {
  enquiryEmailHref,
  enquiryFirstMessage,
  enquiryMessages,
  enquiryNoteLine,
  enquirySecondFrom,
  nudgeMessageFor,
  quoted,
  enquiryStageOf,
  enquiryLastTryMessage,
  enquiryFinalMessage,
  lastTryEmailHref,
  lastTryNoteLine,
  lastTrySentOn,
  oldQuotes,
  ENQUIRY_FRESH_DAYS,
  ENQUIRY_SECOND_AFTER_DAYS,
  type EnquiryStage,
} from '../enquiry-message'
import { askAgainLater, isFollowupDue, notNowPatch } from '../followup'
import { overdueDays, SORT_LABELS, sortRows, type RebookSort } from '../rebook-sort'
import { dueDate, effectiveCycle, isPencilledVisit, missedVisit, pushedAndUnbooked, upcomingVisits, type UpcomingVisit } from '../planning'
import { addDaysISO, dayLabel, shownVisitTime, noteDate, noteWords } from '../ui'
import { routeGen } from '../route-state'
import { dismissUndo, offerUndo, undoPatch } from '../undo'
import { inOldEnquiries, didntGoAhead, didntGoAheadWords, moveClosedEnquiry, isLeaving, letGoEnquiry, slideToLetGo } from '../let-go'
import { chatsUnread, paintChatsButton, switchCounts } from './chats'
import { enquirySteps, stepBar, stepDate, type Step } from '../enquiry-steps'
import { forgetReady, readyBox, readyKey, readyWords } from '../ready-words'
import { saidInput, saidLine } from '../said-note'
import { clear, cycleLabel, cycleNoteIsMeaningful, cycleOptions, cycleValueFor, el, loadError, money, parseMoney, roundConfirmation, shortDate, telHref, toast, todayISO } from '../ui'
import { initialsOf, lineDrawing, type Drawing } from '../picture-tiles'
import type { Clean, Lead, RoundDay } from '../types'
import { loadRoundJobs, roundJobs, severalJobsOn } from '../job-names'
import { everyWords, visitJobId } from '../jobs'
import { jobDues, jobMessageWord, jobOfferDay, plannedAfterWindows, type JobDue } from '../job-messages'
import { movedUntold, offeredDaysText, visitWords, type WordsVisit } from '../visit-words'
import { guttersAfterWindows } from '../jobs'
import { missedVisitMessage, secondJobMessage, type MissedVisit } from '../rebook-message'
import { jobFromLead, postcodeFromAddress, quotePounds, quotedStatus, repliedQuoteMessage, windowsFromWords } from '../quote-message'
import { quote, type HowOften, type PriceList, type Quote } from '../../functions/lib/price-list'
import { messageThemOffer } from '../book-message'
import { addPlaced, followAfter, recordFor, reverseRecord, startRecord, tracked, undoFollowOn, type MessageRecord } from '../message-records'
import { alsoCancelBox, cancelAfter, leftoverOf, type Leftover } from '../leftover-visit'
import { animateDisclosure, finishDisclosures, messageSwitch, messageView, quickDatePicker, smallMotion, type DateChoice } from '../messages-view'
import '../messages.css'
import { areaWord } from '../area-rename'
import { showDayDoneMoment } from '../day-done-moment'
import { sendAllOn } from '../send-all-on'
import { bookAgainCount, bookAgainLetGo, bookAgainSection, bookAgainTileItems, loadBookAgain } from '../book-again'

// Messages — the owner's follow-up list. New enquiries at the top (the leads
// from New jobs nobody has replied to yet), then the customers who have
// fallen off the round, then everyone — customer or enquiry — waiting on a
// reply.
//
// It invents nothing: every customer row here is one the diary's Round
// summary already counts as Slipping or Going cold, drawn from the SAME
// /api/customers payload through the SAME summariseRound, and every enquiry
// row is a live lead from the SAME /api/leads payload New jobs edits. The
// summary can only show the worst five of each; this is the whole list, with
// the one action that clears a row on it. A customer row leaves the moment a
// future visit is AGREED — the same way marking a clean paid drops it out of
// Owed; an enquiry row leaves when its status turns confirmed, declined or
// cancelled.

let list: RoundCustomer[] | null = null
let leadsList: Lead[] | null = null
// Your prices (0037), read so an enquiry's reply that gives the number of windows has its answer priced; null when the
// round has none, or for anyone but the owner.
let priceList: PriceList | null = null
// Two reads of /api/customers can be in flight at once on this screen — a
// data-change fires one while the mount's is still out. routeGen only catches
// a change of SCREEN, so without a sequence the OLDER answer can land last and
// put a customer who has just agreed a visit back on the list (the same guard
// history.ts uses). The badge counts its own reads for the same reason.
let loadSeq = 0
let badgeSeq = 0
// Daily numbers are independent of the working cards. Never wait for them or redraw an edited message to paint them.
let dailyNumbers = unknownMessagesToday()
let dailyOwner = ''
let dailySeq = 0
let dailyTimer: ReturnType<typeof setTimeout> | null = null
const dailyCompletion = new DailyCompletion()
const numbersOwner = (): string => `${getMe()?.businessId ?? ''}|${getMe()?.email ?? ''}`
function ownDailyNumbers(): void {
  if (dailyOwner === numbersOwner()) return
  dailyOwner = numbersOwner(); dailyNumbers = unknownMessagesToday(); ++dailySeq
  dailyCompletion.opened()
}
// Who you booked on one day of this week (Liam, 4 Nov 2026, 3A: "if we click one of the days it could act as a filter"):
// the day's bar counts the bookings made that day, so the list is those customers, each with the day of their visit and
// its price; a tap opens their page.
function showBookedDay(index: number): void {
  const visits = dailyNumbers.bookedDayVisits?.[index] ?? []
  if (!visits.length || !dailyNumbers.day) return
  const monday = new Date(`${dailyNumbers.day}T12:00:00Z`)
  monday.setUTCDate(monday.getUTCDate() - ((monday.getUTCDay() + 6) % 7) + index)
  const day = monday.toISOString().slice(0, 10)
  const names = new Map((readCache<{ customers: RoundCustomer[] }>('customers')?.data.customers ?? []).map((c) => [c.id, c.name]))
  void import('../day-close').then(({ sheet }) => {
    const s = sheet(`Booked on ${dayLabel(day)}`)
    s.head.append(el('h3', {}, `Booked on ${dayLabel(day)} · ${visits.length}`))
    const list = el('div', { class: 'messages-booked-day-list' })
    for (const v of visits) {
      const a = el('a', { href: `#/customer/${v.c}`, class: 'messages-booked-day-row' },
        el('span', {}, el('strong', {}, names.get(v.c) ?? 'Customer'), el('small', {}, `Visit ${dayLabel(v.d)}`)), el('strong', {}, v.p === null ? 'No price' : money(v.p)))
      a.addEventListener('click', () => s.close())
      list.append(a)
    }
    s.body.append(list)
  })
}
function paintDailyNumbers(root: HTMLElement, celebrate = false): void {
  ownDailyNumbers()
  const banner = root.querySelector<HTMLElement>('.messages-daily-banner')
  if (banner) {
    paintMessagesBanner(banner, dailyNumbers, celebrate || dailyCompletion.celebrating(dailyOwner, dailyNumbers), showBookedDay)
    banner.querySelector('.messages-daily-complete')?.addEventListener('animationend', () => dailyCompletion.played(dailyOwner, dailyNumbers), { once: true })
    banner.hidden = messageView.focus
  }
  for (const tile of root.querySelectorAll<HTMLElement>('.messages-tile')) {
    const slot = tile.querySelector<HTMLElement>('.messages-tile-progress')
    if (slot) paintTileProgress(slot, dailyNumbers, tile.dataset.tile as MessageHome)
    const note = tile.querySelector<HTMLElement>('.messages-tile-note')
    if (tile.dataset.tile === 'enquiries' && note) {
      const base = note.dataset.dailyBase ?? note.textContent ?? ''
      note.dataset.dailyBase = base
      note.textContent = base + (streakNote(dailyNumbers.streak) ? ` · ${streakNote(dailyNumbers.streak)}` : '')
    }
    const baseLabel = tile.dataset.dailyLabel ?? tile.getAttribute('aria-label') ?? ''
    tile.dataset.dailyLabel = baseLabel
    const work = dailyNumbers.homes?.[tile.dataset.tile as MessageHome]
    tile.setAttribute('aria-label', [baseLabel, work && work.total > 0 ? `${work.done} of ${work.total} handled today` : '', tile.dataset.tile === 'enquiries' ? streakNote(dailyNumbers.streak) : ''].filter(Boolean).join(', '))
  }
  const streak = root.querySelector<HTMLElement>('.messages-enquiry-streak')
  if (streak) paintEnquiryStreak(streak, dailyNumbers)
}
function refreshDailyNumbers(): void {
  ownDailyNumbers()
  if (dailyTimer !== null) clearTimeout(dailyTimer)
  const owner = dailyOwner, gen = routeGen, seq = ++dailySeq
  dailyTimer = setTimeout(() => {
    dailyTimer = null
    if (seq !== dailySeq || gen !== routeGen || owner !== numbersOwner()) return
    void fetchMessagesToday().then(next => {
      if (seq !== dailySeq || gen !== routeGen || owner !== numbersOwner()) return
      dailyNumbers = mergeMessagesToday(dailyNumbers, next)
      const root = document.querySelector<HTMLElement>('.messages-page')
      let storage: Storage | undefined
      try { storage = localStorage } catch { /* memory still prevents replay */ }
      const banner = root?.querySelector<HTMLElement>('.messages-daily-banner')
      const visible = !!banner && !banner.hidden && !document.hidden && (!banner.getClientRects || banner.getClientRects().length > 0)
      const celebrate = dailyCompletion.update(owner, dailyNumbers, visible, storage)
      if (root) paintDailyNumbers(root, celebrate)
    })
  }, 120)
}
window.addEventListener('roundly:row-saved', () => {
  if (window.location.hash.split('?')[0] === '#/rebook') refreshDailyNumbers()
})
// The owner's way of working the list, kept while the app is open. Highest
// value first: the dearest overdue customer is the one to message first.
let sortMode: RebookSort = 'value'
// Which row's card is open (namespaced — a lead id and a customer id are both
// small integers and can collide), and whether "Overdue" shows everyone.
let openId: string | null = null
// Which folded groups the owner has opened out ("Show all").
const expanded = new Set<string>()
let filterText = ''
let stageFilter = 'next'
let enquiryPill: EnquiryPill | null = 'yourturn'
// No pill picked (Liam, 2 Nov 2026: "If i tap the same pill again it should show all messages ie not filtered"): every
// enquiry in Your turn, Waiting and Won; Didn't go ahead stays its own list.
function inPickedPill(pill: EnquiryPill | null): boolean {
  return enquiryPill === null ? pill !== null && pill !== 'dead' : pill === enquiryPill
}
let focusSearch: { text: string; stage: string } | null = null
let pageSections: { spec: StageSpec; rows: Row[]; node: HTMLElement }[] = []
let currentRender: (() => void) | null = null
let dockObserver: ResizeObserver | null = null
let dockStatusObserver: MutationObserver | null = null
let lastFirstIds = new Set<string>()
// Focus's order as last drawn, so a send moves on to the next person (messages #7).
let lastFocusOrder: string[] = []
let lastTotal: string | null = null
// The answer just written from their reply flashes pale yellow once as it appears (Liam picked A on the design, 16 Oct
// 2026). The enquiry's id until its card is next drawn with the reply on it.
let flashAnswerFor: number | null = null
// The last old quote was just removed: Old quotes shows a tick and "Old quotes cleared", then folds away (Liam, 16 Oct
// 2026: "a really satisfying animation"). The enquiry's id until the page is next drawn.
let oldQuotesClearing: number | null = null
// Whether the To send list had anyone on it when last drawn, and a celebration owed while Roundly was in the background
// (the last Send opens WhatsApp): clearing the last one celebrates, opening a list that is already empty does not
// (Liam, 16 Oct 2026: "if we clear all message on all group an even better one").
let listHadRows: boolean | null = null
let allClearOwed = false
let focusRestoreId: string | null = null
// Enquiries whose message is folded away on their card ("Hide it"), for this visit to Messages, by the message it hid
// (a later message, such as the quote nudge, is shown again).
const foldedMessages = new Set<string>()
const foldKey = (l: Pick<Lead, 'id' | 'enquiry_messages' | 'enquiry_messaged_on'>): string => `${l.id}:${l.enquiry_messages ?? 0}:${l.enquiry_messaged_on ?? ''}`
// A row that just received someone (I sent a quote): one lemon glow on it, once, and the screen taken to it.
let landId: string | null = null
const foldedGroups = new Map<string, boolean>()
const cardDrafts = new Map<string, { said: boolean; saidBase: string; later: boolean; fields: { label: string; className: string; context: string; value: string }[]; details: boolean; about?: boolean; day?: boolean; deskScrollTop?: number }>()
const phoneMessages = (): boolean => typeof window.matchMedia === 'function' ? window.matchMedia('(max-width:760px)').matches : true

// The card panel ends on screen from the first view (8 Oct 2026). Until the page has scrolled far enough
// for the panel to stick under the top bar, its height is cut to what is left of the window, so the
// pinned Send row shows at once. Wider screens only; a no-op when Messages is not showing.
let panelFrame = 0
function fitMessagesPanel(): void {
  panelFrame = 0
  if (phoneMessages() || typeof getComputedStyle !== 'function') return
  const panel = document.querySelector<HTMLElement>('.messages-page .messages-panel')
  if (!panel) return
  const top = Math.max(panel.getBoundingClientRect().top, (document.querySelector('.topbar')?.getBoundingClientRect().bottom ?? 0) + 14)
  panel.style.setProperty('--messages-panel-top', `${Math.round(top)}px`)
}

let enquiryLayoutObserver: ResizeObserver | null = null
function watchEnquiryLayout(panel: HTMLElement): void {
  enquiryLayoutObserver?.disconnect(); enquiryLayoutObserver = null
  if (phoneMessages() || typeof ResizeObserver === 'undefined') return
  enquiryLayoutObserver = new ResizeObserver(queuePanelFit)
  enquiryLayoutObserver.observe(panel)
}
// A soft edge only while Send is held over the card: the actions after it are still out of view below.
let pinObserver: IntersectionObserver | null = null
function watchSendPin(panel: HTMLElement): void {
  pinObserver?.disconnect(); pinObserver = null
  const pin = panel.querySelector<HTMLElement>('.messages-send-pin'), after = pin?.nextElementSibling
  if (!pin || !after || phoneMessages() || typeof IntersectionObserver === 'undefined') return
  pinObserver = new IntersectionObserver(([entry]) => {
    if (entry) pin.classList.toggle('is-floating', !entry.isIntersecting && entry.boundingClientRect.top > (entry.rootBounds?.bottom ?? window.innerHeight))
  }, { root: panel.closest('.messages-focus') ? null : panel })
  pinObserver.observe(after)
}
const queuePanelFit = (): void => { if (!panelFrame && typeof requestAnimationFrame === 'function') panelFrame = requestAnimationFrame(fitMessagesPanel) }
window.addEventListener('scroll', queuePanelFit, { passive: true })
window.addEventListener('resize', queuePanelFit)

// Send at hand on a phone (Liam, 16 Oct 2026: "i want to make it easier to send a message to the customer as this is
// the main CTA"; he chose Astra's bar for when Send is scrolled past, "careful with edge cases if multiple are open of its
// the last one tapped", and leaned to "fixed at the bottom"). While a card is open and its own Send is off the screen
// (below, before you reach it, or above, once scrolled past), a bar above the tab bar says "WhatsApp Hannah" and taps
// that Send: the same button and handlers, the box's words as they are at the tap. A phone shows one open card at a
// time, the last one tapped, so the bar is always that card's, and it names them. Gone while typing in the card (the
// keyboard is up), when little of the card is on the screen, in Focus (which docks Send already) and on a computer
// (Send is pinned inside the card's panel there).
let sendBarStop: (() => void) | null = null
function watchSendBar(root: HTMLElement): void {
  sendBarStop?.(); sendBarStop = null
  if (!phoneMessages() || messageView.focus || typeof IntersectionObserver === 'undefined') return
  const card = root.querySelector<HTMLElement>('.rebook-card')
  const sendNow = card?.querySelector<HTMLElement>('.rebook-send')
  const send = sendNow && sendNow.getAttribute('aria-disabled') !== 'true' ? sendNow : null
  // An enquiry's Book them in and They replied (Liam, 19 Oct 2026: "wouldn't that bar be split between book in and they
  // replied?"): beside Send as the narrow half where there is one, else the two halves themselves.
  const bookNow = card?.querySelector<HTMLButtonElement>('.enquiry-book') ?? null
  const book = bookNow && !bookNow.disabled ? bookNow : null
  const repliedNow = card?.querySelector<HTMLButtonElement>('.enquiry-replied-open') ?? null
  const replied = repliedNow && !repliedNow.hidden ? repliedNow : null
  // Follow up where the card has it in They replied's place (tidy-up item 6, 20 Oct 2026): the bar's half opens it there.
  const follow = card?.querySelector<HTMLElement>('.enquiry-follow-open') ?? null
  const main = send ?? book
  if (!card || !main) return
  const name = firstName((card.getAttribute('aria-label') ?? '').replace(/^Message for /, ''))
  // A card button's own look (its classes; the page's colour rules apply, as the bar sits in the page like Focus's dock).
  const lookOf = (b: HTMLElement): string => [...b.classList].filter((c) => !['rebook-send-second', 'enquiry-book', 'enquiry-replied-open', 'rebook-action-tile'].includes(c)).join(' ')
  const halves: HTMLElement[] = []
  if (send) {
    const href = send.getAttribute('href') ?? ''
    const words = send.textContent ?? ''
    const way: 'text' | 'email' | 'whatsapp' = href.startsWith('sms:') || /\btext\b/i.test(words) ? 'text' : href.startsWith('mailto:') || href.startsWith('https://mail.google.com/') || /email/i.test(words) ? 'email' : 'whatsapp'
    const verb = way === 'text' ? 'Text' : way === 'email' ? 'Email' : 'WhatsApp'
    // The last message (an enquiry's, 28 Oct 2026, or a customer's final one) says so: it also takes them off.
    const last = send.classList.contains('rebook-send-final')
    const go = el('button', { type: 'button', class: `${lookOf(send)} messages-send-bar-go`, 'aria-label': `${last ? 'Send last message to' : verb} ${name || 'them'}: the same as Send on their card` },
      wayIcon(way), el('span', {}, last ? 'Send last message' : `${verb} ${name || 'them'}`))
    go.addEventListener('click', () => { if (send.isConnected) send.click() })
    halves.push(go)
  }
  if (book) {
    const go = el('button', { type: 'button', class: `${lookOf(book)} messages-send-bar-go`, 'aria-label': `Book ${name || 'them'}: the same as Book on their card` },
      calendarIcon(), el('span', { class: 'enquiry-book-words' }, send ? 'Book' : `Book ${name || 'them'}`))
    go.addEventListener('click', () => { if (book.isConnected) book.click() })
    halves.push(go)
  }
  if (!send && follow) {
    const go = el('button', { type: 'button', class: 'btn-secondary messages-send-bar-go', 'aria-label': `Follow up: ${name || 'them'}` }, 'Follow up')
    // Opens the card's own Follow up pop-up (design B, 25 Oct 2026).
    go.addEventListener('click', () => { if (follow.isConnected) follow.click() })
    halves.push(go)
  } else if (!send && replied) {
    // Opens their reply box on the card and takes the screen to it, where the words are typed.
    const go = el('button', { type: 'button', class: 'btn-secondary messages-send-bar-go', 'aria-label': `They replied: ${name || 'them'}` }, 'They replied')
    go.addEventListener('click', () => {
      if (!replied.isConnected) return
      replied.click()
      replied.closest('.enquiry-replied')?.querySelector('form')?.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' })
    })
    halves.push(go)
  }
  const bar = el('div', { class: `messages-send-bar${halves.length > 1 ? ' messages-send-bar-two' : ''}`, role: 'region', 'aria-label': `${send ? 'Send' : 'Actions'} for ${name || 'them'}` }, ...halves)
  bar.hidden = true
  ;(card.closest('.messages-panel') ?? root).append(bar)
  const navTop = (): number => {
    const nav = document.querySelector<HTMLElement>('.owner-nav')
    return nav && getComputedStyle(nav).position === 'fixed' ? nav.getBoundingClientRect().top : window.innerHeight
  }
  const topbar = (): number => Math.max(0, document.querySelector<HTMLElement>('.topbar')?.getBoundingClientRect().bottom ?? 0)
  let cardOn = false, sendOn = false, typing = false
  const paint = (): void => {
    const show = cardOn && !sendOn && !typing && card.isConnected && main.isConnected
    bar.hidden = !show
    document.body.classList.toggle('messages-send-bar-on', show)
    if (!show) return
    const lift = Math.max(0, window.innerHeight - navTop())
    bar.style.bottom = `${lift}px`
    document.body.style.setProperty('--messages-send-bar', `${Math.ceil(lift + bar.getBoundingClientRect().height)}px`)
  }
  const margin = (): string => `-${Math.ceil(topbar())}px 0px -${Math.ceil(Math.max(0, window.innerHeight - navTop()))}px 0px`
  // The card counts as on the screen while a good part of it shows; its main button (Send, else Book them in) counts only
  // when all of it shows.
  const seeCard = new IntersectionObserver(([e]) => { cardOn = !!e && e.intersectionRect.height >= 160; paint() }, { rootMargin: margin(), threshold: Array.from({ length: 21 }, (_, i) => i / 20) })
  const seeSend = new IntersectionObserver(([e]) => { sendOn = !!e && e.intersectionRatio >= 0.99; paint() }, { rootMargin: margin(), threshold: [0, 0.99, 1] })
  seeCard.observe(card); seeSend.observe(main)
  const typed = (e: Event): void => { const t = e.target as HTMLElement | null; typing = e.type === 'focusin' && !!t?.matches('textarea, input, [contenteditable]'); paint() }
  card.addEventListener('focusin', typed); card.addEventListener('focusout', typed)
  sendBarStop = (): void => {
    seeCard.disconnect(); seeSend.disconnect()
    card.removeEventListener('focusin', typed); card.removeEventListener('focusout', typed)
    bar.remove()
    document.body.classList.remove('messages-send-bar-on')
    document.body.style.removeProperty?.('--messages-send-bar')
  }
}

let sheetStop: (() => void) | null = null
let sheetFocusId: string | undefined
function stopMessageDock(): void {
  sheetStop?.(); sheetStop = null
  sendBarStop?.(); sendBarStop = null
  pinObserver?.disconnect(); pinObserver = null
  dockObserver?.disconnect(); dockObserver = null
  dockStatusObserver?.disconnect(); dockStatusObserver = null
  document.querySelector('.messages-action-bar')?.remove()
  document.body.classList.remove('messages-docked')
  document.body.style.removeProperty?.('--messages-action-height')
  document.body.style.removeProperty?.('--messages-undo-height')
}

window.addEventListener('hashchange', () => {
  if (window.location.hash.split('?')[0] === '#/rebook') return
  finishDisclosures(); stopMessageDock(); currentRender = null; sheetFocusId = undefined
  foldedMessages.clear()
  if (openId === 'closed') openId = null
  forgetEnquiryChats()
  enquiryLayoutObserver?.disconnect(); enquiryLayoutObserver = null
})
if (typeof window.matchMedia === 'function') window.matchMedia('(max-width:760px)').addEventListener('change', () => {
  if (window.location.hash.split('?')[0] === '#/rebook') currentRender?.()
})
// Arrived here from a Message button elsewhere in the app (Work, a customer's
// page, New jobs): who was asked for, so the page can say plainly when that
// person has nothing to send rather than showing an empty list and leaving the
// owner to guess why. Cleared the moment they type their own search.
let asked: { id: number; name: string; kind: 'customer' | 'lead'; jobId?: number | null } | null = null
// A visit just booked from Book a visit, not agreed (Liam approved the redesign, 9 Oct 2026): its day is offered on
// that person's card (their row, or the extra job's own row) even on a day nobody is set to work, so the message asks
// about the day already on the diary and sending it never moves the visit somewhere else.
let carried: { customerId: number; jobId: number | null; day: string } | null = null

// Open Messages on one person. The message itself is only ever composed here,
// so the buttons elsewhere bring the owner TO it instead of building a second
// copy that could drift from this one (Liam 2026-09-16).
// Open Messages at the "No date yet" group, all of it showing: the diary's "Message the 3 you're not sure
// about" (Liam, 29 Sep).
let showNoDateGroup = false
// Just the ones the owner was not sure about, for this visit to Messages; "Show all" clears it.
let noDateFocus: Set<number> | null = null
let noDateFocusFresh = false
export function openMessagesNoDate(ids: number[]): void {
  messageView.focus = false; focusSearch = null; stageFilter = 'all'
  asked = null
  filterText = ''
  expanded.add(NO_DATE.title)
  showNoDateGroup = true
  noDateFocus = ids.length ? new Set(ids) : null
  noDateFocusFresh = true
  window.location.hash = '#/rebook'
}

// Their card opens with the message ready, on a phone too, so the next tap is Send (Liam, 9 Oct 2026: "click message
// on slipping ... put me into messages with that person searched but i feel we can take a tap out"). Someone filed
// elsewhere (a reply, another job) still shows as the search found them.
// carry (Book a visit's "Message them about <day>"): the job the visit is for (null: their main job) and its day.
export function openMessagesFor(record: { id: number; name: string }, kind: 'customer' | 'lead', carry?: { jobId?: number | null; visitId?: number; day?: string }): void {
  messageView.focus = false; focusSearch = null; stageFilter = 'all'
  const jobId = kind === 'customer' ? carry?.jobId ?? null : null
  asked = { id: record.id, name: record.name, kind, jobId }
  filterText = record.name
  openId = kind === 'customer' && jobId !== null ? `j${jobId}` : `${kind === 'customer' ? 'c' : 'l'}${record.id}`
  revealId = openId
  carried = kind === 'customer' && carry?.day ? { customerId: record.id, jobId, day: carry.day } : null
  if (carried) {
    if (jobId === null) offers.set(record.id, carried.day)
    else jobOffers.set(jobId, carried.day)
    multipleOffers.set(openId, [carried.day])
  }
  window.location.hash = '#/rebook'
}
// The card opened from Needs you or the Diary, scrolled to once it is drawn (the search, its note and empty groups sit
// above it). Forgotten once shown, or once another card is opened.
let revealId: string | null = null
function revealAskedCard(root: HTMLElement): void {
  if (!revealId) return
  if (openId !== revealId) { revealId = null; return }
  const id = revealId
  if (!root.querySelector(`.rebook-card[data-message-id="${id}"]`)) return
  revealId = null
  // The page is drawn before it is put on screen: measure on the next frame, when it is there.
  const scroll = (): void => {
    const card = document.querySelector<HTMLElement>(`.rebook-card[data-message-id="${id}"]`)
    if (!card) return
    // The card's top, unless that leaves Send below the tab bar: then as far as it takes for Send to show, so the
    // message and its Send are on screen together. A card with no message to send (Dates offered, waiting: Follow up,
    // Book agreed visit, They replied) shows its buttons the same way (Liam's phone, 11 Oct 2026: opened from the Diary's
    // "Offered to", the buttons were below the screen's edge).
    const topbar = Math.max(0, document.querySelector<HTMLElement>('.topbar')?.getBoundingClientRect().bottom ?? 0)
    const nav = document.querySelector<HTMLElement>('.owner-nav')?.getBoundingClientRect()
    const floor = nav && getComputedStyle(document.querySelector('.owner-nav')!).position === 'fixed' ? nav.top : window.innerHeight
    const send = (card.querySelector<HTMLElement>('.rebook-send') ?? card.querySelector<HTMLElement>('.secondary-actions'))?.getBoundingClientRect()
    const toTop = window.scrollY + card.getBoundingClientRect().top - topbar - 12
    const toSend = send ? window.scrollY + send.bottom - (floor - 16) : toTop
    window.scrollTo(0, Math.max(0, toTop, toSend))
  }
  // A frame, and a moment later in case the browser holds frames back; the second finds it already in place.
  if (typeof requestAnimationFrame === 'function') requestAnimationFrame(scroll)
  setTimeout(scroll, 150)
}

export function openVisitDetailsFor(record: { id: number; name: string }): void {
  openMessagesFor(record, 'customer')
  stageFilter = 'visit'
  expanded.add('Needs a visit')
  openId = `c${record.id}`
}

// One row on the page: a customer from the round, or a live lead.
// Several jobs (step 2, PLAN 4a): a 'job' row is one extra job of a customer (gutters), with its own dates and
// Messages count. A customer whose windows and gutters both wait for a first message in the same group is one
// 'customer' row whose card names both (mergedJobs).
// An enquiry row may carry its own stage: the enquiries still waiting for an answer share one group (10 Oct 2026).
type Row = { kind: 'customer'; c: RoundCustomer; reply?: boolean } | { kind: 'enquiry'; l: Lead; stage?: SectionStage } | { kind: 'job'; d: JobDue }
const rowStage = (r: Row, spec: StageSpec): SectionStage => (r.kind === 'enquiry' && r.stage ? r.stage : spec.stage)
// 'lapsed' is a SECTION, not a rung on the message ladder: these customers are
// already off the list, so there is no second message and no taking them off
// again. They are here to be asked back, one at a time (Liam 2026-09-16).
type SectionStage = RebookStage | 'new' | 'lapsed' | 'visit' | 'recanvass' | 'taken_off' | ReplyGroup

const rowId = (r: Row): string => (r.kind === 'customer' ? (r.reply && r.c.message_reply_job_id != null ? `r${r.c.id}j${r.c.message_reply_job_id}` : `c${r.c.id}`) : r.kind === 'job' ? `j${r.d.job.id}` : `l${r.l.id}`)
// 'new' shares the green (send-now) styling of 'to_message'; only the enquiry
// rows ever carry it.
const stageClass = (s: SectionStage): string => (s === 'new' ? 'to_message' : s)

function matches(c: RoundCustomer, q: string): boolean {
  if (!q) return true
  // Notes too, as Work's search (planning.ts matchesSearch): the old Area notes moved there on 30 Sep 2026.
  const hay = [c.name, c.address, c.postcode, c.phone, c.area, c.notes, c.messages_shelf_reason].map((v) => String(v ?? '').toLowerCase()).join(' ')
  return q.split(/\s+/).filter(Boolean).every((word) => hay.includes(word))
}

function matchesLead(l: Lead, q: string): boolean {
  if (!q) return true
  const hay = [l.name, l.address, l.phone].map((v) => String(v ?? '').toLowerCase()).join(' ')
  return q.split(/\s+/).filter(Boolean).every((word) => hay.includes(word))
}

function addressLine(c: RoundCustomer): string {
  return addressWithPostcode(c.address, c.postcode, ' · ') || 'No address on file'
}

// A rejected save must not vanish: the same alert the customer page raises.
function alert4xx(ack: Ack): void {
  if (!ack.ok && ack.status >= 400 && ack.status < 500) window.alert(ack.error ?? 'rejected')
}

// Taps not yet acknowledged, per customer. Offline (or before the first ack)
// a second tap must send count + 2, not count + 1 again: the queue rewrites
// only the version on a chained save, and an identical body is a no-op on
// the server, so the second message would never be counted.
// Taps whose save is still in the queue for this row. Counted FROM THE QUEUE,
// not from a map cleared on ack: a save that lands from the queue never
// acks, so a map credit outlived the save and the next tap over-counted.
// An enquiry's sends still queued: a send stamps "last contacted", while "They replied" and Quoted by hand do not.
function queuedEnquirySends(path: string): number {
  return getQueue().filter((q) => q.path === path && q.method === 'PATCH' && (q.status === 'queued' || q.status === 'sending') && !!q.body && 'enquiry_messages' in (q.body as Record<string, unknown>) && 'last_contacted_on' in (q.body as Record<string, unknown>)).length
}
function queuedTaps(path: string, field: string): number {
  return getQueue().filter((q) => q.path === path && q.method === 'PATCH' && (q.status === 'queued' || q.status === 'sending') && !!q.body && field in (q.body as Record<string, unknown>)).length
}
// The same guard for enquiry rows, keyed separately — a lead id and a
// customer id are both small integers.

// One tap on WhatsApp counts as one message SENT: the owner is looking at the
// message in WhatsApp with their thumb on send, and the count is what the
// "No reply" rule runs on. The save rides the customer's version, so two
// phones tapping the same row cannot both count the same message.
//
// Since 2026-09-16 a first message that NAMES A DAY also pencils that day
// into the diary: Liam asked "should the customers that we message for
// Thursday 24th be showing up in the 24th panel as asked?" and nothing
// remembered the offer. The picker itself still books nothing — picking a day
// is wording until the message goes. The pencilled visit arrives unconfirmed,
// so the diary's own badge says it was asked, not agreed.
// ---- sending it some other way ----------------------------------------------
//
// Roundly used to learn that a customer had been messaged in exactly one way:
// somebody tapped its green WhatsApp button. Anything typed in WhatsApp itself
// — which is most of it, because that is where the customer's reply already is
// — left them sitting in this list looking un-contacted. Lewis, 19 Sep 2026:
// "sometimes we just get messages through on WhatsApp and it's not going to
// pick that up... if there was a way of me just ticking a box to say
// 'messaged', so that it clocks that, that would be good."
//
// So the record and the sending are two separate things now. The button below
// makes the SAME record the green one makes — the count, the note line, the
// pencilled day — and opens nothing.

function alreadySentButton(who: string, record: () => void | false): HTMLElement {
  const b = el('button', { type: 'button', class: 'link-button rebook-already-sent', 'aria-label': `Count a message to ${who} that was sent some other way` }, 'I messaged them myself')
  b.addEventListener('click', () => { if (record() !== false) b.disabled = true })
  return b
}

// The wording on the clipboard, for a message going out some other way. Lewis
// asked for "templates or something that I can just copy and paste"; the app
// already writes the words, it just had no way of handing them over.
// "Change wording" beside a message (Liam, 8 Oct 2026): straight to that message on More > Your messages.
function wordingLink(key: WordingKey): HTMLElement {
  return el('a', { href: `#/your-messages?m=${key}`, class: 'link-button rebook-wording' }, 'Change wording')
}
function previewTools(...tools: HTMLElement[]): HTMLElement {
  return el('span', { class: 'rebook-preview-tools' }, ...tools)
}
// Which wording a customer's message on this card uses, the same choice messageFor makes.
function messageKeyFor(c: RoundCustomer, stage: RebookStage, today: string): WordingKey {
  if (movedVisits.has(c.id)) return 'visit_moved'
  if (stage !== 'to_message') return 'rebook_second'
  if (longCycle(c) && cycleRisk(c) !== 'cold') return 'rebook_six_months'
  if (upcomingIds.has(c.id) || noDateIds.has(c.id)) return 'rebook_due'
  const kind = firstMessageKind(overdueDays(c, today), cycleRisk(c) === 'cold', isAway(c, today))
  return kind === 'overdue' ? 'rebook_overdue' : kind === 'cold' ? 'rebook_cold' : kind === 'away' ? 'rebook_away' : 'rebook_due'
}

function copyMessageButton(text: string | (() => string), who: string, short = false, compact = false): HTMLElement {
  const b = el('button', { type: 'button', class: 'link-button rebook-copy', 'aria-label': `Copy the message for ${who}` }, compact ? 'Copy' : short ? 'Copy it' : 'Copy the message')
  b.addEventListener('click', () => {
    void copyText(typeof text === 'function' ? text() : text, { button: b, what: 'message' })
  })
  return b
}

// A box on a card that copies what it holds when tapped; its label says Copied for two seconds.
function copyFact(label: string, shown: string, copy: string, aria: string): HTMLElement {
  const name = el('span', { class: 'rebook-fact-label' }, label)
  const b = el('button', { type: 'button', class: 'rebook-fact rebook-fact-copy', 'aria-label': aria }, name, el('span', { class: 'rebook-fact-value' }, shown))
  b.addEventListener('click', () => {
    void copyText(copy, { button: b, what: label.toLowerCase(), label: name, restore: () => { name.textContent = label } })
  })
  return b
}

// After a card leaves in Focus, the next person slides in from the right (the movement set's slide-in; Liam, 24 Oct
// 2026, "where else in the app", 5). Only the card drawn straight after a send, for someone else, on the same visit to
// Messages: leaving while the card goes forgets it, so nothing slides on opening Messages (Astra, 24 Oct 2026).
let nextSlidesIn: { gen: number; from: string | undefined } | null = null
function animateMessageDeparture(card: HTMLElement): Promise<void> {
  if (messageView.focus) nextSlidesIn = { gen: routeGen, from: card.dataset.messageId }
  if (messageView.feedback) tickStamp(card)
  if (!messageView.extra) return Promise.resolve()
  const row = messageView.focus ? null : [...document.querySelectorAll<HTMLElement>('.rebook-tile')].find((tile) => tile.dataset.messageId === card.dataset.messageId)
  if (row) row.inert = true
  const delay = messageView.feedback ? 180 : 0
  return Promise.all([slideAway(card, delay), ...(row ? [slideAway(row, delay)] : [])]).then(() => {})
}

// `way` is how it went: the send button's way, or for "I messaged them myself" their usual way (contact.ts).
function recordMessage(c: RoundCustomer, stage: RebookStage, card?: HTMLElement, way: CustomerMessageBy = wayFor(c), opts: { onPencil?: (v: { id: number; version: number }) => void } = {}): void {
  sendJobsMessage(c, true, [], stage, card, way)
}

// "11 Sep: rebook WhatsApp 1" → "2026-09-11" (this year, or last year when
// the month is ahead of today's). Null when the line does not start with a day.
function dateFromNoteLine(line: string, today: string): string | null {
  const m = /^(\d{1,2}) ([A-Z][a-z]{2})(?: (\d{2}))?:/.exec(line)
  if (!m) return null
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const mi = months.indexOf(m[2]!)
  if (mi < 0) return null
  let year = m[3] ? 2000 + Number(m[3]) : Number(today.slice(0, 4))
  const iso = `${year}-${String(mi + 1).padStart(2, '0')}-${m[1]!.padStart(2, '0')}`
  if (!m[3] && iso > today) year -= 1
  return `${year}-${String(mi + 1).padStart(2, '0')}-${m[1]!.padStart(2, '0')}`
}

// "Didn't send it": the tap was counted but the message never went. Takes
// one off the count (and clears the date when that leaves none), and drops
// the last "rebook WhatsApp N" line from the note.
//
// A recorded send identifies its exact diary effects. Without that evidence,
// correct the legacy count only and leave every visit for an explicit review.
async function uncountMessage(c: RoundCustomer): Promise<void> {
  // A message that named their other jobs too (several jobs), kept on this phone: the whole of it goes back, every
  // count and every visit it made, and nothing else (Astra r1 finding 8, r2 findings 1 and 2).
  let kept = recordFor(c.id, c.rebook_messaged_on ?? null)
  if (c.message_record_id && kept?.id !== c.message_record_id) kept = null
  if (!kept && c.message_record_id) { try { kept = (await api<{record: MessageRecord | null}>(`/api/customers/${c.id}/message-record`)).record } catch { toast("Could not check this message. Try again when connected."); return } }
  if (kept?.main) return putBackRecord(c, kept)
  const n = Math.max(0, messagesThisCycle(c) - 1)
  const noteLines = (c.contact_note ?? '').split('\n')
  const rebookLine = new RegExp(`: rebook ${NOTE_WAY} \\d+$`)
  const lastIdx = noteLines.map((line) => rebookLine.test(line)).lastIndexOf(true)
  // Also works on another phone without the local exact-effects record: a
  // multiple offer made no diary visit, so there is no visit to remove.
  const choiceIdx = noteLines.findIndex((line, i) => i > lastIdx && lastIdx >= 0 && /^\d{1,2} \w{3}: offered \d{4}-\d{2}-\d{2}(?: or \d{4}-\d{2}-\d{2})+; awaiting their choice$/.test(line))
  const note = noteLines.filter((_, i) => i !== lastIdx && i !== choiceIdx).join('\n')
  // The date on the tile follows the last message that still counts (its
  // note line carries the day), not the one just withdrawn.
  const remaining = noteLines.filter((_, i) => i !== lastIdx).filter((line) => rebookLine.test(line)).at(-1)
  const messagedOn = n ? (remaining ? dateFromNoteLine(remaining, todayISO()) ?? c.rebook_messaged_on ?? null : c.rebook_messaged_on ?? null) : null
  void mutate({
    label: `Didn't send: ${c.name}`,
    method: 'PATCH',
    path: `/api/customers/${c.id}`,
    body: { version: c.version, rebook_messages: n, rebook_messaged_on: messagedOn, contact_note: note || null },
    onAck: (ack) => { alert4xx(ack); void load() },
    onConflict: () => void load(),
  })
  toast('Message count put back. No linked visit could be verified; existing diary visits were kept.')
}

// Workbook key: messaged at least twice with no reply = not a customer any
// more. Lapsed customers leave Messages (and the diary's Slipping / Going
// cold) on the next read; the Work page's Status column brings them back.
// A visit still in the diary, not agreed, for someone being marked as lapsed. Left there it would read "check before
// going" in the Diary for someone off the round, so Mark as lapsed offers to cancel it in the same tap, with one Undo
// for both (Diary and Messages together, Release 2, 8 Oct 2026). Roundly's suggestions and contact reminders are not
// visits anyone made, so they are left to the Diary.
function leftoverVisit(c: RoundCustomer): { id: number; version: number; date: string } | null {
  return c.next_booked && c.next_booked_confirmed === 0 && c.next_booked_source !== 'tentative' && c.next_booked_source !== 'suggested'
    && typeof c.next_booked_id === 'number' && typeof c.next_booked_version === 'number' ? { id: c.next_booked_id, version: c.next_booked_version, date: c.next_booked } : null
}
function lapseButton(c: RoundCustomer, primary: boolean): HTMLElement {
  const visit = leftoverVisit(c)
  const off = el('button', { type: 'button', class: primary ? 'btn-primary rebook-take-off' : 'btn-secondary rebook-take-off-early', 'aria-label': `Mark ${c.name} as lapsed` }, 'Mark as lapsed')
  if (!visit) { off.addEventListener('click', () => void markNoReply(c, off, null)); return off }
  const also = el('input', { type: 'checkbox' }) as HTMLInputElement
  also.checked = true
  off.addEventListener('click', () => void markNoReply(c, off, also.checked ? visit : null))
  return el('div', { class: 'rebook-lapse' }, el('label', { class: 'check-label' }, also, el('span', {}, `Also cancel their visit on ${shortDate(visit.date)}`)), off)
}

// Off the round after the final message, or quietly (Liam, 26 Oct 2026), as the Diary's "Off the round" saves it: the
// reason says which, and a visit still waiting in the diary from the first message is cancelled once that has saved.
// One Undo puts both back.
// Customers already being taken off on this phone: a second tap (the send link again, or a tile) does nothing.
const takingOff = new Set<number>()
async function takeOffAfterFinal(c: RoundCustomer, quietly: boolean, button?: HTMLButtonElement, why?: string): Promise<void> {
  if (takingOff.has(c.id)) return
  takingOff.add(c.id)
  setTimeout(() => takingOff.delete(c.id), 15_000)
  const path = `/api/customers/${c.id}`
  const restore = standingFields(c)
  if (button) button.disabled = true
  let queuedKey: string | null = null
  const reason = why ?? (quietly ? 'Taken off with no message, after two messages with no reply.' : `Sent the final message ${shortDate(todayISO())}.`)
  const ack = await mutate({ method: 'PATCH', path, label: `Taken off round: ${c.name}`, body: { version: c.version, customer_context: { action: 'set_standing', standing: 'taken_off', reason } },
    onQueued: (m) => { queuedKey = m.key }, onConflict: () => void load() })
  if (!ack.ok && ack.status !== 0) { alert4xx(ack); if (button) button.disabled = false; void load(); return }
  const visit = leftoverVisit(c)
  const extra = visit ? await cancelAfter(ack, queuedKey, visit, c.name) : { undo: () => {}, words: '' }
  void load()
  const version = (ack.row as { version?: number } | undefined)?.version ?? c.version + 1
  offerUndo(why ? `${c.name} moved to Old customers${extra.words}` : `Took ${c.name} off the round${quietly ? '' : ' · Taken off, counted'}${extra.words}`, () => {
    extra.undo()
    void mutate({ label: `Undo taken off: ${c.name}`, method: 'PATCH', path, body: { version, customer_context: { action: 'restore_standing', fields: restore } },
      onAck: (back) => { if (!back.ok && back.status >= 400 && back.status < 500) window.alert(`Undo was refused: ${back.error ?? 'rejected'}`); void load() }, onConflict: () => void load() })
  })
}

// The lapse first; the cancel only once the lapse is saved (Astra: a lapse refused because the customer changed on
// another phone must never cancel their visit). With no signal the cancel waits on this phone for the lapse to land
// (message-records.ts followAfter) and the Undo is offered at once, as for any save waiting for signal: before, the
// cancel and the Undo were only made when the lapse answered, so a lapse sent later from the queue cancelled nothing
// and offered no Undo (bug hunt 8 Oct 2026, server-data #7).
// Where they went, in the words of Old customers (Liam, 27 Oct 2026; design B4 of
// https://claude.ai/artifact/1YEVfgqUzyxqKK61sTeCir): "Sam is in Old customers, under Lapsed".
const lapsedWords = (c: RoundCustomer): string => `${c.name} is in Old customers, under Lapsed`
async function markNoReply(c: RoundCustomer, button: HTMLButtonElement, visit: { id: number; version: number; date: string } | null = null): Promise<void> {
  const n = messagesThisCycle(c)
  const path = `/api/customers/${c.id}`
  button.disabled = true
  let lapseKey: string | null = null
  const ack = await mutate({
    label: `No reply: ${c.name}`,
    method: 'PATCH',
    path,
    body: {
      version: c.version,
      status: 'lapsed',
      contact_note: appendNote(c.contact_note, noReplyNoteLine(noteDate(todayISO()), n)),
    },
    onQueued: (m) => { lapseKey = m.key },
    onConflict: () => void load(),
  })
  alert4xx(ack)
  if (!ack.ok && ack.status !== 0) { button.disabled = false; void load(); return }
  const lapseVersion = (ack.row as { version?: number } | undefined)?.version ?? c.version + 1
  const undoLapse = (): void => { void mutate({ label: `Undo mark as lapsed: ${c.name}`, method: 'PATCH', path, body: { version: lapseVersion, status: 'active', contact_note: c.contact_note ?? null },
    onAck: (back) => { if (!back.ok && back.status >= 400 && back.status < 500) window.alert(`Undo was refused: ${back.error ?? 'rejected'}`); void load() }, onConflict: () => void load() }) }
  const cancelSave = visit ? { label: `Cancel visit: ${c.name} ${shortDate(visit.date)}`, path: `/api/cleans/${visit.id}`, body: { version: visit.version, state: 'cancelled' } } : null
  // Its Undo puts the visit back as it was (undo_restore: a door record the cancel cleared comes back too).
  const uncancel = { state: 'booked', undo_restore: true }
  if (!visit || !cancelSave) { void load(); offerUndo(`${lapsedWords(c)}`, undoLapse); return }
  if (!ack.ok) {
    // Waiting for signal: the cancel follows the lapse when it lands.
    const follow = lapseKey ? followAfter(lapseKey, cancelSave, uncancel) : null
    void load()
    offerUndo(follow ? `${lapsedWords(c)}. Their visit on ${shortDate(visit.date)} is cancelled when this saves` : lapsedWords(c), () => { if (follow) undoFollowOn(follow); undoLapse() })
    return
  }
  const cancelled = await mutate({ ...cancelSave, method: 'PATCH', onConflict: () => void load() })
  alert4xx(cancelled)
  void load()
  if (!cancelled.ok && cancelled.status !== 0) { offerUndo(`${lapsedWords(c)}. Their visit on ${shortDate(visit.date)} changed elsewhere, so it was kept`, undoLapse); return }
  const cancelVersion = (cancelled.row as { version?: number } | undefined)?.version ?? visit.version + 1
  offerUndo(`${lapsedWords(c)}. Their visit on ${shortDate(visit.date)} is cancelled`, () => {
    void mutate({ label: `Undo cancel: ${c.name} ${shortDate(visit.date)}`, method: 'PATCH', path: cancelSave.path, body: { version: cancelVersion, ...uncancel }, onAck: () => void load(), onConflict: () => void load() })
    undoLapse()
  })
}

// "Not now, ask again on…": the customer said leave it a while — a fortnight,
// a month, two. One save, the same one the diary's ⋯ menu makes (notNowPatch):
// the promised date in, contacted today, the note line appended. There is no
// extra flag to keep in step — the filters in render()/toMessageCount read
// follow_up_on itself, so the row drops off this list on the reload and, on
// the day, comes back at the top of the overdue group.
async function recordNotNow(c: RoundCustomer, askOn: string, said = '', alsoCancel: Leftover | null = null): Promise<void> {
  const body = notNowPatch(c, askOn)
  // A new reason replaces the old one; an empty box leaves the old one alone.
  if (said && said !== (c.said_note ?? '').trim()) body.said_note = said
  let queuedKey: string | null = null
  const ack = await mutate({
    label: `Not now: ${c.name}, ask again ${shortDate(askOn)}`,
    method: 'PATCH',
    path: `/api/customers/${c.id}`,
    body: { version: c.version, ...body },
    onQueued: (m) => { queuedKey = m.key },
    onConflict: () => void load(),
  })
  alert4xx(ack)
  void load()
  if (!ack.ok && ack.status !== 0) return
  // The visit still in the diary, when they ticked it off too (leftover-visit.ts): one Undo for both.
  const extra = alsoCancel ? await cancelAfter(ack, queuedKey, alsoCancel, c.name) : null
  offerReplyUndo(c, ack, `Marked ${c.name} not now, ask again ${shortDate(askOn)}${extra?.words ?? ''}`, `Undo not now: ${c.name}`,
    { follow_up_on: c.follow_up_on ?? null, last_contacted_on: c.last_contacted_on ?? null, contact_note: c.contact_note ?? null,
      ...('said_note' in body ? { said_note: c.said_note ?? null, said_on: c.said_on ?? null } : {}) }, extra, () => void load())
}

// ---- enquiries ---------------------------------------------------------------

// The enquiry rows that belong in a shared stage (waiting / second /
// no_reply) or at the top as brand new. Won (confirmed) and dead (declined /
// cancelled) leads leave the list the same way a lapsed customer does.
// Let go: messaged twice and no answer a week after the second (src/enquiry-lane.ts). Off Messages; New jobs keeps them
// under Maybe later, and a reply or a new message brings them back.
function letGone(l: Lead, today: string): boolean {
  const on = letGoOn(l)
  return !!on && today >= on
}

function liveEnquiries(leads: Lead[]): Lead[] {
  return leads.filter(leadIsOpen)
}

// Enquiries nobody has replied to yet: never messaged, and not contacted in
// the last two days (a fresh contact buys two more days before the nudge is
// due). Oldest enquiry first, no date last.
// Since 10 Oct 2026 the same "to answer" rule New jobs reads (enquiry-lane.ts): never messaged and not already quoted or
// parked, or a reply from them waiting (that comes first, whatever its age).
export function freshEnquiries(leads: Lead[], today: string): Lead[] {
  const cutoff = addDaysISO(today, -2)
  const oldest = addDaysISO(today, -ENQUIRY_FRESH_DAYS)
  const replied = (l: Lead): boolean => (l.replies_unseen ?? 0) > 0
  return liveEnquiries(leads)
    // A reminder still to come keeps them off (Remind me in a week, tidy-up item 6, 20 Oct 2026); a reply wins.
    .filter((l) => !remindedLater(l, today))
    .filter((l) => enquiryLane(l, today) === 'answer')
    // Dated within the last month; an undated or older quote is not "new".
    .filter((l) => replied(l) || (!!l.quoted_on && l.quoted_on >= oldest && (!l.last_contacted_on || l.last_contacted_on < cutoff)))
    .sort((a, b) => Number(replied(b)) - Number(replied(a)) || Number(reminderDue(b, today)) - Number(reminderDue(a, today)) || (a.quoted_on ?? '9999-12-31').localeCompare(b.quoted_on ?? '9999-12-31'))
}

// The heading number and the nav badge: the names in the three send-now
// groups — new enquiries + coming up + overdue with nothing agreed. Null when
// the customer payload cannot answer at all (unknown, not zero).
function toMessageCount(rows: RoundCustomer[], leads: Lead[] | null, today: string): number | null {
  rows = rows.filter(c => !shelved(c) && !listQuiet(c))
  // A moved agreed visit needs telling: each counts once, and is left out of the groups below (as on the page).
  const movedCount = rows.filter((c) => movedVisitOf(c)).length
  rows = rows.filter((c) => !movedVisitOf(c))
  const originalRows = rows
  rows = rows.filter(c => !replyQuiet(c, today))
  const s = summariseRound(rows)
  if (!s.riskKnown) return null
  // "Not now, ask again on…" quietens a row everywhere this count reads it —
  // the badge must not keep tallying someone the list itself no longer shows.
  const risk = [...s.cold, ...s.slipping, ...rows.filter(c => promisedReplyDue(c,today) && ![...s.cold,...s.slipping].some(r => r.id === c.id))].filter((c) => !askAgainLater(c, today) && !pushedAndUnbooked(c, today))
  const riskIds = new Set(risk.map((c) => c.id))
  const horizon = addDaysISO(today, comingUpDays())
  const upcoming = rows.filter((c) => {
    if (c.status !== 'active' || riskIds.has(c.id) || c.next_confirmed || askAgainLater(c, today)) return false
    const due = dueDate(c)
    // Pushed to next week in the Diary's Due (0063): left alone until then, unless a day is already written down.
    if (pushedAndUnbooked(c, today)) return false
    const planned = c.next_booked && c.next_booked >= today && c.next_booked <= horizon && c.next_booked_source !== 'suggested' && c.next_booked_source !== 'tentative'
    return (!!planned || !!due && due >= today && due <= horizon) && stageOf(c, today) === 'to_message'
  })
  const overdue = risk.filter((c) => stageOf(c, today) === 'to_message')
  // Several jobs: a customer with only an extra job waiting for its first message counts once too.
  const named = new Set([...upcoming, ...overdue].map((c) => c.id))
  const jobsOnly = severalJobsOn()
    ? new Set(jobDues(originalRows, roundJobs(), today, (c) => askAgainLater(c, today)).filter(d => !replyQuiet(originalRows.find(c => c.id === d.job.customer_id)!, today, d.job.id)).filter((d) => d.stage === 'to_message' && d.group !== 'ladder' && !named.has(d.job.customer_id)).map((d) => d.job.customer_id)).size
    : 0
  return (leads ? freshEnquiries(leads, today).length : 0) + movedCount + upcoming.length + overdue.length + jobsOnly
}

// One tap on WhatsApp (or the envelope, when the lead has an address) counts
// as one enquiry message SENT — same contract as the customers' recordMessage,
// on the lead's own columns. The channel names the note line so the put-back
// can drop the right one.
// An enquiry as the arrow menu saves it (contact-ui.ts wayMenu): its own way on the enquiry (0075). The menu keeps the
// object's way and version up to date as it saves.
function leadForWay(l: Lead): WayCustomer {
  return { id: l.id, name: l.name, version: l.version, phone: l.phone, email: l.email, message_by: l.message_by ?? null, route: 'leads' }
}

// One send action (functions/lib/enquiry-send.ts; tidy-up item 6, Liam, 20 Oct 2026: "I've sent another message"): the
// count, date, note line and an answer's price in ONE save of the enquiry that also keeps the words (or none, sent some
// other way), reads their messages up to the newest this phone had seen (last_in_id) and takes their replies off They
// replied down to any that came after. It replaces the three saves it was (the words, the count, "Seen": the last read
// the whole round's newest message as seen, so a reply landing meanwhile was lost; Astra's review, 20 Oct 2026).
// `stay`: the card does not leave its group (a second message counted from Follow up), so it stays open, no slide.
function recordEnquiryMessage(l: Lead, channel: NoteChannel = 'WhatsApp', card?: HTMLElement, words?: string, priced?: Record<string, unknown>, opts: { stay?: boolean; counted?: string; byYou?: boolean } = {}): void {
  // One at a time: a second tap while the first is on its way records nothing (Sonnet's edge cases, 20 Oct 2026).
  if (enquirySending(l)) { toast(STILL_SAVING_JOB); return }
  // Answering their reply starts a fresh wait (one message out, the nudge in five days), rather than being the last try.
  const n = (l.replies_unseen ?? 0) > 0 ? 1 : enquiryMessages(l) + queuedEnquirySends(`/api/leads/${l.id}`) + 1
  const today = todayISO()
  const line = enquiryNoteLine(noteDate(today), n, channel)
  const note = appendNote(l.contact_note, line)
  const body: Record<string, unknown> = {
    version: l.version,
    enquiry_messages: n,
    enquiry_messaged_on: today,
    last_contacted_on: today,
  }
  // Left out when the line would not fit: the owner's own note must survive.
  if (note !== (l.contact_note ?? '')) body.contact_note = note
  // An answer with the price in it (They replied) keeps the price on the enquiry, as Write a quote does.
  Object.assign(body, priced ?? {})
  const offer = body.answer_offer
  const offerDraftKey = body.answer_offer_draft_key
  delete body.answer_offer
  delete body.answer_offer_draft_key
  body.sent = { ...(offer ? { offer } : {}), ...(opts.byYou ? { by_you: true } : {}), way: channel === 'WhatsApp' ? 'whatsapp' : channel, words: words ?? null, upto: l.last_in_id ?? 0 }
  let queuedKey: string | null = null
  void mutate({
    label: `Enquiry ${channel} ${n}: ${l.name}`,
    method: 'PATCH',
    path: `/api/leads/${l.id}`,
    body,
    onQueued: (m) => { queuedKey = m.key },
    onAck: (ack) => {
      alert4xx(ack)
      if (ack.ok && typeof offerDraftKey === 'string') { try { localStorage.removeItem(offerDraftKey) } catch { /* storage off */ } }
      // The same tick and slide as a customer's message (see recordMessage); a card that stays in its group stays open.
      if (opts.stay) { openId = `l${l.id}`; focusRestoreId = `l${l.id}`; if (card?.isConnected && messageView.feedback) tickStamp(card); void load() }
      else if (ack.ok && card?.isConnected) {
        const gen = routeGen
        card.inert = true
        void animateMessageDeparture(card).then(() => { if (gen === routeGen) void load() })
      } else void load()
      const key = (ack.row as { sent_key?: unknown } | undefined)?.sent_key
      const version = (ack.row as { version?: unknown } | undefined)?.version
      const sendKey = typeof key === 'string' ? key : queuedKey
      if (ack.ok && sendKey && typeof version === 'number') offerUndo(opts.counted ?? countedWords(channel, l.name), () => putBackSend(l, sendKey, version))
    },
    onConflict: () => {
      void load()
    },
  })
}

// A send or its put-back still on its way for this enquiry: the card, its Follow up and the phone's bar make no other
// change to it meanwhile (AGREED.md 6; the same hold as Needs you's leadStillSaving, waiting-ok.ts), so nothing goes on
// the version before it and a double tap records once.
function enquirySending(l: Pick<Lead, 'id'>): boolean {
  // I sent a quote at the door or another way is a plain save, held the same (Astra's review, 25 Oct 2026).
  return getQueue().some((q) => q.path === `/api/leads/${l.id}` && q.method === 'PATCH' && q.status !== 'conflict' && q.status !== 'failed' && !!q.body
    && typeof q.body === 'object' && ('sent' in (q.body as Record<string, unknown>) || 'unsend' in (q.body as Record<string, unknown>) || q.label.toLowerCase().startsWith(QUOTE_LABEL_START) || q.label.toLowerCase().startsWith(`undo ${QUOTE_LABEL_START}`)))
}
const STILL_SAVING_JOB = 'Still saving that job. Try again in a moment.'

// Put it back (Didn't send it, or Undo): the server restores exactly what that send changed while it is still the
// enquiry's latest change, and takes off the message it kept (functions/lib/enquiry-send.ts). No count is taken off by
// hand: a second message put back that way lost the first message's day (enquiry-message.ts enquiryUncountFields).
function putBackSend(l: Lead, key: string, version: number): boolean {
  if (enquirySending(l)) { toast(STILL_SAVING_JOB); return false }
  const path = `/api/leads/${l.id}`
  void mutate({
    label: `Didn't send: ${l.name}`,
    method: 'PATCH',
    path,
    body: { version, unsend: key },
    onAck: () => { focusRestoreId = `l${l.id}`; toast(`Put back: ${l.name}'s message is no longer counted.`); void load() },
    onConflict: (ack) => {
      // Changed since (another message, a reply typed in, another phone), or already put back: said plainly, never left
      // as a change to sort out.
      for (const q of getQueue()) if (q.path === path && q.status === 'conflict' && !!q.body && typeof q.body === 'object' && 'unsend' in (q.body as Record<string, unknown>)) dismiss(q.key)
      toast(ack.error ?? "That message can't be put back now.")
      void load()
    },
  }).then((ack) => { if (!ack.ok && ack.status >= 400 && ack.status < 500 && ack.status !== 409) toast(ack.error ?? "That message can't be put back now.") })
  return true
}

// Remind me in a week (tidy-up item 6, Liam, 20 Oct 2026: "out of the way until that day, then back at the top"): the
// enquiry's own follow-up date (leads.follow_up_on, the one New jobs' sheet shows) and a note line. Nothing is counted.
// Off Messages until the day; then first in its group until something is done (a message counted, a reply, Not
// interested, booked in, or another reminder). A reply from them brings it back at once.
function remindEnquiry(l: Lead, button?: HTMLButtonElement): void {
  if (enquirySending(l)) { toast(STILL_SAVING_JOB); return }
  if (button) button.disabled = true
  const today = todayISO()
  const on = addDaysISO(today, 7)
  const note = appendNote(l.contact_note, `${noteDate(today)}: remind me ${noteDate(on)}`)
  const body: Record<string, unknown> = { version: l.version, follow_up_on: on }
  if (note !== (l.contact_note ?? '')) body.contact_note = note
  const path = `/api/leads/${l.id}`
  void mutate({
    label: `Remind me: ${l.name}, ${shortDate(on)}`,
    method: 'PATCH',
    path,
    body,
    onAck: (ack) => {
      alert4xx(ack)
      if (!ack.ok && button) button.disabled = false
      openId = null
      void load()
      undoPatch({ text: `${l.name} is out of the way until ${dateChoiceLabel(on)}`, label: `Undo remind me: ${l.name}`, path, ack, version: l.version,
        body: { follow_up_on: l.follow_up_on ?? null, contact_note: l.contact_note ?? null }, after: () => { focusRestoreId = `l${l.id}`; void load() } })
    },
    onConflict: () => void load(),
  }).then((ack) => { if (ack.status === 0 && button) { button.disabled = true; button.querySelector('strong')?.replaceChildren('Remind me: waiting for signal') } })
}

// A reminder still to come hides the enquiry from Messages, wherever it would be listed; a reply from them wins.
function remindedLater(l: Lead, today: string): boolean {
  return askAgainLater(l, today) && !((l.replies_unseen ?? 0) > 0)
}
// Its day has come: first in its group, with "Reminder due" on its row, until something is done.
function reminderDue(l: Lead, today: string): boolean {
  return isFollowupDue(l, today) && !((l.replies_unseen ?? 0) > 0)
}

// Take an enquiry off the list: status_raw DECLINED (the stored wording the
// New jobs sheet shows), with Undo putting back exactly what was there.
function markEnquiryDeclined(l: Lead, button: HTMLButtonElement): void {
  if (enquirySending(l)) { toast(STILL_SAVING_JOB); return }
  button.disabled = true
  void mutate({
    label: `Not interested: ${l.name}`,
    method: 'PATCH',
    path: `/api/leads/${l.id}`,
    body: { version: l.version, status_raw: 'DECLINED', let_go: 'interested' },
    onAck: (ack) => {
      alert4xx(ack)
      if (!ack.ok) button.disabled = false
      void load()
      // Says what just happened, with Undo beside it: it read "Put <name> back on the enquiries", which is
      // what Undo does, so a Remove looked like it had put the quote back (Claude's iPhone check, 29 Sep 2026).
      undoPatch({ text: `Took ${l.name} off: now under Didn't go ahead in Messages`, label: `Undo not interested: ${l.name}`, path: `/api/leads/${l.id}`, ack, version: l.version,
        body: { status_raw: l.status_raw ?? null }, after: () => void load() })
    },
    onConflict: () => void load(),
  })
}

// The last message after two with no reply, sent or sent some other way (Liam, 28 Oct 2026, Safet: "a way / flow for last
// reach out message before i take her off the list"; drawn https://claude.ai/artifact/Vff46qekb4c956K6TVPaN8, "go with
// A"): off as Not interested is, with "28 Oct: last message WhatsApp" in their notes. Undo puts both back.
function enquiryOffAfterLast(l: Lead, channel: NoteChannel | 'self', button?: HTMLButtonElement): void {
  if (enquirySending(l)) { toast(STILL_SAVING_JOB); return }
  if (button) button.disabled = true
  const today = todayISO()
  const note = appendNote(l.contact_note, `${noteDate(today)}: last message${channel === 'self' ? ', sent myself' : ` ${channel}`}`)
  const body: Record<string, unknown> = { version: l.version, status_raw: 'DECLINED', last_contacted_on: today }
  // Left out when the line would not fit: the owner's own note must survive.
  if (note !== (l.contact_note ?? '')) body.contact_note = note
  const first = l.name.split(' ')[0] || l.name
  void mutate({
    label: `Last message: ${l.name}`,
    method: 'PATCH',
    path: `/api/leads/${l.id}`,
    body,
    onAck: (ack) => {
      alert4xx(ack)
      if (!ack.ok && button) button.disabled = false
      void load()
      undoPatch({ text: `Last message sent. ${first} is off your list.`, label: `Undo last message: ${l.name}`, path: `/api/leads/${l.id}`, ack, version: l.version,
        body: { status_raw: l.status_raw ?? null, contact_note: l.contact_note ?? null, last_contacted_on: l.last_contacted_on ?? null }, after: () => void load() })
    },
    onConflict: () => void load(),
  })
}

// One tap on "Last try" (WhatsApp or the envelope) counts the last try as sent: today as "last
// contacted" and a "28 Sep: last try WhatsApp" note line. The enquiry message count is left alone, so
// the quote stays in Old quotes, marked, rather than starting the new-enquiry ladder. Undo puts both
// fields back.
function recordLastTry(l: Lead, channel: NoteChannel): void {
  const today = todayISO()
  const note = appendNote(l.contact_note, lastTryNoteLine(noteDate(today), channel))
  // No room for the line in the job's notes (2,000 characters): say so rather than half-record it,
  // or the row would offer the last try again.
  if (note === (l.contact_note ?? '')) {
    toast(`${l.name}'s notes are full, so the last try couldn't be marked. Shorten them in New jobs.`)
    return
  }
  const body: Record<string, unknown> = { version: l.version, last_contacted_on: today, contact_note: note }
  void mutate({
    label: `Last try ${channel}: ${l.name}`,
    method: 'PATCH',
    path: `/api/leads/${l.id}`,
    body,
    onAck: (ack) => {
      alert4xx(ack)
      void load()
      undoPatch({ text: countedWords(channel, l.name, 'last-try '), label: `Undo last try: ${l.name}`, path: `/api/leads/${l.id}`, ack, version: l.version,
        body: { last_contacted_on: l.last_contacted_on ?? null, contact_note: l.contact_note ?? null }, after: () => void load() })
    },
    onConflict: () => void load(),
  })
}

// ---- rows and cards ---------------------------------------------------------

function weeksOf(days: number): string {
  const w = Math.round(days / 7)
  if (w < 9) return w === 1 ? '1 week' : `${w} weeks`
  const m = Math.round(days / 30.4)
  return m === 1 ? '1 month' : `${m} months`
}

function overdueWords(c: RoundCustomer, today: string): string {
  const days = overdueDays(c, today)
  if (!days) return 'due now'
  if (days < 14) return `${days} day${days === 1 ? '' : 's'} late`
  const weeks = Math.round(days / 7)
  if (weeks < 9) return `${weeks} weeks late`
  const months = Math.round(days / 30.4)
  if (months < 24) return `${months} months late`
  return `${Math.round(days / 365)} years late`
}

// Days since the enquiry came in, or null when the lead has no date at all.
function enquiryWaitDays(l: Lead, today: string): number | null {
  if (!l.quoted_on) return null
  const ms = new Date(`${today}T12:00:00`).getTime() - new Date(`${l.quoted_on}T12:00:00`).getTime()
  return Math.max(0, Math.round(ms / 86_400_000))
}

// Customers due within How far ahead to ask with nothing agreed — set by render() so the
// card knows to use the "due next week" wording.
let upcomingIds = new Set<number>()
// The subset of those whose date is already in the diary and simply not agreed
// yet. Their message offers THAT day, and the card shows no day picker: the
// day is already chosen, and a picker that changed the wording without moving
// the visit would be a promise the diary does not keep.
let bookedSoonIds = new Set<number>()
// Active customers with no date at all (never cleaned, nothing booked): their own group, "No date yet".
let noDateIds = new Set<number>()

// ---- the day being offered --------------------------------------------------

// The round is in an area on a day whether or not this customer has said yes,
// so the message offers one of those days rather than asking an open question
// (Liam, 2026-09-14). NOTHING is booked by picking one: picking is wording,
// and stays wording until the message is actually sent — it is the SEND of a
// first message that names a day which pencils that day into the diary
// (unconfirmed), in recordMessage above.
//
// Which days are offerable: the ones with somebody out on them (the diary's
// roster dropdown, migration 0013). The choice itself lives in memory only,
// per customer, for as long as the screen is open — the pick is not a fact
// about the customer; the visit the send creates is.
let roundDays: RoundDay[] = []
let roundDaysFailed = false
// Who could be out on a day (GET /api/round-days workers): the names "Who's out?" offers.
let roundWorkers: string[] = []
const offers = new Map<number, string>()
const multipleOffers = new Map<string, string[]>()
// Several jobs: the day picked for an extra job's own row, by job id; and the extra jobs folded into a customer's
// card because they wait in the same group (set by render(), like upcomingIds).
const jobOffers = new Map<number, string>()
// The owner's answer when gutters are already planned after the windows day (Liam Q11; Astra r1, finding 4): move
// them to the windows day with this message, or keep them. Nothing is offered or moved until they say.
const plannedChoice = new Map<number, 'move' | 'keep'>()
let mergedJobs = new Map<number, JobDue[]>()
// An agreed visit moved to another day and the customer not told yet (visit-words.ts movedUntold): they leave every
// other group for "Visit moved · tell them", with the visit moved message ready (Release 2, 8 Oct 2026).
let movedVisits = new Map<number, UpcomingVisit>()
function movedVisitOf(c: RoundCustomer): UpcomingVisit | null {
  return (upcomingVisits(c) ?? []).find((v) => movedUntold(v, c)) ?? null
}

function areaOf(c: RoundCustomer): string {
  return customerArea(c)
}

function suggestedWorkingDate(c: RoundCustomer, today: string): string {
  const week = plannedWeekOf(c)
  const days = week ? roundDays.filter(d => d.date >= week && d.date <= addDaysISO(week, 6)) : roundDays
  if (!week && c.next_booked && c.next_booked >= today && c.next_booked_source !== 'suggested' && c.next_booked_source !== 'tentative' && days.some(d => d.date === c.next_booked)) return c.next_booked
  return defaultOfferDate(c, days, today)
}

function offerFor(c: RoundCustomer, today: string): string {
  const chosen = offers.get(c.id)
  return chosen === undefined ? suggestedWorkingDate(c, today) : chosen
}

function dateChoiceLabel(date: string): string {
  return new Date(`${date}T12:00:00Z`).toLocaleDateString(screenLocale(), { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' })
}

function customerDateChoices(c: RoundCustomer, today: string, jobId: number | null = null): DateChoice[] {
  const area = areaOf(c)
  const days = roundDays.filter((d) => d.date >= today)
  const choices = [...new Set(days.map((d) => d.date))].sort().map((date) => {
    const day = days.find((d) => d.date === date && d.areas?.includes(area)) ?? days.find((d) => d.date === date)!
    // A one-person round's days are all the owner's: no name after them (Liam, 19 Oct 2026).
    return { date, label: dateChoiceLabel(date), detail: [...(day.areas ?? []).filter((area) => area.trim()).slice(0, 3), worksAlone() ? null : day.worker].filter(Boolean).join(' · ') }
  })
  // The day of a visit just booked for them in Book a visit, offered even when nobody is set to work it.
  const carry = carried && carried.customerId === c.id && carried.jobId === jobId && carried.day >= today && !choices.some((d) => d.date === carried!.day) ? carried.day : null
  return carry ? [...choices, { date: carry, label: dateChoiceLabel(carry), detail: 'their visit' }].sort((a, b) => a.date.localeCompare(b.date)) : choices
}

function quickCustomer(c: RoundCustomer, today: string): boolean {
  return messageView.dates && !isAway(c, today)
}

function chosenDates(key: string, choices: DateChoice[], fallback: string): string[] {
  const saved = multipleOffers.get(key)
  // Once the owner has deliberately cleared every choice, keep it empty.
  return saved === undefined ? choices.some((d) => d.date === fallback) ? [fallback] : []
    : saved.filter((date) => choices.some((d) => d.date === date))
}

function customerDates(c: RoundCustomer, today: string): string[] {
  return quickCustomer(c, today)
    ? chosenDates(`c${c.id}`, customerDateChoices(c, today), offerFor(c, today)) : [offerFor(c, today)].filter(Boolean)
}

function pencilCustomerDate(c: RoundCustomer, today: string): string | null {
  const dates = customerDates(c, today)
  return dates.length === 1 ? dates[0]! : null
}

function jobDateChoices(d: JobDue, today: string): DateChoice[] {
  const choices = customerDateChoices(d.entry, today, d.job.id)
  const windows = d.job.kind === 'gutter' ? windowsNextOf(d) : null
  return choices.filter((choice) => !windows || !guttersAfterWindows(choice.date, windows)).sort((a, b) => a.date.localeCompare(b.date))
}

function quickJob(d: JobDue, today: string): boolean {
  return messageView.dates && !plannedAfterWindows(d, windowsNextOf(d), today)
}

function jobDates(d: JobDue, today: string): string[] {
  return quickJob(d, today) ? chosenDates(`j${d.job.id}`, jobDateChoices(d, today), jobOfferFor(d, today)) : [jobOfferFor(d, today)].filter(Boolean)
}

function refreshDateMessage(card: HTMLElement, c: RoundCustomer, stage: RebookStage, today: string, job?: JobDue): void {
  const dates = job ? jobDates(job, today) : customerDates(c, today)
  const empty = !dates.length
  const body = job ? jobMessageFor(job, stage, today) : messageFor(c, stage, today)
  const preview = card.querySelector<HTMLElement>('.rebook-preview-text')
  if (preview) preview.textContent = body
  const copy = copyMessageButton(body, c.name)
  if (empty) copy.setAttribute('disabled', 'disabled')
  if (empty) copy.title = 'Choose a working day first'
  card.querySelector('.rebook-copy')?.replaceWith(copy)
  const dock = document.querySelector<HTMLElement>('.messages-action-bar')
  const controls = [card, ...(dock && dock.dataset.messageId === card.dataset.messageId ? [dock] : [])]
  for (const scope of controls) {
    const link = scope.querySelector<HTMLAnchorElement>('.rebook-send')
    if (link) {
      const send = linkFor(wayFor(c), c, body, `Your next visit from ${businessSettings().business_name}`)
      if (empty) link.removeAttribute('href'); else if (send.href) link.href = send.href
      link.setAttribute('aria-disabled', String(empty))
      link.classList.toggle('messages-send-disabled', empty)
    }
    const already = scope.querySelector<HTMLButtonElement>('.rebook-already-sent')
    if (already) already.disabled = empty
  }
  smallMotion(preview, 'dates')
}

// Eight months or more since their last visit, and overdue with it: the
// "start again?" message, which names no day. A customer in Coming up is due
// NOW on their own cycle — an eleven-month gap on a yearly cycle is the cycle
// working, not someone lost — so they never reach this.
// Cleaned every 6 months or once a year, with a last clean to count from (firstMessageKind's six_months).
function longCycle(c: RoundCustomer): boolean {
  return !!c.last_clean && (effectiveCycle(c).days ?? 0) >= LONG_CYCLE_DAYS
}

// A customer cleaned every 6 months or once a year is never "away" for a gap that is their own rhythm: they get their
// own message (rebook_six_months), which names a day, so they get the day picker and the send puts that day in the
// Diary like anyone else's (bug hunt 8 Oct 2026, messages #1 and server-data #6). Two whole cycles missed (cold) is away.
function isAway(c: RoundCustomer, today: string): boolean {
  if (longCycle(c) && cycleRisk(c) !== 'cold') return false
  return !upcomingIds.has(c.id) && overdueDays(c, today) > 0 && longAway(c.last_clean)
}

// The message this tap would send, by stage and lateness.
function messageFor(c: RoundCustomer, stage: RebookStage, today: string): string {
  const moved = movedVisits.get(c.id)
  if (moved?.moved_from) return visitMovedMessage(c.name, (c.job_name?.trim() || 'windows').toLowerCase(), { date: moved.date, moved_from: moved.moved_from, time_slot: moved.time_slot })
  // Once the first message has gone, the only message left to show is the second.
  if (stage !== 'to_message') return secondMessage(c.name)
  const dates = customerDates(c, today)
  const offer = dates[0] || null
  // Several jobs: their other jobs due in the same group are named in the same message, gutters first ("Your
  // gutters and windows are due"). None, and the words are exactly as before.
  const merged = mergedJobs.get(c.id) ?? []
  const jobs = merged.length ? [...merged.map((d) => jobMessageWord(d.job)), (c.job_name?.trim() || 'windows').toLowerCase()] : undefined
  // No date yet reads like one due now: "Your windows are due for a clean. Would <day> work for you?"
  if ((upcomingIds.has(c.id) || noDateIds.has(c.id)) && !longCycle(c)) return rebookMessage({ name: c.name, kind: 'upcoming', lastClean: c.last_clean, due: dueDate(c), offer, offers: dates, jobs })
  const kind = firstMessageKind(overdueDays(c, today), cycleRisk(c) === 'cold', isAway(c, today), longCycle(c))
  return rebookMessage({ name: c.name, kind, lastClean: c.last_clean, due: dueDate(c), offer, offers: dates, jobs: kind === 'away' ? undefined : jobs })
}

// The enquiry's message for this stage: the first reply, then the chase.
function enquiryMessageFor(l: Lead, stage: SectionStage): string {
  // The second message: the gentle quote nudge once they have a quote, else the photos chase (10 Oct 2026).
  return stage === 'new' ? enquiryFirstMessage(l.name) : nudgeMessageFor(l)
}

// Shared with the diary's enquiry rows (schedule.ts): ONE WhatsApp icon, so
// the app's send buttons cannot drift apart.
export function waIcon(): SVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('width', '20'); svg.setAttribute('height', '20'); svg.setAttribute('aria-hidden', 'true')
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  path.setAttribute('d', 'M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 21l2.1-5.4A8.5 8.5 0 1 1 21 11.5z')
  path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '2'); path.setAttribute('stroke-linecap', 'round'); path.setAttribute('stroke-linejoin', 'round')
  svg.append(path)
  return svg
}

// The envelope beside it, same share rule: the diary's enquiry rows and the
// enquiry card here draw the SAME mark (plan item A, 2026-09-17).
export function mailIcon(): SVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('width', '20'); svg.setAttribute('height', '20'); svg.setAttribute('aria-hidden', 'true')
  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  rect.setAttribute('d', 'M3 6h18v12H3z')
  const flap = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  flap.setAttribute('d', 'm3 7 9 6 9-6')
  for (const p of [rect, flap]) {
    p.setAttribute('fill', 'none'); p.setAttribute('stroke', 'currentColor'); p.setAttribute('stroke-width', '2'); p.setAttribute('stroke-linecap', 'round'); p.setAttribute('stroke-linejoin', 'round')
  }
  svg.append(rect, flap)
  return svg
}

// The day picker. Dated messages cannot be sent or copied until a working day is chosen.
//
// Only days with somebody out on them appear. If nobody has been put on any
// upcoming day yet, the control says so and points at the diary, because the
// fix is there and not here.
// Empty is only known after a successful read. Cached choices remain useful
// offline, with an explicit refresh warning; no saved days is not a setup verdict.
// `here`: on a customer's or a job's card, a round with no working days at all sets them right here (design A, below).
function workingDaysNotice(eligible: number, today: string, here?: { week?: string | null; onDay?: (date: string) => void }): HTMLElement | null {
  if (eligible && !roundDaysFailed) return null
  const box = el('div', { class: eligible ? 'messages-date-load-warning' : 'messages-date-section messages-date-empty' })
  if (!eligible) box.append(el('span', { class: 'rebook-fact-label' }, 'Days to offer'))
  // Design B (Liam, 23 Oct 2026: "no days to offer hasnt been redesigned?"): what stops the offer as an amber tile, and
  // what to do about it as picture tiles, the way the card's own buttons are.
  const actions = el('div', { class: 'messages-date-actions' })
  if (roundDaysFailed) {
    box.append(el('p', { role: 'status' }, eligible ? 'Couldn’t refresh working days. Showing saved days.' : 'Couldn’t load working days. Try again when you have a connection.'))
    const retry = actionTile(el('button', { type: 'button', class: 'btn-secondary', 'data-round-days-retry': 'true' }), 'again', 'Retry', 'Load working days again')
    retry.addEventListener('click', async () => {
      if (retry.getAttribute('aria-disabled') === 'true') return
      retry.setAttribute('aria-disabled', 'true'); retry.querySelector('strong')!.textContent = 'Retrying…'
      // In the Diary's reply pop-up: read the working days again there, never draw Messages over the Diary.
      if (replyHost) { replyHost.reload(); return }
      const id = box.closest<HTMLElement>('.rebook-card')?.dataset.messageId
      const gen = routeGen
      await load()
      if (gen !== routeGen || (document.activeElement !== document.body && document.activeElement !== retry)) return
      const card = [...document.querySelectorAll<HTMLElement>('.rebook-card')].find(n => n.dataset.messageId === id)
      card?.querySelector<HTMLElement>('[data-round-days-retry], .messages-date-button, .messages-date-dropdown > summary, .messages-open-diary')?.focus({preventScroll:true})
    })
    actions.append(retry)
  } else if (here && !roundDays.some(d => d.date >= today)) {
    const alone = worksAlone()
    box.append(whyTile('calendarCross', 'No days to offer yet', alone
      ? 'None of these are working days yet. Tap the days you’ll work, and they’re offered to them.'
      : 'Nobody is out on these days yet. Tap one to choose who’s out, and it’s offered to them.'))
    box.append(setDaysHere(today, here.week ?? null, here.onDay))
    // The rest of the week, or every week, is still the Diary's and My working days' (the Messages tips point here).
    const links = el('p', { class: 'messages-set-links' })
    links.append(alone
      ? el('a', { href: '#/my-days', class: 'messages-open-diary', 'data-guide-days-setup': 'true' }, 'Set repeating days in My working days')
      : el('a', { href: '#/schedule', class: 'messages-open-diary', 'data-guide-days-setup': 'true' }, 'Plan more days in the Diary'))
    if (!alone && ownerDoesJobs()) links.append(el('a', { href: '#/my-days', class: 'messages-open-diary' }, 'My working days'))
    box.append(links)
  } else if (worksAlone()) {
    // A one-person round sets its days only in My working days (Liam, 19 Oct 2026: nothing on the Diary sets them), so
    // the fix is there: no worker to assign, no diary to open. The same words as My working days (work-days-view.ts).
    const hasWorkingDays = roundDays.some(d => d.date >= today)
    box.append(whyTile('calendarCross', hasWorkingDays ? 'No suitable days for this job' : 'No days to offer yet',
      hasWorkingDays ? 'Your working days are set, but none fit this job’s timing. Review the job, or your days in My working days.' : SET_YOUR_DAYS))
    const link = actionTile(el('a', { href: '#/my-days', class: 'btn-secondary messages-open-diary' }), 'calendarTick', 'My working days', 'Set the days you work')
    if (!hasWorkingDays) link.setAttribute('data-guide-days-setup', 'true')
    actions.append(link)
  } else {
    const hasWorkingDays = roundDays.some(d => d.date >= today)
    box.append(whyTile('calendarCross', hasWorkingDays ? 'No suitable days for this job' : 'No days to offer yet',
      hasWorkingDays ? 'Working days are set, but none fit this job’s timing. Review the job and working days in the diary.' : ownerDoesJobs() ? 'Set your usual working days in My days, or assign a worker in the diary. Empty working days can be offered too.' : 'Assign yourself or a worker to an upcoming day in the diary. It will then appear here.'))
    const link = actionTile(el('a', { href: '#/schedule', class: 'btn-secondary messages-open-diary' }), 'calendar', 'Open diary', 'Put someone on a day')
    if (!hasWorkingDays) link.setAttribute('data-guide-days-setup', 'true')
    actions.append(link)
    if (ownerDoesJobs()) actions.append(actionTile(el('a', { href: '#/my-days', class: 'btn-secondary messages-open-diary' }), 'calendarTick', 'My working days', 'Set your usual days'))
  }
  if (actions.children.length) box.append(actions)
  return box
}

// The customer's next visit in the words the Diary uses for it (docs/DIARY-AND-MESSAGES.md section 2, src/visit-words.ts):
// "Fri 9 Oct, 10:00 · Day agreed · time to confirm". Null with no visit booked.
function nextVisitOf(c: RoundCustomer): WordsVisit | null {
  if (!c.next_booked) return null
  // The day it was put on its date, as the Diary reads it, so Messages says "Not asked yet" when the Diary does.
  const up = (upcomingVisits(c) ?? []).find((v) => v.id === c.next_booked_id)
  return { date: c.next_booked, confirmed: c.next_booked_confirmed ?? 0, source: (c.next_booked_source ?? 'manual') as WordsVisit['source'], state: 'booked', time_slot: c.next_booked_time_slot?.trim() || null, time_agreed_for: c.next_booked_time_agreed_for ?? null, dated_on: up?.dated_on ?? null }
}
function nextVisitLine(c: RoundCustomer, today: string): string | null {
  const visit = nextVisitOf(c)
  if (!visit) return null
  // The day as the rest of the app writes it, with its year when that is not this one (it was left off next to New Year).
  const day = dayLabel(visit.date)
  return `${day}${shownVisitTime(visit) ? `, ${shownVisitTime(visit)}` : ''} · ${visitWords(visit, c, today).text}`
}

function appendPlanningNote(card: HTMLElement, c: RoundCustomer, today: string): void {
  const week = plannedWeekOf(c)
  // A one-person round's days are set in My working days, never in the diary (Liam, 19 Oct 2026).
  const alone = worksAlone()
  // As tiles (design B): the pencilled week or visit as the title, what to do as the line under it; amber only when
  // something stands in the way.
  if (week) {
    const hasDays = roundDays.some(d => d.date >= today && d.date >= week && d.date <= addDaysISO(week, 6))
    const noneAtAll = !roundDaysFailed && !roundDays.some(d => d.date >= today)
    card.append(whyTile('calendar', `Week of ${shortDate(week)}, day not chosen`, hasDays ? 'Choose working days to offer below.' : roundDaysFailed ? 'Working days could not be checked.' : noneAtAll ? (alone ? 'None of that week is a working day yet. Tap a day below to work it.' : 'Nobody is out that week yet. Tap a day below to choose who’s out.') : alone ? 'None of your working days are in that week. Choose another working date below or add a day in My working days.' : 'No working days are set for that week. Choose another working date below or set a day in the diary.', hasDays ? 'info' : 'warn'))
  } else if (c.next_booked && c.next_booked >= today && c.next_booked_source !== 'suggested' && c.next_booked_source !== 'tentative') {
    const onADay = roundDays.some(d => d.date === c.next_booked)
    card.append(whyTile('calendar', nextVisitLine(c, today) ?? '', onADay
      ? 'Choose the day or alternatives to offer below.'
      : `${roundDaysFailed ? 'Working days could not be checked.'
        // Opened from Book a visit on this very day: the message offers it, so never "choose an available date" above it
        // (roundly-bugs, 9 Oct 2026; Liam's rule 4, never two places that disagree).
        : carried && carried.customerId === c.id && carried.jobId === null && carried.day === c.next_booked ? alone ? 'That day isn’t one of your working days yet: add it in My working days.' : 'Nobody is set to work that day yet: set a working day in the diary.'
        : alone ? 'That date isn’t one of your working days. Choose an available date or add it in My working days.'
        : 'No working day is set for that date. Choose an available date or set a working day in the diary.'}`, onADay ? 'info' : 'warn'))
  }
}

function offerPicker(c: RoundCustomer, today: string, rerender: () => void): HTMLElement {
  const box = el('div', { class: 'rebook-offer' })
  box.append(el('span', { class: 'rebook-fact-label' }, 'Days to offer'))
  const upcoming = roundDays.filter((d) => d.date >= today)
  if (!upcoming.length) {
    box.querySelector('.rebook-fact-label')?.remove()
    // Saved, the day is the one their message offers.
    box.append(workingDaysNotice(0, today, { week: plannedWeekOf(c), onDay: (day) => { offers.set(c.id, day); multipleOffers.set(`c${c.id}`, [day]) } })!)
    return box
  }
  const pick = el('select', { class: 'rebook-offer-select', 'aria-label': `Day to offer ${c.name}` })
  pick.append(el('option', { value: '' }, 'No day yet · type it yourself'))
  for (const d of upcoming) pick.append(el('option', { value: d.date }, offerLabel(d, shortDate, !worksAlone())))
  const chosen = offerFor(c, today)
  pick.value = upcoming.some((d) => d.date === chosen) ? chosen : ''
  pick.addEventListener('change', () => { offers.set(c.id, pick.value); multipleOffers.set(`c${c.id}`, pick.value ? [pick.value] : []); rerender() })
  box.append(pick)
  if (quickCustomer(c, today)) {
    pick.hidden = true
    const choices = customerDateChoices(c, today)
    const dates = customerDates(c, today)
    box.querySelector('.rebook-fact-label')?.remove()
    box.append(quickDatePicker(choices, dates, (days) => {
      multipleOffers.set(`c${c.id}`, days); offers.set(c.id, days[0] ?? '')
      const card = box.closest<HTMLElement>('.rebook-card')
      if (card) refreshDateMessage(card, c, 'to_message', today)
    }, areaOf(c) ? el('span', {}, "They're in ", areaWord(areaOf(c))) : undefined))
  }
  const notice = workingDaysNotice(upcoming.length, today)
  if (notice) box.append(notice)
  const area = areaOf(c)
  // Beside the heading when the days are tiles (design B); under the list otherwise.
  if (area && !quickCustomer(c, today)) box.append(el('p', { class: 'muted rebook-offer-area' }, 'They are in ', areaWord(area), '.'))
  return box
}

// The "Not now, ask again on…" chooser: an in-card panel, never the browser's
// own confirm — the same shape as the week panel's move-all question. Chips
// fill the date box (a quick thumb, a typed date still possible) and Save is
// the only thing that writes.
function notNowChooser(c: RoundCustomer, today: string): HTMLElement {
  const box = el('div', { class: 'notnow-chooser', hidden: '' })
  const date = el('input', { type: 'date', 'aria-label': `Ask ${c.name} again on` })
  date.value = addDaysISO(today, 30)
  const chips = el('div', { class: 'notnow-chips', role: 'group', 'aria-label': `How long to leave ${c.name}` })
  const chipBtns: HTMLButtonElement[] = []
  const clearChips = (): void => { for (const b of chipBtns) b.classList.remove('rebook-chip-on') }
  for (const [days, label] of [[14, '2 weeks'], [30, '1 month'], [60, '2 months']] as const) {
    const chip = el('button', { type: 'button', class: `rebook-chip${days === 30 ? ' rebook-chip-on' : ''}` }, label)
    chip.addEventListener('click', () => {
      date.value = addDaysISO(today, days)
      clearChips()
      chip.classList.add('rebook-chip-on')
    })
    chipBtns.push(chip)
    chips.append(chip)
  }
  date.addEventListener('input', clearChips)
  const status = el('p', { class: 'notnow-status', role: 'status', 'aria-live': 'polite' })
  // The reason, while it is fresh: "not yet, neighbour having work done" (Liam, 29 Sep).
  const said = saidInput(c)
  // A visit still in the diary, not agreed: offered off too when asking again after its day (leftover-visit.ts).
  const leftover = leftoverOf(c, undefined, today)
  const cancelBox = leftover ? alsoCancelBox(leftover) : null
  const save = el('button', { type: 'button', class: 'btn-primary' }, 'Save')
  save.addEventListener('click', () => {
    if (!date.value || !date.validity.valid) { status.textContent = 'Pick a real date first.'; return }
    save.disabled = true
    void recordNotNow(c, date.value, said.value.trim(), leftover && cancelBox?.checked() && date.value > leftover.date ? leftover : null)
  })
  const back = el('button', { type: 'button', class: 'btn-secondary' }, 'Back')
  back.addEventListener('click', () => { box.hidden = true })
  box.append(el('span', { class: 'rebook-fact-label' }, 'Ask again on'), chips, date, el('label', { class: 'said-label' }, 'What did they say? (optional)', said), ...(cancelBox ? [cancelBox.node] : []), el('div', { class: 'notnow-btns' }, save, back), status)
  return box
}

// The open customer card (design C, opened like A): the message shown before
// it is sent, then the one green action for this stage, then Book / Call /
// page.
function customerCard(c: RoundCustomer, stage: RebookStage, today: string, rerender: () => void): HTMLElement {
  const card = el('div', { class: `rebook-card rebook-card-${stage}` })
  const top = el('div', { class: 'rebook-card-top' })
  const who = el('div', { class: 'rebook-card-who' })
  who.append(el('a', { href: `#/customer/${c.id}`, class: 'rebook-card-name' }, c.name))
  who.append(el('span', { class: 'sched-addr' }, addressLine(c)))
  top.append(who)
  // A customer here for a date already in the diary may have no cycle at all,
  // so the pill reads that date. Before, everyone in Coming up was there
  // BECAUSE of a due date, and dueDate() could be trusted not to be null.
  const soonDate = bookedSoonIds.has(c.id) ? c.next_booked : dueDate(c)
  // A follow-up that has arrived is the reason this card is at the top: the
  // pill says the promise came due, ahead of how many months they are late.
  const overdue = movedVisits.has(c.id)
    ? el('span', { class: 'rebook-pill rebook-pill-late' }, 'visit moved')
    : noDateIds.has(c.id)
    ? el('span', { class: 'rebook-pill rebook-pill-soon' }, 'no date yet')
    : upcomingIds.has(c.id) && soonDate
    ? el('span', { class: 'rebook-pill rebook-pill-soon' }, `${bookedSoonIds.has(c.id) ? plannedWeekOf(c) ? 'week of' : 'visit' : 'due'} ${shortDate(soonDate)}`)
    : isFollowupDue(c, today) && c.follow_up_on
      ? el('span', { class: 'rebook-pill rebook-pill-late' }, c.follow_up_on === today ? 'follow-up due today' : `follow-up late · ${shortDate(c.follow_up_on)}`)
      : el('span', { class: `rebook-pill ${cycleRisk(c) === 'cold' ? 'rebook-pill-cold' : 'rebook-pill-late'}` }, overdueWords(c, today))
  top.append(overdue)
  card.append(top)
  for (const lead of leadsList ?? []) if (lead.converted_customer_id === c.id && lead.has_extra_offer) {
    const open = el('button', { type: 'button', class: 'link-button' }, 'Open the enquiry')
    open.addEventListener('click', () => void import('./new-jobs').then(m => m.openNewJobsAt(lead.id)))
    card.append(el('div', { class: 'notice customer-pending-offer' }, el('p', {}, "Offered extras weren't added: open the enquiry to add them"), open))
  }
  // What they said last time, in front of the owner before the next message (Liam, 29 Sep).
  if (saidLine(c)) card.append(el('p', { class:'said-note' }, el('strong', {}, 'What they said '), saidLine(c)))

  // The price, how often and the tier as one tile that opens one pop-up (design B, Liam, 23 Oct 2026: "I like B"); the
  // last visit as a line under it. Still the card's .rebook-facts, so the phone's Focus view folds it under Details.
  // Every and Tier are still set HERE, not only on Work: this card is where a wrong cycle shows itself (Liam 2026-09-16).
  card.append(el('div', { class: 'rebook-facts rebook-facts-tile' }, priceTile(c),
    el('p', { class: 'rebook-last-visit muted' }, c.last_clean ? `Last visit ${shortDate(c.last_clean)}` : 'No visits done yet')))

  const sent = messagesThisCycle(c)
  const from = secondMessageFrom(c)
  // A first message names a day and the send put a visit in the diary for it: the card says the day back, so the owner
  // can see the offer landed in the diary without opening it. The day is not agreed yet (the line already says asked).
  if (sent > 0) {
    card.append(el('p', { class: 'rebook-sent-line' }, sent === 1
      ? `First message sent ${shortDate(c.rebook_messaged_on!)}${stage === 'waiting' && from ? ` · second message from ${shortDate(from)}` : ''}`
      : `Messaged twice · last ${shortDate(c.rebook_messaged_on!)} · no reply`))
    const visitLine = c.next_booked && c.next_booked_confirmed === 0 ? nextVisitLine(c, today) : null
    if (visitLine) card.append(el('p', { class: 'rebook-sent-line' }, visitLine))
  }

  // Which day of the round to offer them. Only on the first message: the
  // second one is the "coming off the list" note and offers nothing. Someone
  // away eight months or more is asked whether they want to start again at
  // all, so there is no day in their message and no day to pick — a picker
  // above wording that never names a day is a control that does nothing.
  const moved = movedVisits.get(c.id)
  if (moved) {
    const words = visitWords({ ...moved, state: 'booked' }, c, today)
    card.append(whyTile('calendarMove', `Visit moved to ${dayLabel(moved.date)}${shownVisitTime(moved) ? `, ${shownVisitTime(moved)}` : ''}`, words.text))
  }
  // The missed visit says itself above the days (item B; design B's amber tile): what was booked and didn't happen, so
  // the wording's day has a visible reason. Gone once the visit moves (the count drops to zero on reload).
  const missedTile = missedVisit(c) && c.missed_visit_date
    ? whyTile('calendarCross', `Was due ${shortDate(c.missed_visit_date)}, never got done`, stage === 'to_message' && !isAway(c, today) && !moved ? 'Pick a new day to offer them below' : undefined)
    : null
  if (missedTile) card.append(missedTile)
  if (stage === 'to_message' && !isAway(c, today) && !moved) {
    const before = card.children.length
    appendPlanningNote(card, c, today)
    // A planning note already says to choose below: the tile's own line would say it twice.
    if (missedTile && card.children.length > before) missedTile.querySelector('.rebook-why-words > span')?.remove()
    card.append(offerPicker(c, today, rerender))
  }
  if (stage === 'to_message' && isAway(c, today) && !moved) {
    card.append(el('p', { class: 'muted rebook-away-note' }, `Away since ${c.last_clean ? shortDate(c.last_clean) : 'a long time'}, so this one asks if they want to start again rather than offering a day.`))
  }

  // Messaged twice, no reply: the final message (Liam, 26 Oct 2026). Sending it, or saying it went some other way,
  // takes them off the round; "Take off quietly" does the same with no message.
  if (stage === 'no_reply') {
    const words = finalMessage(c.name, c.last_clean, c.job_name)
    const first = firstName(c.name) || c.name
    const preview = el('div', { class: 'rebook-preview' })
    const label = el('div', { class: 'rebook-preview-head' })
    label.append(el('span', { class: 'rebook-fact-label' }, `What ${first} gets`))
    label.append(previewTools(copyMessageButton(words, c.name), wordingLink('rebook_final')))
    preview.append(label, el('p', { class: 'rebook-preview-text' }, words))
    card.append(preview)
    card.append(el('p', { class: 'rebook-final-note' }, `Sending it moves ${first} to `, el('strong', {}, 'Taken off'), ': nothing more goes to them. If they reply, tap their name to put them back on the round.'))
  }

  if (stage !== 'no_reply') {
    const words = messageFor(c, stage, today)
    const preview = el('div', { class: 'rebook-preview' })
    const label = el('div', { class: 'rebook-preview-head' })
    label.append(el('span', { class: 'rebook-fact-label' }, stage === 'to_message' ? 'Message to send' : stage === 'waiting' && from ? `Second message · from ${shortDate(from)}` : 'Second message'))
    label.append(previewTools(copyMessageButton(words, c.name), wordingLink(messageKeyFor(c, stage, today))))
    preview.append(label)
    preview.append(el('p', { class: 'rebook-preview-text' }, words))
    card.append(preview)
  }

  const actions = el('div', { class: 'rebook-card-actions' })
  // Several jobs: the other jobs this one message is about, and each one's count goes up with the send.
  const merged = stage === 'to_message' ? mergedJobs.get(c.id) ?? [] : []
  if (merged.length) {
    card.insertBefore(el('p', { class: 'rebook-sent-line' }, `Also due: ${merged.map((d) => `${d.job.name}${d.job.price_pence !== null ? ` · ${money(d.job.price_pence)}` : ''}${d.due ? ` (due ${shortDate(d.due)})` : ''}`).join(', ')}. One message covers both jobs, with ${merged.map((d) => d.job.name.toLowerCase()).join(' and ')} first when booked together.`), card.querySelector('.rebook-preview'))
  }
  const sendAll = (way?: CustomerMessageBy): void => sendJobsMessage(c, true, merged, stage, card, way ?? wayFor(c))
  if (stage === 'to_message' || stage === 'second') {
    // Their way, else the round's usual (contact.ts); the ▾ beside it changes it for this customer.
    const control = sendControl(c, messageFor(c, stage, today), `Your next visit from ${businessSettings().business_name}`, {
      label: (way) => (stage === 'second' ? 'Send second message' : wayWords(way).button),
      className: `btn-whatsapp rebook-send${stage === 'second' ? ' rebook-send-second' : ''}`,
      onSend: (way) => (merged.length ? sendAll(way) : recordMessage(c, stage, card, way)),
      changed: () => void load(),
      onConflict: () => void load(),
    })
    actions.append(control.root)
    // Offered with or without a link: a message sent some other way still needs counting here.
    actions.append(alreadySentButton(c.name, () => (merged.length ? sendAll() : recordMessage(c, stage, card))))
  } else if (stage === 'waiting' && from) {
    const wait = el('button', { type: 'button', class: 'btn-waiting', disabled: 'disabled', title: `Give them ${SECOND_MESSAGE_AFTER_DAYS} days to reply. The second message unlocks on ${shortDate(from)}.` }, `Waiting · second message from ${shortDate(from)}`)
    actions.append(wait)
    // A message about their other jobs too goes back whole, and says so.
    const together = severalJobsOn() ? recordFor(c.id, c.rebook_messaged_on ?? null) : null
    const names = together?.main ? together.jobs.map((id) => roundJobs().find((j) => j.id === id)?.name.toLowerCase()).filter(Boolean) : []
    const didnt = el('button', { type: 'button', class: 'link-button rebook-didnt-send' }, names.length ? `Didn't send it? Put them back (the ${names.join(' and ')} too)` : "Didn't send it? Put them back")
    didnt.addEventListener('click', () => { didnt.disabled = true; uncountMessage(c) })
    actions.append(didnt)
  } else if (stage === 'no_reply') {
    const control = sendControl(c, finalMessage(c.name, c.last_clean, c.job_name), `From ${businessSettings().business_name}`, {
      label: () => 'Send final message',
      className: 'btn-whatsapp rebook-send rebook-send-final',
      onSend: () => void takeOffAfterFinal(c, false),
      changed: () => void load(),
      onConflict: () => void load(),
    })
    actions.append(control.root)
    const mine = actionTile(el('button', { type: 'button', class: 'btn-secondary rebook-final-mine', 'aria-label': `I sent ${c.name} the final message myself` }), 'tick', 'I sent it myself', 'Taken off, counted')
    mine.addEventListener('click', () => void takeOffAfterFinal(c, false, mine))
    const quiet = actionTile(el('button', { type: 'button', class: 'btn-secondary rebook-final-quiet', 'aria-label': `Take ${c.name} off the round with no message` }), 'personOff', 'Take off quietly', 'No message')
    quiet.addEventListener('click', () => void takeOffAfterFinal(c, true, quiet))
    actions.append(el('div', { class: 'rebook-final-tiles' }, mine, quiet))
  }
  const row = el('div', { class: 'rebook-card-row' })
  const book = actionTile(el('button', { type: 'button', class: 'btn-secondary', 'aria-label': `Book visit for ${c.name}` }), 'calendarPlus', 'Book visit', 'Put a day in')
  book.addEventListener('click', () => openBooking({ customerId: c.id }))
  row.append(book)
  row.append(callTile(c.phone))
  if (stage !== 'no_reply' && sent >= 1) {
    // Off the list early: a dead number or a "not interested" heard elsewhere.
    const off = lapseButton(c, false)
    row.append(off.tagName === 'BUTTON' ? actionTile(off, 'personOff', 'Mark as lapsed', 'Off the list for now') : off)
  }
  actions.append(row)
  card.append(actions)
  // The quiet-down: its own block under the action row (the row's grid is
  // three cells and stays Book · Call · Not now). Only on the first-message
  // cards — the overdue and coming-up groups; the waiting / second / take-off
  // stages have their own answers.
  if (stage === 'to_message') {
    const chooser = notNowChooser(c, today)
    const notNow = actionTile(el('button', { type: 'button', class: 'btn-secondary rebook-notnow', 'aria-label': `Not now, ask ${c.name} again later` }), 'hourglass', 'Not now', 'Ask again later')
    notNow.addEventListener('click', () => { chooser.hidden = !chooser.hidden })
    row.append(notNow)
    card.append(chooser)
  }
  return card
}

// ---- several jobs: an extra job's own row (PLAN 4a) ---------------------------------------------------------

// The customer behind a job row, as Messages last read them.
function customerOf(d: JobDue): RoundCustomer | undefined {
  return list?.find((c) => c.id === d.job.customer_id)
}

// The day this job's message offers: a date already written in the diary for it, else for gutters the windows'
// booked day when it is within a fortnight (never after it), else the day picked here, else the round's pick.
function windowsNextOf(d: JobDue): string | null {
  const c = customerOf(d)
  return c && !c.job_stopped_on && !plannedWeekOf(c) && c.next_booked_source !== 'suggested' && c.next_booked_source !== 'tentative' ? c.next_booked ?? null : null
}

function jobOfferFor(d: JobDue, today: string): string {
  const clash = plannedAfterWindows(d, windowsNextOf(d), today)
  // Kept on a day after the windows: no day is offered at all (Astra r2, finding 7).
  if (clash) return plannedChoice.get(d.job.id) === 'move' && roundDays.some(r => r.date === clash.to) ? clash.to : ''
  const chosen = jobOffers.get(d.job.id)
  if (chosen !== undefined) return chosen
  const choices = jobDateChoices(d, today)
  const candidate = jobOfferDay(d, windowsNextOf(d), suggestedWorkingDate(d.entry, today), today)
  if (choices.some(r => r.date === candidate)) return candidate
  const week = plannedWeekOf(d.entry)
  const eligible = roundDays.filter(r => choices.some(c => c.date === r.date) && (!week || r.date >= week && r.date <= addDaysISO(week, 6)))
  return defaultOfferDate(d.entry, eligible, today)
}

function jobMessageFor(d: JobDue, stage: RebookStage, today: string): string {
  const word = jobMessageWord(d.job)
  if (stage !== 'to_message') return secondJobMessage(d.entry.name, word)
  const dates = jobDates(d, today)
  const offer = dates[0] || null
  if (d.group === 'coming_up') return rebookMessage({ name: d.entry.name, kind: 'upcoming', lastClean: d.entry.last_clean, due: d.due, offer, offers: dates, jobs: [word] })
  const kind = firstMessageKind(overdueDays(d.entry, today), d.cold, false)
  return rebookMessage({ name: d.entry.name, kind, lastClean: d.entry.last_clean, due: d.due, offer, offers: dates, jobs: [word] })
}

// These aggregates describe the same id/version being moved. Older cached
// payloads may lack the agreement fields; never invent them from a date/time.
function messageMoveBefore(c: RoundCustomer, missed: boolean): Record<string, unknown> {
  const date = missed ? c.missed_visit_date : c.next_booked
  const confirmed = missed ? c.missed_visit_confirmed : c.next_booked_confirmed
  const slot = missed ? c.missed_visit_time_slot : c.next_booked_time_slot
  const key = missed ? c.missed_visit_time_agreed_for : c.next_booked_time_agreed_for
  return { date,
    ...(confirmed === 0 || confirmed === 1 ? { confirmed } : {}),
    ...(slot !== undefined ? { time_slot: slot } : {}),
    ...(key !== undefined ? { time_agreed_for: confirmed === 1 && slot?.trim() && key === `${date}|${slot.trim()}` ? key : null } : {}),
  }
}

// One message about a customer's jobs (several jobs; Astra r1 finding 8, r2 findings 1 and 2): their extra jobs
// in `jobs`, and their main job too when `main` (one message naming both). Every save it makes is kept on one record
// (src/message-records.ts): each job's count, the customer's last-contacted day and note line, and the visit each
// FIRST message pencils in (or the missed visit it moves, or the gutters it moves onto the windows day with the
// owner's yes). One Undo bar reverses all of it, and so does "Didn't send it" later, however the saves went (now or
// from the queue, even after a reload).
// opts, for the Diary's "ask about a day" (askAboutDay below): the one day to offer, a fresh first ask, the visit
// already placed by the Diary (so nothing is booked or moved here), and how to refresh instead of drawing Messages.
// placement: the visit the Diary placed (its row as saved), so the message's Undo takes it back off too; alsoUndo: the
// Diary's own take-off, for a caller that does not say which visit it placed.
// missed: a visit that couldn't be done and was just moved (docs/plans/rearrange/PLAN.md): every visit moved with it joins
// the record (placements), and the note says what happened.
interface SendOpts { offerDates?: string[]; freshAsk?: boolean; visitPlaced?: boolean; reload?: () => void; placement?: Placement; placements?: Placement[]; alsoUndo?: () => void; missedFrom?: string }
export type Placement = { kind: 'pencil'; id: number; version: number; before?: undefined } | { kind: 'move'; id: number; version: number; before: Record<string, unknown> }
function sendJobsMessage(c: RoundCustomer, main: boolean, jobs: JobDue[], stage: RebookStage, card: HTMLElement | undefined, way: CustomerMessageBy, opts: SendOpts = {}): void {
  const today = todayISO()
  const reload = opts.reload ?? ((): void => { void load() })
  const rec = startRecord(c.id, today, jobs.map((d) => d.job.id), main)
  const noun = wayWords(way).noun
  // The visit moved message starts a fresh ask about the new day: it counts as their first message.
  const moved = main ? movedVisits.get(c.id) : undefined
  const n1 = moved || opts.freshAsk ? 1 : messagesThisCycle(c) + queuedTaps(`/api/customers/${c.id}`, 'rebook_messages') + 1
  const words = [...jobs.map((d) => jobMessageWord(d.job)), ...(main ? [(c.job_name?.trim() || 'windows').toLowerCase()] : [])]
  const lines = [
    ...(main ? [messageNoteLine(noteDate(today), n1, noteWord(way))] : []),
    ...jobs.map((d) => `${noteDate(today)}: ${jobMessageWord(d.job)} message ${noteWord(way)} ${messagesThisCycle(d.entry) + 1}`),
  ]
  const dates = opts.offerDates ?? (moved ? [] : stage === 'to_message' ? main ? customerDates(c, today) : jobs[0] ? jobDates(jobs[0], today) : [] : [])
  if (moved?.moved_from) lines.push(`${noteDate(today)}: visit moved from ${noteDate(moved.moved_from)} to ${noteDate(moved.date)}; asked if it suits`)
  if (opts.missedFrom && dates[0]) lines.push(`${noteDate(today)}: couldn't do ${noteDate(opts.missedFrom)}; moved to ${noteDate(dates[0])}; asked if it suits`)
  if (dates.length > 1) lines.push(`${noteDate(today)}: offered ${dates.join(' or ')}; awaiting their choice`)
  else if (dates.length === 1) lines.push(`${noteDate(today)}: offered ${dates[0]}; awaiting their reply`)
  const note = lines.reduce((acc, line) => appendNote(acc, line), c.contact_note ?? '')
  const body: Record<string, unknown> = { version: c.version, last_contacted_on: today, ...(c.follow_up_on && c.follow_up_on <= today ? {follow_up_on:null} : {}), ...(main ? { rebook_messages: n1, rebook_messaged_on: today } : {}) }
  if (note !== (c.contact_note ?? '')) body.contact_note = note
  const before = { message_record_id: c.message_record_id ?? null, ...(c.follow_up_on && c.follow_up_on <= today ? {follow_up_on:c.follow_up_on} : {}), last_contacted_on: c.last_contacted_on ?? null, contact_note: c.contact_note ?? null, ...(main ? { rebook_messages: c.rebook_messages ?? 0, rebook_messaged_on: c.rebook_messaged_on ?? null } : {}) }
  let slid = false
  const leave = (): void => {
    if (slid) return
    slid = true
    if (card?.isConnected) {
      const gen = routeGen
      card.inert = true
      void animateMessageDeparture(card).then(() => { if (gen === routeGen) reload() })
    } else reload()
  }
  const counts: Promise<Ack>[] = [tracked(rec, 'count', before, { label: `${wayWords(way).short}: ${c.name} (${words.join(' and ')})`, method: 'PATCH', path: `/api/customers/${c.id}`, body, onAck: (ack) => { alert4xx(ack); if (ack.ok) leave(); else reload() }, onConflict: () => reload() })]
  for (const d of jobs) {
    const j = d.job
    // A fresh ask (a missed visit's jobs moved with it) starts each job's count again too, as the main one's (GPT-6.1).
    const jn = opts.freshAsk ? 1 : messagesThisCycle(d.entry) + queuedTaps(`/api/customer-jobs/${j.id}`, 'rebook_messages') + 1
    counts.push(tracked(rec, 'count', { message_record_id: j.message_record_id ?? null, rebook_messages: j.rebook_messages ?? 0, rebook_messaged_on: j.rebook_messaged_on ?? null }, {
      label: `${wayWords(way).short} ${opts.freshAsk ? 1 : messagesThisCycle(d.entry) + 1}: ${c.name} (${j.name})`,
      method: 'PATCH',
      path: `/api/customer-jobs/${j.id}`,
      body: { version: j.version, rebook_messages: jn, rebook_messaged_on: today },
      onAck: (ack) => alert4xx(ack),
      onConflict: () => reload(),
    }))
  }
  // A visit the Diary put on the day just before this message (To place, then the Ask pop-up): it joins the record,
  // so this message's Undo, or "Didn't send it" later, takes it back off too (bug hunt 8 Oct 2026, server-data #9).
  for (const p of [...(opts.placement ? [opts.placement] : []), ...(opts.placements ?? [])]) addPlaced(rec, p.kind, p.id, p.version, p.before ?? null)
  const visitSaves = (): void => {
    if (stage !== 'to_message' || opts.visitPlaced) return
    // The day this message offers: the main job's (combined sends are only made when both go on it), else the job's.
    const offer = dates.length === 1 ? dates[0]! : null
    if (main) {
      const missed = missedVisit(c) && typeof c.missed_visit_id === 'number' && typeof c.missed_visit_version === 'number' ? { id: c.missed_visit_id, version: c.missed_visit_version, date: c.missed_visit_date ?? null } : null
      const canPencil = !c.next_booked && (!missedVisit(c) || missed !== null) && !isAway(c, today)
      // Already in the diary on another day, not agreed (a pencil, a week, or Roundly's suggestion): the one day this
      // message offers is where the visit goes, so the Diary shows the day the customer was offered (Diary and
      // Messages together, Release 2, 8 Oct 2026). Undo and "Didn't send it" put it back. Several days offered leave it.
      // A week with no day chosen is moved even when the day offered is that week's Monday (the date it carries): it
      // then has its day (found fixing bug hunt server-data #4, 8 Oct 2026).
      const pencilled = !!offer && !!c.next_booked && (c.next_booked !== offer || plannedWeekOf(c) !== null) && c.next_booked_confirmed === 0 && c.next_booked_source !== 'tentative'
        && typeof c.next_booked_id === 'number' && typeof c.next_booked_version === 'number' && !isAway(c, today)
      if (pencilled) void tracked(rec, 'move', messageMoveBefore(c, false), { label: `Move visit: ${c.name} to ${shortDate(offer!)}`, method: 'PATCH', path: `/api/cleans/${c.next_booked_id}`, body: { version: c.next_booked_version, date: offer, adopt_booking: true } })
      else if (offer && canPencil && missed) void tracked(rec, 'move', messageMoveBefore(c, true), { label: `Move missed visit: ${c.name} to ${shortDate(offer)}`, method: 'PATCH', path: `/api/cleans/${missed.id}`, body: { version: missed.version, date: offer, adopt_booking: true } })
      else if (offer && canPencil) void tracked(rec, 'pencil', null, { label: `Pencil ${shortDate(offer)}: ${c.name}`, method: 'POST', path: `/api/customers/${c.id}/cleans`, body: { date: offer, ...(c.reg_price_pence !== null && c.reg_price_pence !== undefined ? { amount_pence: c.reg_price_pence } : {}), state: 'booked', allow_additional: false } })
    }
    for (const d of jobs) {
      const j = d.job
      const e = d.entry
      // Gutters planned after the windows day, and the owner said yes to moving them onto it with this message.
      const clash = plannedAfterWindows(d, windowsNextOf(d), today)
      if (clash && plannedChoice.get(j.id) === 'move' && typeof e.next_booked_id === 'number' && typeof e.next_booked_version === 'number') {
        void tracked(rec, 'move', messageMoveBefore(e, false), { label: `Move ${j.name}: ${e.name} to ${shortDate(clash.to)}`, method: 'PATCH', path: `/api/cleans/${e.next_booked_id}`, body: { version: e.next_booked_version, date: clash.to, adopt_booking: true } })
        continue
      }
      const missed = missedVisit(e) && typeof e.missed_visit_id === 'number' && typeof e.missed_visit_version === 'number' ? { id: e.missed_visit_id, version: e.missed_visit_version, date: e.missed_visit_date ?? null } : null
      const canPencil = !e.next_booked && (!missedVisit(e) || missed !== null)
      const day = offer
      if (!canPencil || !day) continue
      if (missed) void tracked(rec, 'move', messageMoveBefore(e, true), { label: `Move missed visit: ${e.name} ${j.name} to ${shortDate(day)}`, method: 'PATCH', path: `/api/cleans/${missed.id}`, body: { version: missed.version, date: day, adopt_booking: true } })
      else void tracked(rec, 'pencil', null, { label: `Pencil ${shortDate(day)}: ${e.name} ${j.name}`, method: 'POST', path: `/api/customers/${e.id}/cleans`, body: { date: day, job_id: j.id, kind: j.kind, ...(j.price_pence !== null ? { amount_pence: j.price_pence } : {}), state: 'booked', allow_additional: false } })
    }
  }
  // ONE Undo for the whole message.
  const counted = `Counted ${noun === 'email' ? 'an' : 'a'} ${noun} to ${c.name} about the ${words.join(' and ')}`
  let undone = false
  offerUndo(counted, () => {
    if (undone) return
    undone = true
    focusRestoreId = main ? `c${c.id}` : jobs[0] ? `j${jobs[0].job.id}` : null
    const gen = routeGen
    void reverseRecord(rec).then(() => { if (gen === routeGen) reload() })
    // Before the record knew about it (an older Diary): the Diary's own take-off.
    if (!opts.placement && !opts.placements?.length) opts.alsoUndo?.()
    reload()
  })
  // The visit is booked or moved only once the count is saved, or waiting for signal (it then goes in order behind it).
  // A count refused because the customer changed on another phone books nothing, takes back what did save, and says so
  // instead of "Counted" (bug hunt 8 Oct 2026, server-data #8).
  void Promise.all(counts).then((acks) => {
    if (undone) return
    if (acks.every((a) => a.ok || a.status === 0)) { visitSaves(); return }
    undone = true
    void reverseRecord(rec)
    if (document.querySelector('#undo-bar')?.querySelector('.undo-text')?.textContent === roundConfirmation(counted)) dismissUndo()
    if (acks.some((a) => a.status === 409)) toast(`${c.name} was changed on another phone or computer, so this message was not counted and no visit was booked. Check them, then send again.`)
    reload()
  })
}

// "Didn't send it" for a kept message: the whole of it, at the rows' versions as this screen has them now.
// Its visits are read afresh: one agreed, done or changed since is left where it is, as the main job's own put-back
// always has.
function putBackRecord(c: RoundCustomer, rec: MessageRecord): void {
  const versions = new Map<string, number>([[`/api/customers/${c.id}`, c.version]])
  for (const id of rec.jobs) {
    const j = roundJobs().find((x) => x.id === id)
    if (j) versions.set(`/api/customer-jobs/${id}`, j.version)
  }
  void (async () => {
    try {
      const detail = await api<{ customer: RoundCustomer; cleans: Clean[]; jobs: import('../jobs').CustomerJob[] }>(`/api/customers/${c.id}`)
      const visits = detail.cleans
      for (const e of rec.effects.filter(e => e.kind === 'count')) {
        const current = e.path === `/api/customers/${c.id}` ? detail.customer : detail.jobs.find(j => e.path === `/api/customer-jobs/${j.id}`)
        if (!current || current.version !== e.version) { toast('This conversation changed after the message. Nothing was put back. Review the customer before undoing it.'); return }
        versions.set(e.path,current.version)
      }
      for (const e of rec.effects) {
        if (e.kind === 'count' || e.id === null) continue
        const v = visits.find((x) => x.id === e.id)
        const untouched = v && v.state === 'booked' && !v.confirmed && v.version === e.version
        versions.set(e.path, untouched ? v.version : -1)
        if (!untouched) toast('An edited or agreed visit was kept in the diary.')
      }
    } catch {
      toast(`Couldn't check ${c.name}'s latest conversation. Nothing was put back. Try again when connected.`)
      return
    }
    const gen = routeGen
    // Says what was put back (bug hunt 8 Oct 2026, messages #4). A message that only counted (several days offered,
    // nothing in the diary) gets Undo: the count, note and dates as they were a moment ago. One that booked or moved a
    // visit says the diary is as it was; it is not re-booked by an Undo, which could not put the same visit back.
    const counts = rec.effects.filter((e) => e.kind === 'count')
    const visitsTouched = rec.effects.some((e) => e.kind !== 'count' && e.id !== null && versions.get(e.path) !== -1)
    const mainCount = counts.find((e) => e.path === `/api/customers/${c.id}`)
    const now = list?.find((x) => x.id === c.id) ?? c
    void reverseRecord(rec, versions).then(() => { if (gen === routeGen) void load() })
    void load()
    if (visitsTouched || counts.length !== 1 || !mainCount?.before) { toast(`Put back: ${c.name}'s message is no longer counted${visitsTouched ? ' and the diary is as it was' : ''}.`); return }
    const again: Record<string, unknown> = {}
    for (const k of Object.keys(mainCount.before)) again[k] = (now as unknown as Record<string, unknown>)[k] ?? null
    const version = (versions.get(mainCount.path) ?? c.version) + 1
    offerUndo(`Put back: ${c.name}'s message is no longer counted`, () => {
      void mutate({ label: `Undo put back: ${c.name}`, method: 'PATCH', path: mainCount.path, body: { version, ...again },
        onAck: (back) => { if (!back.ok && back.status >= 400 && back.status < 500) window.alert(`Undo was refused: ${back.error ?? 'rejected'}`); void load() }, onConflict: () => void load() })
    })
  })()
}

// "Didn't send it? Put them back", for a job: reverse the proven send effects.
// Legacy sends without provenance correct only the count and keep every visit.
async function uncountJobMessage(d: JobDue): Promise<void> {
  const j = d.job
  // A message this phone kept: the whole of it goes back, nothing else (finding 8; r2 findings 1, 2).
  let kept = recordFor(j.customer_id, j.rebook_messaged_on ?? null)
  if (j.message_record_id && kept?.id !== j.message_record_id) kept = null
  if (!kept && j.message_record_id) { try { kept = (await api<{record: MessageRecord | null}>(`/api/customers/${j.customer_id}/message-record?job=${j.id}`)).record } catch { toast("Could not check this message. Try again when connected."); return } }
  const customer = customerOf(d)
  if (kept?.jobs.includes(j.id) && customer) return putBackRecord(customer, kept)
  const n = Math.max(0, messagesThisCycle(d.entry) - 1)
  void mutate({
    label: `Didn't send: ${d.entry.name} (${j.name})`,
    method: 'PATCH',
    path: `/api/customer-jobs/${j.id}`,
    body: { version: j.version, rebook_messages: n, rebook_messaged_on: n ? j.rebook_messaged_on ?? null : null },
    onAck: (ack) => { alert4xx(ack); void load() },
    onConflict: () => void load(),
  })
  toast('Message count put back. No linked visit could be verified; existing diary visits were kept.')
}

function jobTile(d: JobDue, stage: RebookStage, today: string, rerender: () => void): HTMLElement {
  const e = d.entry
  const tile = el('button', { type: 'button', class: `rebook-tile rebook-tile-${stage}`, 'aria-expanded': 'false', 'aria-label': `Open ${e.name}, ${d.job.name}` })
  const nameRow = el('span', { class: 'rebook-tile-namewrap' })
  nameRow.append(el('span', { class: 'rebook-tile-name' }, e.name), el('span', { class: 'rebook-tile-tag' }, d.job.name))
  tile.append(nameRow)
  const bits = [d.job.price_pence !== null ? money(d.job.price_pence) : '', streetShort(e.address)].filter(Boolean).join(' · ')
  if (bits) tile.append(el('span', { class: 'rebook-tile-meta' }, bits))
  const line = stage === 'to_message'
    ? d.planned ? `visit ${shortDate(d.planned)} · Not asked yet` : plannedWeekOf(e) ? `week of ${shortDate(plannedWeekOf(e)!)}, day not chosen` : d.group === 'coming_up' && d.due ? `due ${shortDate(d.due)}` : overdueWords(e, today)
    : stage === 'waiting' ? `Messaged ${shortDate(e.rebook_messaged_on ?? '')}` : stage === 'second' ? `Messaged ${shortDate(e.rebook_messaged_on ?? '')} · no reply yet` : `Messaged twice · last ${shortDate(e.rebook_messaged_on ?? '')}`
  tile.append(el('span', { class: 'rebook-tile-line' }, line))
  tile.addEventListener('click', () => { openRow(`j${d.job.id}`); rerender() })
  return tile
}

function jobCard(d: JobDue, stage: RebookStage, today: string, rerender: () => void): HTMLElement {
  const e = d.entry
  const c = customerOf(d) ?? e
  const card = el('div', { class: `rebook-card rebook-card-${stage}` })
  const top = el('div', { class: 'rebook-card-top' })
  const who = el('div', { class: 'rebook-card-who' })
  who.append(el('a', { href: `#/customer/${e.id}`, class: 'rebook-card-name' }, `${e.name} · ${d.job.name}`))
  who.append(el('span', { class: 'sched-addr' }, addressLine(e)))
  top.append(who)
  top.append(stage === 'to_message' && (d.planned || d.group === 'coming_up')
    ? el('span', { class: 'rebook-pill rebook-pill-soon' }, d.planned ? `visit ${shortDate(d.planned)}` : plannedWeekOf(e) ? `week of ${shortDate(plannedWeekOf(e)!)}` : `due ${shortDate(d.due ?? today)}`)
    : el('span', { class: `rebook-pill ${d.cold ? 'rebook-pill-cold' : 'rebook-pill-late'}` }, overdueWords(e, today)))
  card.append(top)
  const facts = el('div', { class: 'rebook-facts' })
  const fact = (label: string, value: string): HTMLElement => el('div', { class: 'rebook-fact' }, el('span', { class: 'rebook-fact-label' }, label), el('span', { class: 'rebook-fact-value' }, value))
  facts.append(fact('Price', d.job.price_pence !== null ? money(d.job.price_pence) : 'Not set'), fact('Every', everyWords(d.job.cycle_days) ?? 'Not set'), fact('Last visit', e.last_clean ? shortDate(e.last_clean) : 'none'))
  card.append(facts)
  const sent = messagesThisCycle(e)
  const from = secondMessageFrom(e)
  if (sent > 0) card.append(el('p', { class: 'rebook-sent-line' }, sent === 1 ? `First message sent ${shortDate(e.rebook_messaged_on ?? '')}${stage === 'waiting' && from ? ` · second message from ${shortDate(from)}` : ''}` : `Messaged twice · last ${shortDate(e.rebook_messaged_on ?? '')} · no reply`))
  const clash = stage === 'to_message' ? plannedAfterWindows(d, windowsNextOf(d), today) : null
  if (clash) {
    // Liam's rule: gutters on the windows day or the day before, never after. The planned day is after, so the
    // owner says which: nothing is moved, and nothing is sent, until they do.
    const ask = el('fieldset', { class: 'rebook-offer rebook-move-ask' }, el('legend', {}, `The ${d.job.name.toLowerCase()} are in the diary for ${shortDate(clash.from)}, after the windows on ${shortDate(clash.to)}. Gutters go on the windows day or the day before.`))
    for (const [value, words] of [['move', `Move them to ${shortDate(clash.to)}, the windows day, and offer that`], ['keep', `Keep them on ${shortDate(clash.from)}`]] as const) {
      const radio = el('input', { type: 'radio', name: `move-${d.job.id}`, value }) as HTMLInputElement
      radio.checked = plannedChoice.get(d.job.id) === value
      if (value === 'move' && !roundDays.some(r => r.date === clash.to)) radio.disabled = true
      radio.addEventListener('change', () => { plannedChoice.set(d.job.id, value); rerender() })
      ask.append(el('label', { class: 'check-label' }, radio, el('span', {}, words)))
    }
    // A one-person round adds the day in My working days, never the diary (Liam, 19 Oct 2026).
    if (!roundDays.some(r => r.date === clash.to)) ask.append(...(worksAlone()
      ? [el('p', {}, 'Make the windows date one of your working days before offering it.'), el('a', { href: '#/my-days', class: 'btn-secondary messages-open-diary' }, 'My working days →')]
      : [el('p', {}, 'Set a working day for the windows date before offering it.'), el('a', { href: '#/schedule', class: 'btn-secondary messages-open-diary' }, 'Open diary →')]))
    card.append(ask)
  } else if (stage === 'to_message') {
    appendPlanningNote(card, d.entry, today)
    const box = el('div', { class: 'rebook-offer' }, el('span', { class: 'rebook-fact-label' }, 'Day to offer'))
    const upcoming = roundDays.filter((r) => r.date >= today)
    const pick = el('select', { class: 'rebook-offer-select', 'aria-label': `Day to offer ${e.name} for the ${d.job.name.toLowerCase()}` })
    pick.append(el('option', { value: '' }, 'No day yet · type it yourself'))
    const chosen = jobOfferFor(d, today)
    // Never a day after the windows for gutters (Liam Q11).
    const windowsNext = d.job.kind === 'gutter' ? windowsNextOf(d) : null
    const days = [...new Set([...upcoming.map((r) => r.date)])].filter((day) => !windowsNext || !guttersAfterWindows(day, windowsNext)).sort()
    for (const day of days) {
      const r = upcoming.find((x) => x.date === day)
      pick.append(el('option', { value: day }, r ? offerLabel(r, shortDate, !worksAlone()) : `${shortDate(day)} · the windows day`))
    }
    pick.value = chosen
    pick.addEventListener('change', () => { jobOffers.set(d.job.id, pick.value); multipleOffers.set(`j${d.job.id}`, pick.value ? [pick.value] : []); rerender() })
    if (days.length) box.append(pick)
    else box.querySelector('.rebook-fact-label')?.remove()
    if (quickJob(d, today) && days.length) {
      pick.hidden = true
      box.querySelector('.rebook-fact-label')?.remove()
      box.append(quickDatePicker(jobDateChoices(d, today), jobDates(d, today), (dates) => {
        multipleOffers.set(`j${d.job.id}`, dates); jobOffers.set(d.job.id, dates[0] ?? '')
        refreshDateMessage(card, c, stage, today, d)
      }))
    }
    const notice = workingDaysNotice(days.length, today, { onDay: (day) => { jobOffers.set(d.job.id, day); multipleOffers.set(`j${d.job.id}`, [day]) } })
    if (notice) box.append(notice)
    const windows = windowsNextOf(d)
    if (d.job.kind === 'gutter' && windows && chosen === windows) box.append(el('p', { class: 'muted rebook-offer-area' }, `The windows are in the diary for ${shortDate(windows)}; offer the gutters that day, first.`))
    card.append(box)
  }
  if (missedVisit(e) && e.missed_visit_date) card.append(whyTile('calendarCross', `Was due ${shortDate(e.missed_visit_date)}, never got done`))
  // Kept after the windows (Astra r2, finding 7): the booking stays, but no message offers that day.
  const keptAfter = !!clash && plannedChoice.get(d.job.id) === 'keep'
  if (stage !== 'no_reply' && !keptAfter) {
    const words = jobMessageFor(d, stage, today)
    const preview = el('div', { class: 'rebook-preview' })
    const label = el('div', { class: 'rebook-preview-head' })
    label.append(el('span', { class: 'rebook-fact-label' }, stage === 'to_message' ? 'Message to send' : 'Second message'), copyMessageButton(words, e.name))
    preview.append(label, el('p', { class: 'rebook-preview-text' }, words))
    card.append(preview)
  }
  const actions = el('div', { class: 'rebook-card-actions' })
  if (clash && !plannedChoice.has(d.job.id)) {
    actions.append(el('p', { class: 'muted' }, 'Choose above first: move them to the windows day, or keep them.'))
  } else if (keptAfter) {
    actions.append(el('p', { class: 'muted rebook-kept-after' }, `The ${d.job.name.toLowerCase()} stay on ${shortDate(clash!.from)}. Roundly won't offer gutters after the windows, so there is no message to send for that day. Talk to them yourself, or move them to ${shortDate(clash!.to)} above.`))
  } else if (stage === 'to_message' || stage === 'second') {
    const control = sendControl(c, jobMessageFor(d, stage, today), `Your next visit from ${businessSettings().business_name}`, {
      label: (way) => (stage === 'second' ? 'Send second message' : wayWords(way).button),
      className: `btn-whatsapp rebook-send${stage === 'second' ? ' rebook-send-second' : ''}`,
      onSend: (way) => { const cu = customerOf(d); if (cu) sendJobsMessage(cu, false, [d], stage, card, way) },
      changed: () => void load(),
      onConflict: () => void load(),
    })
    actions.append(control.root, alreadySentButton(e.name, () => { const cu = customerOf(d); if (cu) sendJobsMessage(cu, false, [d], stage, card, wayFor(c)) }))
  } else if (stage === 'waiting') {
    actions.append(el('button', { type: 'button', class: 'btn-waiting', disabled: 'disabled' }, from ? `Waiting · second message from ${shortDate(from)}` : 'Waiting for a reply'))
    const didnt = el('button', { type: 'button', class: 'link-button rebook-didnt-send' }, "Didn't send it? Put them back")
    didnt.addEventListener('click', () => { didnt.disabled = true; uncountJobMessage(d) })
    actions.append(didnt)
  } else {
    actions.append(el('p', { class: 'muted' }, `Messaged twice about the ${d.job.name.toLowerCase()} with no reply. If they don't want them any more, stop the ${d.job.name.toLowerCase()} on their page. They stay a customer.`))
  }
  const row = el('div', { class: 'rebook-card-row' })
  const book = actionTile(el('button', { type: 'button', class: 'btn-secondary', 'aria-label': `Book ${d.job.name} for ${e.name}` }), 'calendarPlus', 'Book visit', 'Put a day in')
  book.addEventListener('click', () => openBooking({ customerId: e.id, jobId: d.job.id }))
  row.append(book, callTile(e.phone))
  row.append(actionTile(el('a', { href: `#/customer/${e.id}`, class: 'btn-secondary' }), 'person', 'Their page', 'Visits, notes and money'))
  actions.append(row)
  card.append(actions)
  return card
}

// A reply that gives the number of windows, priced from Your prices (Liam, 16 Oct 2026: "the flow could generate a
// message if number of windows are known eg she said Hi Liam, there are 8 windows including the front door - H"). The
// count is read only when their words hold that one number (quote-message.ts windowsFromWords). No words when the round
// prices another way, has no prices yet, or the price would still be a range (no postcode while areas differ). How
// often goes in the words only when it changes the regular price. The day offered is the next working day in the
// diary, nearest their area first, as a customer's (rebook-message.ts defaultOfferDate).
function repliedQuote(l: Lead, said: string, today: string): { windows: number; q: Quote | null; words: string | null } | null {
  const windows = windowsFromWords(said)
  if (!windows) return null
  const list = priceList
  if (!list || list.method !== 'per_window') return { windows, q: null, words: null }
  const draft = jobFromLead(l)
  const at = (how: HowOften): Quote => quote(list, { ...draft, windows, how_often: how }, currencySymbol(), roundConfig().country)
  const often: HowOften = draft.how_often ?? 'w4'
  const q = at(often)
  const same = (['w2', 'w4', 'w6', 'w8', 'w12'] as const).every((h) => at(h).regular_pence === q.regular_pence)
  const day = defaultOfferDate({ postcode: postcodeFromAddress(l.address) }, roundDays, addDaysISO(today, 1)) || null
  const words = repliedQuoteMessage(l.name, q, { often: same ? null : often, day })
  return words ? { windows, q, words } : { windows, q: null, words: null }
}

// "They replied" on an enquiry waiting for an answer (Liam, 16 Oct 2026: "hannah replied but theres no flow to she
// replied", then "go for a they replied section"): what they said to the owner's own phone, pasted in, is kept on the
// enquiry (POST /api/leads/:id/they-replied) and they move up to They replied with the answer ready. No Undo bar: on a
// phone it came up under the thumb that had just tapped Save and took the reply straight back off (Liam, 16 Oct 2026:
// "i put hannahs reply in … but it didnt generate a flow"); the card under They replied has "Take this reply off".
function theyRepliedControl(l: Lead): HTMLElement {
  const wrap = el('div', { class: 'enquiry-replied' })
  // A picture tile beside Book (25 Oct 2026), as on every other card.
  const open = actionTile(el('button', { type: 'button', class: 'btn-secondary enquiry-replied-open', 'aria-label': `They replied: ${l.name}` }), 'reply', 'They replied', 'Paste what they said')
  const form = el('form', { class: 'enquiry-replied-form' })
  form.hidden = true
  const box = el('textarea', { rows: '4', class: 'ready-words-input', 'aria-label': `What ${l.name} said` }) as HTMLTextAreaElement
  const save = el('button', { type: 'submit', class: 'btn-primary' }, 'Save their reply') as HTMLButtonElement
  const cancel = el('button', { type: 'button', class: 'link-button' }, 'Cancel')
  form.append(
    el('span', { class: 'rebook-fact-label' }, 'What did they say?'),
    box,
    el('p', { class: 'muted enquiry-replied-help' }, 'Paste their message. If it gives the number of windows, your answer with the price is written for you.'),
    el('div', { class: 'enquiry-replied-buttons' }, save, cancel),
  )
  open.addEventListener('click', () => {
    open.hidden = true; form.hidden = false
    if (phoneMessages()) box.focus()
    else requestAnimationFrame(() => {
      if (!form.isConnected) return
      form.scrollIntoView({ block: 'nearest', inline: 'nearest' })
      box.focus({ preventScroll: true })
      queuePanelFit()
    })
  })
  cancel.addEventListener('click', () => { form.hidden = true; open.hidden = false; box.value = '' })
  form.addEventListener('submit', (e) => {
    e.preventDefault()
    const words = box.value.trim()
    if (!words) { box.focus(); return }
    // Feedback where the tap happened while it saves (Liam, 16 Oct 2026: "we may need some loading animation").
    save.disabled = true
    cancel.hidden = true
    save.replaceChildren(el('span', { class: 'enquiry-saving', 'aria-hidden': 'true' }), 'Saving their reply')
    keepTheirReply(l, words)
  })
  wrap.append(open, form)
  return wrap
}

function keepTheirReply(l: Lead, words: string): void {
  if (enquirySending(l)) { toast(STILL_SAVING_JOB); return }
  const path = `/api/leads/${l.id}/they-replied`
  const way = leadWay(l)
  void mutate({
    label: `They replied: ${l.name}`,
    method: 'POST',
    path,
    body: { words, way },
    onAck: (ack) => {
      alert4xx(ack)
      // Their card opens again under They replied, whatever group or search was showing, and the screen follows it there
      // (Liam, 16 Oct 2026: "it takes me out of the tile": the card moved up a group and the screen stayed put, on the
      // bottom of her card and the next group). Their words, the answer and Send are on screen together.
      if (ack.ok || ack.status === 0) { filterText = ''; asked = null; openId = `l${l.id}`; focusRestoreId = `l${l.id}`; revealId = `l${l.id}`; flashAnswerFor = l.id }
      void load()
    },
  })
}

// A reply kept by hand comes off again from its card (the undo route, by the reply's own id), never from a bar that
// shows up where the next tap lands. They go back to waiting.
function takeReplyOff(l: Lead, messageId: number, button: HTMLButtonElement): void {
  button.disabled = true
  void mutate({
    label: `Took off the reply: ${l.name}`,
    method: 'POST',
    path: `/api/leads/${l.id}/they-replied`,
    body: { undo: messageId },
    onAck: (ack) => { alert4xx(ack); void load() },
  })
}

// The open enquiry card, same layout as a customer card: who, prices, the
// message, one green action for the stage, then Open in New jobs / Call /
// Not interested.
function moveClosedOnMessages(l: Lead, action: 'old' | 'bring-back'): void {
  const gen = routeGen
  void moveClosedEnquiry(l, action, () => { if (gen === routeGen) { openId = null; void load() } })
}

function enquiryCard(l: Lead, stage: SectionStage, today: string): HTMLElement {
  const desk = !phoneMessages()
  const card = el('div', { class: `rebook-card rebook-card-${stageClass(stage)}` })
  const top = el('div', { class: 'rebook-card-top' })
  const who = el('div', { class: 'rebook-card-who' })
  who.append(el('span', { class: 'rebook-card-name' }, l.name))
  who.append(el('span', { class: 'sched-addr' }, l.address || l.phone || 'No address on file'))
  top.append(who)
  const wait = enquiryWaitDays(l, today)
  top.append(el('span', { class: 'rebook-pill rebook-pill-late' },
    wait === null ? 'no date' : stage === 'new' ? (wait === 0 ? 'enquired today' : `waiting ${wait} day${wait === 1 ? '' : 's'}`) : `enquired ${shortDate(l.quoted_on)}`))
  card.append(top)

  const facts = el('div', { class: 'rebook-facts' })
  const fact = (label: string, value: string): HTMLElement => el('div', { class: 'rebook-fact' }, el('span', { class: 'rebook-fact-label' }, label), el('span', { class: 'rebook-fact-value' }, value))
  facts.append(fact('Initial', l.initial_pence !== null && l.initial_pence !== undefined ? money(l.initial_pence) : 'Not set'))
  facts.append(fact('Regular', l.regular_pence !== null && l.regular_pence !== undefined ? money(l.regular_pence) : 'Not set'))
  facts.append(fact('Enquired', l.quoted_on ? shortDate(l.quoted_on) : 'no date'))
  // An enquiry with only an email (one that came by email) shows the address where the number would be.
  // A tap on either copies it (Liam, 16 Oct 2026: "Email here or phone number when tapped should add to clipboard"):
  // the whole address, not the cut-off one the box shows, and the first number without a note like "- NO WA".
  const email = (l.email ?? '').trim()
  const number = l.phone ? /\+?\d[\d\s().-]*\d/.exec(l.phone.replace(/\(0\)/g, ''))?.[0].trim() ?? null : null
  facts.append(!l.phone && email ? copyFact('Email', email, email, `Copy ${l.name}'s email`)
    : number ? copyFact('Phone', l.phone!, number, `Copy ${l.name}'s number`) : fact('Phone', l.phone || 'Not set'))
  card.append(facts)
  // Call and Open in New jobs take you somewhere else, so they are links at the top (design B, Liam, 30 Oct 2026:
  // https://claude.ai/artifact/Pcm7NyoENUHXgofxdreghQ); no number, no Call, never a button that does nothing.
  const tel = telHref(l.phone)
  card.append(el('div', { class: 'enquiry-top-links' }, ...(tel ? [el('a', { href: tel, class: 'link-button enquiry-call' }, `Call ${firstName(l.name) || l.name}`)] : []),
    el('a', { href: '#/new-jobs', class: 'link-button enquiry-new-jobs' }, 'Open in New jobs')))

  if (didntGoAhead(l)) {
    const chat = enquiryChat(l, new Map())
    chat.querySelector('.enquiry-chat-note')?.remove()
    const back = el('button', { type: 'button', class: 'link-button enquiry-bring-back' }, 'Bring back')
    back.addEventListener('click', () => { back.disabled = true; moveClosedOnMessages(l, 'bring-back') })
    // The swipe's tap and keyboard twin, so a computer can do it too (review, 2 Nov 2026).
    const old = el('button', { type: 'button', class: 'link-button enquiry-move-old' }, 'Move to Old customers')
    old.addEventListener('click', () => { old.disabled = true; moveClosedOnMessages(l, 'old') })
    card.append(el('p', { class: 'muted' }, didntGoAheadWords(l)), el('div', { class: 'rebook-card-row' }, back, old), chat)
    return card
  }

  const sent = enquiryMessages(l)
  const from = enquirySecondFrom(l)
  if (sent > 0) {
    card.append(el('p', { class: 'rebook-sent-line' }, sent === 1
      ? `First message sent ${shortDate(l.enquiry_messaged_on!)}${stage === 'waiting' && from ? ` · second message from ${shortDate(from)}` : ''}`
      : `Messaged twice · last ${shortDate(l.enquiry_messaged_on!)} · no reply`))
  }

  // Text for a round that texts, else WhatsApp as before (contact.ts leadPhoneLink).
  // They wrote back (10 Oct 2026): the card shows what they said, and the send buttons open an empty message for the
  // owner's own answer (it counts, and the reply is seen).
  const lastReply = stage === 'new' && (l.replies_unseen ?? 0) > 0 ? quoteReplies(l).at(-1) ?? null : null
  // A reply giving the number of windows has the answer written with the price (Liam, 16 Oct 2026); any other reply
  // opens an empty message for the owner's own answer.
  const answer = lastReply ? repliedQuote(l, lastReply.body, today) : null
  const answerKey = `${readyKey(l.id, 'answer')}:${getMe()?.businessId ?? 0}:${getMe()?.email ?? ''}:${lastReply?.at ?? ''}`
  // The message to send, editable in its box before sending (src/ready-words.ts; the same box as New jobs').
  const boxKey = readyKey(l.id, stage === 'no_reply' ? 'final' : stage === 'new' ? 'first' : 'nudge')
  const toSend = (): string => { const words = (lastReply ? readyWords(answerKey, answer?.words ?? '') : stage === 'no_reply' ? readyWords(boxKey, enquiryFinalMessage(l.name)) : stage === 'new' || stage === 'second' ? readyWords(boxKey, enquiryMessageFor(l, stage)) : enquiryMessageFor(l, stage)); return offered()?withOfferEnding(words):words }
  // What the answer keeps on the enquiry when sent: its price, while the words sent still say it.
  let offerDraftKey: string | null = null
  let offered: (() => ExtraOffer | null) = () => null
  let offerProblem: (() => string | null) = () => null
  const pricedFields = (now: string): Record<string, unknown> | undefined => {
    const offer = offered()
    const offerFields = { ...(offer ? { answer_offer: offer } : {}), ...(offerDraftKey ? { answer_offer_draft_key: offerDraftKey } : {}) }
    if (!answer?.q || !now.includes(quotePounds(answer.q.regular_pence)) || !now.includes(quotePounds(answer.q.first_pence))) return offerFields
    const status = quotedStatus(l.status_raw)
    return { ...offerFields, initial_pence: answer.q.first_pence, regular_pence: answer.q.regular_pence, ...(status ? { status_raw: status } : {}) }
  }
  const sentWords = (now: string): string | undefined => now
  // Their own way, picked on the arrow beside the send (0075), else the round's usual (contact.ts leadWay).
  const way = leadWay(l)
  const phoneLink = leadPhoneLink(l.phone, toSend(), { own: l.message_by })
  const wa = phoneLink.href
  // Answering their reply: an email of the owner's own (empty, or the answer with the price), not the photos request.
  const mail = lastReply ? mailtoHref((l.email ?? '').trim().toLowerCase(), mailSubject('reply'), toSend()) : enquiryEmailHref(l.email, l.name)
  // The wide send is the email when Email is picked for them, or when there is no number to send to and nothing was
  // picked. Text or WhatsApp picked for them with no mobile on file says so instead of quietly going by email (Liam,
  // 26 Oct 2026, Jackie Page: "when I select text it still says send by email ... it would be better if the text updated
  // to say no email or something. Instead of looking like a bug").
  const pickedPhone = l.message_by === 'text' || l.message_by === 'whatsapp'
  const byEmail = !!mail && (way === 'email' || (!wa && !pickedPhone))
  const usedChannel: NoteChannel = byEmail ? 'email' : phoneLink.channel
  if (lastReply) {
    // Drawn once with the flash, straight after Save their reply; any later redraw is still.
    const flash = flashAnswerFor === l.id
    if (flash) flashAnswerFor = null
    const said = el('div', { class: 'rebook-preview' }, el('div', { class: 'rebook-preview-head' }, el('span', { class: 'rebook-fact-label' }, 'They replied')), el('p', { class: 'rebook-preview-text' }, lastReply.body))
    // Kept by hand (They replied on the card): it can come off again, from here.
    const keptId = (lastReply as { message_id?: unknown }).message_id
    if (typeof keptId === 'number') {
      said.append(replyOffButton(l, keptId, desk))
    }
    card.append(said)
    if (answer?.words && answer.q) {
      const priceLine = answer.q.first_pence === answer.q.regular_pence ? `${quotePounds(answer.q.regular_pence)} a clean` : `${quotePounds(answer.q.regular_pence)} a clean, first clean ${quotePounds(answer.q.first_pence)}`
      const preview = el('div', { class: 'rebook-preview' })
      const head = el('div', { class: 'rebook-preview-head' }, el('span', { class: 'rebook-fact-label' }, 'Your answer'))
      head.append(previewTools(copyMessageButton(toSend, l.name, true, !desk), el('a', { href: '#/prices', class: 'link-button rebook-wording' }, 'Your prices')))
      const box = readyBox(answerKey, answer.words, `Answer to ${l.name}`)
      if (flash) box.classList.add('enquiry-answer-flash')
      preview.append(head, el('p', { class: 'rebook-sent-line enquiry-answer-price' }, `${answer.windows} windows, from what they said · ${priceLine}`), box)
      card.append(preview)
    } else if (answer) {
      card.append(el('p', { class: 'muted enquiry-answer-price' }, `${answer.windows} windows, from what they said. Fill in `, el('a', { href: '#/prices' }, 'Your prices'), ' and your answer with the price is written here.'))
    }
  }
  if (lastReply && !answer?.words) {
    card.append(el('div', { class: 'rebook-preview' },
      el('div', { class: 'rebook-preview-head' }, el('span', { class: 'rebook-fact-label' }, 'Your answer'), previewTools(copyMessageButton(toSend, l.name, true, !desk), el('a', { href: '#/prices', class: 'link-button rebook-wording' }, 'Your prices'))),
      readyBox(answerKey, '', `Answer to ${l.name}`)))
  }
  if (lastReply) {
    const area = card.querySelector<HTMLTextAreaElement>('.ready-words-input')!
    const preview = area.closest('.rebook-preview')!
    // Drafts belong to this signed-in round and this reply, never another business or a later answer.
    const draftKey = `roundly:answer-offer:${getMe()?.businessId ?? 0}:${getMe()?.email ?? ''}:${l.id}:${l.last_in_id ?? 0}:${lastReply.at}`
    offerDraftKey = draftKey
    let saved: { offer?: ExtraOffer; draft?: OfferExtrasDraft; words?: string; sentences?: string[] } | null = null
    try { saved = JSON.parse(localStorage.getItem(draftKey) ?? 'null') } catch { /* no draft */ }
    let previous = Array.isArray(saved?.sentences) ? saved.sentences.filter(s => typeof s === 'string') : []
    if (typeof saved?.words === 'string') { area.value = saved.words; setReadyWords(answerKey, saved.words) }
    const persist = (): void => {
      try { localStorage.setItem(draftKey, JSON.stringify({ offer: picker.value(), draft: picker.draft(), words: area.value, sentences: previous })) } catch { /* private window */ }
    }
    const warning = el('p', { class: 'form-error offer-warning', role: 'alert' })
    const picker = offerExtras({ inside: () => answer?.q?.inside_pence ?? null, initial: saved?.offer, draft: saved?.draft, everyDefault: false,
      onChange: () => {
        const sentences = offerSentences(picker.value())
        const next = replaceOfferWords(area.value, previous, sentences)
        previous = [...new Set([...sentences.filter(s => next.words.includes(s)), ...next.retained])]
        area.value = sentences.length?withOfferEnding(next.words):next.words.replace(`\n${OFFER_ENDING}`,''); setReadyWords(answerKey, area.value)
        warning.textContent = offerProblem() ?? ''
        persist()
      } })
    offered = () => { const v = picker.value(); return v.items.length || v.insides ? v : null }
    offerProblem = () => picker.problem() ?? (replaceOfferWords(area.value, previous, offerSentences(picker.value())).changed ? 'Check the offer words before sending. You changed this sentence. Use Back to the usual wording to write it again at the current price.' : null)
    area.addEventListener('input', () => { warning.textContent = offerProblem() ?? ''; persist() })
    const reset = preview.querySelector('.ready-words-reset')
    reset?.addEventListener('click', () => {
      const sentences = offerSentences(picker.value())
      area.value = sentences.length?withOfferEnding(replaceOfferWords(area.value, [], sentences).words):replaceOfferWords(area.value, [], sentences).words; setReadyWords(answerKey, area.value)
      previous = sentences; warning.textContent = ''; persist()
    })
    const row = el('div', { class: 'answer-offers' }, el('strong', {}, 'Offer too?'), picker.node,
      el('p', { class: 'muted' }, 'An offer only. Accepted extras go on the first visit.'), warning)
    preview.insertBefore(row, area.parentElement)
  }
  // Waiting for their answer there is no message on the card: the second goes from Follow up, before its day if they
  // like (tidy-up item 6, Liam, 20 Oct 2026, the drawing; it folded to one line under the buttons before, Liam, 19 Oct
  // 2026: "we have to scroll down to take action"). A message that can go now stays open where it was.
  // The message as a tile that says what it is, the words in a soft box under it with Copy and Change wording, and Send in
  // lemon under that (Liam, 25 Oct 2026, the "I sent them a quote" pack, boards 1 and 2: "doesnt feel on brand"). The tile
  // folds the words and their Send away ("Hide it"), leaving Book and Follow up, for someone already dealt with.
  if (!lastReply && stage !== 'no_reply' && stage !== 'waiting') {
    const words = enquiryMessageFor(l, stage)
    const title = stage === 'new' ? 'First message' : 'Second message'
    const folded = foldedMessages.has(foldKey(l))
    const preview = el('div', { class: 'rebook-preview enquiry-message' })
    const fold = el('button', { type: 'button', class: 'enquiry-message-tile', 'aria-expanded': String(!folded), 'aria-label': `${title} for ${l.name}: ${folded ? 'see it and send it' : 'hide it'}` },
      el('span', { class: 'rebook-action-ring', 'aria-hidden': 'true' }, lineDrawing('bubble', 19)),
      el('span', { class: 'rebook-action-words' }, el('strong', {}, title), el('span', {}, folded ? 'See it and send it' : 'Hide it')),
      lineDrawing(folded ? 'chevronDown' : 'chevronUp', 18))
    fold.addEventListener('click', () => {
      const k = foldKey(l)
      if (foldedMessages.has(k)) foldedMessages.delete(k); else foldedMessages.add(k)
      currentRender?.()
    })
    preview.append(fold)
    if (!folded) {
      const box = stage === 'new' || stage === 'second' ? readyBox(boxKey, words, `Message to ${l.name}`) : el('p', { class: 'rebook-preview-text' }, words)
      preview.append(box, el('div', { class: 'enquiry-message-tools' }, copyMessageButton(toSend, l.name, true, !desk), wordingLink(stage === 'new' ? 'enquiry_first' : quoted(l) ? 'quote_nudge' : 'enquiry_second')))
    }
    card.append(preview)
    if (folded) card.classList.add('enquiry-message-folded')
  }

  // Messaged twice, no reply: the last message, ready to send, as a customer's final message (design A).
  if (!lastReply && stage === 'no_reply') {
    const first = l.name.split(' ')[0] || l.name
    const words = enquiryFinalMessage(l.name)
    const preview = el('div', { class: 'rebook-preview' })
    const label = el('div', { class: 'rebook-preview-head' })
    label.append(el('span', { class: 'rebook-fact-label' }, 'Last message'))
    label.append(previewTools(copyMessageButton(toSend, l.name, true, !desk), wordingLink('enquiry_final')))
    preview.append(label, readyBox(boxKey, words, `Last message to ${l.name}`))
    card.append(preview)
    card.append(el('p', { class: 'rebook-final-note' }, `Sending it moves ${first} to `, el('strong', {}, "Didn't go ahead"), ' on New jobs: nothing more goes to them.'))
  }

  const actions = el('div', { class: 'rebook-card-actions' })
  if (stage === 'new' || stage === 'second') {
    // One wide send and the arrow beside it (Liam, 15 Oct 2026: "Arrow maybe that would replace the email?"; Astra
    // advised the visible arrow over a long hold): the arrow picks Text, WhatsApp or Email for this enquiry, saved on
    // it (0075), and the card is drawn again the new way. Either way a tap counts one message and the note line says
    // which way it went.
    const arrow = (): HTMLDetailsElement => wayMenu(leadForWay(l), () => void load(), { onConflict: () => void load() })
    if (wa && !byEmail) {
      const sendRow = el('div', { class: 'rebook-send-row' })
      const phoneWay = phoneLink.channel === 'text' ? 'text' : 'whatsapp'
      const link = el('a', { href: wa, target: phoneWay === 'text' ? '_self' : '_blank', rel: 'noopener', class: `btn-whatsapp rebook-send${stage === 'second' ? ' rebook-send-second' : ''}`, 'aria-label': `${wayWords(phoneWay).button}: ${l.name}` })
      link.append(wayIcon(phoneWay), el('span', {}, stage === 'second' ? 'Send second message' : wayWords(phoneWay).button))
      // Opens with the box's words as they are at the tap.
      bindEmailSend(link, () => {
        if (offerProblem()) { toast(offerProblem()!); return null }
        if (enquirySending(l)) { toast(STILL_SAVING_JOB); return null }
        const now = toSend(), href = leadPhoneLink(l.phone, now, { own: l.message_by }).href
        const fields = pricedFields(now), words = sentWords(now)
        return href ? { href, name: l.name, sent: () => {
          recordEnquiryMessage(l, phoneLink.channel, card, words, fields); forgetReady(boxKey); forgetReady(answerKey)
        } } : null
      })
      sendRow.append(link, arrow())
      actions.append(sendRow)
    } else if (byEmail) {
      // Email picked for them, or only an email (Liam, 11 Oct 2026, an enquiry that came by email: "the message doesnt
      // allow me to reply on email"): the wide send is the email, with the box's words, counted as Messages counts an email.
      const email = (l.email ?? '').trim().toLowerCase()
      const link = el('a', { href: mail!, class: `btn-primary rebook-send rebook-send-email${stage === 'second' ? ' rebook-send-second' : ''}`, 'aria-label': `Send by email: ${l.name}` })
      link.append(wayIcon('email'), el('span', {}, stage === 'second' ? 'Send second message by email' : wayWords('email').button))
      bindEmailSend(link, () => {
        if (offerProblem()) { toast(offerProblem()!); return null }
        if (enquirySending(l)) { toast(STILL_SAVING_JOB); return null }
        const now = toSend()
        const href = mailtoHref(email, mailSubject(lastReply ? 'reply' : 'enquiry'), now)
        const fields = pricedFields(now)
        return href ? { href, sent: () => {
          recordEnquiryMessage(l, 'email', card, sentWords(now), fields); forgetReady(boxKey); forgetReady(answerKey)
        } } : null
      })
      actions.append(el('div', { class: 'rebook-send-row' }, link, arrow()))
    } else {
      const first = l.name.split(' ')[0] || l.name
      const none = el('p', { class: 'muted rebook-no-number' }, mail && pickedPhone
        ? `No ${phoneLink.channel === 'text' ? 'mobile' : 'WhatsApp number'} for ${first} yet, so a ${phoneLink.channel === 'text' ? 'text' : 'WhatsApp'} can't go. Pick Email on the arrow, or add a mobile in New jobs.`
        : l.phone ? `${phoneLink.channel === 'text' ? 'No mobile' : 'No WhatsApp number'} on file. Call, or add a mobile in New jobs.` : 'No phone or email on file. Add one in New jobs.')
      // A number that cannot take this way (a landline for a text, one marked no WhatsApp) may take another: the arrow
      // stays, so Text can be picked where WhatsApp cannot go (Codex, 15 Oct 2026); and Email, for someone with an email.
      actions.append(l.phone || mail ? el('div', { class: 'rebook-send-row rebook-send-none' }, none, arrow()) : none)
    }
    // Sent from their own phone: an answer with the price still keeps the price.
    actions.append(alreadySentButton(l.name, () => {
      if (offerProblem()) { toast(offerProblem()!); return false }
      const fields = pricedFields(toSend()), hasOffer = !!fields?.answer_offer
      recordEnquiryMessage(l, usedChannel, card, hasOffer ? toSend() : undefined, fields, { byYou: true })
      forgetReady(boxKey); forgetReady(answerKey)
    }))
    // Book them in beside the send, never instead of it: sending is this stage's main step (the reviewers, 19 Oct 2026).
    // The second message's card: Follow up holds They replied, Remind me in a week and Not interested (its send and "I
    // messaged them myself" are already here; tidy-up item 6, 20 Oct 2026).
    const heard = heardRow(l, false, stage === 'second' ? 'follow' : null, card, today)
    // A new enquiry's Not interested beside Book (the second message's is in Follow up).
    if (stage === 'new') { heard.classList.remove('enquiry-heard-one'); heard.append(notInterestedTile(l)) }
    actions.append(orInstead('Or instead', heard))
    if (stage === 'second') appendPutBack(actions, l)
  } else if (stage === 'waiting') {
    // Nothing to send until the second message's day (the sent line says when): Book them in lemon and Follow up beside
    // it, with everything else that can happen next behind it (tidy-up item 6, Liam, 20 Oct 2026: "They replied becomes
    // Follow up"; before that, Liam, 19 Oct 2026: "you message them, you arrange something, you go back in").
    actions.append(el('p', { class: 'muted enquiry-heard-help' }, 'Nothing to send yet. Arranged it already? Book them in here.'), orInstead('What next', heardRow(l, true, 'follow', card, today)))
    appendPutBack(actions, l)
  } else if (stage === 'no_reply') {
    // Messaged twice (design A, 28 Oct 2026): Send last message, their way; I sent it myself; Take off quietly (Not
    // interested, as before, no message); They replied.
    const words = enquiryFinalMessage(l.name)
    const lastLink = leadPhoneLink(l.phone, words, { own: l.message_by })
    const lastMail = mailtoHref((l.email ?? '').trim().toLowerCase(), mailSubject('enquiry'), words)
    const viaMail = !!lastMail && (way === 'email' || !lastLink.href)
    const href = viaMail ? lastMail : lastLink.href
    if (href) {
      const channel: NoteChannel = viaMail ? 'email' : lastLink.channel
      const send = el('a', { href, ...(viaMail ? {} : { target: lastLink.channel === 'text' ? '_self' : '_blank', rel: 'noopener' }), class: `${viaMail ? 'btn-primary rebook-send-email' : 'btn-whatsapp'} rebook-send rebook-send-final`, 'aria-label': `Send last message: ${l.name}` })
      send.append(wayIcon(viaMail ? 'email' : lastLink.channel === 'text' ? 'text' : 'whatsapp'), el('span', {}, 'Send last message'))
      if (viaMail) bindEmailSend(send, () => {
        if (enquirySending(l)) { toast(STILL_SAVING_JOB); return null }
        const href = mailtoHref((l.email ?? '').trim().toLowerCase(), mailSubject('enquiry'), toSend())
        return href ? { href, sent: () => enquiryOffAfterLast(l, 'email') } : null
      })
      else bindEmailSend(send, () => {
        if (enquirySending(l)) { toast(STILL_SAVING_JOB); return null }
        const href = leadPhoneLink(l.phone, toSend(), { own: l.message_by }).href
        return href ? { href, name: l.name, sent: () => enquiryOffAfterLast(l, channel) } : null
      })
      actions.append(send)
    }
    // I sent it myself as a small button under Send, as on the other steps; Book, They replied and Take off quietly as
    // tiles under "Or instead" (design B).
    const mine = el('button', { type: 'button', class: 'link-button rebook-final-mine', 'aria-label': `I sent ${l.name} the last message myself` }, 'I sent it myself') as HTMLButtonElement
    mine.addEventListener('click', () => enquiryOffAfterLast(l, 'self', mine))
    const quiet = actionTile(el('button', { type: 'button', class: 'btn-secondary rebook-final-quiet rebook-take-off enquiry-off', 'aria-label': `Not interested: ${l.name}` }), 'personOff', 'Take off quietly', 'No message')
    quiet.addEventListener('click', () => markEnquiryDeclined(l, quiet))
    actions.append(el('div', { class: 'rebook-already-row' }, mine), orInstead('Or instead', heardRow(l, false, 'replied', card, today), el('div', { class: 'rebook-final-tiles enquiry-final-quiet' }, quiet)))
    appendPutBack(actions, l)
  }
  // Folded away: no Send under it either, so the phone's bar never offers a message that is hidden.
  if (card.classList.contains('enquiry-message-folded')) for (const n of actions.querySelectorAll('.rebook-send-row, .rebook-already-sent')) n.remove()
  card.append(actions)
  arrangeEnquirySheet(card, l, stage, today, lastReply)
  return card
}

function replyOffButton(l: Lead, id: number, desk = false): HTMLButtonElement {
  const off = el('button', { type: 'button', class: 'link-button enquiry-reply-off' }, desk ? 'Not right? Take it off' : 'Not right? Take this reply off') as HTMLButtonElement
  off.addEventListener('click', () => takeReplyOff(l, id, off))
  return off
}

// Design 4 rearranges the existing enquiry controls. Sends, prices, reply saves and Undo keep their owners.
function arrangeEnquirySheet(card: HTMLElement, l: Lead, stage: SectionStage, today: string, lastReply: { body: string; at: string; message_id?: unknown } | null): void {
  card.classList.add('messages-enquiry-sheet')
  card.dataset.enquiryStep = lastReply ? 'replied' : stage
  const about = el('div', { class: 'messages-sheet-about-content' })
  for (const node of [...card.children]) if (node.matches('.rebook-facts, .enquiry-top-links, .rebook-sent-line')) about.append(node)
  const actions = card.querySelector<HTMLElement>('.rebook-card-actions')
  if (!actions) return
  const heard = actions.querySelector<HTMLElement>('.enquiry-heard')
  if (!heard) return
  const book = heard.querySelector<HTMLElement>('.enquiry-book')
  const replied = heard.querySelector<HTMLElement>('.enquiry-replied') ?? theyRepliedControl(l)
  const replyOpen = replied.querySelector<HTMLElement>('.enquiry-replied-open')!
  if (replyOpen) replyOpen.hidden = false
  replied.classList.remove('enquiry-heard-form')
  const paste = replied.querySelector('textarea')!
  paste.classList.remove('ready-words-input'); paste.classList.add('enquiry-paste-input')
  const follow = heard.querySelector<HTMLElement>('.enquiry-follow-open') ?? followUpButton(l, card, replied, today)
  const quote = actionTile(el('button', { type: 'button', class: 'btn-secondary enquiry-send-quote' }), 'quote', 'Send a quote', 'Price it now')
  quote.addEventListener('click', () => { if (enquirySending(l)) { toast(STILL_SAVING_JOB); return }; openWriteQuote(l, () => void load()) })
  if (stage !== 'no_reply') about.append(quote)
  if (stage === 'waiting' || stage === 'second' || lastReply) about.append(follow)
  if (lastReply || quoted(l) || l.has_regular_offer) mountEnquiryRegularOffer(l, about, () => actionTile(el('button', { type: 'button', class: 'btn-secondary enquiry-regular-open' }), 'again', 'Offer regular cleans', 'They tap how often') as HTMLButtonElement, () => void load())
  // Keep pasted-message provenance and its exact undo, along with media and Earlier messages.
  const fallback = lastReply ? card.querySelector<HTMLElement>('.rebook-preview') ?? undefined : undefined
  fallback?.remove()
  const off = fallback?.querySelector<HTMLElement>('.enquiry-reply-off')
  const pasted = new Map<number, HTMLElement | undefined>()
  for (const reply of quoteReplies(l)) {
    const id = (reply as { message_id?: unknown }).message_id
    if (typeof id === 'number') pasted.set(id, id === lastReply?.message_id ? off ?? undefined : undefined)
  }
  // Imported notes are owner context, never evidence of what the customer asked.
  for (const [label, value] of [['Initial lead', l.initial_lead], ['Notes', l.notes], ['More notes', l.notes2]]) if (value?.trim()) about.append(el('p', {}, el('strong', {}, `${label}: `), value))
  const questionHeading = el('strong', {}, lastReply ? `They asked · ${stepDate(lastReply.at)}` : 'They asked')
  const questionWords = el('p', {}, lastReply?.body ?? 'Getting their question…')
  const question = el('div', { class: 'messages-sheet-question' }, questionHeading, questionWords)
  const meta = card.querySelector<HTMLElement>('.rebook-pill')
  if (meta) meta.textContent = ['Enquiry', postcodeFromAddress(l.address), l.quoted_on ? shortDate(l.quoted_on) : null].filter(Boolean).join(' · ')
  const address = card.querySelector<HTMLElement>('.sched-addr')
  if (address && meta) { address.textContent = meta.textContent; meta.remove() }
  card.insertBefore(question, card.querySelector('.rebook-preview') ?? actions)
  if (off) about.append(off)
  about.append(enquiryChat(l, pasted, fallback, undefined, lastReply ? undefined : message => {
    questionHeading.textContent = message ? `They asked · ${stepDate(message.at)}` : 'Their enquiry'
    questionWords.textContent = message?.body ?? (message === null ? 'No written question kept. Open About for their conversation and pictures.' : 'Could not get their question. Open About to try the conversation again.')
  }))
  for (const extra of card.querySelectorAll<HTMLElement>('.answer-offers, .enquiry-answer-price, .rebook-copy')) about.append(extra)
  const preview = card.querySelector<HTMLElement>('.rebook-preview')
  const fold = preview?.querySelector<HTMLElement>('.enquiry-message-tile')
  if (fold && !card.classList.contains('enquiry-message-folded')) about.append(fold)
  // Your answer is edited in its bubble. Its price link is still in About; template wording has its own link.
  const priceLink = [...(preview?.querySelectorAll<HTMLAnchorElement>('a') ?? [])].find(a => a.getAttribute('href') === '#/prices')
  if (priceLink) { priceLink.classList.remove('rebook-wording'); priceLink.classList.add('enquiry-your-prices'); about.append(priceLink) }
  if (lastReply && !preview?.querySelector('.rebook-wording')) preview?.append(el('a', { href: '#/your-messages', class: 'link-button rebook-wording' }, 'Change wording'))
  const send = actions.querySelector<HTMLElement>('.rebook-send-row')
  const finalSend = actions.querySelector<HTMLElement>('.rebook-send-final')
  if (finalSend && !send) actions.prepend(el('div', { class: 'rebook-send-row' }, finalSend, wayMenu(leadForWay(l), () => void load(), { onConflict: () => void load() })))
  const mine = actions.querySelector<HTMLElement>('.rebook-already-sent, .rebook-final-mine')
  const call = about.querySelector<HTMLElement>('.enquiry-call')
  const remove = heard.querySelector<HTMLElement>('.enquiry-off') ?? actions.querySelector<HTMLElement>('.rebook-final-quiet') ?? notInterestedTile(l)
  const rounds = el('div', { class: 'messages-sheet-rounds', role: 'group', 'aria-label': 'Message actions' })
  for (const [node, icon, word] of [[mine, 'bubbleTick', 'I sent it'], [book, 'calendarPlus', `Book ${firstName(l.name) || l.name}`], [replyOpen, 'bubble', 'They replied'], [call, 'phone', 'Call'], [remove, stage === 'no_reply' ? 'personOff' : 'hourglass', stage === 'no_reply' ? 'Take off quietly' : 'Not interested']] as [HTMLElement | null, Drawing, string][]) {
    if (node) rounds.append(sheetRound(node, icon, word))
  }
  if (stage === 'waiting') for (const item of enquiryEarlySecond(l, card, today)) {
    const title = item.querySelector('strong')
    if (item.classList.contains('enquiry-follow-send') && title) title.textContent = 'Send the second now'
    about.append(item)
  }
  const putBack = actions.querySelector<HTMLElement>('.rebook-didnt-send')
  if (putBack) about.append(putBack)
  // The original reply wrapper owns the paste form and closures. Its opener can live in the action row.
  card.append(rounds, replied)
  card.append(about)
  for (const empty of actions.querySelectorAll('.enquiry-or')) empty.remove()
}

function sheetRound(node: HTMLElement, icon: Drawing, word: string): HTMLElement {
  node.classList.add('messages-sheet-round')
  node.classList.remove('rebook-action-tile', 'link-button')
  const booking = node.querySelector<HTMLElement>('.enquiry-book-words')
  const bookingWord = booking?.textContent
  const busy = bookingWord?.startsWith('Booking ')
  if (node.getAttribute('aria-disabled') === 'true' && icon === 'phone') word = 'No number'
  node.replaceChildren(el('span', { class: 'messages-sheet-ring', 'aria-hidden': 'true' }, lineDrawing(icon, 22)), el('strong', { ...(booking ? { class: 'enquiry-book-words' } : {}) }, busy ? bookingWord! : word), ...(busy ? [el('span', {}, 'Waiting for signal')] : []))
  return node
}

// Wrap, rather than copy, the working card. About keeps all the quieter controls in the same event path.
function styleMessageSheet(card: HTMLElement, name: string, rerender: () => void, bars?: HTMLElement): void {
  // Standalone cards keep their own bar inside the control owner, including its in-flight disabling guard.
  card.classList.add('messages-sheet-card')
  card.dataset.sheetPhone = String(phoneMessages())
  const aboutContent = card.querySelector<HTMLElement>('.messages-sheet-about-content') ?? el('div', { class: 'messages-sheet-about-content' })
  for (const context of card.querySelectorAll<HTMLElement>('.messages-contact-context')) aboutContent.append(context)
  const top = card.querySelector<HTMLElement>('.rebook-card-top') ?? el('div', { class: 'rebook-card-top' }, el('strong', { class: 'rebook-card-name' }, name))
  const back = el('button', { type: 'button', class: 'messages-sheet-back', 'aria-label': 'Back to the list' }, lineDrawing('chevronLeft', 18), 'Back')
  back.addEventListener('click', () => {
    const id = card.dataset.messageId
    releaseEnquiryChat()
    openId = 'closed'; bookAgainLetGo()
    if (messageView.focus) toggleFocus(rerender); else rerender()
    const tile = [...document.querySelectorAll<HTMLElement>('.rebook-tile, .messages-sheet-row')].find(n => n.dataset.messageId === id && n.matches('.rebook-tile, .messages-sheet-row'))
    ;(tile?.querySelector<HTMLElement>('.enquiry-row-open') ?? tile)?.focus({ preventScroll: true })
  })
  const pager = el('div', { class: 'messages-sheet-pager', 'aria-label': 'People in this list' })
  const head = el('header', { class: 'messages-sheet-head' }, el('div', { class: 'messages-sheet-title' }, back, top, pager), ...(bars ? [bars] : []))
  const about = el('details', { class: 'messages-sheet-about' }, el('summary', {}, `${phoneMessages() ? 'More about' : 'About'} ${firstName(name) || name}`), aboutContent)
  about.open = !phoneMessages() || (cardDrafts.get(card.dataset.messageId ?? '')?.about ?? false)
  const scroll = el('div', { class: 'messages-sheet-scroll', tabindex: '0', 'aria-label': `Message and actions for ${name}` })
  for (const node of [...card.children]) if (node !== top && node !== aboutContent) scroll.append(node)
  if (phoneMessages()) scroll.append(about)
  const main = el('div', { class: 'messages-sheet-main' }, head, scroll)
  card.replaceChildren(main, ...(!phoneMessages() ? [about] : []))
  // Existing sent handlers and missing-contact states remain, with the approved way words.
  for (const send of card.querySelectorAll<HTMLElement>('.rebook-send')) {
    if (card.classList.contains('reply-composer') || card.classList.contains('rebook-card-lapsed')) continue
    if (send.classList.contains('rebook-send-final') || send.classList.contains('rebook-send-second')) continue
    const label = send.querySelector<HTMLElement>('span')
    if (label) label.textContent = /email/i.test(send.getAttribute('aria-label') ?? '') ? 'Send by email' : /text/i.test(send.getAttribute('aria-label') ?? '') ? 'Send as a text' : 'Send on WhatsApp'
  }
}

function customerSheet(card: HTMLElement, r: Row, stage: SectionStage, today: string, rerender: () => void): void {
  const record = r.kind === 'enquiry' ? r.l : r.kind === 'job' ? customerOf(r.d) ?? r.d.entry : r.c
  let bars: HTMLElement | undefined
  if (r.kind === 'enquiry') {
    // Reuse the list's evidence/date/put-back adapter, not a second interpretation of enquiry history.
    const host = enquiryStepHost(el('button', { type: 'button' }), r.l, countedEnquiryPill(r.l, today) === 'waiting' ? 'them' : 'you')
    bars = host.querySelector<HTMLElement>('.enquiry-steps') ?? undefined
  } else {
    const customer = r.kind === 'job' ? r.d.entry : record as RoundCustomer
    const about = el('div', { class: 'messages-sheet-about-content' }, el('p', { class: 'muted' }, addressLine(record as RoundCustomer)))
    if (record.phone) about.append(copyFact('Phone', record.phone, record.phone, `Copy ${record.name}'s number`))
    const top = card.querySelector<HTMLElement>('.rebook-card-top')
    const meta = top?.querySelector<HTMLElement>('.sched-addr')
    if (meta) {
      const due = top?.querySelector('.rebook-pill')
      meta.textContent = [due?.textContent, customer.reg_price_pence != null ? money(customer.reg_price_pence) : null, customer.cycle_days && customer.cycle_days > 0 ? `every ${cycleLabel(customer.cycle_days)}` : cycleLabel(customer.cycle_days)].filter(Boolean).join(' · ')
      due?.remove()
    }
    for (const node of [...card.querySelectorAll<HTMLElement>('.rebook-facts, .messages-owner-context, .messages-contact-context, .said-note, .customer-pending-offer, .rebook-copy')]) about.append(node)
    if (!about.querySelector('.messages-contact-context')) about.append(el('p', { class: 'muted' }, record.last_contacted_on ? `Last contact ${shortDate(record.last_contacted_on)}` : 'No contact recorded yet'))
    const diaryDay = (upcomingVisits(customer) ?? []).find(v => v.job_id === (r.kind === 'job' ? r.d.job.id : null) && v.source !== 'suggested' && v.source !== 'tentative' && v.source !== 'week' && !(plannedWeekOf(customer) && v.id === customer.next_booked_id) && v.date >= today)
    if (diaryDay) for (const note of card.querySelectorAll<HTMLElement>('.rebook-why-info')) about.append(note)
    const roundActions = !card.classList.contains('reply-composer') && ['to_message', 'waiting', 'second', 'no_reply'].includes(stage)
    const mine = roundActions ? card.querySelector<HTMLElement>('.rebook-already-sent, .rebook-final-mine') : null
    const rounds = el('div', { class: 'messages-sheet-rounds', role: 'group', 'aria-label': 'Message actions' })
    const row = roundActions ? card.querySelector<HTMLElement>('.rebook-card-row') : null
    if (mine) {
      rounds.append(sheetRound(mine, 'bubbleTick', 'I sent it'))
      if (stage === 'no_reply') {
        mine.append(el('span', {}, 'Taken off, counted'))
        mine.setAttribute('aria-label', `I sent ${record.name} the final message myself. Taken off, counted`)
      }
    }
    if (row) {
      const book = row.querySelector<HTMLElement>('button')
      const reply = row.querySelector<HTMLElement>('.reply-trigger')
      const call = row.querySelector<HTMLElement>('.rebook-call')
      const later = row.querySelector<HTMLElement>('.rebook-notnow')
      for (const [node, icon, word] of [[book, 'calendarPlus', 'Book visit'], [reply, 'bubble', 'They replied'], [call, 'phone', 'Call'], [later, 'hourglass', 'Not now']] as [HTMLElement | null | undefined, Drawing, string][]) if (node) rounds.append(sheetRound(node, icon, word))
      if (row.children.length) about.append(row)
    }
    if (rounds.children.length) card.append(rounds)
    const later = card.querySelector<HTMLElement>('.notnow-chooser')
    if (later) card.append(later)
    card.append(about)
    const picker = card.querySelector<HTMLElement>('.messages-date-section, .rebook-offer')
    if (picker && stage === 'to_message') {
      const c = r.kind === 'job' ? r.d.entry : record as RoundCustomer
      const dates = r.kind === 'job' ? jobDates(r.d, today) : customerDates(c, today)
      const dayWords = (): string => dates.length ? `${diaryDay && dates.length === 1 && dates[0] === diaryDay.date ? 'Day' : 'Day to offer'} · ${dates.map(shortDate).join(' or ')}` : 'Choose a day'
      const summary = el('summary', {}, dayWords(), el('span', {}, 'Change'))
      const day = el('details', { class: 'messages-sheet-day' }, summary)
      picker.replaceWith(day); day.append(picker)
      day.open = !phoneMessages() || (cardDrafts.get(card.dataset.messageId ?? '')?.day ?? !dates.length)
      const update = (): void => {
        const picked = r.kind === 'job' ? jobDates(r.d, today) : customerDates(c, today)
        summary.replaceChildren(picked.length ? `${diaryDay && picked.length === 1 && picked[0] === diaryDay.date ? 'Day' : 'Day to offer'} · ${picked.map(shortDate).join(' or ')}` : 'Choose a day', el('span', {}, 'Change'))
      }
      picker.addEventListener('click', update); picker.addEventListener('change', update)
      if (!phoneMessages()) {
        const dropdown = picker.querySelector<HTMLElement>('.messages-date-dropdown')
        const choices = dropdown?.querySelector<HTMLElement>('.messages-date-list')
        if (dropdown && choices) { const days = el('div', { class: 'messages-sheet-dates' }, choices); dropdown.replaceWith(days) }
        const area = picker.querySelector<HTMLElement>('.messages-date-aside')
        if (area) about.append(area)
      }
    }
    if (['to_message', 'waiting', 'second', 'no_reply'].includes(stage) && !replyDrafts.has(record.id)) {
      const c = r.kind === 'job' ? r.d.entry : record as RoundCustomer
      // A moved visit keeps confirmed=0 until the new day is agreed again.
      const booked = diaryDay?.confirmed && !isPencilledVisit(diaryDay, c, today) ? diaryDay : undefined
      const waitingDay = !!diaryDay && !booked
      const sent = messagesThisCycle(c) > 0
      bars = stepBar([
        { key: 'day', word: 'Day', state: booked ? 'done' : 'next', turn: waitingDay || sent ? 'them' : 'you', ...(booked ? { detail: `Agreed in the diary for ${dayLabel(booked.date)}` } : { waitingFor: waitingDay ? `Waiting for them to agree to ${dayLabel(diaryDay!.date)}` : 'Waiting for a visit in the diary. Picking a day to offer does not book it.' }) },
        { key: 'message', word: 'Message', state: sent ? 'done' : booked ? 'next' : 'later', ...(sent && c.rebook_messaged_on ? { when: shortDate(c.rebook_messaged_on), detail: `Sent ${shortDate(c.rebook_messaged_on)}` } : {}) },
        { key: 'send', word: 'Send', state: sent ? 'next' : 'later', turn: sent ? 'them' : 'you', waitingFor: sent ? 'Waiting for their reply' : 'Waiting for your message to be sent' },
      ], { label: 'Visit message steps' })
    }
  }
  styleMessageSheet(card, record.name, rerender, bars)
}

// Shared by Waiting's composer and the existing Follow up sheet. These remain the same counted second-message save.
function enquiryEarlySecond(l: Lead, card: HTMLElement, today: string, beforeAction: () => void = () => {}): HTMLElement[] {
  const gen = routeGen
  const who = firstName(l.name) || l.name
  const words = (): string => readyWords(readyKey(l.id, 'nudge'), nudgeMessageFor(l))
  const email = (l.email ?? '').trim().toLowerCase()
  const phone = leadPhoneLink(l.phone, words(), { own: l.message_by })
  const mail = mailtoHref(email, mailSubject('enquiry'), words())
  const byEmail = !!mail && (leadWay(l) === 'email' || (!phone.href && l.message_by !== 'text' && l.message_by !== 'whatsapp'))
  const channel: NoteChannel = byEmail ? 'email' : phone.channel
  const counted = `Counted the second message to ${who}`
  const href = byEmail ? mail : phone.href
  const items: HTMLElement[] = []
  if (href) {
    const from = enquirySecondFrom(l)
    const app = channel === 'email' ? 'your email' : channel === 'text' ? 'your Messages app' : 'WhatsApp'
    const now = actionTile(el('a', { href, target: channel === 'WhatsApp' ? '_blank' : '_self', rel: 'noopener', class: 'enquiry-follow-send' }), 'send', 'Send second message now', `Opens ${app}${from && today < from ? `, before ${shortDate(from)}` : ''}`)
    bindEmailSend(now as HTMLAnchorElement, () => {
      if (enquirySending(l)) { toast(STILL_SAVING_JOB); return null }
      const text = words(), href = byEmail ? mailtoHref(email, mailSubject('enquiry'), text) : leadPhoneLink(l.phone, text, { own: l.message_by }).href
      return href ? { href, sent: () => {
        beforeAction()
        if (routeGen !== gen) return
        recordEnquiryMessage(l, channel, card, text, undefined, { stay: true, counted })
        forgetReady(readyKey(l.id, 'nudge'))
      } } : null
    })

    items.push(now)
  }
  const mine = actionTile(el('button', { type: 'button', class: 'enquiry-follow-myself' }), 'bubbleTick', "I've sent another message", 'From my own phone, so count it') as HTMLButtonElement
  mine.addEventListener('click', () => { beforeAction(); if (routeGen !== gen) return; recordEnquiryMessage(l, channel, card, undefined, undefined, { stay: true, counted }) })
  items.push(mine)
  return items
}

// Book them in and They replied, side by side (Liam, 19 Oct 2026, the drawing; "wouldn't that bar be split between book
// in and they replied?"): the bar at the foot of a phone shows the same two when this row is off the screen
// (watchSendBar). Book is lemon only where there is nothing to send yet. `beside`: They replied ('replied'), Follow up
// ('follow', tidy-up item 6, 20 Oct 2026, with They replied's box under the row, opened from it) or nothing.
function heardRow(l: Lead, lemon: boolean, beside: 'replied' | 'follow' | null, card?: HTMLElement, today = todayISO()): HTMLElement {
  const who = firstName(l.name) || l.name
  const waiting = bookingWaiting(l)
  // Named by its own words ("Book Emma in"), so asking for it by what it says finds it.
  const book = el('button', { type: 'button', class: `${lemon ? 'btn-primary' : 'btn-secondary'} enquiry-book` }) as HTMLButtonElement
  // "Book Jenal", the name on one line, cut short with … when it is long (Liam, 21 Oct 2026: "we can drop the word in
  // from it and what happens when its a super long name").
  // A picture tile, beside Follow up's (Liam, 25 Oct 2026, the "I sent them a quote" pack, board 1).
  book.classList.add('rebook-action-tile')
  book.append(el('span', { class: 'rebook-action-ring', 'aria-hidden': 'true' }, lineDrawing('calendarPlus', 19)),
    el('span', { class: 'rebook-action-words' }, el('strong', { class: 'enquiry-book-words' }, waiting ? `Booking ${who}…` : `Book ${who}`), el('span', {}, waiting ? 'Waiting for signal' : 'Pick a day')))
  // Still on its way (no signal): it books as soon as it can, and a second one is never started.
  if (waiting) { book.disabled = true; book.title = 'Waiting for signal. It saves as soon as it can.' }
  book.addEventListener('click', () => { if (enquirySending(l)) { toast(STILL_SAVING_JOB); return } void bookEnquiry(l) })
  if (beside === 'follow' && card) {
    const replied = theyRepliedControl(l)
    replied.classList.add('enquiry-heard-form')
    replied.querySelector<HTMLElement>('.enquiry-replied-open')!.hidden = true
    return el('div', { class: 'enquiry-heard enquiry-heard-follow' }, book, followUpButton(l, card, replied, today), replied)
  }
  return el('div', { class: `enquiry-heard${beside ? '' : ' enquiry-heard-one'}` }, book, ...(beside === 'replied' ? [theyRepliedControl(l)] : []))
}

// The grey "Or instead" strip under the send (design B, 30 Oct 2026): the other choices as picture tiles.
function orInstead(title: string, ...parts: HTMLElement[]): HTMLElement {
  return el('div', { class: 'enquiry-or' }, el('p', { class: 'enquiry-or-title' }, title), ...parts)
}

// Not interested as a tile, in red words: off the enquiry list, kept in New jobs, with Undo (markEnquiryDeclined).
function notInterestedTile(l: Lead): HTMLButtonElement {
  const off = actionTile(el('button', { type: 'button', class: 'btn-secondary rebook-take-off-early enquiry-off', 'aria-label': `Not interested: ${l.name}` }) as HTMLButtonElement, 'personOff', 'Not interested', "In Didn't go ahead")
  off.addEventListener('click', () => markEnquiryDeclined(l, off))
  return off
}

// "Didn't send it? Put them back" while a send from this card is still the enquiry's latest change (put_back_key, from
// the server): it takes back exactly that send (putBackSend).
function appendPutBack(actions: HTMLElement, l: Lead): void {
  const key = l.put_back_key
  if (!key) return
  const didnt = el('button', { type: 'button', class: 'link-button rebook-didnt-send' }, "Didn't send it? Put them back") as HTMLButtonElement
  didnt.addEventListener('click', () => { didnt.disabled = true; if (!putBackSend(l, key, l.version)) didnt.disabled = false })
  actions.append(didnt)
}

// ---- Follow up as big tiles (Liam, 25 Oct 2026, the "I sent them a quote" pack: "I think B we arent going for quickness
// we are going on quality"; https://claude.ai/artifact/PV95WerZBgk5j9tx6nYsi4, boards 3 to 8) ----------------------------
// Follow up on a waiting or second-message enquiry opens a pop-up like Not done's (their initials in lemon, "What's
// happened with Sarah?", choice tiles): I sent a quote (lemon until they have a price), They replied, Send the second
// message now and I've sent another message (waiting for the second message's day only: the second message's card has
// its own send and "I messaged them myself"), Remind me in a week, Not interested. Each keeps its own save.
// I sent a quote records a quote given outside Roundly (Sarah, quoted on WhatsApp while Roundly still offered the photo
// chase): how it went as six picture tiles, each moving straight on, then the price given. Saved, it is one message out
// (a fresh wait), the price on the enquiry and marked Quote, so it moves to Quote sent and its second message is the
// gentle nudge, five days after the day it was saved. Nothing goes to the customer.
function followUpButton(l: Lead, card: HTMLElement, replied: HTMLElement, today: string): HTMLButtonElement {
  const b = el('button', { type: 'button', class: 'btn-secondary rebook-action-tile enquiry-follow-open', 'aria-label': `Follow up: ${l.name}`, 'aria-haspopup': 'dialog' },
    el('span', { class: 'rebook-action-ring', 'aria-hidden': 'true' }, lineDrawing('arrowRight', 19)),
    el('span', { class: 'rebook-action-words' }, el('strong', {}, 'Follow up'), el('span', {}, "What's next"))) as HTMLButtonElement
  b.addEventListener('click', () => openFollowUp(l, card, replied, today, b))
  return b
}

type QuoteWay = 'whatsapp' | 'text' | 'email' | 'call' | 'door' | 'other'
// How the quote went, in the order the tiles show, with the words the price step and the note line use. A WhatsApp, a
// text, an email or a call is kept in their chat (functions/lib/enquiry-send.ts); at the door or another way is not.
const QUOTE_WAYS: { way: QuoteWay; tile: string; said: string; note: string }[] = [
  { way: 'whatsapp', tile: 'WhatsApp', said: 'By WhatsApp', note: 'by WhatsApp' },
  { way: 'text', tile: 'Text', said: 'By text', note: 'by text' },
  { way: 'email', tile: 'Email', said: 'By email', note: 'by email' },
  { way: 'call', tile: 'Phone call', said: 'On the phone', note: 'on the phone' },
  { way: 'door', tile: 'At the door', said: 'At the door', note: 'at the door' },
  { way: 'other', tile: 'Another way', said: 'Another way', note: 'another way' },
]
const keptInChat = (way: QuoteWay): way is 'whatsapp' | 'text' | 'email' | 'call' => way !== 'door' && way !== 'other'
function quoteWayDrawing(way: QuoteWay): Node {
  return way === 'call' ? lineDrawing('phone') : way === 'door' ? lineDrawing('door') : way === 'other' ? lineDrawing('pencil') : wayIcon(way)
}

function openFollowUp(l: Lead, card: HTMLElement, replied: HTMLElement, today: string, opener: HTMLElement): void {
  const gen = routeGen
  const who = firstName(l.name) || l.name
  const waiting = enquiryStageOf(l, today) === 'waiting'
  const path = `/api/leads/${l.id}`
  const dialog = el('dialog', { class: 'booking-dialog diary-notdone-dialog enquiry-follow-sheet', 'aria-label': `Follow up: ${l.name}` }) as HTMLDialogElement
  const close = el('button', { type: 'button', 'aria-label': 'Close' }, 'Close')
  const said = el('p', {})
  const body = el('div', { class: 'diary-notdone-body' })
  const head = el('div', { class: 'diary-notdone-who' }, el('h2', {}, l.name), said)
  dialog.append(el('header', { class: 'booking-head diary-notdone-head' }, el('span', { class: 'diary-notdone-face', 'aria-hidden': 'true' }, initialsOf(l.name)), head, close), body)
  const shut = (): void => { if (dialog.open) dialog.close() }
  const ask = (words: string): HTMLElement => el('p', { class: 'diary-notdone-ask' }, words)
  const back = (to: () => void): HTMLElement => {
    const b = el('button', { type: 'button', class: 'link-button enquiry-quote-back' }, lineDrawing('chevronLeft', 18), 'Back')
    b.addEventListener('click', to)
    return b
  }
  const sentOn = l.enquiry_messaged_on ? shortDate(l.enquiry_messaged_on) : null
  const intro = sentOn ? `${quoted(l) ? 'Quoted' : 'Messaged'} ${sentOn}` : 'Enquiry'

  // The choices, as Not done's tiles: a picture top left, the words and a line under them at the bottom.
  const choices = (): void => {
    said.textContent = intro
    const busy = enquirySending(l)
    const tiles = el('div', { class: 'diary-notdone-choices', role: 'group', 'aria-label': `What's happened with ${who}?` })
    const tile = <T extends HTMLElement>(node: T, drawing: Drawing, title: string, hint: string, extra = ''): T => {
      node.className = `diary-notdone-choice enquiry-follow-item${extra}`
      node.append(lineDrawing(drawing, 26), el('span', { class: 'diary-notdone-words' }, el('strong', {}, title), el('small', {}, hint)))
      if (busy) node.setAttribute('aria-disabled', 'true')
      tiles.append(node)
      return node
    }
    const choice = (drawing: Drawing, title: string, hint: string, act: (b: HTMLButtonElement) => void, extra = ''): HTMLButtonElement => {
      const b = tile(el('button', { type: 'button' }) as HTMLButtonElement, drawing, title, hint, extra)
      b.disabled = busy
      b.addEventListener('click', () => { shut(); if (routeGen === gen) act(b) })
      return b
    }
    // Lemon until they have a price: the thing an enquiry asked for photos is most likely waiting on.
    const again = quoted(l)
    const quoteTile = tile(el('button', { type: 'button' }) as HTMLButtonElement, 'quote', again ? 'I sent a new quote' : 'I sent a quote', again ? 'Type the new price' : 'Type the price you gave', again ? '' : ' enquiry-follow-go')
    quoteTile.disabled = busy
    quoteTile.addEventListener('click', howStep)
    // They replied: their words pasted into the box under the card's buttons, as before.
    if (phoneMessages() && !card.classList.contains('messages-enquiry-sheet')) choice('reply', 'They replied', 'Paste what they said', () => {
      replied.querySelector<HTMLButtonElement>('.enquiry-replied-open')?.click()
      replied.querySelector('form')?.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' })
    })
    if (waiting && phoneMessages() && !card.classList.contains('messages-enquiry-sheet')) for (const item of enquiryEarlySecond(l, card, today, shut)) {
      const sending = item.classList.contains('enquiry-follow-send')
      const title = item.querySelector('strong')!.textContent!
      const hint = item.querySelector('.rebook-action-words')!.querySelector('span')!.textContent!
      item.className = `diary-notdone-choice enquiry-follow-item ${sending ? 'enquiry-follow-send' : 'enquiry-follow-myself'}`
      item.replaceChildren(lineDrawing(sending ? 'send' : 'bubbleTick', 26), el('span', { class: 'diary-notdone-words' }, el('strong', {}, title), el('small', {}, hint)))
      if (busy) { item.setAttribute('aria-disabled', 'true'); if (item.tagName === 'BUTTON') (item as HTMLButtonElement).disabled = true }
      tiles.append(item)
    }

    const on = addDaysISO(today, 7)
    const waitingForSignal = queuedTaps(path, 'follow_up_on') > 0
    const remind = choice('alarm', waitingForSignal ? 'Remind me: waiting for signal' : 'Remind me in a week', `Back on ${dateChoiceLabel(on)}`, (b) => remindEnquiry(l, b), ' enquiry-follow-remind')
    if (waitingForSignal) remind.disabled = true
    const off = choice('personOff', 'Not interested', "In Didn't go ahead in Messages", (b) => markEnquiryDeclined(l, b), ' diary-notdone-off enquiry-follow-off')
    off.setAttribute('aria-label', `Not interested: ${l.name}`)
    body.replaceChildren(ask(`What's happened with ${who}?`), tiles)
  }

  // How the quote went: six picture tiles, each the answer, moving straight on (a tap, never a form to fill and Next).
  // Lemon is how they are usually messaged.
  const howStep = (): void => {
    said.textContent = quoted(l) ? 'I sent a new quote' : 'I sent a quote'
    const likely = leadWay(l)
    const grid = el('div', { class: 'diary-notdone-why', role: 'group', 'aria-label': 'How did you send it?' })
    for (const w of QUOTE_WAYS) {
      const b = el('button', { type: 'button', class: `diary-notdone-reason enquiry-quote-way${w.way === likely ? ' enquiry-follow-go' : ''}` },
        el('span', { class: 'diary-notdone-ring' }, quoteWayDrawing(w.way)), w.tile)
      b.addEventListener('click', () => priceStep(w.way))
      grid.append(b)
    }
    const usual = QUOTE_WAYS.find((w) => w.way === likely)!.tile
    body.replaceChildren(back(choices), ask('How did you send it?'), grid, el('p', { class: 'muted enquiry-quote-foot' }, `${usual} is lemon: it's how you usually message ${who}.`))
    grid.querySelector<HTMLElement>('.enquiry-follow-go')?.focus({ preventScroll: true })
  }

  // The price given: the two prices the enquiry keeps (Write a quote's), filled in when it has them. What is typed is kept
  // while the pop-up is open, through Change and Back (Astra's review, 25 Oct 2026: changing the way lost it).
  const draft: { regular?: string; first?: string; words?: string; wordsOpen?: boolean; day?: string } = {}
  const priceStep = (way: QuoteWay): void => {
    const w = QUOTE_WAYS.find((q) => q.way === way)!
    const now = todayISO()
    const amount = (p: number | null | undefined): string => p == null ? '' : p % 100 === 0 ? String(p / 100) : (p / 100).toFixed(2)
    const field = (label: string, value: string, keep: (v: string) => void): [HTMLElement, HTMLInputElement] => {
      const input = el('input', { type: 'text', inputmode: 'decimal', autocomplete: 'off', 'aria-label': `${label} price for ${who}`, class: 'enquiry-quote-amount' }) as HTMLInputElement
      input.value = value
      input.addEventListener('input', () => keep(input.value))
      return [el('label', { class: 'enquiry-quote-field' }, el('span', { class: 'enquiry-quote-label' }, label),
        el('span', { class: 'enquiry-quote-money' }, el('span', { 'aria-hidden': 'true' }, currencySymbol()), input)), input]
    }
    const [regularBox, regular] = field('Regular visit', draft.regular ?? amount(l.regular_pence), (v) => { draft.regular = v })
    const [firstBox, first] = field('First clean', draft.first ?? amount(l.initial_pence), (v) => { draft.first = v })
    // The day it went, today unless changed (Astra's review: Friday's quote recorded on Sunday is nudged from Friday).
    const earliest = l.quoted_on && l.quoted_on <= now ? l.quoted_on : addDaysISO(now, -60)
    let day = draft.day && draft.day >= earliest && draft.day <= now ? draft.day : now
    const dayWords = (): string => day === now ? 'today' : day === addDaysISO(now, -1) ? 'yesterday' : dateChoiceLabel(day)
    const wayWords = el('strong', {}, `${w.said}, ${dayWords()}`)
    const change = el('button', { type: 'button', class: 'link-button enquiry-quote-change' }, 'Change')
    change.addEventListener('click', howStep)
    const wayRow = el('div', { class: 'enquiry-quote-wayrow' }, el('span', { class: 'diary-notdone-ring' }, quoteWayDrawing(way)), wayWords, change)
    const dayInput = el('input', { type: 'date', class: 'enquiry-quote-dayinput', 'aria-label': `Day you sent ${who} the quote`, min: earliest, max: now }) as HTMLInputElement
    dayInput.value = day
    const dayRow = el('label', { class: 'enquiry-quote-day' }, el('span', { class: 'enquiry-quote-label' }, 'Day you sent it'), dayInput)
    const words = el('textarea', { rows: '4', class: 'ready-words-input', 'aria-label': `What you sent ${who}` }) as HTMLTextAreaElement
    words.value = draft.words ?? ''
    words.addEventListener('input', () => { draft.words = words.value })
    const wordsBox = el('div', { class: 'enquiry-quote-words' }, el('span', { class: 'enquiry-quote-label' }, 'What you sent'), words)
    wordsBox.hidden = !draft.wordsOpen
    const add = el('button', { type: 'button', class: 'link-button enquiry-quote-add' }, "+ Add what you sent, so it's kept")
    add.hidden = !!draft.wordsOpen
    add.addEventListener('click', () => { draft.wordsOpen = true; add.hidden = true; wordsBox.hidden = false; words.focus() })
    const nudgeWords = el('span', {})
    const sayNudge = (): void => {
      const on = addDaysISO(day, ENQUIRY_SECOND_AFTER_DAYS)
      nudgeWords.textContent = on <= now ? `If ${who} hasn't answered, your gentle nudge is ready now.` : `If ${who} doesn't answer, your gentle nudge is ready on ${dateChoiceLabel(on)}.`
    }
    sayNudge()
    dayInput.addEventListener('change', () => {
      const v = dayInput.value
      day = v && v >= earliest && v <= now ? v : now
      dayInput.value = day
      draft.day = day
      wayWords.textContent = `${w.said}, ${dayWords()}`
      sayNudge()
    })
    const nudge = el('p', { class: 'enquiry-quote-nudge' }, meaningIcon('waiting', 'row'), nudgeWords)
    const error = el('p', { class: 'form-error', role: 'alert' })
    const save = el('button', { type: 'button', class: 'btn-primary enquiry-quote-save' }, 'Save quote sent') as HTMLButtonElement
    save.addEventListener('click', () => {
      let r: number | null, f: number | null
      try { r = parseMoney(regular.value); f = parseMoney(first.value) } catch (err) { error.textContent = `Type ${(err as Error).message}.`; return }
      // A blank box is no price; £0 typed is kept as £0 (a free first clean), but one of them must be a price.
      if (!(r ?? 0) && !(f ?? 0)) { error.textContent = `Type the price you gave ${who}.`; regular.focus(); return }
      error.textContent = ''
      save.disabled = true
      recordQuoteSent(l, way, r, f, keptInChat(way) ? words.value.trim() : '', day, gen, {
        done: shut,
        failed: (why) => { save.disabled = false; error.textContent = why },
      })
    })
    body.replaceChildren(back(howStep), wayRow, ask('What price did you give?'), el('div', { class: 'enquiry-quote-prices' }, regularBox, firstBox),
      ...(keptInChat(way) ? [add, wordsBox] : []), dayRow, nudge, error, save)
    regular.focus({ preventScroll: true })
  }

  choices()
  close.addEventListener('click', shut)
  dialog.addEventListener('close', () => { dialog.remove(); if (opener.isConnected) opener.focus({ preventScroll: true }) })
  document.body.append(dialog)
  dialog.showModal()
}

// One save of the enquiry: one message out on the day it went (a fresh wait, whatever was counted before: the photos
// chase is answered), the price given, Quote as its status when it has none, and a note line ("25 Oct: quote sent by
// WhatsApp, £60 a visit, first clean £70"). A WhatsApp, text, email or call goes as an enquiry send
// (functions/lib/enquiry-send.ts: kept in their chat with any words, their replies up to now seen, a Remind me cleared)
// and its Undo is the server's exact put-back, by the save's own key, also while it waits for signal; at the door or
// another way is a plain save with its own Undo. Every way is held by enquirySending while it is on its way. The nudge
// they had ready (the photos chase, perhaps changed) is forgotten. They move to Quote sent, closed, with one lemon glow
// on their row, unless the screen has changed meanwhile.
const QUOTE_LABEL_START = 'quote sent: '
function recordQuoteSent(l: Lead, way: QuoteWay, regular: number | null, first: number | null, words: string, day: string, gen: number, ui: { done: () => void; failed: (why: string) => void }): void {
  if (enquirySending(l)) { ui.failed(STILL_SAVING_JOB); return }
  // Their message folded away before is a different message now (the nudge), even on the same day: shown again.
  for (const k of [...foldedMessages]) if (k.startsWith(`${l.id}:`)) foldedMessages.delete(k)
  const w = QUOTE_WAYS.find((q) => q.way === way)!
  const prices = [regular !== null ? `${quotePounds(regular)} a visit` : '', first !== null ? `first clean ${quotePounds(first)}` : ''].filter(Boolean).join(', ')
  const note = appendNote(l.contact_note, `${noteDate(day)}: quote sent ${w.note}, ${prices}`)
  const status = quotedStatus(l.status_raw)
  const body: Record<string, unknown> = {
    version: l.version,
    enquiry_messages: 1,
    enquiry_messaged_on: day,
    last_contacted_on: day,
    regular_pence: regular,
    initial_pence: first,
    ...(status ? { status_raw: status } : {}),
  }
  if (note !== (l.contact_note ?? '')) body.contact_note = note
  const kept = keptInChat(way)
  if (kept) body.sent = { way, words: words || null, upto: l.last_in_id ?? 0 }
  else if (l.follow_up_on) body.follow_up_on = null
  // What a plain save's Undo puts back: exactly the fields it changed.
  const before: Record<string, unknown> = {
    enquiry_messages: l.enquiry_messages ?? 0, enquiry_messaged_on: l.enquiry_messaged_on ?? null, last_contacted_on: l.last_contacted_on ?? null,
    regular_pence: l.regular_pence ?? null, initial_pence: l.initial_pence ?? null, contact_note: l.contact_note ?? null,
    ...(status ? { status_raw: l.status_raw ?? null } : {}), ...('follow_up_on' in body ? { follow_up_on: l.follow_up_on ?? null } : {}),
  }
  const path = `/api/leads/${l.id}`
  const label = `Quote sent: ${l.name}`
  const text = `${firstName(l.name) || l.name} moved to Quote sent`
  // Their row, in Quote sent, whatever group, search or tile was showing; only while Messages is still the screen.
  const land = (): void => {
    forgetReady(readyKey(l.id, 'nudge'))
    if (routeGen !== gen) return
    filterText = ''; asked = null; openId = null; landId = `l${l.id}`; void load()
  }
  const after = (): void => { if (routeGen === gen) { focusRestoreId = `l${l.id}`; void load() } }
  // As undoPatch, saying so when the put-back is refused (Astra's third look: a deleted enquiry's 404 went unsaid).
  const plainUndo = (ack: Ack): void => {
    const row = ack.row as { version?: number } | undefined
    const version = typeof row?.version === 'number' ? row.version : l.version + 1
    offerUndo(text, () => {
      void mutate({ label: `Undo quote sent: ${l.name}`, method: 'PATCH', path, body: { version, ...before }, onAck: () => after(),
        onConflict: (back) => { toast(back.error ?? "That quote can't be put back now."); after() } })
        .then((back) => { if (!back.ok && back.status >= 400 && back.status !== 409) { toast(back.error ?? "That quote can't be put back now."); after() } })
    })
  }
  // The server's put-back of this send, by its key: chained behind the save itself while that still waits for signal.
  const sendUndo = (key: string, version: number): void => offerUndo(text, () => {
    void mutate({ label: `Undo quote sent: ${l.name}`, method: 'PATCH', path, body: { version, unsend: key },
      onAck: () => after(),
      onConflict: (back) => {
        for (const q of getQueue()) if (q.path === path && q.status === 'conflict' && !!q.body && typeof q.body === 'object' && 'unsend' in (q.body as Record<string, unknown>)) dismiss(q.key)
        toast(back.error ?? "That quote can't be put back now.")
        after()
      } }).then((back) => { if (!back.ok && back.status >= 400 && back.status !== 409) { toast(back.error ?? "That quote can't be put back now."); after() } })
  })
  void mutate({
    label,
    method: 'PATCH',
    path,
    body,
    // No signal: kept on the phone and sent when it can be; they move now, as for any save waiting for signal.
    onQueued: (m) => { ui.done(); land(); if (kept) sendUndo(m.key, l.version + 1); else plainUndo({ ok: false, status: 0 }) },
    onAck: (ack) => {
      ui.done(); land()
      if (!kept) { plainUndo(ack); return }
      const key = (ack.row as { sent_key?: unknown } | undefined)?.sent_key
      const version = (ack.row as { version?: unknown } | undefined)?.version
      if (typeof key === 'string' && typeof version === 'number') sendUndo(key, version)
      else toast(text)
    },
    // Changed on another phone meanwhile: this save is let go (so a fresh one is not held behind it) and the pop-up says so.
    onConflict: () => {
      for (const q of getQueue()) if (q.path === path && q.status === 'conflict' && q.label === label) dismiss(q.key)
      ui.failed('Changed somewhere else. Close this and look again.')
      if (routeGen === gen) void load()
    },
  }).then((ack) => { if (!ack.ok && ack.status >= 400 && ack.status !== 409) ui.failed(ack.error ?? 'That did not save. Try again.') })
}

// ---- the opened card's picture tiles (design B, Liam, 23 Oct 2026: "Yes i like B ship it") -----------------------------
// Why they are here (a visit that never got done, a visit moved) as an amber tile above the days, and the buttons under
// the message as tiles with a picture and a line saying what each does. Each button keeps its own name, class and
// handler: only what it shows changes.

function whyTile(drawing: Drawing, title: string, line?: string, tone: 'warn' | 'info' = 'warn'): HTMLElement {
  return el('div', { class: tone === 'info' ? 'rebook-why rebook-why-info' : 'rebook-why' }, el('span', { class: 'rebook-why-ring', 'aria-hidden': 'true' }, lineDrawing(drawing, 21)),
    el('span', { class: 'rebook-why-words' }, el('strong', {}, title), ...(line ? [el('span', {}, line)] : [])))
}

function actionTile<T extends HTMLElement>(node: T, drawing: Drawing, title: string, line: string): T {
  clear(node)
  node.classList.remove('ic', 'ic-phone')
  node.classList.add('rebook-action-tile')
  node.append(el('span', { class: 'rebook-action-ring', 'aria-hidden': 'true' }, lineDrawing(drawing, 19)),
    el('span', { class: 'rebook-action-words' }, el('strong', {}, title), el('span', {}, line)))
  return node
}

// Call as a tile: the number it rings (the first number, without a note like "- NO WA"), or why there is no call.
function callTile(phone: string | null | undefined): HTMLElement {
  const tel = telHref(phone)
  const number = phone ? /\+?\d[\d\s().-]*\d/.exec(phone.replace(/\(0\)/g, ''))?.[0].trim() ?? phone : ''
  return tel ? actionTile(el('a', { href: tel, class: 'btn-secondary rebook-call' }), 'phone', 'Call', number)
    : actionTile(el('span', { class: 'btn-secondary rebook-call', 'aria-disabled': 'true' }), 'phone', 'No number', 'Add one on their page')
}

// ---- No days to offer: set them right here (design A, Liam, 23 Oct 2026: "I like a") ----------------------------------
// The week they are pencilled for (else the coming week) as day tiles. A team round taps a day and picks who is out, the
// Diary's Out on this day (POST /api/round-days); a one-person round taps a day to work it, My working days' own save
// (POST /api/work-days). Saved, the day is the one their message offers, with Undo, and the card draws its day tiles.
// "Other day" picks any date. https://claude.ai/artifact/1bsSFUWUnZh79mzFhu8Dr8

// "Fri 30", as the move sheet writes it; never cut out of a day label (a US one reads "Sun, Oct 11").
function shortDayWords(iso: string): string {
  return new Date(`${iso}T12:00:00`).toLocaleDateString(screenLocale(), { weekday: 'short', day: 'numeric' })
}

// The days list reads 45 days ahead (functions/api/round-days WINDOW_DAYS): a day set further out could never be offered.
const SET_DAYS_AHEAD = 44

function workerNames(): string[] {
  const seen = new Map<string, string>() // lowercase → as written
  for (const w of [...roundWorkers, ...roundDays.map((d) => d.worker)]) {
    const t = (w ?? '').trim()
    if (t) seen.set(t.toLowerCase(), t)
  }
  return [...seen.values()].sort((a, b) => a.localeCompare(b))
}

function setDaysHere(today: string, week: string | null, onDay?: (date: string) => void): HTMLElement {
  const alone = worksAlone()
  const start = week && week > today && week <= addDaysISO(today, SET_DAYS_AHEAD - 6) ? week : today
  const grid = el('div', { class: 'messages-set-days', role: 'group', 'aria-label': alone ? 'Days you could work' : 'Days to put someone out' })
  for (let i = 0; i < 7; i++) {
    const day = addDaysISO(start, i)
    const b = el('button', { type: 'button', class: 'messages-set-day', 'aria-label': alone ? `Work ${dayLabel(day)}` : `Choose who’s out on ${dayLabel(day)}` },
      el('strong', {}, shortDayWords(day)), el('span', {}, alone ? 'Not working' : 'Who’s out?')) as HTMLButtonElement
    b.addEventListener('click', () => { if (alone) void workDayHere(day, b, onDay); else openWhoIsOut(day, b, onDay) })
    grid.append(b)
  }
  const other = el('button', { type: 'button', class: 'messages-set-day messages-set-other' }, lineDrawing('calendarPlus', 18), el('span', {}, 'Other day'))
  other.addEventListener('click', () => openWhoIsOut(null, other, onDay))
  grid.append(other)
  return grid
}

// A one-person round's day worked: My working days' save and its Undo (screens/my-days.ts saveDays), which reverses
// only what this save changed.
async function workDayHere(day: string, button: HTMLButtonElement | null, onDay?: (date: string) => void): Promise<boolean> {
  if (button) button.disabled = true
  const what = `Working ${dayLabel(day)}`
  const queued = new Set(getQueue().map((q) => q.key))
  const saving = mutate({ label: what, method: 'POST', path: '/api/work-days', body: { date: day } })
  const key = getQueue().find((q) => !queued.has(q.key) && q.path === '/api/work-days')?.key ?? null
  const ack = await saving
  if (!ack.ok && ack.status >= 400) {
    if (button) button.disabled = false
    toast(ack.error ?? 'That didn’t save. Try again.')
    return false
  }
  onDay?.(day)
  // As My working days: still on the phone and never sent, it is simply taken back; sent but not answered, it lands
  // first, so the Undo never reaches Roundly before the save it undoes (GPT-6.1's review).
  if (key) offerUndo(what, () => {
    if (withdraw(key)) { void load(); return }
    void (async () => {
      if (getQueue().some((q) => q.key === key)) await flushQueue()
      await mutate({ label: `Undo: ${what}`, method: 'POST', path: '/api/work-days/undo', body: { key }, onAck: () => void load(), onConflict: () => void load() })
    })()
  })
  void load()
  return true
}

function openWhoIsOut(date: string | null, opener: HTMLElement, onDay?: (date: string) => void): void {
  const alone = worksAlone()
  let day = date ?? addDaysISO(todayISO(), 1)
  let worker = ''
  const dialog = el('dialog', { class: 'booking-dialog who-out-dialog' }) as HTMLDialogElement
  const close = el('button', { type: 'button', 'aria-label': 'Close' }, 'Close')
  const title = el('h2', {})
  const body = el('div', { class: 'who-out-body' })
  const save = el('button', { type: 'button', class: 'btn-primary who-out-save' }) as HTMLButtonElement
  const error = el('p', { class: 'form-error', role: 'alert' })
  const words = (): void => {
    title.textContent = alone ? `Work ${dayLabel(day)}?` : `Who’s out on ${dayLabel(day)}?`
    save.textContent = alone ? `Work ${dayLabel(day)} and offer it` : `Save and offer ${dayLabel(day)}`
    save.disabled = !alone && !worker.trim()
  }
  if (!date) {
    const dayInput = el('input', { type: 'date', min: todayISO(), max: addDaysISO(todayISO(), SET_DAYS_AHEAD), 'aria-label': 'Day' }) as HTMLInputElement
    dayInput.value = day
    dayInput.addEventListener('change', () => { if (dayInput.value && dayInput.value >= todayISO() && dayInput.value <= addDaysISO(todayISO(), SET_DAYS_AHEAD)) { day = dayInput.value; words() } else dayInput.value = day })
    body.append(el('label', { class: 'who-out-day' }, el('span', {}, 'Day'), dayInput))
  }
  if (!alone) {
    const me = getMe()?.workerName?.trim().toLowerCase() ?? ''
    const group = el('div', { class: 'who-out-names', role: 'group', 'aria-label': 'Who is out' })
    const tiles: HTMLButtonElement[] = []
    const other = el('input', { type: 'text', class: 'who-out-other', maxlength: '100', placeholder: 'Their name', 'aria-label': 'Their name', hidden: '' }) as HTMLInputElement
    const pick = (name: string | null, tile: HTMLButtonElement): void => {
      for (const t of tiles) t.setAttribute('aria-pressed', String(t === tile))
      other.hidden = name !== null
      worker = name ?? other.value.trim()
      if (name === null) other.focus()
      words()
    }
    for (const name of workerNames()) {
      const isMe = !!me && name.toLowerCase() === me
      const tile = el('button', { type: 'button', class: 'who-out-name', 'aria-pressed': 'false' },
        el('span', { class: 'who-out-ring', 'aria-hidden': 'true' }, initialsOf(name)),
        el('span', { class: 'who-out-words' }, el('strong', {}, isMe ? 'You' : name), ...(isMe ? [el('span', {}, name)] : []))) as HTMLButtonElement
      tile.addEventListener('click', () => pick(name, tile))
      tiles.push(tile); group.append(tile)
    }
    const someone = el('button', { type: 'button', class: 'who-out-name who-out-someone', 'aria-pressed': 'false' },
      el('span', { class: 'who-out-ring', 'aria-hidden': 'true' }, lineDrawing('personPlus', 18)), el('span', { class: 'who-out-words' }, el('strong', {}, 'Someone else'))) as HTMLButtonElement
    someone.addEventListener('click', () => pick(null, someone))
    tiles.push(someone); group.append(someone)
    other.addEventListener('input', () => { worker = other.value.trim(); words() })
    body.append(group, other)
    if (tiles.length === 1) pick(null, someone)
  }
  body.append(el('p', { class: 'who-out-note muted' }, alone ? 'It goes in My working days, and the day is offered to them. Undo puts it back.' : 'They go on the Diary for that day, and the day is offered to them. Undo puts it back.'), error, pinFoot(save))
  save.addEventListener('click', () => {
    if (alone) {
      save.disabled = true
      void workDayHere(day, null, onDay).then((ok) => { if (ok && dialog.open) dialog.close(); else save.disabled = false })
      return
    }
    const who = worker.trim().slice(0, 100)
    if (!who) return
    save.disabled = true
    const queued = new Set(getQueue().map((q) => q.key))
    const saving = mutate<RoundDay>({
      label: `${who} out on ${day}`, method: 'POST', path: '/api/round-days', body: { date: day, worker: who },
      onConflict: () => { error.textContent = 'Someone is already out that day. Close this and look again.'; void load() },
    })
    const key = getQueue().find((q) => !queued.has(q.key) && q.path === '/api/round-days')?.key ?? null
    void saving.then((ack) => {
      if (!ack.ok && ack.status >= 400) { if (ack.status !== 409) error.textContent = ack.error ?? 'That didn’t save. Try again.'; save.disabled = false; return }
      if (dialog.open) dialog.close()
      onDay?.(day)
      // Undo takes the day off again. Waiting for signal (GPT-6.1's review), it is taken back off the phone; sent
      // meanwhile, the day is found by its date and name once it has landed.
      offerUndo(`${who} is out on ${dayLabel(day)}`, () => {
        if (key && withdraw(key)) { void load(); return }
        void (async () => {
          if (key && getQueue().some((q) => q.key === key)) await flushQueue()
          const row = ack.row ?? (await api<{ round_days: RoundDay[] }>(`/api/round-days?from=${day}&to=${day}`).catch(() => null))?.round_days.find((r) => r.date === day && r.worker === who)
          if (!row) { toast('Couldn’t undo that yet. Take the day off in the Diary.'); return }
          await mutate({ label: `Undo ${who} out on ${day}`, method: 'DELETE', path: `/api/round-days/${row.id}`, body: { version: row.version }, onAck: () => void load(), onConflict: () => void load() })
        })()
      })
      void load()
    })
  })
  words()
  close.addEventListener('click', () => dialog.close())
  dialog.append(el('header', { class: 'booking-head' }, title, close), body)
  dialog.addEventListener('close', () => { dialog.remove(); if (opener.isConnected) opener.focus({ preventScroll: true }) })
  document.body.append(dialog)
  dialog.showModal()
}

// ---- their price, how often and their tier (design B, Liam, 23 Oct 2026) -----------------------------------------------
// The customer's own fields, the same ones their customer page and the Work sheet edit, so one usual price, one cycle and
// one tier per customer and no second copy. The tile says them in one line; the pop-up changes them together, one Save,
// one Undo. Visits already booked keep their own price (changing one and every one after is the visit's own price
// pop-up in the Diary: price-edit.ts).

function everyWordsOf(c: RoundCustomer): string {
  const label = cycleLabel(c.cycle_days, c.cycle_text)
  if (!label) {
    // A guess is worded as one, as the old Every box did, so the card never looks like it was told a cycle.
    const cyc = effectiveCycle(c)
    return cyc.guessed && cyc.days ? `about every ${weeksOf(cyc.days)} (a guess)` : 'no cycle set'
  }
  return label === 'yearly' || label === 'when they ask' ? label : `every ${label}`
}

function priceTile(c: RoundCustomer): HTMLElement {
  const price = c.reg_price_pence != null ? money(c.reg_price_pence) : 'No price yet'
  // The first clean price matters until they have had one (Liam: "What if its adhoc pricing or initial quote").
  const firstClean = !c.last_clean && c.first_clean_price_pence != null ? `First clean ${money(c.first_clean_price_pence)}` : ''
  const tier = (c.tier ?? '').trim()
  const tierWords = legacyTier(c.tier) ? `Tier: ${tier}` : tier ? `Tier ${tier}` : 'Tier not set'
  const line = `${price} ${everyWordsOf(c)}`
  const tile = el('button', { type: 'button', class: 'rebook-price-tile', 'aria-label': `${line}. ${[firstClean, tierWords].filter(Boolean).join('. ')}. Change ${c.name}'s price, how often or tier` },
    el('span', { class: 'rebook-price-ring', 'aria-hidden': 'true' }, lineDrawing('pound', 21)),
    el('span', { class: 'rebook-price-words' }, el('strong', {}, line), el('span', {}, [firstClean, tierWords].filter(Boolean).join(' · '))),
    lineDrawing('chevronRight', 18))
  tile.addEventListener('click', () => openPriceSheet(c, tile))
  return tile
}

function openPriceSheet(c: RoundCustomer, opener: HTMLElement): void {
  const who = firstName(c.name) || c.name
  const dialog = el('dialog', { class: 'booking-dialog price-sheet-dialog', 'aria-label': `${who}'s price and visits` }) as HTMLDialogElement
  const close = el('button', { type: 'button', 'aria-label': 'Close' }, 'Close')
  const body = el('div', { class: 'price-sheet-body' })
  const amount = (p: number | null | undefined): string => p == null ? '' : (p / 100).toFixed(2)
  const moneyField = (label: string, value: number | null | undefined, big: boolean): HTMLInputElement => {
    const input = el('input', { type: 'text', inputmode: 'decimal', autocomplete: 'off', 'aria-label': label, class: big ? 'price-sheet-amount' : 'price-sheet-small' }) as HTMLInputElement
    input.value = amount(value)
    return input
  }
  // Usual price: typed, or a pound at a time with − and +.
  const usual = moneyField('Usual price', c.reg_price_pence, true)
  // As wide as what is typed, so the pound sign sits against the number in the middle of the box.
  const fit = (): void => { usual.style.width = `${Math.max(usual.value.length, 4) + 1.5}ch` }
  usual.addEventListener('input', fit)
  fit()
  const nudge = (by: number): void => {
    let now = 0
    try { now = parseMoney(usual.value) ?? 0 } catch { now = 0 }
    usual.value = amount(Math.max(0, now + by))
    fit()
  }
  const less = el('button', { type: 'button', class: 'price-sheet-step', 'aria-label': `${currencySymbol()}1 less` }, '−')
  const more = el('button', { type: 'button', class: 'price-sheet-step', 'aria-label': `${currencySymbol()}1 more` }, '+')
  // A tap moves a pound; holding keeps going, faster the longer it is held (Liam, 23 Oct 2026: "If we hold the press or
  // mins button could it go through increments quicker single taps retain one at a time?").
  let holding = 0
  const letGo = (): void => { clearTimeout(holding); holding = 0 }
  const holdToRepeat = (button: HTMLElement, by: number): void => {
    button.addEventListener('pointerdown', (e) => {
      if (e.button !== 0) return
      letGo()
      nudge(by)
      let n = 0
      const again = (): void => { n++; nudge(by); holding = window.setTimeout(again, n < 8 ? 120 : n < 25 ? 60 : 30) }
      holding = window.setTimeout(again, 400)
    })
    for (const name of ['pointerup', 'pointerleave', 'pointercancel']) button.addEventListener(name, letGo)
    // The keyboard's Enter or Space (a click with no pointer behind it) still moves one pound.
    button.addEventListener('click', (e) => { if (e.detail === 0) nudge(by) })
    // A long press on a phone would otherwise offer to copy or select.
    button.addEventListener('contextmenu', (e) => e.preventDefault())
  }
  holdToRepeat(less, -100)
  holdToRepeat(more, 100)
  body.append(el('div', { class: 'price-sheet-field' }, el('span', { class: 'price-sheet-label' }, 'Usual price'),
    el('div', { class: 'price-sheet-stepper' }, less, el('label', { class: 'price-sheet-money' }, el('span', { 'aria-hidden': 'true' }, currencySymbol()), usual), more)))
  const firstClean = moneyField('First clean price', c.first_clean_price_pence, false)
  body.append(el('div', { class: 'price-sheet-row' }, el('span', { class: 'price-sheet-label' }, 'First clean'), el('label', { class: 'price-sheet-money price-sheet-money-small' }, el('span', { 'aria-hidden': 'true' }, currencySymbol()), firstClean)))
  const chips = (choices: [string, string][], picked: () => string, pick: (v: string) => void, label: string): HTMLElement => {
    const group = el('div', { class: 'price-sheet-chips', role: 'group', 'aria-label': label })
    const draw = (): void => { for (const b of Array.from(group.children) as HTMLButtonElement[]) b.setAttribute('aria-pressed', String(b.dataset.value === picked())) }
    for (const [value, words] of choices) {
      const b = el('button', { type: 'button', class: 'price-sheet-chip', 'data-value': value }, words) as HTMLButtonElement
      b.addEventListener('click', () => { pick(value); draw() })
      group.append(b)
    }
    draw()
    return group
  }
  // How often, the one question (src/how-often.ts; Liam, 27 Oct 2026, design D): saved with Save, as before.
  let oftenNow: Often | null = null, oftenKindNow: OftenKind | null = oftenKind({ days: c.cycle_days ?? null, marker: c.cycle_text ?? null })
  const oftenPick = howOftenPicker({ value: { days: c.cycle_days ?? null, marker: c.cycle_text ?? null }, question: 'How often?', onChange: (v, k) => { oftenNow = v; oftenKindNow = k } })
  body.append(el('div', { class: 'price-sheet-field price-sheet-often' }, oftenPick.node))
  // Tier, unless it is an old one kept as context (moved from Customer context).
  let tier = (c.tier ?? '').trim()
  const startTier = tier
  if (!legacyTier(c.tier)) {
    const tiers: [string, string][] = [['', 'Not set'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4']]
    if (tier && !tiers.some(([v]) => v === tier)) tiers.push([tier, tier])
    body.append(el('div', { class: 'price-sheet-field' }, el('span', { class: 'price-sheet-label' }, 'Tier'), chips(tiers, () => tier, (v) => { tier = v }, 'Tier')))
  }
  else body.append(el('p', { class: 'price-sheet-note muted' }, `Tier holds an old note ("${tier}"). Move it using Customer context.`))
  if (c.next_booked) body.append(el('p', { class: 'price-sheet-note muted' }, `Visits already booked keep their own price. To change ${shortDate(c.next_booked)} and every one after, tap its price in the Diary.`))
  const error = el('p', { class: 'form-error', role: 'alert' })
  const save = el('button', { type: 'button', class: 'btn-primary price-sheet-save' }, 'Save') as HTMLButtonElement
  body.append(error, pinFoot(save))
  save.addEventListener('click', () => {
    let price: number | null, first: number | null
    try { price = parseMoney(usual.value); first = parseMoney(firstClean.value) } catch (err) { error.textContent = `Type ${(err as Error).message}.`; return }
    const patch: Record<string, unknown> = {}
    const was: Record<string, unknown> = {}
    if (price !== (c.reg_price_pence ?? null)) { patch.reg_price_pence = price; was.reg_price_pence = c.reg_price_pence ?? null }
    if (first !== (c.first_clean_price_pence ?? null)) { patch.first_clean_price_pence = first; was.first_clean_price_pence = c.first_clean_price_pence ?? null }
    if (oftenKindNow === 'regular' && !oftenNow) { error.textContent = 'Pick every how many weeks.'; return }
    if (oftenNow && (oftenNow.days !== (c.cycle_days ?? null) || (!oftenNow.days && cycleLabel(null, oftenNow.marker) !== cycleLabel(null, c.cycle_text)))) {
      // The number and the words together, so they never drift; a note worth keeping stays on a number.
      const keepNote = cycleNoteIsMeaningful(c.cycle_days, c.cycle_text)
      Object.assign(patch, { cycle_days: oftenNow.days, cycle_text: oftenNow.marker ?? (keepNote ? c.cycle_text ?? null : null) })
      was.cycle_days = c.cycle_days ?? null; was.cycle_text = c.cycle_text ?? null
    }
    if (tier !== startTier) {
      patch.tier = tier || null
      was.tier = c.tier ?? null
      if (typeof c.tier_by_hand === 'number') was.tier_by_hand = c.tier_by_hand
    }
    if (!Object.keys(patch).length) { dialog.close(); return }
    save.disabled = true
    const path = `/api/customers/${c.id}`
    void mutate({
      label: `Price and visits: ${c.name}`, method: 'PATCH', path, body: { version: c.version, ...patch },
      onAck: (ack) => {
        if (!ack.ok && ack.status >= 400) { save.disabled = false; error.textContent = ack.error ?? 'That did not save. Try again.'; return }
        if (dialog.open) dialog.close()
        void load()
        undoPatch({ text: `Changed ${c.name}'s price and visits`, label: `Undo price and visits: ${c.name}`, path, ack, version: c.version, body: was, after: () => void load() })
      },
      onConflict: () => { save.disabled = false; error.textContent = 'Changed somewhere else. Close this and look again.'; void load() },
      // No signal: kept on the phone and sent when it can be, so the pop-up closes and Undo is offered at once, as for any
      // save waiting for signal (Astra's review, 24 Oct 2026: it sat there with Save greyed out).
      onQueued: () => {
        if (dialog.open) dialog.close()
        void load()
        undoPatch({ text: `Changed ${c.name}'s price and visits`, label: `Undo price and visits: ${c.name}`, path, ack: { ok: false, status: 0 }, version: c.version, body: was, after: () => void load() })
      },
    })
  })
  close.addEventListener('click', () => dialog.close())
  dialog.append(el('header', { class: 'booking-head' }, el('h2', {}, `${who}'s price and visits`), close), body)
  dialog.addEventListener('close', () => { letGo(); dialog.remove(); if (opener.isConnected) opener.focus({ preventScroll: true }) })
  document.body.append(dialog)
  dialog.showModal()
}

// ---- lapsed: the ones already off the list ----------------------------------
// Their own card rather than a branch through customerCard: nothing on the
// ladder applies to them (no second message, no taking them off again), and
// the screen Liam's rebooking runs on is not the place to thread a fifth stage
// through code that works.

// Asking a lapsed customer back PROMISES money off, so the promise is written
// into their note where the booking form and their page both show it. The
// count of rebook messages is deliberately NOT touched: that counter drives the
// ladder for customers on the round, and these are not on it.
function recordWinback(c: RoundCustomer, button: HTMLElement, way: CustomerMessageBy = wayFor(c)): void {
  const today = todayISO()
  const line = winbackNoteLine(noteDate(today), noteWord(way))
  const note = appendNote(c.contact_note, line)
  const body: Record<string, unknown> = { version: c.version, last_contacted_on: today }
  if (note !== (c.contact_note ?? '')) body.contact_note = note
  void mutate({
    label: `Winback ${wayWords(way).noun}: ${c.name}`,
    method: 'PATCH',
    path: `/api/customers/${c.id}`,
    body,
    onAck: (ack) => {
      alert4xx(ack)
      void load()
      undoPatch({ text: `Asked ${c.name} back`, label: `Undo asked back: ${c.name}`, path: `/api/customers/${c.id}`, ack, version: c.version,
        body: { last_contacted_on: c.last_contacted_on ?? null, contact_note: c.contact_note ?? null }, after: () => void load() })
    },
    onConflict: () => void load(),
  })
  button.setAttribute('aria-disabled', 'true')
}

// Back on the round: status only. Booking them is a separate, ordinary
// booking — this is the bit that would otherwise be forgotten, and without it
// a customer who says yes stays lapsed and falls out of the round again.
function markActiveAgain(c: RoundCustomer, button: HTMLButtonElement): void {
  button.disabled = true
  void mutate({
    label: `Back on the round: ${c.name}`,
    method: 'PATCH',
    path: `/api/customers/${c.id}`,
    body: { version: c.version, status: 'active' },
    onAck: (ack) => {
      alert4xx(ack)
      if (!ack.ok) button.disabled = false
      void load()
      undoPatch({ text: `${c.name} is back on the round`, label: `Undo back on round: ${c.name}`, path: `/api/customers/${c.id}`, ack, version: c.version,
        body: { status: c.status }, after: () => void load() })
    },
    onConflict: () => void load(),
  })
}

function lapsedTile(c: RoundCustomer, rerender: () => void): HTMLElement {
  const tile = el('button', { type: 'button', class: 'rebook-tile rebook-tile-lapsed', 'aria-expanded': 'false', 'aria-label': `Open ${c.name}` })
  tile.append(el('span', { class: 'rebook-tile-name' }, c.name))
  const bits = [c.reg_price_pence != null ? money(c.reg_price_pence) : '', streetShort(c.address)].filter(Boolean).join(' · ')
  if (bits) tile.append(el('span', { class: 'rebook-tile-meta' }, bits))
  tile.append(el('span', { class: 'rebook-tile-line' }, c.last_clean ? `last visit ${shortDate(c.last_clean)}` : 'no visits'))
  tile.addEventListener('click', () => { openRow(`c${c.id}`); rerender() })
  return tile
}

function lapsedCard(c: RoundCustomer, today: string): HTMLElement {
  const card = el('div', { class: 'rebook-card rebook-card-lapsed' })
  const top = el('div', { class: 'rebook-card-top' })
  const who = el('div', { class: 'rebook-card-who' })
  who.append(el('a', { href: `#/customer/${c.id}`, class: 'rebook-card-name' }, c.name))
  if (c.address) who.append(el('span', { class: 'rebook-card-address' }, c.address))
  top.append(who, el('span', { class: 'rebook-pill rebook-pill-cold' }, 'off the list'))
  card.append(top)

  const facts = el('div', { class: 'rebook-facts' })
  const fact = (label: string, value: string): HTMLElement => el('div', { class: 'rebook-fact' }, el('span', { class: 'rebook-fact-label' }, label), el('span', { class: 'rebook-fact-value' }, value))
  facts.append(fact('Usual price', c.reg_price_pence != null ? money(c.reg_price_pence) : 'Not set'))
  facts.append(fact('Every', cycleLabel(c.cycle_days, c.cycle_text) || 'Not set'))
  facts.append(fact('Last visit', c.last_clean ? shortDate(c.last_clean) : 'none'))
  card.append(facts)

  // Asked already? The date is the whole point of the group: it is what stops
  // the same person being asked back twice in a fortnight.
  if (c.last_contacted_on) card.append(el('p', { class: 'rebook-sent-line' }, `Last contacted ${shortDate(c.last_contacted_on)}`))

  const body = rebookMessage({ name: c.name, kind: 'winback', lastClean: c.last_clean })
  const preview = el('div', { class: 'rebook-preview' })
  const previewHead = el('div', { class: 'rebook-preview-head' })
  previewHead.append(el('span', { class: 'rebook-fact-label' }, 'Message to send'))
  previewHead.append(previewTools(copyMessageButton(body, c.name), wordingLink('rebook_winback')))
  preview.append(previewHead)
  preview.append(el('p', { class: 'rebook-preview-text' }, body))
  card.append(preview)

  const actions = el('div', { class: 'rebook-card-actions' })
  const control = sendControl(c, body, `Hello again from ${businessSettings().business_name}`, {
    label: (way) => (way === 'text' ? 'Ask them back by text' : way === 'email' ? 'Ask them back by email' : 'Ask them back on WhatsApp'),
    className: 'btn-whatsapp rebook-send',
    onSend: (way) => { if (control.link) recordWinback(c, control.link, way) },
    changed: () => void load(),
    onConflict: () => void load(),
  })
  actions.append(control.root)
  const askedAlready = alreadySentButton(c.name, () => recordWinback(c, askedAlready))
  actions.append(askedAlready)
  card.append(actions)

  const row = el('div', { class: 'rebook-card-row' })
  const back = el('button', { type: 'button', class: 'btn-secondary', 'aria-label': `Put ${c.name} back on the round` }, 'They said yes, back on the round')
  back.addEventListener('click', () => markActiveAgain(c, back))
  row.append(back)
  const tel = telHref(c.phone)
  if (tel) row.append(el('a', { href: tel, class: 'rebook-call ic ic-phone' }, 'Call'))
  card.append(row)
  card.append(el('p', { class: 'muted rebook-winback-note' }, `Putting them back on the round is what returns them to Work and to the message list. The ${WINBACK_DISCOUNT_PERCENT}% goes in their notes when you send, so the booking form shows it.`))
  return card
}

// Old quotes: one line each with both buttons on it, no card to open, so a pile of forty can be
// worked through quickly (Liam: "an easy to delete button").
const OLD_QUOTES_TITLE = 'Old quotes · one last try, or remove'

// last: the only old quote left, so removing it clears Old quotes (oldQuotesCleared).
function oldQuoteRow(l: Lead, last = false): HTMLElement {
  const li = el('li', { class: 'oldq-row' })
  const who = el('div', { class: 'oldq-who' })
  who.append(el('span', { class: 'oldq-name' }, l.name))
  const price = l.regular_pence ?? l.initial_pence
  const bits = [l.quoted_on ? `Quoted ${shortDate(l.quoted_on)}` : 'No date', price !== null && price !== undefined ? money(price) : '', streetShort(l.address) || l.phone || ''].filter(Boolean).join(' · ')
  who.append(el('span', { class: 'oldq-meta muted' }, bits))
  const sentOn = lastTrySentOn(l)
  if (sentOn) who.append(el('span', { class: 'oldq-sent' }, `Last try sent ${sentOn}`))
  li.append(who)
  const actions = el('div', { class: 'oldq-actions' })
  if (!sentOn) {
    // One last try per row: the first tap opens the message and records it; any tap after that, on
    // either link, does nothing until the page redraws (Codex review 2026-09-28).
    const links: HTMLAnchorElement[] = []
    let tried = false
    const recordOnce = (channel: NoteChannel): void => {
      if (tried) return
      tried = true
      for (const a of links) { a.setAttribute('aria-disabled', 'true'); a.classList.add('oldq-done') }
      recordLastTry(l, channel)
    }
    const phoneLink = leadPhoneLink(l.phone, enquiryLastTryMessage(l.name), { own: l.message_by })
    const wa = phoneLink.href
    if (wa) {
      const way = phoneLink.channel === 'text' ? 'text' : 'whatsapp'
      const link = el('a', { href: wa, target: way === 'text' ? '_self' : '_blank', rel: 'noopener', class: 'btn-whatsapp oldq-try', 'aria-label': `Last try ${way === 'text' ? 'by text' : 'on WhatsApp'} to ${l.name}` })
      link.append(wayIcon(way), el('span', {}, 'Last try'))
      bindEmailSend(link, () => tried ? null : { href: wa, name: l.name, sent: () => recordOnce(phoneLink.channel) })
      links.push(link)
      actions.append(link)
    }
    const mail = lastTryEmailHref(l.email, l.name)
    if (mail) {
      const mlink = el('a', { href: mail, class: 'icon-btn icon-btn-mail', 'aria-label': `Last try by email to ${l.name}` })
      mlink.append(mailIcon())
      bindEmailSend(mlink, () => tried ? null : { href: mail, sent: () => recordOnce('email') })
      links.push(mlink)
      actions.append(mlink)
    }
    if (!wa && !mail) actions.append(el('span', { class: 'muted oldq-none' }, 'No number or email'))
  }
  const remove = el('button', { type: 'button', class: 'btn-secondary oldq-remove', 'aria-label': `Remove ${l.name}: didn't go ahead` }, 'Remove')
  remove.addEventListener('click', () => { oldQuotesClearing = last ? l.id : null; markEnquiryDeclined(l, remove) })
  actions.append(remove)
  li.append(actions)
  return li
}

function oldQuotesSection(root: HTMLElement, rows: Lead[], rerender: () => void): void {
  // Left off when nobody is in it, like every other group (Liam, 16 Oct 2026: "old quotes say 0 but its showing");
  // picked under Filter it still shows, saying None.
  // The last one has just gone: a tick says so, then the group folds away. Until the page is drawn without them (the
  // Remove still on its way), they stay marked; a Remove that fails leaves them on the list and the moment passes.
  const clearing = oldQuotesClearing
  if (clearing !== null && !rows.some((r) => r.id === clearing)) oldQuotesClearing = null
  if (!rows.length && clearing !== null && !filterText.trim() && (stageFilter === 'all' || stageFilter === 'oldquotes')) { root.append(oldQuotesCleared(rerender)); return }
  if (!rows.length && stageFilter !== 'oldquotes') return
  const sec = el('section', { class: 'rebook-stage rebook-stage-oldquotes' })
  sec.hidden = stageFilter !== 'all' && stageFilter !== 'oldquotes' && stageFilter !== 'home:enquiries'
  const head = el('div', { class: 'rebook-stage-head' })
  head.append(el('h2', { class: 'rebook-stage-title' }, meaningIcon('enquiries', 'row'), OLD_QUOTES_TITLE))
  head.append(el('span', { class: 'rebook-stage-count' }, String(rows.length)))
  sec.append(head, el('p', { class: 'rebook-blurb muted' }, "Quotes over a month old that nobody has chased. Send one last message, or remove the ones that are finished: they move to Didn't go ahead on New jobs."))
  if (!rows.length) { sec.classList.add('rebook-stage-empty'); sec.append(el('p', { class: 'empty-note' }, 'None.')); foldSection(sec, 'oldquotes', stageFilter === 'oldquotes'); root.append(sec); return }
  const all = expanded.has(OLD_QUOTES_TITLE) || !!filterText.trim()
  const list = el('ul', { class: 'oldq-list' })
  for (const l of all ? rows : rows.slice(0, TILES_SHOWN)) list.append(oldQuoteRow(l, rows.length === 1 && !filterText.trim()))
  sec.append(list)
  if (rows.length > TILES_SHOWN && !filterText.trim()) {
    const more = el('button', { type: 'button', class: 'btn-secondary rebook-show-all' }, all ? 'Show fewer' : `Show all ${rows.length}`)
    more.addEventListener('click', () => { if (expanded.has(OLD_QUOTES_TITLE)) expanded.delete(OLD_QUOTES_TITLE); else expanded.add(OLD_QUOTES_TITLE); rerender() })
    sec.append(more)
  }
  foldSection(sec, 'oldquotes', !!filterText.trim() || stageFilter === 'oldquotes')
  root.append(sec)
}

// ---- A pile cleared (Liam, 16 Oct 2026: "if we completely clear old messages feel like there should a really satisfying
// animation", and "an even better one" when every group is clear). Designs: "Old quotes cleared" canvas. -------------
// The tick, drawn in with a burst of sparks: small on Old quotes, big with confetti when all of To send is clear. With
// reduced motion the tick is simply there and nothing flies (messages.css).
export function clearedMark(big: boolean): HTMLElement {
  const mark = el('span', { class: `cleared-mark${big ? ' cleared-mark-big' : ''}`, 'aria-hidden': 'true' })
  for (let i = 0; i < (big ? 16 : 8); i++) mark.append(el('span', { class: 'cleared-spark' }))
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('viewBox', '0 0 64 64'); svg.setAttribute('class', 'cleared-tick')
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  path.setAttribute('d', 'M20 33l8 8 16-17')
  svg.append(path)
  mark.append(svg)
  return mark
}

// Day done (Liam, 22 Oct 2026), shared by Today and the Diary (Liam said yes to D4: the computer marks jobs done in the
// Diary). The whole day, never a filtered list (Astra): every job of it done or answered with Couldn't do it. Once per
// round per day on this phone, whichever screen showed it first; marked seen the moment it shows (Astra, 23 Oct 2026: left
// within a moment, it came back later as a second one), and a redraw while it is up puts the same box back (keepDayDone).
export interface DayDoneVisit { state?: string | null; blocked_reason?: string | null; amount_pence?: number | null }
export function dayIsDone(visits: DayDoneVisit[]): boolean {
  const counted = visits.filter((c) => c.state !== 'cancelled')
  return counted.length > 0 && !counted.some((c) => c.state === 'booked' && !c.blocked_reason)
}
// The box while it is on its few seconds: a redraw straight after the last Done (the save coming back, the Undo bar)
// puts it back where it was rather than losing it, and an Undo of that Done takes it away (Sonnet's review, 23 Oct 2026).
let dayDoneLive: { day: string; box: HTMLElement } | null = null
// Since 27 Oct 2026 the moment covers the screen (day-done-moment.ts), so a redraw cannot lose it; an Undo of that last
// Done takes it away. `place` stays for the callers.
// Still waiting behind a sheet (the payment message) to play: an Undo of that last Done meanwhile stops it, so it never
// plays on a day no longer done (the Help terminal's check, 27 Oct 2026), and it can play when the day is done again.
let dayDonePending: { day: string; cancelled: boolean; key: string } | null = null
export function keepDayDone(_place: (box: HTMLElement) => void, day: string, visits: DayDoneVisit[]): void {
  if (dayDonePending?.day === day && !dayIsDone(visits)) {
    dayDonePending.cancelled = true
    try { localStorage.removeItem(dayDonePending.key) } catch { /* no storage */ }
    dayDonePending = null
  }
  if (!dayDoneLive || dayDoneLive.day !== day) return
  if (!dayDoneLive.box.isConnected) { dayDoneLive = null; return }
  if (!dayIsDone(visits)) { dayDoneLive.box.remove(); dayDoneLive = null }
}
export function showDayDone(place: (box: HTMLElement) => void, day: string, visits: DayDoneVisit[], hidePrices: boolean): void {
  if (day !== todayISO() || getMe()?.role !== 'owner' || !dayIsDone(visits)) return
  // Already on its few seconds (finished in the Diary, then straight back to Today): the same box, never a second one
  // (GPT-6.1's review, 23 Oct 2026).
  if (dayDoneLive?.day === day && dayDoneLive.box.isConnected) return
  const key = `roundly:day-done:${getMe()?.businessId ?? ''}:${day}`
  try { if (localStorage.getItem(key)) return } catch { /* no storage: shown anyway */ }
  const done = visits.filter((c) => c.state === 'done')
  const worked = done.reduce((n, c) => n + (c.amount_pence ?? 0), 0)
  const words = `${done.length} done${hidePrices ? '' : ` · ${money(worked)} worked`}`
  // The big one (Liam's pick 4, 27 Oct 2026): over the whole screen for four seconds, the blob dancing in the finished
  // ring. Wherever the last Done was, Today or the Diary.
  // A sheet that opened with the last Done (the payment message, Job done) would cover it: it waits until that is
  // closed, then plays (a dialog sits above anything else on the page). Marked seen at once, so it is still once a day.
  void place
  try { localStorage.setItem(key, '1') } catch { /* no storage */ }
  const started = Date.now()
  const pending = { day, cancelled: false, key }
  dayDonePending = pending
  const whenClear = (): void => {
    if (pending.cancelled) return
    if (document.querySelector('dialog[open]') && Date.now() - started < 10 * 60_000) { window.setTimeout(whenClear, 300); return }
    if (dayDonePending === pending) dayDonePending = null
    dayDoneLive = { day, box: showDayDoneMoment(words) }
    buzz('success')
    // Send all payment texts (0093, B1): with people waiting for a payment text, the card under the figures.
    const box = dayDoneLive.box
    if (sendAllOn()) void import('../send-all-sheet').then((m) => m.askDayDone(box)).catch(() => { /* no signal for Send all's screens: nothing shows */ })
  }
  whenClear()
}

// The last old quote has just been removed: Old quotes says Cleared with the tick and a buzz, holds a moment, then folds
// away and the page is drawn without it (which may leave all of To send clear: allCaughtUp). Undo still puts it back.
function oldQuotesCleared(rerender: () => void): HTMLElement {
  const sec = el('section', { class: 'rebook-stage rebook-stage-oldquotes oldq-cleared', 'aria-label': 'Old quotes' })
  const head = el('div', { class: 'rebook-stage-head' })
  head.append(el('h2', { class: 'rebook-stage-title' }, meaningIcon('enquiries', 'row'), OLD_QUOTES_TITLE), el('span', { class: 'rebook-stage-count oldq-cleared-count' }, 'Cleared'))
  sec.append(head, el('div', { class: 'cleared-words', role: 'status' }, clearedMark(false), el('strong', {}, 'Old quotes cleared'), el('span', { class: 'muted' }, 'Nothing left to chase.')))
  buzz('success')
  // Where it can be seen: the Undo bar comes up at the bottom with it and covered a group low on a phone's screen (walked
  // live, 16 Oct 2026), so a group that would be hidden is brought up to the middle; one in plain view stays put.
  if (typeof requestAnimationFrame === 'function') requestAnimationFrame(() => {
    if (!sec.isConnected || typeof sec.getBoundingClientRect !== 'function' || typeof window.scrollTo !== 'function') return
    const r = sec.getBoundingClientRect()
    const top = document.querySelector<HTMLElement>('header.topbar, header')?.getBoundingClientRect().bottom ?? 0
    if (r.top >= top && r.bottom <= window.innerHeight - 180) return
    window.scrollTo({ top: Math.max(0, window.scrollY + r.top - Math.max(top, (window.innerHeight - r.height) / 2 - 60)), behavior: reducedMotion() ? 'auto' : 'smooth' })
  })
  window.setTimeout(() => {
    if (sec.isConnected) void foldAway(sec).then(() => { if (sec.isConnected) rerender() })
  }, 2600)
  return sec
}

// Nothing left on To send. Cleared just now: the big tick with a ring, confetti and a buzz; opened already clear: the
// same words, still. The last Send usually opens WhatsApp, so a celebration owed while Roundly is in the background
// plays when it comes back (the redraw on coming back, or this box if no redraw comes).
function allCaughtUp(celebrate: boolean): HTMLElement {
  const box = el('section', { class: 'messages-all-clear', role: 'status' }, clearedMark(true), el('h2', {}, 'All caught up'), el('p', { class: 'muted' }, 'Next up is clear. Nobody is waiting on a message from you.'))
  const play = (): void => { allClearOwed = false; box.classList.add('is-celebrating'); buzz('success') }
  if (!celebrate && !allClearOwed) return box
  if (typeof document === 'undefined' || document.visibilityState !== 'hidden') { play(); return box }
  allClearOwed = true
  const back = (): void => {
    if (document.visibilityState === 'hidden') return
    document.removeEventListener('visibilitychange', back)
    window.setTimeout(() => { if (box.isConnected && allClearOwed) play() }, 1200)
  }
  document.addEventListener('visibilitychange', back)
  return box
}

// ---- Replies: a customer has answered, so leave the no-reply ladder. -------
type ReplyOutcome = 'dates' | 'later' | 'paused' | 'stopped'
type ReplyKind = '' | ReplyOutcome | 'book' | 'note' | 'follow' | 'reminder' | 'remind'
interface ReplyDraft { agreedDate?: string; kind: ReplyKind; followup?: boolean; note: string; date: string; dates: string[]; jobId: number | null; jobIds: (number | null)[]; busy: boolean; error: string; pending?: Record<string, unknown> }
const replyDrafts = new Map<number, ReplyDraft>()
const replySaving = new Set<number>()
// "They replied" over the Diary (openReplyDialog, Liam 9 Oct 2026): the same reply card, answers, saves and Undo as
// here, in a pop-up. While it is open the reply flow redraws the pop-up and tells the Diary, instead of drawing
// Messages (which is not on the screen) or changing what Messages shows when it next opens.
// row: the customer as read, for Undo (the card shows replyForJob's copy, which lays one job's reply over the row).
interface ReplyHost { reload: () => void; close: () => void; row: () => RoundCustomer | null; open: () => boolean }
let replyHost: ReplyHost | null = null
// Taken when a save starts, so an Undo pressed after the pop-up has closed still refreshes the screen it came from.
function replyReloader(): () => void {
  const host = replyHost
  return host ? host.reload : () => void load()
}
const REPLY_GROUPS: { key: ReplyGroup; title: string; blurb: string }[] = [
  { key: 'datesoffered', title: 'Dates offered', blurb: 'Waiting for them to choose a date.' },
  { key: 'followup', title: 'Ask again later', blurb: 'Out of the chasing list until the chosen follow-up date.' },
  { key: 'paused', title: 'Paused', blurb: 'They will contact you. No reminders.' },
  { key: 'stopped', title: 'Stopped', blurb: 'Customer declined. Their history stays on their card.' },
  { key: 'replybooked', title: 'Booked after replying', blurb: 'The visit has an agreed date.' },
]
function promisedReplyDue(c: RoundCustomer, today: string): boolean {
  return c.status === 'active' && !!c.follow_up_on && c.follow_up_on <= today && !c.next_confirmed && (!c.last_clean || c.last_clean < c.follow_up_on)
}
const replyTitle = (c: RoundCustomer, today: string): string => {
  const group = replyGroup(c, today)
  return group === 'followup' ? `Ask again ${shortDate(c.follow_up_on!)}` : group === 'replybooked' ? `Day agreed · ${shortDate(c.reply_agreed!)}`
    : group === 'datesoffered' ? replyNeedsFollowup(c,today) ? `Dates offered: ${offeredDaysText(replyDates(c))} · follow-up ready` : `Dates offered: ${offeredDaysText(replyDates(c))}, waiting` : group === 'stopped' ? 'Stopped · no longer needs cleaning' : 'Paused · they will contact us'
}
function replyDateChoices(c: RoundCustomer, jobId: number | null, today: string): DateChoice[] {
  const job = jobId == null ? null : roundJobs().find(j => j.id === jobId)
  const windows = !plannedWeekOf(c) && c.next_booked_source !== 'suggested' && c.next_booked_source !== 'tentative' ? c.next_booked : null
  return customerDateChoices(c, today).filter(d => !job || job.kind !== 'gutter' || !windows || !guttersAfterWindows(d.date, windows))
}
function startReply(c: RoundCustomer, jobId: number | null, rerender: () => void, kind: ReplyKind = ''): void {
  const choices = replyDateChoices(c, jobId, todayISO())
  const old = replyDrafts.get(c.id)
  replyDrafts.set(c.id, old && old.jobId === jobId ? { ...old, kind, jobId, followup: kind === 'follow' } : { kind, followup: kind === 'follow', jobId, jobIds:[jobId], note: c.said_note ?? '', date: addDaysISO(todayISO(), 30), dates: replyDates(c).filter(d => choices.some(ch => ch.date === d)), busy: false, error: '' })
  const draft = replyDrafts.get(c.id)!
  if (!draft.dates.length) {
    const entry = jobId == null ? c : jobDues([c], roundJobs(), todayISO(), () => false).find(d => d.job.id === jobId)?.entry ?? c
    const preferred = suggestedWorkingDate(entry, todayISO())
    const pick = choices.find(d => d.date === preferred) ?? (!plannedWeekOf(entry) ? choices[0] : undefined)
    if (pick) draft.dates = [pick.date]
  }
  // Where the page was: redrawing Messages puts it back at the top (Liam's screenshots, 9 Oct 2026).
  const y = window.scrollY
  rerender()
  if (typeof window.scrollTo === 'function') window.scrollTo(0, y)
  document.querySelector<HTMLElement>('.reply-panel h3')?.focus({ preventScroll: true })
  revealReplyPanel()
}
// "They replied" (and Follow up) open the reply on the card: the page moves to "Record a reply" so its choices are on
// screen, not the top of the card the composer now starts with (Liam's screenshots, 9 Oct 2026: it "forces us up to the
// top ... not to the record a reply"). Left alone when it is already near the top of the screen; in the Diary's pop-up
// the pop-up shows it already.
function revealReplyPanel(): void {
  const place = (smooth: boolean): void => {
    const panel = document.querySelector<HTMLElement>('.reply-panel')
    if (!panel || panel.closest('dialog') || typeof getComputedStyle !== 'function' || typeof window.scrollTo !== 'function') return
    const behavior: ScrollBehavior = smooth && !(typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'smooth' : 'auto'
    // On a computer the card has its own scrolling panel beside the list: that panel moves. On a phone, the page.
    let box: HTMLElement | null = panel.parentElement
    while (box && box !== document.body) {
      const y = getComputedStyle(box).overflowY
      if ((y === 'auto' || y === 'scroll') && box.scrollHeight > box.clientHeight + 1) break
      box = box.parentElement
    }
    const topbar = Math.max(0, document.querySelector<HTMLElement>('.topbar')?.getBoundingClientRect().bottom ?? 0)
    const near = (top: number, from: number): boolean => top >= from && top <= from + Math.min(160, window.innerHeight * 0.25)
    if (box && box !== document.body) {
      // The panel itself just under the top bar (it stays there as the page scrolls), then "Record a reply" at its top.
      const boxTop = box.getBoundingClientRect().top
      if (boxTop > topbar + 24) window.scrollTo({ top: window.scrollY + boxTop - topbar - 12, behavior })
      const rel = panel.getBoundingClientRect().top - boxTop
      if (!near(rel, 0)) box.scrollTo({ top: Math.max(0, box.scrollTop + rel - 12), behavior })
      return
    }
    const top = panel.getBoundingClientRect().top
    if (!near(top, topbar)) window.scrollTo({ top: Math.max(0, window.scrollY + top - topbar - 12), behavior })
  }
  // A frame, once it is drawn; and a moment later in case the browser held the frame back.
  if (typeof requestAnimationFrame === 'function') requestAnimationFrame(() => place(true))
  setTimeout(() => place(false), 400)
}
// Undo for a reply, and for the visit it also cancelled (leftover-visit.ts) when there was one: one bar for both.
function offerReplyUndo(c: RoundCustomer, ack: Ack, text: string, label: string, before: Record<string, unknown>, extra: { undo: () => void } | null, after: () => void): void {
  const path = `/api/customers/${c.id}`
  if (!extra) { undoPatch({ text, label, path, ack, version: c.version, body: before, after }); return }
  const row = ack.row as { version?: number } | undefined
  const version = typeof row?.version === 'number' ? row.version : c.version + 1
  offerUndo(text, () => {
    extra.undo()
    void mutate({ label, method: 'PATCH', path, body: { version, ...before },
      onAck: (back) => { if (!back.ok && back.status >= 400 && back.status < 500) window.alert(`Undo was refused: ${back.error ?? 'rejected'}`); after() }, onConflict: () => after() })
  })
}
async function saveReply(c: RoundCustomer, patch: Record<string, unknown>, text: string, rerender: () => void, alsoCancel: Leftover | null = null): Promise<void> {
  const draft = replyDrafts.get(c.id)
  if (draft?.busy || replySaving.has(c.id) || pendingReply(c.id)) return
  replySaving.add(c.id)
  const host = replyHost, reload = replyReloader()
  const wasFocus = messageView.focus, wasOpen = openId
  // Over the Diary the row was just read there; Messages' list may be from an earlier visit.
  const stored = host ? host.row() ?? c : list?.find(row => row.id === c.id) ?? c
  const before: Record<string, unknown> = {}
  for (const key of Object.keys(patch).filter(k => k !== 'reply_job_ids')) before[key] = (stored as unknown as Record<string, unknown>)[key] ?? null
  if ('said_note' in patch) before.said_on = c.said_on ?? null
  if ('message_reply' in patch) before.message_replies = c.message_replies ?? null
  if (draft) { draft.busy = true; draft.error = '' }
  // Keep the clicked outbound anchor mounted until its native navigation has
  // run. Disable editable controls in place while the acknowledgement arrives.
  const panel = document.querySelector<HTMLElement>('.reply-panel')
  panel?.setAttribute('aria-busy', 'true')
  for (const input of panel?.querySelectorAll<HTMLButtonElement | HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>('button,input,textarea,select') ?? []) input.disabled = true
  let queuedKey: string | null = null
  const ack = await mutate({ method: 'PATCH', path: `/api/customers/${c.id}`, label: text, body: { version: c.version, ...patch }, onQueued: (m) => { queuedKey = m.key }, onConflict: () => reload() })
  replySaving.delete(c.id)
  if (!ack.ok && ack.status !== 0) {
    if (draft) { draft.busy = false; draft.error = ack.status === 409 ? 'This customer changed on another device. Your reply is kept; review it and save again.' : `Could not save: ${ack.error ?? 'please retry'}` }
    toast(draft?.error ?? 'Could not save this reply. Please retry.')
    // The pop-up was closed while it saved: nothing is left half done on their Messages card (unless a new reply has
    // been begun for them since).
    if (host && !host.open() && replyDrafts.get(c.id) === draft) replyDrafts.delete(c.id)
    rerender(); return
  }
  if (ack.status === 0) {
    if (draft) { draft.busy = false; draft.pending = patch; draft.error = 'Saved on this phone. Waiting for a connection before changing their status.' }
    rerender()
    const extra = alsoCancel ? await cancelAfter(ack, queuedKey, alsoCancel, c.name) : null
    offerReplyUndo(c, ack, `Reply saved on this phone, waiting to sync${extra?.words ?? ''}`, `Undo ${text}`, before, extra, () => { replyDrafts.delete(c.id); reload() })
    return
  }
  replyDrafts.delete(c.id); cardDrafts.delete(`c${c.id}`)
  // Update this mounted copy only after acknowledgement, before reloading.
  Object.assign(c, patch, ack.row ?? {})
  if (!host) {
    if ('message_reply' in patch || 'follow_up_on' in patch) { messageView.focus = false; focusSearch = null; filterText = ''; openId = c.message_reply_job_id != null ? `r${c.id}j${c.message_reply_job_id}` : `c${c.id}` }
    else { messageView.focus=wasFocus;openId=wasOpen }
    const group = replyGroup(c, todayISO()); if (group) foldedGroups.set(group, true)
  }
  // Over the Diary, the reply is saved: the pop-up closes (its redraw finds no reply left to record).
  rerender()
  const extra = alsoCancel ? await cancelAfter(ack, null, alsoCancel, c.name) : null
  offerReplyUndo(c, ack, `${text}${extra?.words ?? ''}`, `Undo ${text}`, before, extra, host ? reload : () => { messageView.focus = wasFocus; filterText = ''; openId = wasOpen; focusRestoreId = wasOpen; void load() })
  reload()
}
// "No longer needs cleaning" is the Taken off list, saved exactly as Where they stand saves it (their words as the
// reason, visits and history kept), with the same Undo: one name for one outcome on the card, its box, the group and
// the Diary, not "Stopped" here and "Taken off" there (bug hunt 8 Oct 2026, messages #9; Astra: the standing itself, not
// only its words). Older customers stopped this way before keep their "Stopped".
async function takeOffRound(c: RoundCustomer, draft: ReplyDraft, rerender: () => void, alsoCancel: Leftover | null = null): Promise<void> {
  if (draft.busy || replySaving.has(c.id)) return
  replySaving.add(c.id)
  const host = replyHost, reload = replyReloader()
  draft.busy = true; draft.error = ''
  const path = `/api/customers/${c.id}`
  const restore = standingFields(c)
  let queuedKey: string | null = null
  const ack = await mutate({ method: 'PATCH', path, label: `Taken off round: ${c.name}`, body: { version: c.version, customer_context: { action: 'set_standing', standing: 'taken_off', reason: draft.note.trim() } }, onQueued: (m) => { queuedKey = m.key }, onConflict: () => reload() })
  replySaving.delete(c.id)
  draft.busy = false
  if (!ack.ok && ack.status !== 0) {
    draft.error = ack.status === 409 ? 'This customer changed on another device. Review them and try again.' : `Could not save: ${ack.error ?? 'please retry'}`
    if (host && !host.open()) { if (replyDrafts.get(c.id) === draft) replyDrafts.delete(c.id); toast(draft.error); return }
    rerender(); return
  }
  replyDrafts.delete(c.id); cardDrafts.delete(`c${c.id}`)
  host?.close()
  reload()
  const extra = alsoCancel ? await cancelAfter(ack, queuedKey, alsoCancel, c.name) : null
  offerReplyUndo(c, ack, `Took ${c.name} off the round${extra?.words ?? ''}`, `Undo taken off: ${c.name}`, { customer_context: { action: 'restore_standing', fields: restore } }, extra, host ? reload : () => { focusRestoreId = `c${c.id}`; void load() })
}
function replyPatch(c: RoundCustomer, draft: ReplyDraft, kind: ReplyOutcome, way?: CustomerMessageBy): Record<string, unknown> {
  const today = todayISO()
  const line = kind === 'dates' ? `${noteDate(today)}: offered ${draft.dates.map(noteDate).join(' or ')} ${way ? noteWord(way) : ''}; awaiting their choice`
    : kind === 'later' ? `${noteDate(today)}: customer replied, ask again ${noteDate(draft.date)}`
      : `${noteDate(today)}: customer ${kind === 'paused' ? 'requested a pause until they contact us' : 'no longer needs cleaning'}`
  const patch: Record<string, unknown> = {
    message_reply: kind, message_reply_on: today, message_reply_dates: kind === 'dates' ? JSON.stringify(draft.dates) : null,
    message_reply_job_id: kind === 'dates' ? draft.jobId : null,
    ...(kind === 'dates' ? {reply_job_ids:draft.jobIds} : {}),
    status: kind === 'paused' || kind === 'stopped' ? 'paused' : 'active',
    follow_up_on: kind === 'later' ? draft.date : null, last_contacted_on: today,
    ...(kind === 'dates' && !draft.jobIds.includes(null) ? {} : { rebook_messages: 0, rebook_messaged_on: null }), said_note: draft.note.trim() || null,
  }
  const note = appendNote(c.contact_note, line)
  if (note !== (c.contact_note ?? '')) patch.contact_note = note
  return patch
}
function pendingReply(id: number): boolean {
  return getQueue().some(q => q.path === `/api/customers/${id}` && (q.status === 'queued' || q.status === 'sending') && !!q.body && 'message_reply' in (q.body as Record<string, unknown>))
}
// "They accepted a date": their answer recorded as a reply naming the day, then the booking opens on it with the day
// filled in. Messages' "Book the agreed date", and a "Dates offered, waiting" row dropped on a day of the Diary
// (acceptDayFromDiary). 'opened', 'stale' (the screen or the reply moved on while it loaded), or why it failed.
// current: whether the answer is still wanted (Messages: its reply is still the one open on the card).
async function acceptDate(c: RoundCustomer, draft: ReplyDraft, date: string, reload: () => void, beforeBooking?: () => void, current: () => boolean = () => replyDrafts.get(c.id) === draft): Promise<'opened' | 'stale' | string> {
  const gen = routeGen
  const detail = await api<{ cleans: Clean[] }>(`/api/customers/${c.id}`)
  if (gen !== routeGen || !current()) return 'stale'
  // Prefer a matching-day booking, otherwise an unconfirmed pencil for this job.
  // Never move a different agreed visit or silently choose another job.
  const visits = detail.cleans.filter(v => v.state === 'booked' && (v.job_id ?? null) === draft.jobId && !v.deleted_at)
  const existing = visits.find(v => v.date === date) ?? visits.filter(v => !v.confirmed).sort((a,b) => a.date.localeCompare(b.date))[0]
  // Their answer is recorded first, as a reply naming that day, so once the booking agrees the visit they are under
  // "Booked after replying" with its one-tap Time agreed, as the truth doc says, not in no group at all (bug hunt
  // 8 Oct 2026, messages #11). Left there if the booking is not saved: "Dates offered: <that day>", Book agreed
  // visit. A reply already naming the day is kept as it is.
  const reply = replyForJob(c, draft.jobId)
  if (!(reply.message_reply === 'dates' && replyDates(reply).includes(date))) {
    const today = todayISO()
    const note = appendNote(c.contact_note, `${noteDate(today)}: customer accepted ${noteDate(date)}`)
    const accepted = await mutate({ method: 'PATCH', path: `/api/customers/${c.id}`, label: `${c.name} accepted ${shortDate(date)}`,
      body: { version: c.version, message_reply: 'dates', message_reply_on: today, message_reply_dates: JSON.stringify([date]), message_reply_job_id: draft.jobId,
        status: 'active', follow_up_on: null, last_contacted_on: today,
        ...(note !== (c.contact_note ?? '') ? { contact_note: note } : {}) }, onConflict: () => reload() })
    if (gen !== routeGen || !current()) return 'stale'
    if (!accepted.ok && accepted.status !== 0) return accepted.status === 409 ? 'This customer changed on another device. Review them and try again.' : `Could not save: ${accepted.error ?? 'please retry'}`
    const row = accepted.row as Partial<RoundCustomer> | undefined
    if (typeof row?.version === 'number') c.version = row.version
  }
  beforeBooking?.()
  openBooking({ customerId: c.id, jobId: draft.jobId, cleanId: existing?.id, agreedDate: date,
    replyConfirmation: true, initialVisitNote: draft.note,
    onBooked: () => { if (replyDrafts.get(c.id) === draft) replyDrafts.delete(c.id); reload() },
  })
  return 'opened'
}

function replyCard(c: RoundCustomer, today: string, rerender: () => void): HTMLElement {
  const stored = replyDrafts.get(c.id)
  if (stored?.pending && Object.entries(stored.pending).every(([key,value]) => ((c as unknown as Record<string,unknown>)[key] ?? null) === value)) {
    replyDrafts.delete(c.id)
  }
  const draft = replyDrafts.get(c.id)
  const reload = replyReloader()
  const card = el('div', { class: 'rebook-card reply-composer' })
  card.append(el('div', { class: 'rebook-card-top' }, el('div', { class: 'rebook-card-who' }, el('a', { class: 'rebook-card-name', href: `#/customer/${c.id}` }, c.name), el('span', { class: 'sched-addr' }, addressLine(c))),
    el('span', { class: 'rebook-pill' }, draft ? draft.followup ? 'Follow up' : draft.kind === 'note' ? 'Customer note' : 'They replied' : REPLY_GROUPS.find(g => g.key === replyGroup(c, today))?.title ?? 'Reply recorded')))
  if (!draft) {
    const group = replyGroup(c, today)
    const explanation = group === 'datesoffered' ? 'Waiting for their choice before booking a visit.' : group === 'followup' ? 'They will reappear on the chosen follow-up date. Their offer and reply context are kept.' : group === 'paused' ? 'Chasing is paused until they contact you.' : group === 'stopped' ? 'No follow-up or win-back messages. Their visits and notes are kept.' : 'The agreed visit is in the diary.'
    card.append(el('div', { class: 'reply-outcome' }, el('span', { class: 'reply-outcome-tick', 'aria-hidden': 'true' }, '✓'), el('div', {}, el('h3', {}, replyTitle(c, today)), el('p', {}, explanation))))
    if (saidLine(c)) card.append(el('p', { class:'said-note' }, el('strong', {}, 'What they said '), saidLine(c)))
    const actions = el('div', { class: 'rebook-card-row secondary-actions' })
    if (group === 'datesoffered') {
      const follow = el('button', { type:'button', class:'btn-secondary', 'data-guide-followup':'true' }, 'Follow up')
      follow.addEventListener('click', () => startReply(c,c.message_reply_job_id ?? null,rerender,'follow')); actions.append(follow)
      if (replyNeedsFollowup(c,today)) card.append(el('p', {class:'reply-help'}, 'It has been a week, or the offered dates have passed. Choose a next step; nothing is sent automatically.'))
      card.append(el('div', { class: 'reply-offered' }, el('span', { class: 'rebook-fact-label' }, 'Dates offered'), el('p', {}, replyDates(c).map(dateChoiceLabel).join(' · '))))
      const book = el('button', { type: 'button', class: 'btn-secondary reply-trigger' }, 'Book agreed visit')
      book.addEventListener('click', () => startReply(c, c.message_reply_job_id ?? null, rerender, 'book')); actions.append(book)
    } else if (group !== 'replybooked') {
      const resume = el('button', { type: 'button', class: 'btn-secondary' }, 'Bring back to Messages')
      resume.addEventListener('click', () => { resume.disabled = true; void saveReply(c, { status: 'active', message_reply: null, message_reply_on: null, message_reply_dates: null, message_reply_job_id: null, follow_up_on: null, rebook_messages: 0, rebook_messaged_on: null }, `Brought ${c.name} back to Messages`, rerender) }); actions.append(resume)
    }
    if (group !== 'replybooked') { const change = el('button', { type: 'button', class: 'btn-secondary' }, group === 'datesoffered' ? 'They replied' : 'Change reply'); change.addEventListener('click', () => startReply(c, c.message_reply_job_id ?? null, rerender)); actions.append(change) }
    else {
      // The agreed visit in the shared words, and "Time agreed" when only its time is left (Release 2).
      const line = c.next_booked && c.next_booked === c.reply_agreed ? nextVisitLine(c, today) : null
      if (line) card.append(el('p', { class: 'rebook-sent-line' }, line))
      const timeButton = timeAgreedButton(c, rerender)
      if (timeButton) actions.append(timeButton)
      actions.append(openDiaryOn(c))
    }
    if (['followup','paused','stopped'].includes(group ?? '') && c.next_booked) { card.append(el('p', { class:'reply-help' }, `Still in the diary: ${nextVisitLine(c, today)}. Check it before anyone goes.`)); actions.append(el('a', { class:'btn-secondary', href:`#/customer/${c.id}` }, 'Review existing visits')) }
    card.append(actions); return card
  }
  const panel = el('div', { class: 'reply-panel' })
  const choices: [ReplyOutcome | 'book', string, string, string][] = [
    ['book', 'They accepted a date', 'Set the time and review a confirmation.', '✓'],
    ['dates', 'Send some dates', 'They want to arrange a visit.', '↗'], ['later', 'Ask again later', 'Agree when to get back in touch.', '◷'],
    ['paused', 'Pause until they contact us', 'Leave them out of the chasing list.', 'Ⅱ'], ['stopped', 'No longer needs cleaning', 'Taken off the round. Their visits and history stay.', '✓'],
  ]
  const back = el('button', { type: 'button', class: 'link-button' }, draft.kind && draft.kind !== 'follow' ? 'Back' : 'Cancel')
  back.addEventListener('click', () => { if (draft.kind && draft.kind !== 'follow') draft.kind = draft.followup ? 'follow' : ''; else replyDrafts.delete(c.id); rerender() })
  panel.append(el('div', { class: 'reply-panel-head' }, el('div', {}, el('span', { class: 'reply-eyebrow' }, draft.followup ? 'Follow up' : draft.kind === 'note' ? 'Customer note' : 'Record a reply'), el('h3', { tabindex: '-1' }, draft.kind === 'book' ? 'Book the agreed date' : draft.kind === 'note' ? 'Save what they said' : draft.kind === 'follow' ? 'No reply yet?' : draft.kind === 'reminder' ? 'Send a gentle reminder' : draft.kind === 'remind' ? 'Remind me later' : (draft.followup && draft.kind === 'dates' ? 'Offer fresh dates' : choices.find(o => o[0] === draft.kind)?.[1]) ?? 'What would they like to do?')), back))
  const noteField = (): HTMLElement => {
    const input = el('textarea', { class: 'reply-note-input', rows: '2', maxlength: '500', 'aria-label': 'What did they say?', placeholder: 'Add a short note or paste their reply…' }); input.value = draft.note
    input.addEventListener('input', () => { draft.note = input.value })
    return el('label', { class: 'reply-field' }, 'What did they say?', el('span', {}, 'Optional · only for you'), input)
  }
  if (!draft.kind) {
    const options = el('div', { class: 'reply-options' })
    for (const [kind, title, subtitle, symbol] of choices) {
      const button = el('button', { type: 'button', 'data-reply-kind': kind }, el('span', { class: 'reply-option-icon', 'aria-hidden': 'true' }, symbol), el('span', {}, el('strong', {}, title), el('small', {}, subtitle)), el('span', { 'aria-hidden': 'true' }, '›'))
      button.addEventListener('click', () => { draft.kind = kind; draft.error = ''; rerender() }); options.append(button)
    }
    const noteOnly = el('button', {type:'button',class:'btn-secondary'}, 'Just save a note')
    noteOnly.addEventListener('click', () => {draft.kind='note';rerender()}); options.append(noteOnly)
    panel.append(options, el('p', { class: 'reply-help' }, 'Choose what happens next. You can add their reply on the next step.'))
  } else if (draft.kind === 'note') {
    panel.append(noteField(), el('p', {class:'reply-help'}, 'Saves their words only. Dates, chasing and follow-ups stay as they are.'))
    const save = el('button', {type:'button',class:'btn-primary'}, 'Save note')
    save.addEventListener('click', () => void saveReply(c,{said_note:draft.note.trim() || null},`Saved what ${c.name} said`,rerender)); panel.append(save)
  } else if (draft.kind === 'follow') {
    panel.append(el('p', {class:'reply-help'}, 'Choose the next step. No reply is recorded and no visit is booked.'))
    const options = el('div',{class:'reply-follow-options'})
    for (const [kind,label] of [['reminder','Send a gentle reminder'],['dates','Offer fresh dates'],['remind','Remind me later']] as const) {
      const b=el('button',{type:'button',class:'btn-secondary'},label);b.addEventListener('click',()=>{draft.kind=kind;draft.error='';rerender()});options.append(b)
    }
    panel.append(options)
  } else if (draft.kind === 'remind') {
    const input=el('input',{type:'date','aria-label':'Remind me on',min:addDaysISO(today,1)});input.value=draft.date
    input.addEventListener('input',()=>{draft.date=input.value})
    const save=el('button',{type:'button',class:'btn-primary'},'Save reminder')
    save.addEventListener('click',()=>{if(!input.validity.valid || !draft.date || draft.date<=today){draft.error='Choose a future reminder date.';rerender();return}void saveReply(c,{follow_up_on:draft.date},`Reminder for ${c.name} on ${shortDate(draft.date)}`,rerender)})
    panel.append(el('p',{class:'reply-help'},'Your reminder, not a reply from the customer. Applies to all their jobs; existing offers and visits are kept.'),input,save)
  } else if (draft.kind === 'reminder') {
    const text=`Hi ${firstName(c.name)}, just checking whether you would still like us to arrange your next visit. Let me know when you get a chance. Thanks, ${businessSettings().booking_signoff}`
    const sent=(way:CustomerMessageBy):void=>void saveReply(c,{last_contacted_on:today,...(c.follow_up_on && c.follow_up_on <= today ? {follow_up_on:null} : {}),contact_note:appendNote(c.contact_note,`${noteDate(today)}: follow-up ${noteWord(way)}, awaiting reply`)},`Follow-up recorded for ${c.name}`,rerender)
    const control=sendControl(c,text,'Your next visit',{label:way=>wayWords(way).button,className:'btn-whatsapp rebook-send',onSend:sent,changed:reload,onConflict:reload})
    panel.append(el('p',{class:'rebook-preview-text'},text),control.root,alreadySentButton(c.name,()=>sent(wayFor(c))),el('p',{class:'reply-help'},'Only records this follow-up. The existing offer, visit and reply state are kept.'))
  } else if (draft.kind === 'dates') {
    const extraJobs = roundJobs().filter(j => j.customer_id === c.id && !j.deleted_at && !j.stopped_on)
    const scopeJobs = [{id:null as number|null,name:c.job_name || kindLabel('window')},...extraJobs]
    if (severalJobsOn() && extraJobs.length) {
      const scope = el('fieldset',{class:'reply-job-scope'},el('legend',{},'Offer dates for'))
      for (const job of scopeJobs) {
        const input=el('input',{type:'checkbox','aria-label':`Include ${job.name}`});input.checked=draft.jobIds.includes(job.id);input.disabled=job.id===draft.jobId
        input.addEventListener('change',()=>{draft.jobIds=input.checked?[...new Set([...draft.jobIds,job.id])]:draft.jobIds.filter(id=>id!==job.id);rerender()})
        scope.append(el('label',{},input,job.name))
      }
      panel.append(scope)
    }
    const dates = replyDateChoices(c, draft.jobId, today).filter(d => draft.jobIds.every(id => replyDateChoices(c,id,today).some(day=>day.date===d.date)))
    // Fresh dates to someone who never replied (Follow up > Offer fresh dates) is not a reply to them: their first
    // message's own wording with the new days, never "great!" (bug hunt 8 Oct 2026, messages #8). "Send some dates"
    // after a real reply keeps the dates reply.
    const fresh = draft.followup
    const replyText = ():string => {
      const jobs=scopeJobs.filter(j=>draft.jobIds.includes(j.id)).map(j=>j.name.toLowerCase())
      if (fresh) return draft.dates.length ? rebookMessage({ name: c.name, kind: 'due', lastClean: c.last_clean, offer: draft.dates[0] ?? null, offers: draft.dates, jobs: extraJobs.length ? jobs : undefined }) : 'Choose at least one day to offer.'
      return datesReplyMessage(c.name,draft.dates,extraJobs.length ? jobs.join(' and ') : undefined)
    }
    draft.dates = draft.dates.filter(date => dates.some(d => d.date === date))
    const preview = el('p', { class: 'rebook-preview-text' }, replyText())
    const sent = (way: CustomerMessageBy): void => { if (draft.dates.length && !draft.busy && !pendingReply(c.id)) void saveReply(c, replyPatch(c, draft, 'dates', way), `Dates offered to ${c.name}`, rerender) }
    const control = sendControl(c, preview.textContent ?? '', `Your next visit from ${businessSettings().business_name}`, { label: way => way === 'whatsapp' ? 'Send dates on WhatsApp' : wayWords(way).button, className: 'btn-whatsapp rebook-send', onSend: sent, changed: reload, onConflict: reload })
    const already = alreadySentButton(c.name, () => sent(wayFor(c))) as HTMLButtonElement
    const refresh = (): void => {
      const text = replyText(); preview.textContent = text
      const link = control.link
      if (link) {
        const next = linkFor(wayFor(c), c, text, `Your next visit from ${businessSettings().business_name}`)
        if (!draft.dates.length || draft.busy || pendingReply(c.id)) link.removeAttribute('href'); else if (next.href) link.href = next.href
        link.setAttribute('aria-disabled', String(!draft.dates.length || draft.busy || pendingReply(c.id))); link.classList.toggle('messages-send-disabled', !draft.dates.length || draft.busy || pendingReply(c.id))
      }
      already.disabled = !draft.dates.length || draft.busy || pendingReply(c.id)
      smallMotion(preview, 'dates')
    }
    panel.append(el('p', { class: 'reply-help' }, 'Offer a choice. Book the visit once they agree a date.'))
    if (dates.length) panel.append(quickDatePicker(dates, draft.dates, selected => { draft.dates = selected; refresh() }))
    const notice = workingDaysNotice(dates.length, today)
    if (notice) panel.append(notice)
    panel.append(el('div', { class: 'rebook-preview' }, el('div', { class: 'rebook-preview-head' }, el('span', { class: 'rebook-fact-label' }, 'Message to send'), wordingLink(fresh ? 'rebook_due' : 'dates_reply')), preview), ...(fresh ? [] : [noteField()]), el('div', { class: 'rebook-card-actions' }, control.root, already))
    refresh()
  } else if (draft.kind === 'book') {
    panel.append(el('p', { class: 'reply-help' }, `Which date did ${c.name} agree to?`))
    const offered = acceptedReplyDates(c, draft.jobId).filter(date => date >= today)
    const selected = el('input', { type: 'date', class: 'reply-book-date', 'aria-label': 'Agreed visit date', min: today, required: 'required' })
    selected.value = draft.agreedDate ?? ''
    const dates = el('div', { class: 'reply-date-shortcuts', role: 'group', 'aria-label': 'Dates already offered' })
    const buttons: HTMLButtonElement[] = []
    const refresh = (): void => {
      draft.agreedDate = selected.value
      for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.date === selected.value))
      book.disabled = !selected.value || !selected.validity.valid
    }
    for (const date of offered) {
      const button = el('button', { type: 'button', 'data-date': date }, dateChoiceLabel(date))
      button.addEventListener('click', () => { selected.value = date; refresh() })
      buttons.push(button); dates.append(button)
    }
    const book = el('button', { type: 'button', class: 'btn-primary reply-save' }, 'Continue to booking')
    selected.addEventListener('input', refresh); selected.addEventListener('change', refresh)
    book.addEventListener('click', async () => {
      if (!selected.value || !selected.validity.valid || book.disabled) return
      book.disabled = true
      const host = replyHost
      try {
        const out = await acceptDate(c, draft, selected.value, reload, host ? host.close : undefined)
        // Closed while it loaded or saved: the Diary still reads again, as their answer may already be saved.
        if (out === 'stale') { if (host) reload(); return }
        if (out !== 'opened') { draft.error = out; book.disabled = false; rerender(); return }
        // Over the Diary their answer is saved before the booking: the Diary shows it even if the booking is closed.
        if (host) reload()
        book.disabled = false
      } catch { draft.error = 'Could not load their visits. Please retry.'; rerender() }
    })
    if (offered.length) panel.append(el('span', { class: 'rebook-fact-label' }, 'Dates already offered'), dates)
    panel.append(el('label', { class: 'reply-field' }, 'Agreed date', selected), noteField(), book)
    panel.append(el('p', { class: 'reply-help' }, 'Their note carries into the visit. Set a time, check the job and price, then save and review the message.'))
    refresh()
  } else {
    const kind = draft.kind
    panel.append(el('p', { class: 'reply-help' }, kind === 'later' ? 'They will reappear on this date, with their note beside them.' : kind === 'paused' ? 'No reminders or win-back messages. You can resume whenever they ask.' : 'They go on the Taken off list: off the round, no more messages. Their visits and notes stay on their customer card.'))
    if (severalJobsOn() && roundJobs().some(j => j.customer_id === c.id && !j.deleted_at)) panel.append(el('p', { class: 'reply-help' }, 'This applies to all their jobs. For just one job, use its controls on the customer page.'))
    // A visit still in the diary and not agreed: offered off with this reply (leftover-visit.ts; Liam, 9 Oct 2026). An
    // agreed one stays, to check before going.
    const leftover = leftoverOf(c)
    const cancelBox = leftover ? alsoCancelBox(leftover) : null
    if (cancelBox) panel.append(cancelBox.node)
    else if (c.next_booked) panel.append(el('p', { class: 'reply-help' }, 'A visit is already in the diary. Review any booked visits on their customer page.'))
    const input = el('input', { type: 'date', class: 'reply-date-input', min: addDaysISO(today,1), 'aria-label': 'Ask again on' }); input.value = draft.date
    input.addEventListener('input', () => { draft.date = input.value })
    if (kind === 'later') {
      const shortcuts = el('div', { class: 'reply-date-shortcuts', role: 'group', 'aria-label': 'Follow-up shortcuts' })
      const choices: { button: HTMLButtonElement; date: string }[] = []
      const refreshSelection = (): void => { for (const choice of choices) choice.button.setAttribute('aria-pressed', String(input.value === choice.date)) }
      for (const [days, label] of [[14,'2 weeks'],[30,'1 month'],[60,'2 months']] as const) {
        const button = el('button', { type:'button' }, label), date = addDaysISO(today,days)
        button.addEventListener('click', () => { draft.date = date; input.value = date; refreshSelection() })
        choices.push({ button, date }); shortcuts.append(button)
      }
      input.addEventListener('input', refreshSelection)
      input.addEventListener('change', () => { draft.date = input.value; refreshSelection() })
      refreshSelection()
      panel.append(el('span', { class: 'rebook-fact-label' }, 'Ask again on'), shortcuts, input)
    }
    const save = el('button', { type: 'button', class: 'btn-primary reply-save' }, kind === 'later' ? 'Save follow-up' : kind === 'paused' ? 'Pause chasing' : 'Take off round')
    save.addEventListener('click', () => {
      if (kind === 'later' && (!draft.date || draft.date <= today || !input.validity.valid)) { draft.error='Choose a future follow-up date.'; rerender(); return }
      // Asked again before the visit's day: the visit comes first anyway, so it stays.
      const cancel = leftover && cancelBox?.checked() && (kind !== 'later' || draft.date > leftover.date) ? leftover : null
      if (kind === 'stopped') { void takeOffRound(c, draft, rerender, cancel); return }
      void saveReply(c, replyPatch(c,draft,kind), kind === 'later' ? `Ask ${c.name} again ${shortDate(draft.date)}` : `Paused chasing ${c.name}`, rerender, cancel)
    })
    panel.append(noteField(), save)
  }
  if (draft.error) panel.append(el('p', { class:'reply-form-error', role:'status' }, draft.error))
  if (draft.busy || pendingReply(c.id)) { panel.setAttribute('aria-busy','true'); for (const input of panel.querySelectorAll<HTMLButtonElement | HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>('button,input,textarea,select')) input.disabled=true }
  card.append(panel); return card
}

function renderCard(r: Row, stage: SectionStage, today: string, rerender: () => void): HTMLElement {
  if (r.kind === 'enquiry' && enquiryLane(r.l, today) === 'won') {
    const card = renderTile(r, stage, today, rerender); card.classList.add('rebook-card'); card.dataset.messageId = rowId(r); return card
  }
  const replyCustomer = r.kind === 'customer' ? r.c : r.kind === 'job' ? customerOf(r.d) ? replyForJob(customerOf(r.d)!,r.d.job.id) : undefined : undefined
  const isReplyCard = !!replyCustomer && (replyDrafts.get(replyCustomer.id)?.jobId === (r.kind === 'job' ? r.d.job.id : replyCustomer.message_reply_job_id ?? null) || REPLY_GROUPS.some(g => g.key === stage) || stage==='taken_off' && !replyCustomer.customer_list)
  const card = ['recanvass','taken_off'].includes(stage) && r.kind==='customer' && (stage!=='taken_off'||!!r.c.customer_list) ? el('div',{class:'rebook-card messages-visit-card'},el('div',{class:'rebook-card-top'},el('h3',{class:'rebook-card-name'},r.c.name),el('p',{},r.c.address||'No address recorded'),listSummary(r.c),el('p',{class:'reply-help'},r.c.future_visit_count?`Still in the diary: ${nextVisitLine(r.c, todayISO()) ?? 'a future visit'}${r.c.future_visit_count > 1 ? ` and ${r.c.future_visit_count - 1} more` : ''}. Check it before anyone goes.`:'History and any money owed are kept.'),el('a',{href:`#/customer/${r.c.id}`},'Review customer'))) : stage === 'visit' && r.kind === 'customer' ? el('div',{class:'rebook-card messages-visit-card'},el('div',{class:'rebook-card-top'},el('h3',{},r.c.name),el('p',{},r.c.address || 'No address recorded'),el('p',{},r.c.last_clean ? `Last visit · ${shortDate(r.c.last_clean)}` : 'No visit recorded'),el('p',{},`Customer status · ${r.c.status}${r.c.message_reply ? ` · ${r.c.message_reply === 'stopped' ? 'Chasing stopped' : r.c.message_reply === 'paused' ? 'Chasing paused' : r.c.message_reply === 'later' ? 'Ask again later' : 'Dates offered'}` : ''}`),r.c.follow_up_on ? el('p',{},`Retained follow-up · ${shortDate(r.c.follow_up_on)}`) : '',r.c.next_booked ? el('p',{},`Visit stays in the diary · ${shortDate(r.c.next_booked)}${r.c.next_confirmed ? ' · an agreed visit is retained' : ' · not agreed'}. Review their visits on the customer page.`) : '',el('p',{class:'reply-help'},'Bringing back clears shelving only. Their existing status, replies and follow-up still apply.'),el('a',{href:`#/customer/${r.c.id}`},'Open customer'))) : isReplyCard ? replyCard(replyCustomer!, today, rerender) : r.kind === 'enquiry' ? enquiryCard(r.l, stage, today)
    : r.kind === 'job' ? jobCard(r.d, stage as RebookStage, today, rerender)
      : stage === 'lapsed' ? lapsedCard(r.c, today) : customerCard(r.c, stage as RebookStage, today, rerender)
  const record = r.kind === 'enquiry' ? r.l : r.kind === 'job' ? customerOf(r.d) ?? r.d.entry : r.c
  if (!['visit','recanvass','taken_off'].includes(stage) && !isReplyCard && replyCustomer) {
    const replied = actionTile(el('button', { type: 'button', class: 'btn-secondary reply-trigger', 'data-guide-reply': 'true' }), 'bubble', 'They replied', 'Save their answer')
    replied.addEventListener('click', () => startReply(replyCustomer, r.kind === 'job' ? r.d.job.id : null, rerender))
    const actions = card.querySelector('.rebook-card-row') ?? card.querySelector('.rebook-card-actions')
    if (actions) actions.insertBefore(replied, actions.children[1] ?? null); else card.append(replied)
    if (['waiting','second','no_reply'].includes(stage)) { const follow=actionTile(el('button',{type:'button',class:'btn-secondary','data-guide-followup':'true'}),'again','Follow up','Send again, or remind me');follow.addEventListener('click',()=>startReply(replyCustomer,r.kind==='job'?r.d.job.id:null,rerender,'follow'));(actions ?? card).append(follow) }
  }
  if (replyCustomer) { const context=customerContext(replyCustomer, () => void load()); const top=card.querySelector('.rebook-card-top'); if(top) top.after(context);else card.prepend(context) }
  card.dataset.messageId = rowId(r)
  card.dataset.saidBase = 'said_note' in record ? String(record.said_note ?? '') : ''
  card.setAttribute('role', 'region'); card.setAttribute('aria-label', `Message for ${record.name}`)
  if (messageView.context && !isReplyCard) {
    const context = el('div', { class: 'messages-contact-context' },
      el('span', {}, record.last_contacted_on ? `Last contact · ${shortDate(record.last_contacted_on)}` : 'No contact recorded yet'))
    if (record.contact_note?.trim()) context.append(el('p', {}, record.contact_note.trim().split('\n').slice(-2).map((line) => noteWords(contactLineWords(line, shortDate))).join('\n')))
    card.querySelector('.rebook-card-top')?.after(context)
  }
  const draft = cardDrafts.get(rowId(r))
  if (draft && !isReplyCard) {
    const saidDraft = draft.fields.find((f) => f.className === 'said-input' && f.context === 'said')
    if (saidDraft && saidDraft.value !== draft.saidBase && saidDraft.value === card.dataset.saidBase) draft.said = false
    if (draft.said) card.querySelector<HTMLButtonElement>('.said-edit')?.click?.()
    const later = card.querySelector<HTMLElement>('.notnow-chooser')
    if (later) later.hidden = !draft.later
    for (const field of card.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea')) {
      const context = field.closest('.notnow-chooser') ? 'later' : 'said'
      const saved = draft.fields.find((d) => d.label === (field.getAttribute('aria-label') ?? '') && d.className === field.className && d.context === context)
      if (saved) field.value = saved.value
    }
    const details = card.querySelector<HTMLDetailsElement>('.messages-visit-details')
    if (details) details.open = draft.details
  }
  // Guard the outbound link as well as its record: a rapid second tap must not
  // reopen WhatsApp or queue the same first message twice while a save is in flight.
  let sending = false
  const guard = (event: Event): void => {
    const target = event.target as HTMLElement | null
    const send = target?.closest<HTMLElement>('.rebook-send, .rebook-already-sent, .icon-btn-mail')
    if (!send || !isSendPress(event as MouseEvent)) return
    if (sending || replyCustomer && contextPending(replyCustomer.id) || send.getAttribute('aria-disabled') === 'true') {
      event.preventDefault(); event.stopImmediatePropagation(); return
    }
    // Gmail opening is not a save. Not sent must leave the same control usable.
    if (send.dataset.emailConfirm === 'true') return
    sending = true
    card.setAttribute('aria-busy', 'true')
  }
  card.addEventListener('click', guard, true)
  card.addEventListener('auxclick', guard, true)
  // Send stays in view on a long card (Liam, 8 Oct 2026: "not always immediately clear"). Its own row,
  // pinned to the bottom of the card while scrolling on wider screens (messages.css). The same element
  // and handlers, still inside the card; only moved when it already opens the actions, so nothing reorders.
  const firstSend = card.querySelector<HTMLElement>('.send-way, .rebook-send-row'), sendParent = firstSend?.parentElement
  if (firstSend && sendParent && sendParent.parentElement === card && sendParent.children[0] === firstSend) {
    const pin = el('div', { class: 'messages-send-pin' })
    card.insertBefore(pin, sendParent); pin.append(firstSend)
  }
  // The mobile dock moves these original controls, so bind the same guard to
  // their common container too; it leaves the card's event path when docked.
  const sendRow = card.querySelector<HTMLElement>('.send-way, .rebook-send-row')
  sendRow?.addEventListener('click', (event) => { if (!card.contains(sendRow)) guard(event) }, true)
  sendRow?.addEventListener('auxclick', (event) => { if (!card.contains(sendRow)) guard(event) }, true)
  if (stage === 'to_message' && r.kind !== 'enquiry' && !isReplyCard) {
    const quick = r.kind === 'job' ? true : quickCustomer(r.c, today)
    if (quick) refreshDateMessage(card, r.kind === 'job' ? customerOf(r.d) ?? r.d.entry : r.c, stage, today, r.kind === 'job' ? r.d : undefined)
  }
  customerSheet(card, r, stage, today, rerender)
  return card
}

// A closed tile: name, price, street, how late — tap to open the card.
// A messaged customer's line in Messages' three waiting groups, and on the Diary's "Waiting for a reply": one set of
// words for both.
function ladderWords(c: RoundCustomer, stage: Exclude<RebookStage, 'to_message'>): string {
  if (stage === 'waiting') { const from = secondMessageFrom(c); return `Messaged ${shortDate(c.rebook_messaged_on!)}${from ? ` · send again from ${shortDate(from)}` : ''}` }
  return stage === 'second' ? `Messaged ${shortDate(c.rebook_messaged_on!)} · no reply yet` : `Messaged twice · last ${shortDate(c.rebook_messaged_on!)}`
}

function customerTile(c: RoundCustomer, stage: RebookStage, today: string, rerender: () => void): HTMLElement {
  const tile = el('button', { type: 'button', class: `rebook-tile rebook-tile-${stage}`, 'aria-expanded': 'false', 'aria-label': `Open ${c.name}` })
  // Several jobs: their other jobs due with this one are in the same message, so the tile says so.
  const merged = stage === 'to_message' ? mergedJobs.get(c.id) ?? [] : []
  if (merged.length) {
    const nameRow = el('span', { class: 'rebook-tile-namewrap' })
    nameRow.append(el('span', { class: 'rebook-tile-name' }, c.name), el('span', { class: 'rebook-tile-tag' }, `${merged.map((d) => d.job.name).join(', ')} too`))
    tile.append(nameRow)
  } else tile.append(el('span', { class: 'rebook-tile-name' }, c.name))
  const price = c.reg_price_pence !== null && c.reg_price_pence !== undefined ? c.reg_price_pence + merged.reduce((sum, d) => sum + (d.job.price_pence ?? 0), 0) : null
  const bits = [price !== null ? money(price) : '', streetShort(c.address)].filter(Boolean).join(' · ')
  if (bits) tile.append(el('span', { class: 'rebook-tile-meta' }, bits))
  let line = ''
  const movedTile = movedVisits.get(c.id)
  if (movedTile) line = visitWords({ ...movedTile, state: 'booked' }, c, today).day
  else if (stage === 'to_message') {
    line = isFollowupDue(c, today) && c.follow_up_on && !upcomingIds.has(c.id)
      ? c.follow_up_on === today ? 'follow-up due today' : `follow-up late · ${shortDate(c.follow_up_on)}`
      : bookedSoonIds.has(c.id) && c.next_booked
        ? plannedWeekOf(c) ? `week of ${shortDate(c.next_booked)}, day not chosen` : `visit ${shortDate(c.next_booked)} · ${((w) => `${w.day} · ${w.time}`)(visitWords(nextVisitOf(c)!, c, today))}`
        : upcomingIds.has(c.id) ? `due ${shortDate(dueDate(c)!)}` : noDateIds.has(c.id) ? 'no date yet' : overdueWords(c, today)
  }
  else line = ladderWords(c, stage)
  tile.append(el('span', { class: `rebook-tile-line ${stage === 'to_message' && cycleRisk(c) === 'cold' ? 'rebook-cold-text' : ''}` }, line))
  tile.addEventListener('click', () => { openRow(`c${c.id}`); rerender() })
  return tile
}

// An enquiry tile: the grey "enquiry" tag tells it apart from a customer in
// the shared groups.
function enquiryTile(l: Lead, stage: SectionStage, today: string, rerender: () => void): HTMLElement {
  const tile = el('button', { type: 'button', class: `rebook-tile rebook-tile-${stageClass(stage)}`, 'aria-expanded': 'false', 'aria-label': `Open ${l.name}` })
  const nameRow = el('span', { class: 'rebook-tile-namewrap' })
  nameRow.append(el('span', { class: 'rebook-tile-name' }, l.name))
  nameRow.append(el('span', { class: 'rebook-tile-tag' }, 'enquiry'))
  tile.append(nameRow)
  const meta = l.address ? streetShort(l.address) : (l.phone ?? '')
  if (meta) tile.append(el('span', { class: 'rebook-tile-meta' }, meta))
  let line: string
  if (stage === 'new') {
    const wait = enquiryWaitDays(l, today)
    line = wait === null ? 'No date' : wait === 0 ? `Enquired ${shortDate(l.quoted_on)}` : `Enquired ${shortDate(l.quoted_on)} · waiting ${wait} day${wait === 1 ? '' : 's'}`
  } else if (stage === 'waiting' && quoted(l)) {
    // Quote sent (the pack's board 7): when it was quoted and when the gentle nudge is ready.
    const from = enquirySecondFrom(l)
    line = `${l.enquiry_messaged_on ? `Quoted ${shortDate(l.enquiry_messaged_on)}` : 'Quote marked, send day not recorded'}${from ? ` · nudge from ${shortDate(from)}` : ''}`
  } else if (stage === 'waiting') {
    const from = enquirySecondFrom(l)
    line = `Messaged ${shortDate(l.enquiry_messaged_on!)}${from ? ` · send again from ${shortDate(from)}` : ''}`
  } else if (stage === 'second' && quoted(l)) {
    line = `Quoted ${shortDate(l.enquiry_messaged_on!)} · nudge due`
  } else if (stage === 'second') {
    line = `Messaged ${shortDate(l.enquiry_messaged_on!)} · no reply yet`
  } else {
    line = `Messaged twice · last ${shortDate(l.enquiry_messaged_on!)}`
  }
  // Remind me in a week: its day has come (tidy-up item 6, 20 Oct 2026).
  if (reminderDue(l, today)) line = `Reminder due · ${line}`
  if (l.regular_offers_enabled) {
    const picked = regularChoiceOn(l)
    if (picked) line = `${firstName(l.name) || l.name} picked ${regularChoiceWords(picked.days)}`
    else if (l.regular_offer_state === 'sent') line = 'Sent on WhatsApp · waiting for their tap'
    else if (l.regular_offer_state === 'unknown') line = "Roundly isn't sure it went"
  }
  tile.append(el('span', { class: 'rebook-tile-line' }, line))
  tile.addEventListener('click', () => { openRow(`l${l.id}`); rerender() })
  return tile
}

// Keep the row opener and the real step buttons as siblings, including in Won.
function enquiryStepHost(row: HTMLElement, lead: Lead, turn: 'you' | 'them'): HTMLElement {
  const host = el('div', { class: row.className, role: 'group', 'aria-label': `Enquiry: ${lead.name}` })
  if (row.dataset.messageId) host.setAttribute('data-message-id', row.dataset.messageId)
  row.className = 'enquiry-row-open'
  host.append(row, enquirySteps(lead, turn, {
    describe: async (step: Step) => {
      // Read the existing scoped History endpoint only on a tap. Its opaque key identifies the send exactly;
      // neither the latest message's text nor an enquiry's current status can identify it safely.
      const data = await api<{ events: { idempotency_key: string; action: string; before_json: string | null; after_json: string | null; created_at: string }[] }>(`/api/events?entity=leads&entity_id=${lead.id}&limit=500`)
      const events = data.events.map(e => ({ ...e, before: JSON.parse(e.before_json ?? '{}'), after: JSON.parse(e.after_json ?? '{}') }))
      const namesStep = (e: typeof events[number]): boolean => {
        if (step.key === 'asked') return e.action === 'create' && !!lead.progress_known
        if (step.key === 'answered') return Number(e.after.enquiry_messages) > 0 && !e.before.enquiry_messages && e.after.status !== 'quote'
        if (step.key === 'quoted') return (e.after.status === 'quote' && e.before.status !== 'quote' && Number(e.after.enquiry_messages) > Number(e.before.enquiry_messages ?? 0)) ||
          (typeof e.after.contact_note === 'string' && e.after.contact_note !== e.before.contact_note && e.after.contact_note.includes(': quote sent '))
        if (step.key === 'yes') return e.after.status === 'confirmed' && e.before.status !== 'confirmed'
        // Conversion alone does not date a booking; leave its date unrecorded here.
        if (step.key === 'booked') return false
        return false
      }
      if (step.key === 'booked' && lead.converted_customer_id) {
        const visits = await api<{ events: { idempotency_key: string; created_at: string }[] }>(`/api/events?entity=cleans&customer_id=${lead.converted_customer_id}&limit=500`)
        // The same exact action pair used by progress_booked, rather than the conversion time or visit day.
        const booking = visits.events.find(v => events.some(e => v.idempotency_key === `${e.idempotency_key}:book-visit`))
        return booking ? { when: stepDate(booking.created_at), detail: `Booked ${stepDate(booking.created_at)}` } : {}
      }
      const event = events.find(namesStep)
      const newest = events[0]
      const send = lead.put_back_key && newest?.idempotency_key === lead.put_back_key && newest.after.version === lead.version && namesStep(newest) ? newest : undefined
      // Only the step for that exact send may offer the existing version-guarded put-back. A second nudge
      // does not become the original Answered step, and a Yes/Booked action is never an outbound send.
      const canGoBack = send && ['answered', 'quoted'].includes(step.key) && !enquirySending(lead)
      return {
        ...(event ? { when: stepDate(event.created_at), detail: `${['answered', 'quoted'].includes(step.key) ? 'Sent' : step.word} ${stepDate(event.created_at)}` } :
          step.key === 'quoted' && lead.quote_send_sent && lead.quote_send_at ? { when: stepDate(lead.quote_send_at), detail: `Sent ${stepDate(lead.quote_send_at)}` } : {}),
        ...(canGoBack ? { goBack: () => putBackSend(lead, lead.put_back_key!, lead.version) } : {}),
      }
    },
  }))
  host.addEventListener('click', e => { if (e.target === host) row.click() })
  return host
}

// Tapping the open row again closes it on a phone (Liam, 10 Oct 2026: "we tap this and it expands which is great but we
// should be able to tap it again and it closes"). On a computer the chosen row stays chosen.
function openRow(id: string): void {
  bookAgainLetGo()
  openId = phoneMessages() && !messageView.focus && openId === id ? null : id
}

function renderTile(r: Row, stage: SectionStage, today: string, rerender: () => void): HTMLElement {
  if (r.kind === 'enquiry' && didntGoAhead(r.l)) {
    const l = r.l
    const tile = el('button', { type: 'button', class: 'rebook-tile messages-dead-row', 'data-message-id': rowId(r), 'aria-label': `Open ${l.name}`, 'aria-expanded': String(openId === rowId(r)) },
      el('span', { class: 'messages-row-copy' }, el('strong', { class: 'rebook-tile-name' }, l.name), el('span', {}, didntGoAheadWords(l))), lineDrawing('chevronRight', 18))
    tile.addEventListener('click', () => { openRow(rowId(r)); rerender() })
    slideToLetGo(tile, l.name, () => {}, () => false, { left: () => { moveClosedOnMessages(l, 'old') } })
    return tile
  }

  if (['visit','recanvass','taken_off'].includes(stage) && r.kind === 'customer') {
    const tile = el('button',{type:'button',class:'rebook-tile','aria-label':`Open ${r.c.name}`, 'aria-expanded':String(openId === rowId(r))},el('span',{class:'messages-row-copy'},el('strong',{},r.c.name),el('span',{},r.c.address || 'No address recorded'),el('span',{},stage==='visit' ? r.c.messages_shelf_review_on && r.c.messages_shelf_review_on <= today ? 'Review due' : 'Needs a visit' : recanvass(r.c) && r.c.customer_list_review_on && r.c.customer_list_review_on<=today ? 'Recanvass · review due' : listTitle(r.c))))
    tile.prepend(meaningIcon(homeOf(stage)!, 'row')); tile.append(el('span', {class:'messages-row-action'}, 'Open'))
    tile.dataset.messageId=rowId(r);tile.addEventListener('click',()=>{openRow(rowId(r));rerender()});return tile
  }
  if (r.kind === 'enquiry' && enquiryLane(r.l, today) === 'won') {
    const lead = r.l
    const button = el('button', { type: 'button', class: 'rebook-tile messages-won-row', 'aria-label': `${lead.live_customer_id ? 'Open' : 'Book'} ${lead.name}`, 'data-message-id': rowId(r) },
      meaningIcon('enquiries', 'row'), el('span', { class: 'messages-row-copy' }, el('strong', { class: 'rebook-tile-name' }, lead.name), el('span', {}, lead.address ?? 'No address on file')),
      el('span', { class: 'messages-row-action' }, lead.live_customer_id ? 'Their page' : `Book ${firstName(lead.name)}`))
    button.addEventListener('click', () => { if (lead.live_customer_id) window.location.hash = `#/customer/${lead.live_customer_id}`; else void bookEnquiry(lead) })
    return enquiryStepHost(button, lead, 'you')
  }
  const replyTile = r.kind === 'customer' && r.reply ? el('button', { type:'button', class:'rebook-tile', 'aria-label': `Open ${r.c.name}${r.c.message_reply_job_id != null ? ', reply' : ''}` }, el('span', { class:'rebook-tile-line' }, replyTitle(r.c,today))) : null
  replyTile?.addEventListener('click', () => { openRow(rowId(r)); rerender() })
  let tile = replyTile ?? (r.kind === 'enquiry' ? enquiryTile(r.l, stage, today, rerender)
    : r.kind === 'job' ? jobTile(r.d, stage as RebookStage, today, rerender)
      : stage === 'lapsed' ? lapsedTile(r.c, rerender) : customerTile(r.c, stage as RebookStage, today, rerender))
  const record = r.kind === 'enquiry' ? r.l : r.kind === 'job' ? r.d.entry : r.c
  const line = tile.querySelector('.rebook-tile-line')
  if (r.kind === 'customer' && REPLY_GROUPS.some(g => g.key === stage) && line) line.textContent = replyTitle(r.c, today)
  const tag = r.kind === 'enquiry' ? 'Enquiry' : r.kind === 'job' ? r.d.job.name
    : r.reply && r.c.message_reply_job_id != null ? roundJobs().find(j => j.id === r.c.message_reply_job_id)?.name ?? 'Job'
    : [(r.c.job_name || kindLabel('window')), ...(stage === 'to_message' ? mergedJobs.get(r.c.id) ?? [] : []).map((d) => d.job.name)].join(' + ')
  const price = r.kind === 'enquiry' ? r.l.regular_pence ?? r.l.initial_pence : r.kind === 'job' ? r.d.job.price_pence
    : r.reply && r.c.message_reply_job_id != null ? roundJobs().find(j => j.id === r.c.message_reply_job_id)?.price_pence ?? null
    : r.c.reg_price_pence == null ? null : r.c.reg_price_pence + (stage === 'to_message' ? mergedJobs.get(r.c.id) ?? [] : []).reduce((n, d) => n + (d.job.price_pence ?? 0), 0)
  const copy = el('span', { class: 'messages-row-copy' },
    el('span', { class: 'rebook-tile-namewrap' }, el('span', { class: 'rebook-tile-name' }, record.name), el('span', { class: 'rebook-tile-tag' }, tag)),
    el('span', { class: 'rebook-tile-meta' }, record.address || record.phone || 'No address on file'))
  if (line) copy.append(line)
  // Late reads late everywhere (Liam, 2 Nov 2026: "three days late" in Next up, amber like the Late list and its hourglass).
  if (line && r.kind !== 'enquiry' && rowHome(r, stage) === 'late') line.classList.add('messages-line-late')
  // Design B (Liam, 23 Oct 2026: "it looks just like a time which presume is over due which a good idea makes ui useful"):
  // a picture of where they stand in place of their letters, the price or what is still to give, and an arrow to open.
  const icon = meaningIcon(rowHome(r, stage), 'row')
  icon.classList.add('messages-row-ring')
  tile.replaceChildren(icon, copy,
    el('span', { class: 'messages-row-price' }, price != null ? money(price) : r.kind === 'enquiry' ? 'Quote' : 'No price'), el('span', { class: 'messages-row-action' }, r.kind === 'enquiry' ? (r.l.replies_unseen ?? 0) > 0 ? 'Reply' : stage === 'new' ? 'Answer' : 'Nudge' : stage === 'to_message' ? 'Offer a day' : stage === 'waiting' ? 'Follow up' : 'Open'))
  tile.dataset.messageId = rowId(r)
  tile.setAttribute('aria-expanded', String(openId === rowId(r)))
  if (r.kind === 'enquiry') tile = enquiryStepHost(tile, r.l, countedEnquiryPill(r.l, today) === 'waiting' ? 'them' : 'you')
  // Just moved here (I sent a quote): one lemon glow, and the screen taken to the row once it is drawn.
  if (landId === rowId(r)) {
    landId = null
    tile.classList.add('rd-land')
    const show = (): void => { if (tile.isConnected) tile.scrollIntoView?.({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' }) }
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(show); else setTimeout(show, 0)
  }
  // Slide an enquiry left to let it go: Spam, Not our area, Not interested (src/let-go.ts), on a phone.
  if (r.kind === 'enquiry' && phoneMessages() && openId !== rowId(r)) {
    const l = r.l
    slideToLetGo(tile, l.name, (reason) => {
      const gen = routeGen
      letGoEnquiry(l, reason, () => { if (gen === routeGen) void load() })
      rerender()
    }, () => false, { right: { act: () => remindEnquiry(l) } })
  }
  // Liam, 2 Nov 2026: a customer too. Left (red, bin) takes them off the round into Old customers, where the red bin wipes
  // their details; right (soft lemon, Next week) is Not now for a week. Undo on both.
  if (r.kind === 'customer' && r.c.status === 'active' && phoneMessages() && openId !== rowId(r)) {
    const c = r.c
    slideToLetGo(tile, c.name, () => {}, () => takingOff.has(c.id), {
      left: () => { void takeOffAfterFinal(c, true, undefined, `Binned from Messages ${shortDate(todayISO())}.`) },
      right: { act: () => { void recordNotNow(c, addDaysISO(todayISO(), 7)) } },
    })
  }
  return tile
}

// Enquiries keep their own home even while waiting; customer/job first messages use their actual due group.
function rowHome(r: Row, stage: SectionStage): MessageHome {
  if (r.kind === 'enquiry') return 'enquiries'
  if (stage !== 'to_message') return homeOf(stage)!
  if (r.kind === 'job') return homeOf(r.d.group === 'coming_up' ? 'upcoming' : 'overdue')!
  const id = r.c.id
  return homeOf(movedVisits.has(id) ? 'moved' : upcomingIds.has(id) || bookedSoonIds.has(id) ? 'upcoming' : noDateIds.has(id) ? 'nodate' : 'overdue')!
}

function streetShort(address: string | null | undefined): string {
  const a = (address ?? '').split(',')[0]?.trim() ?? ''
  return a.length > 26 ? `${a.slice(0, 24)}…` : a
}

// Rows already nudged this cycle sink below the untouched ones. Kept for the
// tests; the stage sections make it mostly moot.
export function workOrder(rows: RoundCustomer[]): RoundCustomer[] {
  const todo = rows.filter((c) => messagesThisCycle(c) === 0)
  const done = rows.filter((c) => messagesThisCycle(c) > 0)
  return [...todo, ...done]
}

interface StageSpec { stage: SectionStage; title: string; blurb: string; collapsible: boolean; extraClass?: string }
const NEW_ENQUIRIES: StageSpec = { stage: 'new', title: 'New enquiries · reply within 2 days', blurb: 'Received in the last month. No reply sent yet.', collapsible: true }
// Enquiries who wrote back, above the new ones (Liam, 16 Oct 2026: "go for a they replied section"): a reply by email
// or text that came into Roundly, or one kept with They replied on their card. Counted with New enquiries, as before.
const THEY_REPLIED: StageSpec = { stage: 'new', title: 'They replied · answer them', blurb: 'Read their reply and send your answer.', collapsible: true }
// Enquiries messaged and still waiting for an answer stay together under the new ones, so they are kept on top of
// (Liam, 10 Oct 2026: "if they havent replied to the first message they should still sit in enquiries on messages so
// we can keep on top of them maybe after second message we could let it go"). A week after the second message with no
// answer they are let go: off Messages, under Maybe later on New jobs (src/enquiry-lane.ts).
// The enquiries messaged and not answered yet, in two groups (Liam, 16 Oct 2026: "equiries should be broken into
// sections ... new equiries, waiting on a reply, and quoted no reply"): asked for photos or a window count, and sent a
// price (enquiry-message.ts quoted, which already chooses the gentle quote nudge over the photos chase). A week after
// the second message with no answer they are let go: off Messages, under Maybe later on New jobs (src/enquiry-lane.ts).
// Names and lines from Astra's wording review, as Liam took them (16 Oct 2026).
const ENQ_DETAILS: StageSpec = { stage: 'waiting', title: 'Details requested', blurb: 'Waiting for photos or a window count.', collapsible: true }
const ENQ_QUOTED: StageSpec = { stage: 'waiting', title: 'Quote sent', blurb: 'Waiting for them to accept your price.', collapsible: true }
const MOVED: StageSpec = { stage: 'to_message', title: 'Visit moved · tell them', blurb: 'They had agreed a day, and the visit moved. Ask whether the new day suits.', collapsible: false, extraClass: 'rebook-stage-moved' }
const COMING_UP: StageSpec = { stage: 'to_message', title: 'Coming up · due within How far ahead to ask', blurb: 'Booked ahead as always: message them before the date, not after.', collapsible: false }
const OVERDUE: StageSpec = { stage: 'to_message', title: 'Late · no visit agreed', blurb: 'Tap a name to see the message and send it.', collapsible: true }
const NO_DATE: StageSpec = { stage: 'to_message', title: 'No date yet · ask when suits', blurb: 'Customers with no visit in Roundly yet, or whose first visit never got done. The diary can put them in a week instead, under "No date yet".', collapsible: true, extraClass: 'rebook-stage-nodate' }
// The three shared stages hold customers AND enquiries (enquiries wait five
// days between messages, customers seven).
const SHARED_STAGES: StageSpec[] = [
  { stage: 'waiting', title: 'Waiting for a reply', blurb: `Give them ${SECOND_MESSAGE_AFTER_DAYS} days before the second message.`, collapsible: false },
  { stage: 'second', title: 'Send second message', blurb: 'No reply since the first message. The second message tells them they are coming off the list.', collapsible: false },
  { stage: 'no_reply', title: 'No reply · final message', blurb: 'Messaged twice. The final message tells them they are coming off; sending it takes them off the round. Old customers in More keeps them.', collapsible: false },
]
// Lapsed, and worth asking back. Only customers who actually had visits: 72 of
// the 93 lapsed rows the spreadsheet brought in never had a single clean (old
// canvassing and Google Ads names), and a list mostly made of those would be
// ignored, taking the 21 real ones down with it.
const LAPSED: StageSpec = {
  stage: 'lapsed',
  title: 'Lapsed · worth asking back',
  blurb: `Off the round, but they had visits. Asking them back offers ${WINBACK_DISCOUNT_PERCENT}% off the first clean.`,
  collapsible: true,
}
const TILES_SHOWN = 6

function stageKey(spec: StageSpec): string {
  if (spec.extraClass?.startsWith('messages-enquiry-')) return spec.extraClass.slice('messages-enquiry-'.length) === 'waiting' ? 'enqquoted' : spec.extraClass.slice('messages-enquiry-'.length)
  return spec === MOVED ? 'moved' : spec === NEW_ENQUIRIES ? 'new' : spec === THEY_REPLIED ? 'enqreplied' : spec === ENQ_DETAILS ? 'enqdetails' : spec === ENQ_QUOTED ? 'enqquoted' : spec === COMING_UP ? 'upcoming' : spec === OVERDUE ? 'overdue' : spec === NO_DATE ? 'nodate' : spec.stage
}

function keepMessageDrafts(root: HTMLElement): void {
  for (const card of root.querySelectorAll<HTMLElement>('.rebook-card, .messages-sheet-card')) {
    const key = card.dataset.messageId
    if (!key) continue
    const fields = [...card.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea')]
      .filter((f) => f.type !== 'checkbox' && f.type !== 'radio')
      .filter(f => !f.closest('.messages-owner-context'))
      .map((f) => ({ label: f.getAttribute('aria-label') ?? '', className: f.className, context: f.closest('.notnow-chooser') ? 'later' : 'said', value: f.value }))
    const later = card.querySelector<HTMLElement>('.notnow-chooser')
    cardDrafts.set(key, { deskScrollTop: card.querySelector<HTMLElement>('.messages-sheet-scroll')?.scrollTop, about: card.dataset.sheetPhone === 'true' ? card.querySelector<HTMLDetailsElement>('.messages-sheet-about')?.open : cardDrafts.get(key)?.about, day: card.dataset.sheetPhone === 'true' ? card.querySelector<HTMLDetailsElement>('.messages-sheet-day')?.open : cardDrafts.get(key)?.day, fields, saidBase: card.dataset.saidBase ?? '', said: !!card.querySelector('.said-block')?.querySelector('.said-input'), later: !!later && !later.hidden, details: card.querySelector<HTMLDetailsElement>('.messages-visit-details')?.open ?? cardDrafts.get(key)?.details ?? false })
  }
}

// Messages' Filter (Show and Sort): open across redraws while in use; a tap outside it or Escape closes it.
let filterOpen = false
let filterCloserOn = false
function closeFilterOnOutsideTap(): void {
  if (filterCloserOn || typeof document === 'undefined') return
  filterCloserOn = true
  // Inside the Filter counts its own Show and Sort lists too: a styled list opens on the page body, away from the
  // Filter (styled-select.ts), and the pick redraws the page before this hears it, so any pick in a styled list is not
  // a tap elsewhere (Codex, 15 Oct 2026). Any other list's trigger is outside the Filter and has closed it already.
  const inside = (d: HTMLDetailsElement, target: EventTarget | null): boolean =>
    target instanceof Element && (d.contains(target) || !!target.closest('.roundly-select-list'))
  const shut = (target: EventTarget | null, focusBack: boolean): void => {
    for (const d of document.querySelectorAll<HTMLDetailsElement>('details.messages-filter[open]')) {
      if (inside(d, target)) continue
      d.open = false
      filterOpen = false
      if (focusBack) d.querySelector<HTMLElement>('summary')?.focus()
    }
  }
  document.addEventListener('click', (e) => shut(e.target, false))
  // Escape that a Show or Sort list used to close itself is theirs; otherwise it closes the Filter and focus goes back to it.
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !e.defaultPrevented) shut(null, true) })
}

function toggleFocus(rerender: () => void): void {
  if (openId === 'closed') openId = null
  focusRestoreId = null
  messageView.focus = !messageView.focus
  if (messageView.focus) {
    focusSearch = { text: filterText, stage: stageFilter }
    filterText = ''
  } else if (focusSearch) {
    filterText = focusSearch.text; stageFilter = focusSearch.stage; focusSearch = null
  }
  rerender()
  document.querySelector<HTMLButtonElement>('.messages-focus-switch')?.focus({ preventScroll: true })
}

function foldSection(sec: HTMLElement, key: string, startsOpen: boolean): void {
  const head = sec.querySelector('.rebook-stage-head')
  if (!head) return
  const fold = el('details', { class: 'messages-group-fold' })
  fold.open = (!quietGroup(key) && picks(key)) || !!filterText.trim() || (key === 'nodate' && showNoDateGroup) || (foldedGroups.get(key) ?? startsOpen)
  const summary = el('summary', {}, head)
  fold.append(summary, ...Array.from(sec.children))
  fold.addEventListener('toggle', () => { if (fold.isConnected) foldedGroups.set(key, fold.open && fold.dataset.closing !== 'true') })
  animateDisclosure(fold)
  sec.append(fold)
}

// The legacy Everyone waiting Filter option keeps its full cross-home membership.
// The M4 Waiting on them tile itself uses homeOf and excludes enquiry waits.
const PICK_GROUPS: Record<string, string[]> = { awaiting: ['enqdetails', 'enqquoted', 'waiting'] }
const inGroup = (picked: string, key: string): boolean => picked === key || picked === `home:${homeOf(key)}` || (PICK_GROUPS[picked]?.includes(key) ?? false)
const picks = (key: string): boolean => inGroup(stageFilter, key)

// M4, Stage 3: four stable homes; All and every subgroup stay in Filter.
// Retain the existing count-pop and cleared receipt, with no receipt earned by search.
const MESSAGE_TILES: [MessageHome, string][] = [['enquiries', 'Enquiries'], ['comingup', 'Coming up'], ['late', 'Late'], ['waiting', 'Waiting on them']]
let lastTileCounts: Map<string, number> | null = null
let tileOwner = ''
function quietGroup(key: string): boolean { return MESSAGE_HOMES[key as keyof typeof MESSAGE_HOMES]?.quiet ?? false }
function rowDue(row: Row, spec: StageSpec, today: string): boolean {
  return dueToday({ stageKey: stageKey(spec), ...(row.kind === 'enquiry' ? { enquiryStage: actionableEnquiryLane(row.l, today), nudgeDue: reminderDue(row.l, today), deferred: remindedLater(row.l, today) } : {}) })
}
function tileRows(home: MessageHome): { row: Row; spec: StageSpec }[] {
  const seen = new Set<string>()
  return pageSections.filter(({ spec }) => homeOf(stageKey(spec)) === home && !quietGroup(stageKey(spec))).flatMap(({ rows, spec }) => rows.map(row => ({ row, spec }))).filter(({ row }) => {
    const id = rowId(row); if (seen.has(id)) return false; seen.add(id); return true
  })
}
function messageTiles(rerender: () => void, today: string, complete: boolean, enquiryRows: Lead[]): HTMLElement {
  const owner = `${getMe()?.businessId}|${getMe()?.email}`
  if (owner !== tileOwner) { lastTileCounts = null; tileOwner = owner; listHadRows = null; allClearOwed = false }
  const counts = new Map<string, number>()
  const searching = !!filterText.trim()
  const before = searching || !complete ? null : lastTileCounts
  // Offers only add people not yet counted in any home, including Book again and extra-job rows.
  const countedPeople = new Set<string>()
  for (const [home] of MESSAGE_TILES) for (const { row } of tileRows(home)) {
    const id = row.kind === 'customer' ? row.c.id : row.kind === 'job' ? row.d.job.customer_id : row.l.converted_customer_id
    if (id != null) countedPeople.add(`c${id}`)
  }
  for (const item of bookAgainTileItems() ?? []) countedPeople.add(item.id)
  const box = el('div', { class: 'messages-tiles', role: 'group', 'aria-label': 'Groups to show' })
  for (const [home, label] of MESSAGE_TILES) {
    const rows = tileRows(home)
    const rawExtras = home === 'comingup' ? bookAgainTileItems() : home === 'waiting' ? customerOfferTileItems() : []
    const ids = new Set(rows.map(({row}) => rowId(row)))
    const extras = rawExtras?.filter(item => !(home === 'waiting' ? countedPeople : ids).has(item.id)) ?? (rawExtras === null ? null : [])
    // Enquiries use the full read, including undated/sorting enquiries, but never Won or parked history.
    const enquiries = enquiryRows.filter(l => ['yourturn', 'waiting'].includes(countedEnquiryPill(l, today) ?? ''))
    const count = home === 'enquiries' ? enquiries.length : rows.length + (extras?.length ?? 0)
    const known = (home !== 'enquiries' || complete) && extras !== null
    if (known) counts.set(home, count)
    const prices = home === 'enquiries' ? enquiries.map(l => l.regular_pence) : [
      ...rows.flatMap(({ row, spec }) => row.kind === 'job' ? [row.d.job.price_pence] : row.kind === 'enquiry' ? [row.l.regular_pence] : [
        row.reply && row.c.message_reply_job_id != null ? roundJobs().find(j => j.id === row.c.message_reply_job_id)?.price_pence : row.c.reg_price_pence,
        ...(spec.stage === 'to_message' ? mergedJobs.get(row.c.id) ?? [] : []).map(d => d.job.price_pence)]),
      ...(extras ?? []).map(item => item.price),
    ]
    const value = prices.reduce<number>((sum, price) => sum + (price ?? 0), 0)
    const unknown = prices.some(price => price == null)
    const was = before?.get(home)
    const cleared = known && was != null && was > 0 && count === 0
    const picked = stageFilter === `home:${home}`
    const n = el('strong', { class: 'messages-tile-count' }, known ? String(count) : '…')
    let note = !known ? 'Not available · Retry' : count === 0 ? 'Nobody yet' : home === 'waiting' ? 'they have your message' : `${count} ready`
    if (home === 'enquiries' && known && count) note = `${enquiries.filter(l => enquiryLane(l, today) === 'answer' && enquiryMessages(l) === 0 && !(l.replies_unseen ?? 0)).length} new`
    if (home === 'late' && count) {
      const days = Math.max(0, ...rows.map(({ row }) => row.kind === 'customer' ? overdueDays(row.c, today) : row.kind === 'job' ? overdueDays(row.d.entry, today) : 0))
      note = days >= 7 ? `${Math.floor(days / 7)} ${Math.floor(days / 7) === 1 ? 'week' : 'weeks'} late` : `${days} ${days === 1 ? 'day' : 'days'} late`
    }
    const slot = el('span', { class: 'messages-tile-progress', role: 'img', 'data-stage-slot': 'cleared-today' }); slot.hidden = true
    const button = el('button', { type: 'button', class: `messages-tile${cleared ? ' is-cleared' : ''}`, 'data-tile': home, 'aria-pressed': String(picked), 'aria-label': `${label}, ${known ? count : 'not available'}` },
      el('span', { class: 'messages-tile-ring', 'aria-hidden': 'true' }, meaningIcon(home, 'tile'), ...(cleared ? [clearedMark(false)] : [])), n,
      el('span', { class: 'messages-tile-label' }, label), el('span', { class: 'messages-tile-note' }, note),
      el('span', { class: 'messages-tile-money' }, ...(known ? [`${money(value)}${unknown ? ' + ?' : ''}`, el('span', { class: 'messages-tile-money-word' }, ' waiting')] : ['Not available'])), slot)
    button.addEventListener('click', () => { stageFilter = picked ? 'next' : `home:${home}`; openId = null; asked = null; rerender() })
    if (known && was != null && count > 0 && count < was) smallMotion(n, 'count')
    box.append(button)
  }
  if (!searching && complete) lastTileCounts = counts
  return box
}

// Reuse the existing rows and cards. Moving their nodes preserves handlers, drafts and keyboard ownership.
function arrangeMessageQueue(queue: HTMLElement, all: { row: Row; spec: StageSpec }[], today: string): void {
  if (stageFilter === 'next' && !asked) {
    const ordered = nextUp(all, today)
    for (const sec of queue.querySelectorAll<HTMLElement>('.rebook-stage')) sec.hidden = !sec.classList.contains('ba-section') && !sec.classList.contains('customer-offers-messages')
    const section = el('section', { class: 'rebook-stage messages-next-up', 'aria-label': 'Next up' }, el('h2', {}, 'Next up'))
    const list = el('div', { class: 'rebook-tiles' })
    for (const { row } of ordered) {
      const tile = [...queue.querySelectorAll<HTMLElement>('.rebook-tile')].find(tile => tile.dataset.messageId === rowId(row))
      const card = [...queue.querySelectorAll<HTMLElement>('.rebook-card')].find(card => card.dataset.messageId === rowId(row))
      if (tile) list.append(tile)
      if (card) list.append(card)
    }
    section.append(list); queue.prepend(section)
  }
  if (stageFilter.startsWith('home:')) {
    for (const { spec, node } of pageSections) {
      if (!quietGroup(stageKey(spec)) || stageKey(spec) === 'won' || stageKey(spec) === 'closed' && enquiryPill === 'dead' || !picks(stageKey(spec))) continue
      const sec = node.closest<HTMLElement>('.rebook-stage') ?? node
      if (sec.classList.contains('messages-stage-enquiries')) continue
      let fold = sec.querySelector<HTMLDetailsElement>('details.messages-group-fold')
      if (!fold) { foldSection(sec, stageKey(spec), false); fold = sec.querySelector('details.messages-group-fold') }
      if (fold) fold.open = foldedGroups.get(stageKey(spec)) ?? false
      queue.append(sec)
    }
    // Old quotes last, under every other Enquiries group (Liam, 2 Nov 2026: "Old auotes should be at tge bottom").
    if (stageFilter === 'home:enquiries') {
      const old = queue.querySelector<HTMLElement>('.rebook-stage-oldquotes')
      old?.parentElement?.append(old)
    }
  }
}
function actionableEnquiryLane(lead: Lead, today: string): ReturnType<typeof enquiryLane> {
  const lane = enquiryLane(lead, today)
  return lane === 'letgo' && reminderDue(lead, today) ? 'chase' : lane
}
function countedEnquiryPill(lead: Lead, today: string): EnquiryPill | null {
  if (didntGoAhead(lead)) return 'dead'
  const pill = pillOf(actionableEnquiryLane(lead, today))
  return pill === 'won' ? pill : remindedLater(lead, today) || oldQuotes([lead], today).length > 0 ? null : pill
}

function enquiryPage(root: HTMLElement, leads: Lead[], today: string, rerender: () => void, known: boolean): void {
  if (stageFilter !== 'home:enquiries') return
  root.classList.add('messages-enquiries-page')
  const open = leads.filter(l => ['yourturn', 'waiting'].includes(countedEnquiryPill(l, today) ?? '')).length
  const streak = el('span', { class: 'messages-enquiry-streak', 'data-stage-slot': 'enquiry-streak' }); streak.hidden = true
  const pills = el('div', { class: 'messages-enquiry-pills', role: 'group', 'aria-label': 'Enquiries to show' })
  for (const [key, label] of [['yourturn', 'Your turn'], ['waiting', 'Waiting'], ['won', 'Won'], ['dead', "Didn't go ahead"]] as const) {
    const count = leads.filter(l => countedEnquiryPill(l, today) === key).length
    const b = el('button', { type: 'button', class: 'messages-enquiry-pill', 'data-enquiry-pill': key, 'aria-pressed': String(enquiryPill === key) }, `${label} ${known ? count : '…'}`)
    b.addEventListener('click', () => { enquiryPill = enquiryPill === key ? null : key; openId = null; rerender() }); pills.append(b)
  }
  // A filter like the other tiles (Liam, 2 Nov 2026: "it would be better if it just filtered like the others"): the banner
  // and tiles stay, the Enquiries tile shows picked (tap it again for Next up), and this bar heads the list.
  root.querySelector('.messages-queue')?.prepend(el('div', { class: 'messages-enquiry-bar' }, el('h2', {}, `Enquiries · ${known ? open : '…'}`), streak, pills))
  const oldQuotesNode = root.querySelector<HTMLElement>('.rebook-stage-oldquotes')
  if (oldQuotesNode && enquiryPill === 'dead') oldQuotesNode.hidden = true
  for (const { spec, rows, node } of pageSections) {
    if (homeOf(stageKey(spec)) !== 'enquiries') continue
    const quiet = quietGroup(stageKey(spec)) && stageKey(spec) !== 'won'
    const shown = rows.filter(r => r.kind === 'enquiry' && inPickedPill(countedEnquiryPill(r.l, today)))
    node.hidden = enquiryPill === 'dead' ? shown.length === 0 : node.dataset.enquiryLane === 'closed' || !quiet && shown.length === 0
    const ids = new Set(shown.map(rowId))
    for (const tile of node.querySelectorAll<HTMLElement>('.rebook-tile, .rebook-card')) tile.hidden = !quiet && !ids.has(tile.dataset.messageId ?? '')
    const count = node.querySelector('.rebook-stage-count'); if (count && !quiet) count.textContent = String(shown.length)
    const parent = node.closest<HTMLElement>('.messages-stage-enquiries')
    if (parent) parent.hidden = false
  }
}

function nextUp(all: { row: Row; spec: StageSpec }[], today: string): { row: Row; spec: StageSpec }[] {
  const priorities = ['moved', 'enqreplied', 'new', 'upcoming', 'overdue']
  return all.filter(({ row, spec }) => rowDue(row, spec, today)).sort((a, b) => {
    const rank = (spec: StageSpec): number => { const n = priorities.indexOf(stageKey(spec)); return n < 0 ? priorities.length : n }
    return rank(a.spec) - rank(b.spec)
  })
}

type StandaloneSheet = { id: string; name: string; render: () => HTMLElement }
let standaloneSheets: StandaloneSheet[] = []
function standaloneSheetRow(id: string, name: string, render: () => HTMLElement, rerender: () => void, customerId: number, status: string): HTMLElement {
  standaloneSheets.push({ id, name, render: () => {
    const card = render(), customer = list?.find(c => c.id === customerId)
    if (customer) {
      const about = el('div', { class: 'messages-sheet-about-content' },
        el('a', { href: `#/customer/${customer.id}` }, 'Open customer'), el('p', {}, addressLine(customer)), priceTile(customer),
        el('p', { class: 'muted' }, customer.last_clean ? `Last visit ${shortDate(customer.last_clean)}` : 'No visits done yet'),
        el('p', { class: 'muted' }, customer.last_contacted_on ? `Last contact ${shortDate(customer.last_contacted_on)}` : 'No contact recorded yet'),
        customerContext(customer, () => void load()))
      if (saidLine(customer)) about.append(el('p', { class: 'said-note' }, el('strong', {}, 'What they said '), saidLine(customer)))
      card.append(about)
    }
    return card
  } })
  const word = id.startsWith('ba:') ? 'Book again' : id.startsWith('stop:') ? 'Check their reply' : 'Offer of another job'
  const row = el('button', { type: 'button', class: 'messages-sheet-row', 'data-message-id': id, 'aria-expanded': String(openId === id), 'aria-label': `Open ${name}: ${word}` },
    meaningIcon(id.startsWith('ba:') ? 'comingup' : 'waiting', 'row'), el('span', { class: 'messages-row-copy' }, el('strong', {}, name), el('span', {}, word), el('small', { class: 'messages-row-status' }, status)), el('span', { class: 'messages-row-action' }, 'Open'))
  row.addEventListener('click', () => { openId = id; rerender() })
  return row
}

function watchMessageSheet(root: HTMLElement): void {
  const card = root.querySelector<HTMLElement>('.messages-sheet-card')
  if (!card) { sheetFocusId = undefined; return }
  const justOpened = sheetFocusId !== card.dataset.messageId
  sheetFocusId = card.dataset.messageId
  card.classList.toggle('messages-sheet-enter', justOpened)
  const phone = phoneMessages(), panel = card.closest<HTMLElement>('.messages-panel')!
  const scroll = card.querySelector<HTMLElement>('.messages-sheet-scroll')!
  const back = card.querySelector<HTMLButtonElement>('.messages-sheet-back')!
  const savedScroll = cardDrafts.get(card.dataset.messageId ?? '')?.deskScrollTop
  if (savedScroll !== undefined) scroll.scrollTop = savedScroll
  const free: (() => void)[] = []
  const keydown = (event: KeyboardEvent): void => {
    if (event.defaultPrevented) return
    if (event.key === 'Escape') {
      const target = event.target as HTMLElement | null
      if (target?.closest('input, textarea, select, [contenteditable=true]')) return
      if ([...card.querySelectorAll<HTMLElement>('.enquiry-replied-form, .notnow-chooser, .enquiry-step-box, .ba-panel-sheet')].some(n => !n.hidden)) return
      if ([...panel.querySelectorAll<HTMLDialogElement>('dialog')].some(n => n.open)) return
      const menu = [...card.querySelectorAll<HTMLDetailsElement>('details')].find(n => n.open && n.classList.contains('way-menu'))
      if (menu) { menu.open = false; menu.querySelector<HTMLElement>('summary')?.focus(); event.stopPropagation(); return }
      event.preventDefault(); event.stopPropagation(); back.click()
    }
    if (phone && event.key === 'Tab') {
      const buttons = [...panel.querySelectorAll<HTMLElement>('a, button, input, textarea, select, summary, [tabindex]')].filter(n => {
        if (n.hasAttribute('disabled') || n.getAttribute('tabindex') === '-1' || n.getAttribute('aria-disabled') === 'true') return false
        for (let p: HTMLElement | null = n; p && p !== panel; p = p.parentElement) {
          if (p.hidden || p.tagName === 'DETAILS' && !(p as HTMLDetailsElement).open && p.querySelector('summary') !== n) return false
        }
        return n.getClientRects().length > 0
      })
      const first = buttons[0], last = buttons.at(-1)
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus() }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus() }
    }
  }
  panel.addEventListener('keydown', keydown); free.push(() => panel.removeEventListener('keydown', keydown))
  if (phone) {
    panel.classList.add('messages-sheet-overlay')
    panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); panel.setAttribute('aria-label', card.getAttribute('aria-label') ?? 'Selected message')
    const backdrop = el('button', { type: 'button', class: 'messages-sheet-backdrop', 'aria-label': 'Back to the list', tabindex: '-1' })
    backdrop.addEventListener('click', () => back.click()); panel.prepend(backdrop)
    const background = [...root.children].filter(n => n !== panel && !n.contains(panel)) as HTMLElement[]
    const queue = root.querySelector<HTMLElement>('.messages-queue')
    if (queue) background.push(queue)
    for (const n of document.querySelectorAll<HTMLElement>('.owner-nav, .topbar')) background.push(n)
    for (const n of background) { const before = n.inert; n.inert = true; free.push(() => { n.inert = before }) }
    const overflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'; free.push(() => { document.body.style.overflow = overflow })
    // Keep the existing receipts/Undo inside the modal's accessible tree, including ones arriving after a save.
    const receipts = new Map<HTMLElement, HTMLElement>()
    const bringReceipts = (): void => {
      for (const node of document.querySelectorAll<HTMLElement>('#undo-bar, #toast, #queue-chip')) {
        if (panel.contains(node) || !node.parentElement) continue
        receipts.set(node, node.parentElement); panel.append(node)
      }
    }
    bringReceipts()
    const receiptsObserver = typeof MutationObserver === 'undefined' ? null : new MutationObserver(bringReceipts)
    receiptsObserver?.observe(document.body, { childList: true })
    free.push(() => {
      receiptsObserver?.disconnect()
      for (const [node, parent] of receipts) if (panel.isConnected && panel.contains(node)) (parent.isConnected ? parent : document.body).append(node)
    })
    free.push(() => document.body.style.removeProperty?.('--messages-sheet-keyboard'))
    const fit = (): void => {
      const nav = document.querySelector('.owner-nav')?.getBoundingClientRect()
      const top = document.querySelector('.topbar')?.getBoundingClientRect().bottom ?? 52
      panel.style.setProperty?.('--messages-sheet-top', `${top + 18}px`)
      panel.style.setProperty?.('--messages-sheet-bottom', `${nav ? Math.max(0, window.innerHeight - nav.top) : 0}px`)
      const vv = window.visualViewport
      const typing = !!document.activeElement && card.contains(document.activeElement) && (document.activeElement as HTMLElement).matches('input, textarea, select, [contenteditable=true]')
      panel.classList.toggle('messages-sheet-typing', typing)
      const dock = panel.querySelector<HTMLElement>('.messages-action-bar')
      const keyboard = vv && window.innerHeight - vv.height > 120 && typing ? Math.max(0, window.innerHeight - vv.height - vv.offsetTop) : 0
      document.body.style.setProperty?.('--messages-sheet-keyboard', `${keyboard}px`)
      if (dock) { if (keyboard) dock.style.bottom = `${keyboard}px`; else dock.style.removeProperty?.('bottom') }
      if (vv && window.innerHeight - vv.height > 120 && typing) {
        panel.style.top = `${vv.offsetTop}px`; panel.style.bottom = `${Math.max(0, window.innerHeight - vv.height - vv.offsetTop)}px`
        const field = document.activeElement as HTMLElement
        const rect = field.getBoundingClientRect(), area = scroll.getBoundingClientRect()
        if (rect.bottom > area.bottom) scroll.scrollTop += rect.bottom - area.bottom + 12
        if (rect.top < area.top) scroll.scrollTop -= area.top - rect.top + 12
      } else { panel.style.removeProperty?.('top'); panel.style.removeProperty?.('bottom') }
    }
    fit()
    for (const type of ['focusin', 'focusout', 'input']) card.addEventListener(type, fit)
    window.addEventListener('resize', fit); window.visualViewport?.addEventListener('resize', fit); window.visualViewport?.addEventListener('scroll', fit)
    free.push(() => {
      for (const type of ['focusin', 'focusout', 'input']) card.removeEventListener(type, fit)
      window.removeEventListener('resize', fit); window.visualViewport?.removeEventListener('resize', fit); window.visualViewport?.removeEventListener('scroll', fit)
    })
    if (justOpened) back.focus({ preventScroll: true })
  }
  sheetStop = () => { for (const release of free) release() }
}

function finishMessageLayout(root: HTMLElement, today: string, rerender: () => void, complete: boolean, enquiryRows: Lead[], brandNew: boolean): void {
  const queue = el('div', { class: 'messages-queue', 'aria-label': 'People to contact' })
  const panel = el('aside', { class: 'messages-panel', 'aria-label': 'Selected message' })
  const layout = el('div', { class: 'messages-layout' }, queue, panel)
  const sections = [...root.querySelectorAll<HTMLElement>('.rebook-stage')]
  for (const sec of sections) queue.append(sec)
  root.append(layout)
  enquiryPage(root, enquiryRows, today, rerender, complete)
  const all = pageSections.flatMap(({ spec, rows }) => rows.map((row) => ({ row, spec })))
  if (!messageView.focus) {
    const tiles = messageTiles(rerender, today, complete, enquiryRows)
    const bar = root.querySelector('.messages-filters')
    const banner = root.querySelector<HTMLElement>('.messages-daily-banner')!
    const top = el('div', { class: 'messages-home-top' }, banner, tiles)
    if (bar) root.insertBefore(top, bar); else root.insertBefore(top, layout)
  }
  paintDailyNumbers(root)
  // Focus and Next up share dueToday eligibility and the existing priority and within-group sorts.
  const first = nextUp(all, today)
  arrangeMessageQueue(queue, all, today)
  const firstIds = new Set(first.map(({ row }) => rowId(row)))
  const restored = [...firstIds].filter((id) => !lastFirstIds.has(id))
  const previouslyHadRows = lastTotal !== null
  lastFirstIds = firstIds
  const available = messageView.focus || stageFilter === 'next' && !asked ? first : all.filter(({ row, spec }) => (stageFilter === 'all' || picks(stageKey(spec))) && (stageFilter !== 'home:enquiries' || row.kind !== 'enquiry' || enquiryPill !== 'dead' && quietGroup(stageKey(spec)) && !['won', 'closed'].includes(stageKey(spec)) || inPickedPill(countedEnquiryPill(row.l, today))))
  const foundCount = root.querySelector('.messages-search-count')
  if (foundCount && stageFilter === 'next') foundCount.textContent = `${first.length} found`
  const candidates = available.map(({ row, spec }) => ({
    id: rowId(row), name: row.kind === 'enquiry' ? row.l.name : row.kind === 'job' ? row.d.entry.name : row.c.name,
    render: () => renderCard(row, rowStage(row, spec), today, rerender),
  })).concat(standaloneSheets)
  const listChoices = (): StandaloneSheet[] => {
    if (messageView.focus) return candidates
    const positions = new Map<string, number>()
    for (const [index, row] of [...queue.querySelectorAll<HTMLElement>('.rebook-tile, .messages-sheet-row')].entries()) if (row.dataset.messageId && !positions.has(row.dataset.messageId)) positions.set(row.dataset.messageId, index)
    const visible = new Set([...queue.querySelectorAll<HTMLElement>('.rebook-tile, .messages-sheet-row')].filter(row => {
      for (let p: HTMLElement | null = row; p && p !== queue; p = p.parentElement) {
        if (p.hidden || p.tagName === 'DETAILS' && !(p as HTMLDetailsElement).open) return false
      }
      return true
    }).map(row => row.dataset.messageId))
    return candidates.filter(c => visible.has(c.id)).sort((a, b) => (positions.get(a.id) ?? Infinity) - (positions.get(b.id) ?? Infinity))
  }
  let choices = listChoices()
  if (focusRestoreId && choices.some(c => c.id === focusRestoreId)) { openId = focusRestoreId; focusRestoreId = null }
  if (messageView.focus && openId && !choices.some(c => c.id === openId)) {
    const was = lastFocusOrder.indexOf(openId)
    openId = lastFocusOrder.slice(was + 1).find(id => choices.some(c => c.id === id)) ?? null
  }
  if (messageView.focus) { lastFocusOrder = choices.map(c => c.id); queue.hidden = true }
  const selected = choices.find(c => c.id === openId) ?? (messageView.focus ? choices[0] : undefined)
  let card = [...queue.querySelectorAll<HTMLElement>('.rebook-card')].find(c => c.dataset.messageId === selected?.id)
  for (const old of queue.querySelectorAll<HTMLElement>('.rebook-card')) if (old !== card) old.remove()
  if (selected) {
    openId = selected.id
    card ??= selected.render()
    if (!card.classList.contains('messages-sheet-card')) {
      card.dataset.messageId = selected.id
      card.setAttribute('aria-label', `Message for ${selected.name}`)
      styleMessageSheet(card, selected.name, rerender)
    }
    panel.append(card)
    panel.hidden = false
    root.classList.add('messages-sheet-open')
    let index = choices.findIndex(c => c.id === selected.id)
    const step = (delta: number): void => {
      choices = listChoices(); index = choices.findIndex(c => c.id === selected.id)
      if (index < 0) return
      const next = choices[index + delta]
      if (!next) return
      openId = next.id; rerender()
      document.querySelector<HTMLElement>('.messages-sheet-back')?.focus({ preventScroll: true })
    }
    const pager = card.querySelector<HTMLElement>('.messages-sheet-pager')!
    if (messageView.focus) pager.classList.add('messages-focus-nav')
    const previous = el('button', { type: 'button', class: 'messages-sheet-previous', 'aria-label': 'Previous person' }, lineDrawing('chevronLeft', 18))
    const next = el('button', { type: 'button', class: 'messages-sheet-next', 'aria-label': 'Next person' }, lineDrawing('chevronRight', 18))
    previous.disabled = index === 0; next.disabled = index === choices.length - 1
    previous.addEventListener('click', () => step(-1)); next.addEventListener('click', () => step(1))
    const count = el('span', { class: 'messages-sheet-count', role: 'status', 'aria-live': 'polite' }, `${index + 1} of ${choices.length}`)
    pager.append(previous, count, next)
    if (!messageView.focus) for (const fold of queue.querySelectorAll<HTMLDetailsElement>('.messages-group-fold')) fold.addEventListener('toggle', () => {
      if (!fold.isConnected) return
      choices = listChoices(); index = choices.findIndex(c => c.id === selected.id)
      if (index < 0) { openId = 'closed'; rerender(); return }
      previous.disabled = index === 0; next.disabled = index === choices.length - 1
      count.textContent = `${index + 1} of ${choices.length}`
    })
    if (messageView.focus && index < choices.length - 1) {
      const skip = el('button', { type: 'button', class: 'link-button messages-skip' }, 'Skip')
      skip.addEventListener('click', () => step(1)); card.querySelector('.messages-sheet-scroll')?.append(skip)
    }
    card.addEventListener('keydown', event => {
      const target = event.target as HTMLElement | null
      const ownsArrows = target === card || target === card?.querySelector('.messages-sheet-scroll') || target === pager || !!target?.closest('.messages-sheet-pager')
      if (event.defaultPrevented || !ownsArrows) return
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); step(event.key === 'ArrowLeft' ? -1 : 1)
      }
    })
    let swipe: { x: number; y: number; id: number } | null = null
    card.addEventListener('pointerdown', event => {
      const target = event.target as HTMLElement
      if (event.button !== 0 || target.closest('a, button, input, textarea, select, summary, .ready-words, .rebook-preview-text, .messages-sheet-about')) return
      swipe = { x: event.clientX, y: event.clientY, id: event.pointerId }
    })
    card.addEventListener('pointerup', event => {
      if (!swipe || swipe.id !== event.pointerId) return
      const dx = event.clientX - swipe.x, dy = event.clientY - swipe.y
      swipe = null
      if (Math.abs(dx) > 65 && Math.abs(dy) < 40) step(dx < 0 ? 1 : -1)
    })
    card.addEventListener('pointercancel', () => { swipe = null })
    if (nextSlidesIn?.gen === routeGen && nextSlidesIn.from !== openId && messageView.focus) slideIn(card)
    for (const tile of queue.querySelectorAll<HTMLElement>('.rebook-tile, .messages-sheet-row')) (tile.querySelector<HTMLElement>('.enquiry-row-open') ?? tile).setAttribute('aria-expanded', String(tile.dataset.messageId === openId))
  } else {
    panel.hidden = true
    if (messageView.focus) {
      panel.hidden = false
      const back = el('button', { type: 'button', class: 'btn-secondary' }, 'Back to the list')
      back.addEventListener('click', () => toggleFocus(rerender))
      panel.append(el('section', { class: 'messages-caught-up' }, el('h2', {}, complete ? 'Next up caught up' : 'Some messages could not load'), back))
    }
  }
  if (!root.querySelector('.messages-enquiry-sheet')) releaseEnquiryChat()
  nextSlidesIn = null
  // Completion follows today's due work, including standalone message cards. Quiet history and passive waits
  // remain reachable; a search, picked home or failed read cannot earn the receipt.
  const wholeList = !messageView.focus && ['all', 'next'].includes(stageFilter) && !filterText.trim() && complete
  const standaloneCards = queue.querySelector('.ba-list, .customer-offers-messages') !== null
  const dueCards = (bookAgainTileItems()?.length ?? 0) > 0 || (customerOfferTileItems(true)?.length ?? 0) > 0
  const nothingOnList = wholeList && first.length === 0 && !dueCards && !roundDaysFailed && bookAgainTileItems() !== null && customerOfferTileItems() !== null
  if (!messageView.focus && !phoneMessages() && !selected && !nothingOnList) panel.append(el('p', { class: 'messages-select-note' }, 'Choose a person to see their message.'))
  if (brandNew && complete && !filterText.trim()) queue.append(el('section', { class: 'messages-new-empty', role: 'status' }, el('img', { src: '/mascot-blob-waving.png', alt: '', width: '120', height: '120' }), el('h2', {}, 'New enquiries will show here')))
  else if (nothingOnList) queue.append(allCaughtUp(listHadRows === true))
  else if (complete && !brandNew && !messageView.focus && !available.length && !standaloneCards && stageFilter !== 'oldquotes') queue.append(el('p', { class: 'empty-note' }, filterText.trim() ? 'No people match your search in this stage.' : stageFilter === 'next' ? 'Next up is clear.' : 'Nobody in this stage.'))
  if (wholeList) listHadRows = !nothingOnList
  if (messageView.focus && phoneMessages()) {
    const card = panel.querySelector<HTMLElement>('.rebook-card')
    const send = card?.querySelector<HTMLElement>('.send-way, .rebook-send-row')
    if (card && send) {
      const dock = el('section', { class: 'messages-action-bar', 'aria-label': card.getAttribute('aria-label')?.replace('Message for', 'Message actions for') ?? 'Message actions' }, send)
      dock.dataset.messageId = card.dataset.messageId
      // A sibling of the animated card: fixed positioning must not be trapped
      // by the card's transform, and its original event handlers stay attached.
      panel.append(dock)
      document.body.classList.add('messages-docked')
      let watchedUndo: HTMLElement | null = null
      const inset = (): void => {
        if (!dock.isConnected) return
        document.body.style.setProperty('--messages-action-height', `${Math.ceil(dock.getBoundingClientRect().height)}px`)
        const undo = document.querySelector<HTMLElement>('#undo-bar')
        document.body.style.setProperty('--messages-undo-height', `${Math.ceil(undo?.getBoundingClientRect().height ?? 0)}px`)
        if (undo !== watchedUndo) {
          if (watchedUndo) dockObserver?.unobserve(watchedUndo)
          if (undo) dockObserver?.observe(undo)
          watchedUndo = undo
        }
      }
      if (typeof ResizeObserver !== 'undefined') { dockObserver = new ResizeObserver(inset); dockObserver.observe(dock); inset() }
      // The app-wide queued/conflict chip must stay clear of both Send and Undo.
      if (typeof MutationObserver !== 'undefined') { dockStatusObserver = new MutationObserver(inset); dockStatusObserver.observe(document.body, { childList: true }) }
    }
  }
  panel.addEventListener('scroll', queuePanelFit, { passive: true })
  queuePanelFit(); watchSendPin(panel); watchEnquiryLayout(panel)
  if (previouslyHadRows) for (const id of restored) {
    const node = [...root.querySelectorAll<HTMLElement>(messageView.focus ? '.rebook-card' : '.rebook-tile')].find((n) => n.dataset.messageId === id)
    if (node) smallMotion(node, 'arrive')
  }
  const total = document.querySelector<HTMLElement>('#rebook-badge')
  if (lastTotal !== null && total?.textContent !== lastTotal) smallMotion(total, 'count')
  lastTotal = total?.textContent ?? null
  if (messageView.focus) requestAnimationFrame(revealFocusRecipient)
}

function revealFocusRecipient(): void {
  if (!messageView.focus || !phoneMessages()) return
  const card = document.querySelector<HTMLElement>('.messages-page .rebook-card-top, .messages-caught-up')
  if (!card) return
  const rect = card.getBoundingClientRect()
  const topbar = document.querySelector<HTMLElement>('.topbar')?.getBoundingClientRect().bottom ?? 0
  const bottom = document.querySelector<HTMLElement>('.messages-action-bar')?.getBoundingClientRect().top ?? window.innerHeight
  if (rect.top < Math.max(0, topbar) || rect.bottom > bottom) {
    const nav = document.querySelector<HTMLElement>('.messages-focus-nav') ?? card
    nav.scrollIntoView({ block: 'start', behavior: 'instant' })
  }
}

// Every enquiry in one section, Enquiries, in four groups (Liam, 16 Oct 2026: "all in one section in messages or the
// messages ... is gonna be long"): They replied, New enquiries, Details requested, Quote sent. A group
// with nobody in it is left out (unless it is the one picked under Filter); the section folds as one, open to start.
function enquiriesSection(root: HTMLElement, groups: [StageSpec, Row[]][], today: string, rerender: () => void): void {
  const landing = landId
  const keys = groups.map(([spec]) => stageKey(spec))
  const sec = el('section', { class: 'rebook-stage rebook-stage-new messages-stage-enquiries', 'aria-label': 'Enquiries' })
  const every = groups.flatMap(([, rows]) => rows)
  // Under a tile or Filter: only the groups it shows, and only those with anyone in them or picked on their own, so the
  // Waiting tile with no enquiry waiting leaves no empty Enquiries heading (Astra's review, 24 Oct 2026).
  const filtered = !messageView.focus && stageFilter !== 'all'
  const shown = filtered ? groups.filter(([spec, rows]) => picks(stageKey(spec)) && (rows.length > 0 || stageFilter === stageKey(spec))) : groups
  sec.hidden = filtered && !shown.length
  // Nobody in any group: left off the page, as an empty customer group is (Liam, 16 Oct 2026: "Hide empty").
  if (!every.length && !keys.includes(stageFilter)) { for (const [spec, rows] of groups) { const gone = el('div', {}); gone.hidden = true; pageSections.push({ spec, rows, node: gone }) } return }
  const counted = shown.flatMap(([, rows]) => rows)
  const value = counted.reduce((sum, r) => sum + (r.kind === 'enquiry' ? r.l.regular_pence ?? 0 : 0), 0)
  const head = el('div', { class: 'rebook-stage-head' })
  head.append(el('h2', { class: 'rebook-stage-title' }, meaningIcon('enquiries', 'row'), 'Enquiries'))
  head.append(el('span', { class: 'rebook-stage-count' }, `${counted.length}${value ? ` · ${money(value)}` : ''}`))
  sec.append(head)
  for (const [spec, rows] of groups) {
    const key = stageKey(spec)
    const title = spec.title.split(' · ')[0]!
    const group = el('div', { class: `messages-subgroup messages-stage-${key}`, role: 'group', 'aria-label': title })
    group.hidden = !messageView.focus && stageFilter !== 'all' && !picks(key)
    pageSections.push({ spec, rows, node: group })
    if (!rows.length && stageFilter !== key) continue
    group.append(el('div', { class: 'messages-subgroup-head' }, el('h3', { class: 'messages-subgroup-title' }, title), el('span', { class: 'rebook-stage-count' }, String(rows.length))))
    // One short line under the heading (Astra's wording, 16 Oct 2026).
    group.append(el('p', { class: 'messages-subgroup-line muted' }, spec.blurb))
    const grid = el('div', { class: 'rebook-tiles' })
    for (const row of rows) {
      grid.append(renderTile(row, rowStage(row, spec), today, rerender))
      if (rowId(row) === openId) grid.append(renderCard(row, rowStage(row, spec), today, rerender))
    }
    group.append(rows.length ? grid : el('p', { class: 'empty-note' }, 'Nobody in this group.'))
    sec.append(group)
  }
  if (!every.length) sec.append(el('p', { class: 'empty-note' }, 'No enquiries waiting on you.'))
  foldSection(sec, 'enquiries', true)
  const fold = sec.querySelector<HTMLDetailsElement>('details.messages-group-fold')
  if (fold && ((filtered && shown.length > 0) || every.some((r) => rowId(r) === openId || rowId(r) === landing))) fold.open = true
  root.append(sec)
}

function section(root: HTMLElement, spec: StageSpec, rows: Row[], today: string, rerender: () => void): void {
  const key = stageKey(spec)
  // A group with nobody in it is left off the page (Liam, 16 Oct 2026: "Hide empty", after Coming up 0, Overdue 0,
  // Waiting for a reply 0 and more one after another made Messages long). The one picked under Filter still shows,
  // saying nobody is in it. It stays in the page's list of groups, so Search's found number is unchanged.
  if (!rows.length && stageFilter !== key) { const gone = el('section', {}); gone.hidden = true; pageSections.push({ spec, rows, node: gone }); return }
  const sec = el('section', { class: `rebook-stage rebook-stage-${spec.stage} messages-stage-${key}${spec.extraClass ? ` ${spec.extraClass}` : ''}`, 'aria-label': spec.title.split(' · ')[0]! })
  sec.hidden = !messageView.focus && stageFilter !== 'all' && !picks(key)
  pageSections.push({ spec, rows, node: sec })
  const head = el('div', { class: 'rebook-stage-head' })
  const value = rows.reduce((sum, r) => sum + (r.kind === 'customer' ? (r.reply && r.c.message_reply_job_id != null ? roundJobs().find(j => j.id === r.c.message_reply_job_id)?.price_pence ?? 0 : r.c.reg_price_pence ?? 0) + (spec.stage === 'to_message' ? (mergedJobs.get(r.c.id) ?? []).reduce((s2, d) => s2 + (d.job.price_pence ?? 0), 0) : 0) : r.kind === 'job' ? (r.d.job.price_pence ?? 0) : (r.l.regular_pence ?? 0)), 0)
  head.append(el('h2', { class: 'rebook-stage-title' }, meaningIcon(homeOf(key)!, 'row'), spec.title.split(' · ')[0]!))
  head.append(el('span', { class: 'rebook-stage-count' }, `${rows.length}${value ? ` · ${money(value)}` : ''}`))
  sec.append(head)
  const grid = el('div', { class: 'rebook-tiles' })
  for (const row of rows) {
    grid.append(renderTile(row, rowStage(row, spec), today, rerender))
    if (rowId(row) === openId) grid.append(renderCard(row, rowStage(row, spec), today, rerender))
  }
  sec.append(grid)
  if (!rows.length || ['waiting', 'nodate', 'lapsed', 'followup', 'paused', 'stopped', 'replybooked'].includes(key)) {
    if (!rows.length) sec.append(el('p', { class: 'empty-note' }, 'Nobody in this stage.'))
    else sec.insertBefore(el('p', { class: 'rebook-blurb muted' }, spec.blurb), grid)
    foldSection(sec, key, !!filterText.trim() || picks(key) || rows.some((r) => rowId(r) === openId) || expanded.has(spec.title))
  }
  root.append(sec)
}

// Who Messages lists, and in which group: its page (render below) and the Diary's "Waiting for a reply" (awaitingReplies)
// read the same rule, so the two cannot disagree about who is waiting (Liam, 9 Oct 2026).
function messagesBase(allRows: RoundCustomer[], today: string) {
  // Several jobs: a customer whose main job has stopped (windows stopped, gutters carry on) is never asked about
  // the main job. Their extra jobs still come through as their own rows below. Lapsed customers are kept.
  const messageRows = allRows.filter(c => !shelved(c) && !listQuiet(c))
  const moved = new Map<number, UpcomingVisit>(messageRows.flatMap((c) => { const v = movedVisitOf(c); return v ? [[c.id, v] as const] : [] }))
  const mainRows = messageRows.filter(c => !moved.has(c.id)).map(c => replyForJob(c))
  const conversations = messageRows.filter(c => !moved.has(c.id)).flatMap(c => replyConversations(c))
  const rows = (severalJobsOn() ? mainRows.filter((c) => !c.job_stopped_on || c.status === 'lapsed') : mainRows).filter(c => !replyQuiet(c, today))
  const s = summariseRound(rows)
  // "Not now, ask again on…": a promised date still to come quietens the row
  // out of every group this page builds — overdue and coming up alike. On the
  // date itself askAgainLater turns false, isFollowupDue turns true, and the
  // custRows sort below brings them back at the top of the overdue group.
  const risk = s.riskKnown ? [...s.cold, ...s.slipping, ...rows.filter(c => promisedReplyDue(c,today) && ![...s.cold,...s.slipping].some(r => r.id === c.id))].filter((c) => !askAgainLater(c, today) && !pushedAndUnbooked(c, today)) : []
  // Coming up: active, on a cycle, due within "How far ahead to ask" (a week unless the owner changed it in Your
  // messages), and no future visit agreed (an unconfirmed diary date is not an agreement).
  const horizon = addDaysISO(today, comingUpDays())
  const riskIds = new Set(risk.map((c) => c.id))
  // A date already written down for the coming week that nobody has agreed
  // (Liam 2026-09-16). "Planned", never "booked": the Blakes' 22 Sep came off
  // the Work list cell "8 weeks = 22nd sept", which was a note to himself about
  // next time, not an appointment anyone made. The same is true of a date he
  // puts in the diary before asking the customer, so the wording has to be
  // honest for both. Tim and Zoe Blake had one on the 22nd, six days
  // out, and Messages said nothing: it was reading the CYCLE date (30 Sept)
  // and never looked at the diary. A date planned earlier than the cycle says
  // got no nudge before the van turned up. The app's own suggestions are left
  // out — they are its guess, not a date anyone wrote down.
  const bookedSoon = rows.filter((c) => {
    if (c.status !== 'active' || c.next_confirmed || !c.next_booked) return false
    if (c.next_booked_source === 'suggested' || c.next_booked_source === 'tentative') return false
    return c.next_booked >= today && c.next_booked <= horizon
  })
  const bookedSoonIds = new Set(bookedSoon.map((c) => c.id))
  const upcoming = s.riskKnown ? rows.filter((c) => {
    if (c.status !== 'active' || riskIds.has(c.id) || c.next_confirmed || askAgainLater(c, today)) return false
    if (bookedSoonIds.has(c.id)) return true
    // Pushed to next week in the Diary's Due (0063): left alone until then.
    if (pushedAndUnbooked(c, today)) return false
    const due = dueDate(c)
    // Due today counts too: on the day itself a customer is neither overdue nor still to come, and was on no list at
    // all (found in the Diary and Messages cross-check, 8 Oct 2026: the Diary showed them, Messages did not).
    return !!due && due >= today && due <= horizon
  }) : []
  const upcomingIds = new Set(upcoming.map((c) => c.id))
  // Nobody's due date covers them, so without their own group they are on no list at all (Liam, 29 Sep).
  // Not in the heading number or the nav badge: a new round's whole import would read as a pile of
  // messages to send, when most owners will simply put them in a week from the diary.
  // A new customer whose first visit was missed (never cleaned, nothing booked now, not messaged yet) is here too, with
  // "Was due 2 Oct, never got done" on the card: the Diary lists them in To place, and with no past clean they fit no
  // other group, so "Message them" found nobody (bug hunt 8 Oct 2026, messages #5). Paused, shelved, asked-again-later
  // and rebooked customers stay out as before.
  const missedFirst = (c: RoundCustomer): boolean => c.status === 'active' && !c.last_clean && !c.next_booked && (c.overdue_bookings ?? 0) > 0 && messagesThisCycle(c) === 0
  const noDate = rows.filter((c) => (noDateYet(c) || missedFirst(c)) && !riskIds.has(c.id) && !upcomingIds.has(c.id) && !askAgainLater(c, today) && !pushedAndUnbooked(c, today))
  const noDateIds = new Set(noDate.map((c) => c.id))
  // Once messaged, the send pencils the offered day in, so they stop being "no date yet"; with no past
  // clean they are in no risk group either. They stay on the ladder (waiting, second message, take off)
  // until a visit is agreed, as everyone else messaged does (Codex review, 29 Sep).
  const askedFirstTime = rows.filter((c) => c.status === 'active' && !c.last_clean && !c.next_confirmed && messagesThisCycle(c) > 0
    && !noDateIds.has(c.id) && !riskIds.has(c.id) && !upcomingIds.has(c.id) && !askAgainLater(c, today))
  const all = [...risk, ...upcoming, ...noDate, ...askedFirstTime]
  return { messageRows, moved, mainRows, conversations, rows, s, risk, riskIds, bookedSoonIds, upcoming, upcomingIds, noDate, noDateIds, all }
}

function render(allRows: RoundCustomer[], leadRows: Lead[] | null, host: HTMLElement, readsComplete = true): void {
  if(stageFilter==='stopped')stageFilter='taken_off'
  const previousCardId = host.querySelector<HTMLElement>('.rebook-card')?.dataset.messageId
  // A saving styled control keeps focus while disabled; restore that same
  // control after its row reloads, only if the owner has not moved elsewhere.
  const focused = document.activeElement as HTMLElement | null
  const selectFocus = focused?.classList.contains('roundly-select-trigger') && host.contains(focused)
    ? { label: focused.getAttribute('aria-label'), card: focused.closest<HTMLElement>('.rebook-card')?.dataset.messageId } : null
  keepMessageDrafts(host)
  finishDisclosures(); stopMessageDock()
  clear(host)
  const original = messagesLayout() === 'original'
  if (original) messageView.focus = false
  const root = el('div', { class: `messages-page${original ? ' messages-original' : ''}${messageView.focus ? ' messages-focus' : ''}${messageView.comfort ? ' messages-comfort' : ''}` })
  host.append(root)
  pageSections = []; standaloneSheets = []
  const rerender = (): void => render(allRows, leadRows, host, readsComplete)
  currentRender = rerender
  const today = todayISO()
  const base = messagesBase(allRows, today)
  const { messageRows, conversations, rows, s, risk, riskIds, upcoming, noDate, all } = base
  movedVisits = base.moved; bookedSoonIds = base.bookedSoonIds; upcomingIds = base.upcomingIds; noDateIds = base.noDateIds

  // The enquiry half of the page. When the lead read failed entirely the
  // section says so — a missing half must not read as "no enquiries".
  leadRows = leadRows?.filter(l => !inOldEnquiries(l)) ?? leadRows
  const liveLeads = leadRows ? liveEnquiries(leadRows) : []
  const newEnquiries = freshEnquiries(liveLeads, today)
  // Messaged and waiting on them (or due the nudge), the lanes New jobs shows the same way; a reply waiting is in New
  // enquiries instead, a maybe is parked.
  // A reminder still to come keeps an enquiry off every list here; on its day it comes back first in its group (tidy-up
  // item 6, 20 Oct 2026; AGREED.md 6).
  const messagedEnquiries = [...liveLeads]
    .filter((l) => enquiryMessages(l) > 0 && ['waiting', 'chase', 'letgo'].includes(enquiryLane(l, today)) && !remindedLater(l, today))
    .sort((a, b) => Number(reminderDue(b, today)) - Number(reminderDue(a, today)) || (a.enquiry_messaged_on ?? '9999-12-31').localeCompare(b.enquiry_messaged_on ?? '9999-12-31'))
  const staleQuotes = oldQuotes(liveLeads, today).filter((l) => !remindedLater(l, today)).sort((a, b) => Number(reminderDue(b, today)) - Number(reminderDue(a, today)))

  const head = el('div', { class: 'messages-heading' })
  // The big number is the three send-now groups — the same N the nav badge
  // shows, from the same arithmetic (toMessageCount).
  // Book again (0094) joins the count: its ready, opened and 3-days-on cards; one waiting on a payment never does.
  const n = withBookAgain(toMessageCount(allRows, leadRows, today))
  // A successful send reloads this screen without a global data-change event.
  // Keep the nav in step and discard any older badge read still in flight.
  if (leadRows !== null) { ++badgeSeq; paintRebookBadge(n) }
  // M4 title; Search, Focus and Filter share the slim bar. Chats lives in the owner shell.
  const title = el('div', { class: 'messages-title' }, el('h1', {}, 'Messages'))
  const focus = messageSwitch('Focus', messageView.focus, () => toggleFocus(rerender))
  focus.classList.add('messages-focus-switch')
  // Keep the existing navigation badge separate from the retained daily target.
  switchCounts.toSend = s.riskKnown ? n : null
  paintChatsButton(null)
  void chatsUnread().then(paintChatsButton)
  head.append(title)
  const banner = el('div', { class: 'messages-daily-banner', 'data-stage-slot': 'daily-banner' }); banner.hidden = true
  root.append(banner)
  root.append(head)
  if (!s.riskKnown) {
    loadError(root, 'Not available. This list needs the updated customer data. Unknown, not zero.', () => void load())
    return
  }
  const sort = el('select', { 'aria-label': 'Sort Messages', 'data-filter': 'true' })
  for (const [value, label] of Object.entries(SORT_LABELS) as [RebookSort, string][]) {
    sort.append(el('option', { value }, label))
  }
  sort.value = sortMode
  sort.addEventListener('change', () => { sortMode = sort.value as RebookSort; rerender(); document.querySelector<HTMLSelectElement>('[aria-label="Sort Messages"]')?.focus() })
  // Search: name, address, postcode, phone or area — leads' name, address and
  // phone too. A group with nobody matching is left off while typing, as an
  // empty group always is (16 Oct 2026, Liam: "Hide empty").
  const bar = el('div', { class: 'screen-bar rebook-search messages-filters' })
  const search = el('input', { type: 'search', class: 'search-box', placeholder: 'Search name, address or phone', 'aria-label': 'Search Messages' })
  search.value = filterText
  search.addEventListener('input', () => {
    const at = search.selectionStart ?? search.value.length
    filterText = search.value
    // Their own search replaces the one a Message button set up.
    asked = null
    rerender()
    const again = host.querySelector('input[type=search]') as HTMLInputElement | null
    if (again) { again.focus(); try { again.setSelectionRange(at, at) } catch { /* Some browsers restrict search selection. */ } }
  })
  bar.append(search, el('div', { class: 'messages-focus-control' }, el('span', {}, 'Focus'), focus))
  const stagePick = el('select', { 'aria-label': 'Show message stage', 'data-filter': 'true' })
  const stageOptions = [['next', 'Next up'], ['all', 'All'], ['home:enquiries', 'Enquiries'], ['home:comingup', 'Coming up lists'], ['home:late', 'Late lists'], ['home:waiting', 'Waiting on them lists'], ['bookagain', 'Book again'], ['offers', 'Offers of another job'], ['won', 'Won'], ['later', 'Maybe later'], ['letgo', 'Gone quiet'], ['sorting', 'Needs sorting'], ['recanvass','Recanvass'], ['taken_off','Taken off'], ['visit', 'Needs a visit'], ...REPLY_GROUPS.filter(g=>g.key!=='stopped').map(g => [g.key, g.title]), ['enqreplied', 'They replied'], ['new', 'New enquiries'], ['enqdetails', 'Details requested'], ['enqquoted', 'Quote sent'], ['moved', 'Visit moved'], ['upcoming', 'Coming up'], ['overdue', 'Late'], ['nodate', 'No date yet'], ['awaiting', 'Everyone waiting'], ['waiting', 'Waiting for a reply'], ['second', 'Second message'], ['no_reply', 'No reply'], ['oldquotes', 'Old quotes'], ['lapsed', 'Lapsed']]
  for (const [value, label] of stageOptions) stagePick.append(el('option', { value: value! }, label!))
  stagePick.value = stageFilter
  stagePick.addEventListener('change', () => { stageFilter = stagePick.value; rerender(); document.querySelector<HTMLSelectElement>('[aria-label="Show message stage"]')?.focus() })
  // Show and Sort behind one Filter button that says what is chosen (Liam picked A for the top of Messages, 15 Oct 2026).
  // It stays open across a redraw while it is in use, and closes on a tap anywhere else or Escape.
  const filter = el('details', { class: `messages-filter${stageFilter !== 'all' ? ' is-on' : ''}` }) as HTMLDetailsElement
  filter.open = filterOpen
  filter.addEventListener('toggle', () => { filterOpen = filter.open })
  const shown = stageFilter === 'all' ? 'All' : (stageOptions.find(([v]) => v === stageFilter)?.[1] ?? 'All')
  filter.append(el('summary', { class: 'messages-filter-button' }, 'Filter', el('small', { class: 'messages-filter-stage' }, ` · ${shown}`), el('small', { class: 'messages-filter-sort' }, ` · ${SORT_LABELS[sortMode]}`)),
    el('div', { class: 'messages-filter-panel' }, el('label', {}, el('span', {}, 'Show'), stagePick), el('label', {}, el('span', {}, 'Sort'), sort)))
  closeFilterOnOutsideTap()
  bar.append(filter)
  const q = filterText.trim().toLowerCase()
  const coldIds = new Set(s.cold.map((c) => c.id))
  const isCold = (c: RoundCustomer): boolean => coldIds.has(c.id)
  const found = all.filter((c) => matches(c, q))
  const leadVisible = (l: Lead): boolean => matchesLead(l, q) && !isLeaving(l.id)
  if (q) {
    const foundLeads = leadRows ? [...newEnquiries, ...messagedEnquiries, ...staleQuotes].filter(leadVisible).length : 0
    const allLeads = leadRows ? newEnquiries.length + messagedEnquiries.length + staleQuotes.length : 0
    // A search left typed in hides everyone else, easy to forget after switching window (Liam, 8 Oct 2026): say so in
    // plain sight, with the way back, rather than a small grey count.
    search.classList.add('search-active')
    const everyone = el('button', { type: 'button', class: 'link-button messages-search-clear' }, 'Show everyone')
    everyone.addEventListener('click', () => { filterText = ''; asked = null; rerender(); host.querySelector<HTMLInputElement>('input[type=search]')?.focus() })
    bar.append(el('div', { class: 'messages-search-on', role: 'status' }, el('span', {}, 'Showing only people matching ', el('strong', {}, `“${filterText.trim()}”`), ' · ', el('span', { class: 'messages-search-count' }, '')), everyone))
  }
  root.append(bar)
  // Sent here by a Message button, for someone this page has nothing to send:
  // they are not due, they have a visit agreed, or both messages have gone.
  // Without this the page is simply empty and reads as a broken button.
  if (asked) {
    // Asked for one of their extra jobs (Book a visit's "Message them about <day>"): that job's own row is the answer.
    const jobId = asked.jobId ?? null
    const here = asked.kind === 'customer'
      ? jobId !== null
        ? severalJobsOn() && (jobDues(messageRows, roundJobs(), today, (c) => askAgainLater(c, today)).some((d) => d.job.id === jobId && !replyQuiet(allRows.find((c) => c.id === d.job.customer_id)!, today, jobId))
          || allRows.some((c) => c.id === asked!.id && replyQuiet(c, today, jobId)))
        : found.some((c) => c.id === asked!.id) || movedVisits.has(asked.id) || allRows.some(c => c.id === asked!.id && (shelved(c) || listQuiet(c) || replyGroup(c,today)))
      : (leadRows ?? []).some((l) => l.id === asked!.id)
    if (!here) {
      const note = el('p', { class: 'empty-note' }, `Nothing to send ${asked.name} today. They are not due a message, or a visit is already agreed, or both messages have gone.`)
      if (asked.kind === 'customer') note.append(' ', el('a', { href: `#/customer/${asked.id}` }, 'Open their page'))
      root.append(note)
    }
  }
  const sorted = sortRows(found, sortMode, isCold, today)
  // Several jobs (PLAN 4a): each running extra job that is due, overdue or planned and not agreed. One waiting
  // for its first message in the same group as its customer's own row folds into that row's card.
  const dues = severalJobsOn() ? jobDues(messageRows, roundJobs(), today, (c) => askAgainLater(c, today)).filter(d => !replyQuiet(allRows.find(c => c.id === d.job.customer_id)!, today, d.job.id)).filter((d) => matches(d.entry, q)) : []
  const custIds = (ids: (c: RoundCustomer) => boolean): Set<number> => new Set(sorted.filter((c) => stageOf(c, today) === 'to_message' && ids(c)).map((c) => c.id))
  const comingIds = custIds((c) => upcomingIds.has(c.id))
  const overdueIds = custIds((c) => !upcomingIds.has(c.id) && !noDateIds.has(c.id))
  mergedJobs = new Map()
  // Only when one message can really put both on the day it offers (Astra r1, finding 6): the extra job has nothing
  // booked or missed of its own (a send never moves a booking without the owner's yes), and the main job's send
  // pencils its visit on that day (nothing booked yet) or the day IS its planned visit. Otherwise each has its own row.
  const combinable = (c: RoundCustomer, d: JobDue): boolean => {
    if (d.entry.next_booked || missedVisit(d.entry) || isAway(c, today)) return false
    if (bookedSoonIds.has(c.id) && c.next_booked) return true
    return !c.next_booked && (!missedVisit(c) || typeof c.missed_visit_id === 'number')
  }
  const merge = (d: JobDue): boolean => {
    if (asked?.kind === 'customer' && asked.jobId === d.job.id) return false
    if (d.stage !== 'to_message') return false
    const into = d.group === 'coming_up' ? comingIds : d.group === 'overdue' ? overdueIds : null
    if (!into?.has(d.job.customer_id)) return false
    const owner = sorted.find((c) => c.id === d.job.customer_id)
    if (!owner || !combinable(owner, d)) return false
    mergedJobs.set(d.job.customer_id, [...(mergedJobs.get(d.job.customer_id) ?? []), d].sort((a, b) => (a.job.kind === 'gutter' ? 0 : 1) - (b.job.kind === 'gutter' ? 0 : 1) || a.job.id - b.job.id))
    return true
  }
  const ownRows = dues.filter((d) => !merge(d))
  const jobRowsOf = (pickRow: (d: JobDue) => boolean): Row[] => ownRows.filter(pickRow).map((d) => ({ kind: 'job' as const, d }))
  const custRows = (stage: RebookStage): Row[] =>
    sorted
      .filter((c) => stageOf(c, today) === stage && !(stage === 'to_message' && (upcomingIds.has(c.id) || noDateIds.has(c.id))))
      // A follow-up that has arrived comes back at the top of the overdue
      // list, ahead of the chosen sort — they were promised "we'll ask again
      // then", and today is that day. Stable sort: the rest keep their order.
      .sort((a, b) => (stage === 'to_message' ? Number(isFollowupDue(b, today)) - Number(isFollowupDue(a, today)) : 0))
      .map((c) => ({ kind: 'customer' as const, c }))
  const enqRows = (stage: EnquiryStage): Row[] =>
    messagedEnquiries.filter((l) => enquiryStageOf(l, today) === stage && leadVisible(l)).map((l) => ({ kind: 'enquiry' as const, l, stage }))

  // Book again (0094; docs/plans/book-again/BUILD-SPEC.md FINAL 3): its own group at the top, apart from every other count,
  // only while the round has it on and only for the owner; nothing when the list is searched or filtered.
  if (['all', 'next', 'home:comingup', 'bookagain'].includes(stageFilter)) bookAgainSection(root, rerender, q, stageFilter === 'next' || messageView.focus, (id, name, card, customerId, status) => standaloneSheetRow(id, name, card, rerender, customerId, status))
  // Enquiries first, in one section: the newest money on the table. A failed read says so, never "no enquiries".
  if (leadRows === null) {
    const sec = el('section', { class: 'rebook-stage rebook-stage-new messages-stage-enquiries', 'aria-label': 'Enquiries' })
    const h = el('div', { class: 'rebook-stage-head' })
    h.append(el('h2', { class: 'rebook-stage-title' }, meaningIcon('enquiries', 'row'), 'Enquiries'))
    sec.append(h, el('p', { class: 'empty-note' }, 'Not available. The enquiries did not load. Retry above.'))
    root.append(sec)
  } else {
    const wroteBack = (l: Lead): boolean => (l.replies_unseen ?? 0) > 0
    const repliedShown: Row[] = newEnquiries.filter((l) => wroteBack(l) && leadVisible(l)).map((l) => ({ kind: 'enquiry' as const, l }))
    const rowsShown: Row[] = newEnquiries.filter((l) => !wroteBack(l) && leadVisible(l)).map((l) => ({ kind: 'enquiry' as const, l }))
    // The nudge due first, then those still within their wait, then those messaged twice and not yet let go.
    // A reminder that has come keeps them here even past their let-go day, first (AGREED.md 6).
    const due = (r: Row): boolean => r.kind === 'enquiry' && reminderDue(r.l, today)
    const stillWaiting: Row[] = [...enqRows('second'), ...enqRows('waiting'), ...enqRows('no_reply').filter((r) => r.kind === 'enquiry' && (!letGone(r.l, today) || reminderDue(r.l, today)))]
      .sort((a, b) => Number(due(b)) - Number(due(a)))
    const sentPrice = (r: Row): boolean => r.kind === 'enquiry' && quoted(r.l)
    enquiriesSection(root, [[THEY_REPLIED, repliedShown], [NEW_ENQUIRIES, rowsShown], [ENQ_DETAILS, stillWaiting.filter((r) => !sentPrice(r))], [ENQ_QUOTED, stillWaiting.filter(sentPrice)]], today, rerender)
  }
  if (leadRows) {
    const present = new Set(pageSections.flatMap(s => s.rows.filter((r): r is Extract<Row, { kind: 'enquiry' }> => r.kind === 'enquiry').map(r => r.l.id)))
    const old = new Set(staleQuotes.map(l => l.id))
    for (const [key, title] of [['sorting', 'Needs sorting'], ['answer', 'To answer'], ['chase', 'To chase'], ['waiting', 'Waiting'], ['won', 'Won'], ['later', 'Maybe later'], ['letgo', 'Gone quiet'], ['closed', "Didn't go ahead"]] as const) {
      const members = leadRows.filter(l => (key !== 'closed' || didntGoAhead(l)) && !present.has(l.id) && (!old.has(l.id) || didntGoAhead(l)) && (didntGoAhead(l) ? 'closed' : enquiryLane(l, today) === 'won' ? 'won' : remindedLater(l, today) ? 'later' : enquiryLane(l, today)) === key && leadVisible(l))
      if (members.length) {
        const spec: StageSpec = { stage: 'new', title, blurb: '', collapsible: true, extraClass: `messages-enquiry-${key}` }
        section(root, spec, members.map(l => ({ kind: 'enquiry' as const, l, stage: key === 'waiting' ? 'waiting' as const : enquiryStageOf(l, today) })), today, rerender)
        const entry = pageSections[pageSections.length - 1]!
        entry.node.dataset.enquiryLane = key
      }
    }
  }
  const movedRows: Row[] = messageRows.filter((c) => movedVisits.has(c.id) && matches(c, q)).map((c) => ({ kind: 'customer' as const, c }))
  if (movedRows.length || stageFilter === 'moved') section(root, MOVED, movedRows, today, rerender)
  // Coming up next: these are the ones to keep on their cycle, by due date.
  // Once messaged they move through Waiting / second message / take off like
  // everyone else. Then the overdue ones. The last three groups hold both
  // customers and enquiries — customers in the chip's order, enquiries oldest
  // message first.
  // Soonest first, by whichever date put them here: the diary date for a visit
  // already written down, the cycle date for the rest. Sorting a no-cycle
  // customer by a null due date used to fling them to the top.
  const comingUpDate = (c: RoundCustomer): string =>
    (bookedSoonIds.has(c.id) ? c.next_booked : dueDate(c)) ?? ''
  const soon: Row[] = sorted
    .filter((c) => upcomingIds.has(c.id) && stageOf(c, today) === 'to_message')
    .sort((a, b) => comingUpDate(a).localeCompare(comingUpDate(b)))
    .map((c) => ({ kind: 'customer' as const, c }))
  section(root, COMING_UP, [...soon, ...jobRowsOf((d) => d.stage === 'to_message' && d.group === 'coming_up')], today, rerender)
  section(root, OVERDUE, [...custRows('to_message'), ...jobRowsOf((d) => d.stage === 'to_message' && d.group === 'overdue')], today, rerender)
  const offeredReplies = conversations.filter(c => replyGroup(c,today) === 'datesoffered' && matches(c,q))
  if (offeredReplies.length || stageFilter === 'datesoffered') section(root, { stage:'datesoffered',title:'Dates offered',blurb:'Waiting for them to choose a date.',collapsible:false }, offeredReplies.map(c => ({kind:'customer' as const,c,reply:true})), today, rerender)
  // Enquiries are in their own group under New enquiries now (10 Oct 2026); these three are customers' and jobs'.
  section(root, SHARED_STAGES[0]!, [...custRows('waiting'), ...jobRowsOf((d) => d.stage === 'waiting')], today, rerender)
  section(root, SHARED_STAGES[1]!, [...custRows('second'), ...jobRowsOf((d) => d.stage === 'second')], today, rerender)
  section(root, SHARED_STAGES[2]!, [...custRows('no_reply'), ...jobRowsOf((d) => d.stage === 'no_reply')], today, rerender)
  // Last, below the day's actual work: this is a pile to chip away at, not
  // something to do before today's messages.
  const lapsedRows: Row[] = rows
    .filter((c) => c.status === 'lapsed' && !!c.last_clean && matches(c, q))
    .sort((a, b) => (b.last_clean ?? '').localeCompare(a.last_clean ?? '') || a.id - b.id)
    .map((c) => ({ kind: 'customer' as const, c }))
  // With the other piles, below the send-now groups and outside their number: a new round's import
  // would otherwise read as a mountain of messages. Only on a round that has any: an empty "No date yet" on every established round is clutter. Decided
  // on the whole list, not the search, so the heading does not come and go while typing.
  if (noDate.some((c) => stageOf(c, today) === 'to_message')) {
    const groupRows = sorted.filter((c) => noDateIds.has(c.id) && stageOf(c, today) === 'to_message')
    const focus = noDateFocus
    const shown = focus ? groupRows.filter((c) => focus.has(c.id)) : groupRows
    section(root, NO_DATE, shown.map((c) => ({ kind: 'customer' as const, c })), today, rerender)
    if (focus && shown.length < groupRows.length) {
      const all = el('button', { type: 'button', class: 'link-button' }, `Show all ${groupRows.length}`)
      all.addEventListener('click', () => { noDateFocus = null; rerender() })
      const note = el('p', { class: 'rebook-focus-note' }, `Showing the ${shown.length === 1 ? 'one' : shown.length} you weren't sure about. `, all)
      root.querySelector('.rebook-stage-nodate .rebook-stage-head')?.after(note)
    }
  }
  if (showNoDateGroup) {
    showNoDateGroup = false
    const group = root.querySelector<HTMLElement>('.rebook-stage-nodate')
    if (group) {
      requestAnimationFrame(() => {
        const bar = document.querySelector<HTMLElement>('header.topbar, header, nav')?.getBoundingClientRect().bottom ?? 0
        window.scrollTo({ top: Math.max(0, window.scrollY + group.getBoundingClientRect().top - Math.max(0, bar) - 12), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
      })
    }
  }
  // Old quotes, just above Lapsed: the other pile to chip away at (Liam 2026-09-28).
  if (leadRows) oldQuotesSection(root, staleQuotes.filter(leadVisible), rerender)
  for (const group of REPLY_GROUPS.filter(g => g.key !== 'datesoffered' && g.key !== 'stopped')) {
    const members = conversations.filter(c => replyGroup(c,today) === group.key && matches(c,q))
    if (members.length || stageFilter === group.key) section(root, { stage: group.key, title: group.title, blurb: group.blurb, collapsible: true }, members.map(c => ({kind:'customer' as const,c,reply:true})), today, rerender)
  }
  for(const key of ['recanvass','taken_off'] as const) {
    const members=allRows.filter(c=>(key==='recanvass'?recanvass(c):takenOff(c))&&matches(c,q)).sort((a,b)=>(a.customer_list_review_on??'9999').localeCompare(b.customer_list_review_on??'9999')||a.name.localeCompare(b.name))
    if(members.length||stageFilter===key)section(root,{stage:key,title:key==='recanvass'?'Recanvass':'Taken off',blurb:key==='recanvass'?'Handpicked customers worth another try. Review dates are reminders.':'Out of active planning and routine contact. History and money are kept.',collapsible:true},members.map(c=>({kind:'customer' as const,c})),today,rerender)
  }
  const visitRows = allRows.filter(c => shelved(c) && matches(c,q)).sort((a,b)=>(a.messages_shelf_review_on ?? '9999').localeCompare(b.messages_shelf_review_on ?? '9999') || a.name.localeCompare(b.name))
  if (visitRows.length || stageFilter === 'visit') section(root,{stage:'visit',title:'Needs a visit',blurb:'Shelved from Messages for all jobs. Review dates flag only; bring them back explicitly.',collapsible:true},visitRows.map(c=>({kind:'customer' as const,c})),today,rerender)
  section(root, LAPSED, lapsedRows, today, rerender)
  const searchCount = root.querySelector('.messages-search-count')
  if (searchCount) { const n = pageSections.filter(s => !s.node.hidden).reduce((n,s) => n + s.rows.length, 0) + ((stageFilter === 'all' || stageFilter === 'oldquotes') ? staleQuotes.filter(leadVisible).length : 0); searchCount.textContent = `${n} found` }
  if (messageView.focus || ['all', 'next', 'home:waiting', 'offers'].includes(stageFilter)) customerOfferMessages(root, rerender, q, stageFilter === 'next' || messageView.focus, (id, name, card, customerId, status) => standaloneSheetRow(id, name, card, rerender, customerId, status))
  if (!original) finishMessageLayout(root, today, rerender, leadRows !== null && readsComplete, leadRows ?? [], allRows.length === 0 && leadRows?.length === 0)
  for (const select of root.querySelectorAll<HTMLSelectElement>('select')) styleSelect(select)
  const card = root.querySelector<HTMLElement>('.rebook-card')
  if (card && card.dataset.messageId !== previousCardId && !card.classList.contains('reply-composer') && !card.classList.contains('messages-sheet-card')) smallMotion(card, 'dates')
  // No yellow tips over the list any more (Liam picked A for the top of Messages, 15 Oct 2026): the same steps are the
  // Help answer "How Messages works" (messages-tips). src/messages-guide.ts is left unused.
  revealAskedCard(root)
  watchMessageSheet(root); watchSendBar(root)
  if (selectFocus) {
    const replacement = [...root.querySelectorAll<HTMLButtonElement>('.roundly-select-trigger')].find(button =>
      button.getAttribute('aria-label') === selectFocus.label && button.closest<HTMLElement>('.rebook-card')?.dataset.messageId === selectFocus.card)
    replacement?.focus({preventScroll:true})
  }
}

// A read on coming back to Messages (come-back.ts) is quiet: if it fails, Messages stays as it is, with no error panel.
let quietNext = false

async function load(): Promise<void> {
  refreshDailyNumbers()
  const gen = routeGen
  const seq = ++loadSeq
  const quiet = quietNext
  quietNext = false
  const root = document.querySelector<HTMLElement>('#screen')!
  // Keep the roster result even if another read fails. Failure is unknown,
  // never an empty roster; a saved copy stays available with a Retry warning.
  const daysRequest = api<{ round_days: RoundDay[]; workers?: string[] }>('/api/round-days', 'round-days').catch(() => null)
  const pricesRequest = getMe()?.role === 'owner' ? api<{ list: PriceList | null }>('/api/prices', 'prices').catch(() => null) : Promise.resolve(null)
  let jobsComplete = true
  try {
    const [cData, lData, rData, , pData, bookAgainComplete] = await Promise.all([
      api<{ customers: RoundCustomer[] }>('/api/customers', 'customers'),
      api<{ leads: Lead[] }>('/api/leads', 'leads'),
      daysRequest,
      // Several jobs on: every extra job with its own dates and Messages count (none while off).
      loadRoundJobs(() => { jobsComplete = false }),
      pricesRequest,
      loadBookAgain(),
      loadCustomerOfferMessages(),
    ])
    if (gen !== routeGen || seq !== loadSeq) return
    priceList = pData?.list ?? null
    // A quiet read that lands after a reply, Where they stand or Not now was opened leaves it and its copy of the
    // customer alone, so its Save is checked against the version it was opened on (Codex, 15 Oct 2026).
    if (quiet && rebookBusy()) return
    list = cData.customers
    leadsList = lData.leads
    roundDaysFailed = rData === null
    roundDays = rData?.round_days ?? readCache<{ round_days: RoundDay[] }>('round-days')?.data.round_days ?? []
    roundWorkers = rData?.workers ?? readCache<{ workers?: string[] }>('round-days')?.data.workers ?? []
    render(list, leadsList, root, jobsComplete && bookAgainComplete)
  } catch (err) {
    const rData = await daysRequest
    if (gen !== routeGen || seq !== loadSeq || quiet) return
    roundDaysFailed = rData === null
    roundDays = rData?.round_days ?? readCache<{ round_days: RoundDay[] }>('round-days')?.data.round_days ?? []
    roundWorkers = rData?.workers ?? readCache<{ workers?: string[] }>('round-days')?.data.workers ?? []
    const cachedC = readCache<{ customers: RoundCustomer[] }>('customers')
    if (!cachedC) {
      clear(root)
      loadError(root, (err as Error).message, () => void load())
      return
    }
    const rows = cachedC.data.customers
    list = rows
    // A lead cache from an earlier successful read keeps the enquiry half up;
    // without one the page renders and the enquiries section says it could
    // not load (unknown, not zero).
    const cachedL = readCache<{ leads: Lead[] }>('leads')
    if (cachedL) leadsList = cachedL.data.leads
    render(rows, leadsList, root, false)
    loadError(root, (err as Error).message, () => void load(), cachedC.at)
  }
}

export function mountRebook(): void {
  dailyCompletion.opened()
  // The "not sure" focus is for the visit the diary's button started, not the next time Messages opens.
  if (!noDateFocusFresh) noDateFocus = null
  noDateFocusFresh = false
  // Opening Messages on a list that is already clear is calm; only clearing it here celebrates.
  listHadRows = null
  allClearOwed = false
  void load()
}

export function rebookOnDataChanged(): void {
  void load()
}

// Coming back to Messages (main.ts, come-back.ts): read again, quietly, unless a reply or Where they stand is being
// worked on (words typed in a card are kept across the redraw, as after any save).
export function rebookBusy(): boolean {
  // An open "Not now" chooser counts too: a redraw would rebuild its "What did they say?" on the newer copy and a Save
  // could then write the old words over the other person's (Codex, 15 Oct 2026).
  return replyDrafts.size > 0 || contextDraftsHeld() || [...document.querySelectorAll<HTMLElement>('.notnow-chooser')].some((b) => !b.hidden && !b.hasAttribute('hidden'))
}
export function rebookComeBack(): void {
  if (rebookBusy()) return
  quietNext = true
  void load()
}

// Book again's own count added to Messages' (unknown stays unknown).
const withBookAgain = (n: number | null): number | null => { const offers = customerOfferCount(); return n === null || offers === null ? null : n + bookAgainCount() + offers }

// The nav count, kept in the same shape as the Owed badge: never blanked on a
// failed read (that would say "nobody needs messaging"), and blank rather than
// zero when a payload cannot answer the question at all.
function paintRebookBadge(n: number | null): void {
  const badge = document.querySelector<HTMLElement>('#rebook-badge')
  if (!badge) return
  const next = n && n > 0 ? ` ${n}` : ''
  const changed = badge.textContent !== next
  badge.textContent = next
  badge.className = n && n > 0 ? 'rebook-badge' : ''
  if (changed && next) smallMotion(badge, 'count')
}

// "Open diary" opens the Diary on this person's agreed visit and its day, picked out, not on today (Diary and
// Messages together, Liam 8 Oct 2026). With no date to show it is a plain link to the Diary.
// One tap for "time agreed" on a visit whose day is agreed and whose time is set but not agreed: the same save as the
// booking form's "Time agreed" tick (the server checks the exact day and time), with Undo. The Diary has the same button
// with the same name (docs/DIARY-AND-MESSAGES.md section 2, Release 2).
function timeAgreedButton(c: RoundCustomer, after: () => void): HTMLButtonElement | null {
  // A round with no set times has no time to agree (visibleTime is empty then).
  const time = visibleTime({ time_slot: c.next_booked_time_slot })
  if (!c.next_booked || c.next_booked_confirmed !== 1 || !time || typeof c.next_booked_id !== 'number' || typeof c.next_booked_version !== 'number') return null
  const key = `${c.next_booked}|${time}`
  if (c.next_booked_time_agreed_for === key) return null
  const id = c.next_booked_id, version = c.next_booked_version
  const button = el('button', { type: 'button', class: 'btn-secondary messages-time-agreed', 'aria-label': `Time agreed: ${c.name}, ${shortDate(c.next_booked)} ${shownTime(time)}` }, 'Time agreed') as HTMLButtonElement
  button.addEventListener('click', () => {
    button.disabled = true
    void mutate({ label: `Time agreed: ${c.name} ${shortDate(c.next_booked!)} ${time}`, method: 'PATCH', path: `/api/cleans/${id}`, body: { version, time_agreed_for: key },
      onAck: (ack) => { alert4xx(ack); void load() },
      onConflict: () => void load() }).then((ack) => {
      if (!ack.ok && ack.status !== 0) { button.disabled = false; return }
      // Undo for a save waiting for signal too, as the Diary's Time agreed offers (bug hunt 8 Oct 2026, server-data #11).
      if (!ack.ok) button.textContent = 'Time agreed · saves when there is signal'
      undoPatch({ text: `Time agreed: ${c.name}, ${shownTime(time)}${ack.ok ? '' : ' · saves when there is signal'}`, label: `Undo time agreed: ${c.name}`, path: `/api/cleans/${id}`, ack, version, body: { time_agreed_for: null }, after: () => { after(); void load() } })
    })
  })
  return button
}

function openDiaryOn(c: RoundCustomer): HTMLAnchorElement {
  const date = c.next_confirmed ?? c.next_booked ?? null
  const ids = c.next_booked_id && c.next_booked === date ? [c.next_booked_id] : []
  const link = el('a', { class: 'btn-secondary', href: '#/schedule' }, 'Open diary') as HTMLAnchorElement
  if (date) link.addEventListener('click', (event) => {
    event.preventDefault()
    void import('./schedule').then(({ focusDiary }) => { focusDiary(ids, date, null, false); window.location.hash = '#/schedule' })
  })
  return link
}

export async function refreshRebookBadge(): Promise<void> {
  const badge = document.querySelector<HTMLElement>('#rebook-badge')
  if (!badge) return
  const seq = ++badgeSeq
  try {
    const [cData, lData] = await Promise.all([
      api<{ customers: RoundCustomer[] }>('/api/customers', 'customers'),
      api<{ leads: Lead[] }>('/api/leads', 'leads'),
      loadRoundJobs(),
      loadBookAgain(),
      loadCustomerOfferMessages(),
    ])
    if (seq !== badgeSeq) return
    const n = withBookAgain(toMessageCount(cData.customers, lData.leads, todayISO()))
    paintRebookBadge(n)
  } catch {
    // offline — keep the last known count rather than showing nothing
  }
}

// ---- Ask about a day, from the Diary (Design B, Liam approved 8 Oct 2026) --------------------------------------------
// The Diary has just put this customer on a day (drag on a computer; tap them, then a day, on a phone). Their first
// message opens here with THAT day offered: the same words and Your messages wording, their own way to be sent to, the
// same count, note lines, Messages count and Undo as a Messages send, so Messages afterwards sees exactly what its own
// send leaves (docs/DIARY-AND-MESSAGES.md). The Diary placed the visit, so nothing here books or moves one; the Diary's
// own Undo or Cancel takes it back off the day.
// placement: the visit the Diary placed, as saved (see SendOpts); the send's Undo then takes it back off with the message.
// dayNote: what the Diary says about the day itself (a worker's day; nobody out on it). onLater: the pop-up was put away
// without an answer (closed, or swiped down on a phone): the Diary keeps them as "Message N" to send later (round 4).
// dayOut: a day nobody is out on, with the names to choose from there and then.
// customer: the customer as this phone has them, for when their own read cannot be made for want of signal (a number just
// added and still waiting to send, tidy-up item 8; never for a customer removed or another account signed in).
// missed: a visit that couldn't be done, moved to `date` from Today or the Diary (docs/plans/rearrange/PLAN.md): its old
// day and reason (taken before the move cleared them), the moved visit's job, and every visit moved with it, so the
// message names their jobs and its Undo puts them all back. The ask rule is the missed one (book-message.ts).
export interface MissedAsk extends MissedVisit { jobIds: (number | null)[]; placements: Placement[] }
export interface AskAboutDayOptions { visitId?: number | null; cancelLabel?: string; onCancel?: () => void; onDone?: () => void; placement?: Placement; dayNote?: string | null; dayOut?: { names: string[]; choose: (name: string) => void } | null; onLater?: () => void; customer?: RoundCustomer; missed?: MissedAsk }
let askDialog: HTMLDialogElement | null = null

// The first message for this one day: as Messages would write it, except someone long away is asked about the day
// too (the Diary has already picked one), so the long-away wording, which names no day, is not used here.
function askKind(c: RoundCustomer, today: string): ReturnType<typeof firstMessageKind> {
  return firstMessageKind(overdueDays(c, today), cycleRisk(c) === 'cold', false, longCycle(c))
}
function askMessage(c: RoundCustomer, date: string, today: string): string {
  return rebookMessage({ name: c.name, kind: askKind(c, today), lastClean: c.last_clean, due: dueDate(c), offer: date, offers: [date] })
}
function askWordingKey(c: RoundCustomer, today: string): WordingKey {
  const kind = askKind(c, today)
  return kind === 'six_months' ? 'rebook_six_months' : kind === 'overdue' ? 'rebook_overdue' : kind === 'cold' ? 'rebook_cold' : 'rebook_due'
}

// Their number, email or way still waiting to send from this phone (the box to add a number, with no signal or a save
// the server has not answered yet) is laid over what the read answered, so Save and message opens their message with it
// rather than asking for it again (GPT-6.1's review, E07, 20 Oct 2026). The box's own rule (add-details.ts withWaiting),
// "The postcode is enough" and an Undo still waiting included (tidy-up 2 item 3).
function withWaitingDetails(c: RoundCustomer): RoundCustomer {
  return withWaiting(c)
}

export function askAboutDay(customerId: number, date: string, opts: AskAboutDayOptions = {}): void {
  askDialog?.close()
  const previous = document.activeElement as HTMLElement | null
  const today = todayISO()
  const longDay = new Date(`${date}T12:00:00`).toLocaleDateString(screenLocale(), { weekday: 'long', day: 'numeric', month: 'long' })
  const dialog = el('dialog', { class: 'booking-dialog ask-day-dialog', 'aria-labelledby': 'ask-day-title' }) as HTMLDialogElement
  askDialog = dialog
  const title = el('h2', { id: 'ask-day-title' }, `Ask about ${longDay}`)
  const close = el('button', { type: 'button', 'aria-label': 'Close' }, 'Close')
  const content = el('div', { class: 'booking-content ask-day-content' }, el('p', { class: 'muted' }, 'Getting their message ready…'))
  dialog.append(el('header', { class: 'booking-head' }, title, close), content)
  // Whatever was saved, the Diary (and the Messages count) read it afresh.
  const refresh = (): void => { window.dispatchEvent(new CustomEvent('dropby:data-changed')); opts.onDone?.() }
  // Answered (sent, said yes, kept with no message, taken off): not one to message later.
  let answered = false
  close.addEventListener('click', () => dialog.close())
  dialog.addEventListener('close', () => { dialog.remove(); if (askDialog === dialog) askDialog = null; if (!answered) opts.onLater?.(); if (previous?.isConnected) previous.focus() })
  document.body.append(dialog)
  dialog.showModal()
  // Leaving for another page ("Change wording", Back) closes the pop-up instead of leaving it over that page, and says
  // what became of the visit the Diary placed: it stays on the day, not asked yet (bug hunt 8 Oct 2026, messages #13).
  let who = 'They'
  const leave = (): void => {
    if (!dialog.open) return
    dialog.close()
    if (opts.visitId || opts.onCancel) toast(`${who} stays on ${dateChoiceLabel(date)}, not asked yet. Their message is ready in Messages.`)
  }
  window.addEventListener('hashchange', leave)
  dialog.addEventListener('close', () => window.removeEventListener('hashchange', leave))
  void (async () => {
    let c: RoundCustomer | undefined
    let noSignal = false
    try {
      c = (await api<{ customers: RoundCustomer[] }>('/api/customers', 'customers')).customers.find((x) => x.id === customerId)
    } catch (err) {
      // Shown below, unless it is only the signal and the customer is in hand (with a number waiting to send): then
      // their message opens with it (GPT-6.1's edge case G E07, 20 Oct 2026).
      noSignal = err instanceof ApiError && err.status === 0 && (err.message === 'no connection' || err.message === 'timed out')
    }
    if (!c && noSignal && opts.customer?.id === customerId) c = opts.customer
    if (c) c = withWaitingDetails(c)
    if (!dialog.isConnected) return
    clear(content)
    if (!c) { content.append(el('p', {}, "Couldn't load their details. Check your connection and try again, or open Messages.")); return }
    const customer = c
    who = customer.name
    title.textContent = `${opts.missed ? 'Message' : 'Ask'} ${firstNameOf(customer.name)} about ${longDay}`
    content.append(el('p', { class: 'muted' }, [customer.name, addressLine(customer)].filter(Boolean).join(' · ')))
    // A day that has gone is never offered to a customer (bug hunt 8 Oct 2026, messages #2): the Diary does not place
    // anyone on one, and should a visit reach here on one, the only way on is to take it back off.
    if (date < today) {
      answered = true // a day that has gone is never one to message about later
      content.append(el('p', { class: 'ask-day-gone', role: 'status' }, `${longDay} has gone. Pick today or a later day.`))
      if (opts.onCancel) {
        const back = el('button', { type: 'button', class: 'btn-primary ask-day-cancel' }, opts.cancelLabel ?? 'Cancel')
        back.addEventListener('click', () => { answered = true; dialog.close(); opts.onCancel!() })
        content.append(el('div', { class: 'ask-day-actions' }, back))
      }
      return
    }
    // A drop from the Diary (round 4 of docs/plans/diary-due/PLAN.md) never asks the wrong person. What the Diary knows of
    // the day comes first (a worker's day, a day nobody is out on); then the booking form's own rule for who Messages
    // leaves alone (book-message.ts messageThemOffer: Where they stand, Ask again later, a reply awaited or filed, Don't
    // message), in its words, with the visit kept on the day and no message, or taken off again. Nobody can be reached:
    // placed quietly, saying so.
    const fromDiary = !!(opts.visitId || opts.onCancel || opts.onLater)
    const first = firstNameOf(customer.name)
    const weekday = new Date(`${date}T12:00:00`).toLocaleDateString(screenLocale(), { weekday: 'long' })
    if (fromDiary && opts.dayNote) {
      const note = el('p', { class: 'ask-day-note', role: 'status' }, opts.dayNote)
      content.append(note)
      // A one-person round: a day that is not one of the owner's working days. Its days are set only in My working days
      // (Liam, 19 Oct 2026), so a link there in place of the names; leaving for it keeps the visit on the day (leave()).
      if (worksAlone()) content.append(el('a', { href: '#/my-days', class: 'btn-secondary ask-day-link' }, 'My working days'))
      // Nobody out: who is, chosen here in one tap, the note then saying so (Liam, 11 Oct 2026).
      else if (opts.dayOut?.names.length) {
        const choices = el('div', { class: 'ask-day-out', role: 'group', 'aria-label': `Who is out on ${weekday}` })
        for (const name of opts.dayOut.names) {
          const b = el('button', { type: 'button', class: 'btn-secondary' }, `${name} out`)
          b.addEventListener('click', () => { opts.dayOut!.choose(name); choices.remove(); note.textContent = `${name} is out on ${weekday}.` })
          choices.append(b)
        }
        content.append(choices)
      }
    }
    const missed = opts.missed
    const stop = fromDiary ? messageThemOffer({ customer, conversation: customer, jobId: missed?.jobIds[0] ?? null, date, today, aheadDays: 36500, agreed: false, weekOnly: false, way: wayFor(customer), otherVisit: null, placed: true, missed: !!missed }) : { offer: true as const }
    // No way to message them their way (no number, a landline, "no WA", no email when email is their way: the same test
    // as the Diary's + Add a number, add-details.ts; Sonnet's edge case S E9): the box to add it, there and then
    // (tidy-up item 8, Liam, 20 Oct 2026, the drawing). Just placed: the bar says so with + Add a number, and its Undo is
    // the placing's own Cancel. Tapped to message: the box opens straight away. Saved, "Save and message" opens their
    // message here again with the same visit, job and placement.
    const missing = fromDiary && stop.offer ? missingDetails(customer) : null
    if (missing?.number) {
      answered = true
      dialog.close()
      const again = (r: DetailsSaved): void => { if (r.message) askAboutDay(customerId, date, { ...opts, customer: r.customer as RoundCustomer }) }
      const add = (): void => openAddDetails(customer, { message: true, onSaved: again })
      const why = !customer.phone?.trim() && !customer.email?.trim() ? 'there is no phone or email yet' : missing.field === 'email' ? 'there is no email a message can go to yet' : 'there is no mobile a message can go to yet'
      if (opts.onCancel) { const cancel = opts.onCancel; offerUndo(`${first} is on ${weekday}, with no message: ${why}.`, () => cancel(), { act: add, label: missing.field === 'email' ? '+ Add an email' : '+ Add a number' }) }
      else add()
      return
    }
    if (!stop.offer) {
      // Nothing to send, now or later: closing it is not "Message them later" (round 4 review).
      answered = true
      // Nobody is asked here, so the heading does not say "Ask" (Liam's pictures, 11 Oct 2026).
      title.textContent = `${first} on ${longDay}`
      content.append(el('p', { class: 'ask-day-hold', role: 'status' }, `No message goes to ${first}. ${stop.why ?? ''}`.trim()))
      const actions = el('div', { class: 'ask-day-actions' })
      const keep = el('button', { type: 'button', class: 'btn-primary' }, `Keep ${first} on ${weekday}, no message`)
      keep.addEventListener('click', () => { answered = true; dialog.close(); refresh() })
      actions.append(keep)
      if (stageOf(customer, today) !== 'to_message' || replyQuiet(customer, today, null)) {
        const replied = el('button', { type: 'button', class: 'btn-secondary' }, 'They replied')
        replied.addEventListener('click', () => { answered = true; dialog.close(); openReplyDialog(customer.id) })
        actions.append(replied)
      }
      if (opts.onCancel) {
        const cancel = el('button', { type: 'button', class: 'link-button ask-day-cancel' }, opts.cancelLabel ?? 'Cancel')
        cancel.addEventListener('click', () => { answered = true; dialog.close(); opts.onCancel!() })
        actions.append(cancel)
      }
      content.append(actions)
      return
    }
    // The visit the Diary just placed, in the shared words, once the customers read has it.
    const placed = (upcomingVisits(customer) ?? []).find((v) => (opts.visitId ? v.id === opts.visitId : v.date === date && !v.job_id))
    // A missed visit is asked about only while it is still where it was moved, not agreed (GPT-6.1's review: a pop-up
    // left open must not ask about a day the visit has left).
    if (missed && (!placed || placed.date !== date || placed.confirmed === 1)) {
      answered = true
      content.append(el('p', { class: 'ask-day-gone', role: 'status' }, `${first}'s visit has changed since it was moved. Nothing was sent: check it in the Diary.`))
      return
    }
    // Their extra jobs moved with it, as Messages counts them (several jobs): each job's own conversation.
    let jobs: JobDue[] = []
    if (missed?.jobIds.some((j) => j !== null)) {
      const known = await loadRoundJobs().catch(() => [] as import('../jobs').CustomerJob[])
      jobs = jobDues([customer], known, today, () => false, 36500).filter((d) => missed.jobIds.includes(d.job.id))
    }
    const main = !missed || missed.jobIds.includes(null)
    if (placed) {
      const day = dayLabel(placed.date)
      content.append(el('p', { class: 'ask-day-visit' }, `${day}${shownVisitTime(placed) ? `, ${shownVisitTime(placed)}` : ''} · ${visitWords({ ...placed, state: 'booked' }, customer, today).text}`))
    }
    const text = missed && placed ? missedVisitMessage(customer.name, missed, placed, today) : askMessage(customer, date, today)
    const preview = el('div', { class: 'rebook-preview' })
    preview.append(el('div', { class: 'rebook-preview-head' }, el('span', { class: 'rebook-fact-label' }, 'Message to send'), previewTools(copyMessageButton(text, customer.name), wordingLink(missed ? 'visit_missed' : askWordingKey(customer, today)))))
    preview.append(el('p', { class: 'rebook-preview-text' }, text))
    content.append(preview)
    const send = (way: CustomerMessageBy = wayFor(customer)): void => {
      answered = true
      dialog.close()
      // One Undo for the message and the visit the Diary just placed (server-data #9).
      sendJobsMessage(customer, main, jobs, 'to_message', undefined, way, { offerDates: [date], freshAsk: true, visitPlaced: true, reload: refresh, placement: opts.placement, placements: missed?.placements, alsoUndo: opts.onCancel, missedFrom: missed?.from })
    }
    const actions = el('div', { class: 'ask-day-actions' })
    const control = sendControl(customer, text, `Your next visit from ${businessSettings().business_name}`, {
      label: (way) => wayWords(way).button,
      className: 'btn-whatsapp rebook-send',
      onSend: (way) => send(way),
      changed: () => { answered = true; dialog.close(); askAboutDay(customerId, date, opts) },
      onConflict: refresh,
    })
    actions.append(control.root)
    const row = el('div', { class: 'ask-day-row' })
    const myself = el('button', { type: 'button', class: 'btn-secondary' }, 'I messaged them myself')
    myself.addEventListener('click', () => send())
    const yes = el('button', { type: 'button', class: 'btn-secondary' }, 'They already said yes')
    yes.addEventListener('click', () => { yes.disabled = true; void agreeDay(customer, date, opts.visitId ?? placed?.id ?? null, refresh).then((ok) => { if (ok) { answered = true; dialog.close() } else yes.disabled = false }) })
    row.append(myself, yes)
    actions.append(row)
    if (opts.onCancel) {
      const cancel = el('button', { type: 'button', class: 'link-button ask-day-cancel' }, opts.cancelLabel ?? 'Cancel')
      cancel.addEventListener('click', () => { answered = true; dialog.close(); opts.onCancel!() })
      actions.append(cancel)
    }
    // Put it away to keep placing (Liam: "i'd want both somehow"): they wait as "Message N" on the Due bar or column.
    if (opts.onLater) {
      const later = el('button', { type: 'button', class: 'link-button ask-day-later' }, 'Message them later')
      later.addEventListener('click', () => dialog.close())
      actions.append(later)
    }
    content.append(actions)
  })()
}

function firstNameOf(name: string): string {
  return name.trim().split(/\s+/)[0] || name
}

// "They already said yes": the day is agreed on the visit the Diary placed (Mark confirmed's own save), and the
// conversation records it, so both screens read "Day agreed" and Messages has nothing left to ask. One Undo puts both
// back.
async function agreeDay(c: RoundCustomer, date: string, visitId: number | null, refresh: () => void): Promise<boolean> {
  let visit: Clean | undefined
  try {
    const detail = await api<{ customer: RoundCustomer; cleans: Clean[] }>(`/api/customers/${c.id}`)
    visit = detail.cleans.find((v) => visitId ? v.id === visitId : v.date === date && v.state === 'booked' && !v.job_id)
    if (detail.customer) c = { ...c, version: detail.customer.version, contact_note: detail.customer.contact_note }
  } catch { /* below */ }
  if (!visit || visit.state !== 'booked') { toast(`Couldn't find ${c.name}'s visit on ${shortDate(date)}. Try again in a moment.`); return false }
  const today = todayISO()
  const visitAck = await mutate({ label: `Day agreed: ${c.name} ${shortDate(date)}`, method: 'PATCH', path: `/api/cleans/${visit.id}`, body: { version: visit.version, confirmed: 1 } })
  alert4xx(visitAck)
  if (!visitAck.ok && visitAck.status !== 0) { refresh(); return false }
  const note = appendNote(c.contact_note, `${noteDate(today)}: agreed ${noteDate(date)}`)
  const custAck = await mutate({ label: `Agreed ${shortDate(date)}: ${c.name}`, method: 'PATCH', path: `/api/customers/${c.id}`, body: { version: c.version, last_contacted_on: today, contact_note: note } })
  refresh()
  const visitRow = visitAck.row as { version?: number } | undefined, custRow = custAck.row as { version?: number } | undefined
  offerUndo(`Day agreed: ${c.name}, ${shortDate(date)}`, () => {
    void mutate({ label: `Undo day agreed: ${c.name}`, method: 'PATCH', path: `/api/cleans/${visit!.id}`, body: { version: visitRow?.version ?? visit!.version + 1, confirmed: 0 }, onAck: refresh, onConflict: refresh })
    if (custAck.ok) void mutate({ label: `Undo agreed note: ${c.name}`, method: 'PATCH', path: `/api/customers/${c.id}`, body: { version: custRow?.version ?? c.version + 1, last_contacted_on: c.last_contacted_on ?? null, contact_note: c.contact_note ?? null }, onAck: refresh, onConflict: refresh })
  })
  return true
}

// ---- the Diary's "Waiting for a reply" (Liam, 9 Oct 2026) ------------------------------------------------------------
// Everyone Messages has under Waiting for a reply, Send second message and No reply, by Messages' own rule
// (messagesBase), each in Messages' own words: the second message to send first, then those waiting, then no reply,
// longest waiting first.
export interface AwaitingReply { customer: RoundCustomer; stage: Exclude<RebookStage, 'to_message'>; words: string }
const AWAITING_ORDER = { second: 0, waiting: 1, no_reply: 2 } as const
export function awaitingReplies(allRows: RoundCustomer[], today: string = todayISO()): AwaitingReply[] {
  const out: AwaitingReply[] = []
  for (const c of messagesBase(allRows, today).all) {
    const stage = stageOf(c, today)
    if (stage !== 'to_message') out.push({ customer: c, stage, words: ladderWords(c, stage) })
  }
  return out.sort((a, b) => AWAITING_ORDER[a.stage] - AWAITING_ORDER[b.stage]
    || (a.customer.rebook_messaged_on ?? '').localeCompare(b.customer.rebook_messaged_on ?? '') || a.customer.name.localeCompare(b.customer.name))
}

// The customers list and the working days, read fresh for a pop-up over the Diary; a failed read falls back to this
// phone's saved copy, as Messages does.
async function readForPopup(): Promise<RoundCustomer[] | null> {
  const daysRequest = api<{ round_days: RoundDay[]; workers?: string[] }>('/api/round-days', 'round-days').catch(() => null)
  let rows: RoundCustomer[] | null
  try { rows = (await api<{ customers: RoundCustomer[] }>('/api/customers', 'customers')).customers } catch { rows = readCache<{ customers: RoundCustomer[] }>('customers')?.data.customers ?? null }
  const [rData] = await Promise.all([daysRequest, loadRoundJobs().catch(() => [])])
  roundDaysFailed = rData === null
  roundDays = rData?.round_days ?? readCache<{ round_days: RoundDay[] }>('round-days')?.data.round_days ?? []
  roundWorkers = rData?.workers ?? readCache<{ workers?: string[] }>('round-days')?.data.workers ?? []
  // A moved visit Messages saw on an earlier visit must not shape a send made here (sendJobsMessage reads it).
  if (rows) movedVisits = messagesBase(rows, todayISO()).moved
  return rows
}
const NOT_LOADED = "Couldn't load their details. Check your connection and try again, or open Messages."

// "They replied" over the Diary: Messages' own reply card (replyCard), with its answers, saves and Undo, in a pop-up.
// jobId: the job whose reply it is (several jobs), as on Messages' card. The pop-up closes once the reply is saved, or
// on Cancel; a reply begun and not saved is not left open on their Messages card.
let replyDialog: HTMLDialogElement | null = null
export function openReplyDialog(customerId: number, jobId: number | null = null): void {
  replyDialog?.close()
  const previous = document.activeElement as HTMLElement | null
  const dialog = el('dialog', { class: 'booking-dialog reply-dialog', 'aria-labelledby': 'reply-dialog-title' }) as HTMLDialogElement
  replyDialog = dialog
  const title = el('h2', { id: 'reply-dialog-title' }, 'They replied')
  const close = el('button', { type: 'button', 'aria-label': 'Close' }, 'Close')
  const line = el('p', { class: 'muted reply-dialog-line' })
  // Inside Messages' own page style, so its day buttons, ticks and motion look and move as they do there (Liam, 9 Oct
  // 2026: "the messages section has great ux and animations we should reuse").
  const content = el('div', { class: 'booking-content reply-dialog-content messages-page' }, el('p', { class: 'muted' }, 'Getting their details…'))
  dialog.append(el('header', { class: 'booking-head' }, title, close), content)
  let customer: RoundCustomer | null = null, row: RoundCustomer | null = null
  const draw = (): void => {
    if (!dialog.open || !customer) return
    if (!replyDrafts.has(customer.id)) { shut(); return }
    clear(content)
    content.append(line, replyCard(customer, todayISO(), draw))
  }
  const read = async (): Promise<void> => {
    const rows = await readForPopup()
    if (!dialog.open) return
    const found = rows?.find((x) => x.id === customerId)
    if (!found) { clear(content); content.append(el('p', {}, NOT_LOADED)); return }
    const first = !customer
    row = found
    customer = replyForJob(found, jobId)
    const today = todayISO(), stage = stageOf(customer, today)
    title.textContent = `${customer.name} replied`
    line.textContent = [addressLine(customer), replyGroup(customer, today) ? replyTitle(customer, today) : stage !== 'to_message' ? ladderWords(customer, stage) : ''].filter(Boolean).join(' · ')
    if (first) startReply(customer, jobId, draw)
    else draw()
  }
  // Every save and Undo made here tells the Diary (and the Messages count) to read again.
  // Closing stops the reply steps drawing here at once, before the browser's close event arrives.
  const shut = (): void => { if (replyHost === host) replyHost = null; if (dialog.open) dialog.close() }
  const host: ReplyHost = {
    reload: () => { window.dispatchEvent(new CustomEvent('dropby:data-changed')); if (dialog.open) void read() },
    close: () => shut(),
    row: () => row,
    open: () => dialog.open,
  }
  replyHost = host
  const leave = (): void => shut()
  close.addEventListener('click', () => shut())
  dialog.addEventListener('close', () => {
    dialog.remove()
    if (replyDialog === dialog) replyDialog = null
    if (replyHost === host) replyHost = null
    window.removeEventListener('hashchange', leave)
    const draft = customer ? replyDrafts.get(customer.id) : undefined
    if (customer && draft && !draft.busy && !draft.pending) replyDrafts.delete(customer.id)
    if (previous?.isConnected) previous.focus()
  })
  // Leaving for another page (a name, "Change wording") closes the pop-up instead of leaving it over that page.
  window.addEventListener('hashchange', leave)
  document.body.append(dialog)
  dialog.showModal()
  void read()
}

// A "Dates offered, waiting" row dropped on a day of the Diary: they picked that day, so it is Messages' "They
// accepted a date" for it (acceptDate), straight on to the booking with the day filled in and agreed. Never the Ask
// pop-up: they have been asked, and this is their answer.
export function acceptDayFromDiary(customerId: number, jobId: number | null, date: string): void {
  if (date < todayISO()) { toast(`${dateChoiceLabel(date)} has gone. Pick today or a later day.`); return }
  void (async () => {
    let found: RoundCustomer | undefined
    try { found = (await api<{ customers: RoundCustomer[] }>('/api/customers', 'customers')).customers.find((x) => x.id === customerId) } catch { /* below */ }
    if (!found) { toast(NOT_LOADED); return }
    const c = replyForJob(found, jobId)
    // Its own answer, kept out of Messages' open replies: a reply half written on their Messages card stays as it is.
    const draft: ReplyDraft = { kind: 'book', agreedDate: date, jobId, jobIds: [jobId], note: c.said_note ?? '', date: addDaysISO(todayISO(), 30), dates: [], busy: false, error: '' }
    const reload = (): void => { window.dispatchEvent(new CustomEvent('dropby:data-changed')) }
    let out = 'stale'
    try { out = await acceptDate(c, draft, date, reload, undefined, () => true) } catch { out = 'Could not load their visits. Please retry.' }
    if (out === 'opened') reload()
    else if (out !== 'stale') toast(out)
  })()
}

// "Send second message" from the Diary's "Waiting for a reply": Messages' second message for them, with its send and
// "I messaged them myself", in a pop-up over the Diary. The same save as the button on their Messages card.
let secondDialog: HTMLDialogElement | null = null
export function openSecondMessage(customerId: number, from: HTMLElement | null = null): void {
  secondDialog?.close()
  const previous = from ?? document.activeElement as HTMLElement | null
  const dialog = el('dialog', { class: 'booking-dialog ask-day-dialog', 'aria-labelledby': 'second-message-title' }) as HTMLDialogElement
  secondDialog = dialog
  const title = el('h2', { id: 'second-message-title' }, 'Second message')
  const close = el('button', { type: 'button', 'aria-label': 'Close' }, 'Close')
  const content = el('div', { class: 'booking-content ask-day-content' }, el('p', { class: 'muted' }, 'Getting their message ready…'))
  dialog.append(el('header', { class: 'booking-head' }, title, close), content)
  const refresh = (): void => { window.dispatchEvent(new CustomEvent('dropby:data-changed')) }
  const leave = (): void => { if (dialog.open) dialog.close() }
  close.addEventListener('click', () => dialog.close())
  dialog.addEventListener('close', () => { dialog.remove(); if (secondDialog === dialog) secondDialog = null; window.removeEventListener('hashchange', leave); if (previous?.isConnected) previous.focus() })
  window.addEventListener('hashchange', leave)
  document.body.append(dialog)
  dialog.showModal()
  void (async () => {
    const rows = await readForPopup()
    if (!dialog.isConnected) return
    clear(content)
    if (!rows?.some((x) => x.id === customerId)) { content.append(el('p', {}, NOT_LOADED)); return }
    const today = todayISO()
    // Only while the second message is theirs to send: a reply or a send since the Diary was drawn moves them on.
    const customer = awaitingReplies(rows, today).find((a) => a.customer.id === customerId && a.stage === 'second')?.customer
    if (!customer) { content.append(el('p', {}, 'Nothing to send them now. Their messages have moved on since the Diary was drawn.')); refresh(); return }
    title.textContent = `Second message to ${firstNameOf(customer.name)}`
    content.append(el('p', { class: 'muted' }, [addressLine(customer), ladderWords(customer, 'second')].filter(Boolean).join(' · ')))
    const text = secondMessage(customer.name)
    content.append(el('div', { class: 'rebook-preview' },
      el('div', { class: 'rebook-preview-head' }, el('span', { class: 'rebook-fact-label' }, 'Second message'), previewTools(copyMessageButton(text, customer.name), wordingLink('rebook_second'))),
      el('p', { class: 'rebook-preview-text' }, text)))
    const send = (way: CustomerMessageBy = wayFor(customer)): void => { dialog.close(); sendJobsMessage(customer, true, [], 'second', undefined, way, { reload: refresh }) }
    const control = sendControl(customer, text, `Your next visit from ${businessSettings().business_name}`, {
      label: () => 'Send second message',
      className: 'btn-whatsapp rebook-send rebook-send-second',
      onSend: (way) => send(way),
      changed: () => { dialog.close(); openSecondMessage(customerId, previous) },
      onConflict: refresh,
    })
    const myself = el('button', { type: 'button', class: 'btn-secondary' }, 'I messaged them myself')
    myself.addEventListener('click', () => send())
    content.append(el('div', { class: 'ask-day-actions' }, control.root, el('div', { class: 'ask-day-row ask-day-row-one' }, myself)))
  })()
}
